import { vttToLines as fn, parseTimestamp as ri, templateToScenes as lt, supportedFonts as gn, crossFade as Os, getSizeDetails as rr, appendFontFamilies as mn } from "@vouchfor/canvas-video";
import { noChange as nr, unsafeCSS as Yt, css as me, LitElement as pn, html as G } from "lit";
import { property as k, state as ve } from "lit/decorators.js";
import { classMap as te } from "lit/directives/class-map.js";
import { ifDefined as vt } from "lit/directives/if-defined.js";
import { createRef as Se, ref as be } from "lit/directives/ref.js";
import { styleMap as Fs } from "lit/directives/style-map.js";
import { Task as ar } from "@lit/task";
import ct from "p-memoize";
import { AsyncDirective as vn } from "lit/async-directive.js";
import { directive as or, PartType as lr, Directive as yn } from "lit/directive.js";
import Tn from "flat";
import { repeat as hr } from "lit/directives/repeat.js";
import Ms from "tippy.js";
class Ne extends Error {
  constructor(e, t = new Error(), s = !1) {
    super(), this.fatal = !1, this.fatal = s, this.stack = t.stack, this.message = [e, t.message].filter(Boolean).join(" - ");
  }
}
const xn = 5;
class En {
  constructor(e) {
    this._caption = "", this._currentTime = 0, this._activeScenes = [], this._upcomingScenes = [], this._canvas = Se(), this._controls = Se(), this.host = e;
  }
  set activeScenes(e) {
    if (e !== this._activeScenes) {
      const t = e[0], s = this._activeScenes[0];
      this._activeScenes = e, t !== s && (this.host.dispatchEvent(new CustomEvent("scenechange", { detail: e[0] })), this.host.requestUpdate());
    }
  }
  get activeScenes() {
    return this._activeScenes;
  }
  set currentTime(e) {
    var r, n, o, l, h;
    const t = Math.min(this.host.duration, Math.max(0, e));
    this._currentTime = t, this.activeScenes = ((r = this.host.scenes) == null ? void 0 : r.filter(({ start: c, duration: d }) => t >= c && t < c + d)) ?? [], this._upcomingScenes = ((n = this.host.scenes) == null ? void 0 : n.filter(({ start: c }) => t >= c - xn && t < c)) ?? [], this.loadScenes(), this.syncVideoState(), (o = this._controls.value) == null || o.setAttribute("currentTime", t.toString());
    const s = this.activeScenes[0], i = fn((l = s == null ? void 0 : s.videoMeta) == null ? void 0 : l.captions);
    this.caption = ((h = i.find(({ start: c, end: d }) => {
      var f;
      const u = t - s.start + (((f = s.videoMeta) == null ? void 0 : f.start) ?? 0);
      return c && d && u >= ri(c) && u <= ri(d);
    })) == null ? void 0 : h.text) ?? "", this.draw(t), !this.host.paused && !this.host.loading && !this.host.processing && !this.host.waiting && this.host.dispatchEvent(new CustomEvent("timeupdate", { detail: t }));
  }
  get currentTime() {
    return this._currentTime;
  }
  set caption(e) {
    e !== this._caption && (this._caption = e, this.host.requestUpdate());
  }
  get caption() {
    return this._caption;
  }
  canvas() {
    return be(this._canvas);
  }
  controls() {
    return be(this._controls);
  }
  loadScenes() {
    [...this.activeScenes, ...this._upcomingScenes].forEach((e) => {
      var o, l, h;
      const { start: t, duration: s, video: i, videoMeta: r } = e, n = this.host.currentTime > 0 || this.host.preload === "auto" || !this.host.paused;
      if (i && r) {
        const { key: c, hls: d, node: u } = i, { start: f, duration: g } = r, p = this.host.videoState[c];
        u && p && (u.currentTime >= f + g || u.ended || n && (d ? (o = d.startLoadOnce) == null || o.call(d, u.currentTime) : p.initialised || (l = u.startLoadOnce) == null || l.call(u)));
      } else if (n) {
        const c = `${t}-${s}`, d = this.host._sceneController.videoState[c];
        this.host.duration && !((h = d == null ? void 0 : d.buffered) != null && h.length) && (this.host._sceneController.videoState = {
          ...this.host._sceneController.videoState,
          [c]: {
            ...d,
            buffered: [
              {
                start: Math.max(0, t / this.host.duration * 100),
                end: Math.min((t + s) / this.host.duration * 100, 100)
              }
            ]
          }
        });
      }
    });
  }
  syncVideoState() {
    var e;
    (e = this.host.scenes) == null || e.forEach((t) => {
      if (t.video) {
        const { key: s, node: i } = t.video, r = this.host.videoState[s], n = this.activeScenes.includes(t);
        if (i && r)
          if (n && !this.host.waiting && !this.host.loading && !this.host.paused) {
            if (i.paused && r.initialised)
              try {
                return i.play();
              } catch (o) {
                throw new Ne("Video play error", o, !0);
              }
          } else
            i.paused || i.pause();
      }
    });
  }
  draw(e = this.currentTime) {
    var t, s;
    this.host.sceneConfig && this._canvas.value && ((s = (t = this.host).compilation) == null || s.call(t, {
      currentTime: e,
      scenes: this.host.sceneConfig,
      canvas: this._canvas.value
    }));
  }
  clear() {
    var t;
    const e = this._canvas.value;
    (t = e == null ? void 0 : e.getContext("2d")) == null || t.clearRect(0, 0, e.width, e.height);
  }
}
function Sn(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var cr = { exports: {} };
(function(a, e) {
  (function(t) {
    var s = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, n = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, o = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(l, h, c) {
        if (c = c || {}, l = l.trim(), h = h.trim(), !h) {
          if (!c.alwaysNormalize)
            return l;
          var d = o.parseURL(l);
          if (!d)
            throw new Error("Error trying to parse base URL.");
          return d.path = o.normalizePath(
            d.path
          ), o.buildURLFromParts(d);
        }
        var u = o.parseURL(h);
        if (!u)
          throw new Error("Error trying to parse relative URL.");
        if (u.scheme)
          return c.alwaysNormalize ? (u.path = o.normalizePath(u.path), o.buildURLFromParts(u)) : h;
        var f = o.parseURL(l);
        if (!f)
          throw new Error("Error trying to parse base URL.");
        if (!f.netLoc && f.path && f.path[0] !== "/") {
          var g = i.exec(f.path);
          f.netLoc = g[1], f.path = g[2];
        }
        f.netLoc && !f.path && (f.path = "/");
        var p = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: f.scheme,
          netLoc: u.netLoc,
          path: null,
          params: u.params,
          query: u.query,
          fragment: u.fragment
        };
        if (!u.netLoc && (p.netLoc = f.netLoc, u.path[0] !== "/"))
          if (!u.path)
            p.path = f.path, u.params || (p.params = f.params, u.query || (p.query = f.query));
          else {
            var v = f.path, y = v.substring(0, v.lastIndexOf("/") + 1) + u.path;
            p.path = o.normalizePath(y);
          }
        return p.path === null && (p.path = c.alwaysNormalize ? o.normalizePath(u.path) : u.path), o.buildURLFromParts(p);
      },
      parseURL: function(l) {
        var h = s.exec(l);
        return h ? {
          scheme: h[1] || "",
          netLoc: h[2] || "",
          path: h[3] || "",
          params: h[4] || "",
          query: h[5] || "",
          fragment: h[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(r, ""); l.length !== (l = l.replace(n, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    a.exports = o;
  })();
})(cr);
var Ns = cr.exports;
function ni(a, e) {
  var t = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(a);
    e && (s = s.filter(function(i) {
      return Object.getOwnPropertyDescriptor(a, i).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function Le(a) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ni(Object(t), !0).forEach(function(s) {
      bn(a, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : ni(Object(t)).forEach(function(s) {
      Object.defineProperty(a, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return a;
}
function bn(a, e, t) {
  return e = An(e), e in a ? Object.defineProperty(a, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[e] = t, a;
}
function ae() {
  return ae = Object.assign ? Object.assign.bind() : function(a) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (a[s] = t[s]);
    }
    return a;
  }, ae.apply(this, arguments);
}
function Ln(a, e) {
  if (typeof a != "object" || a === null)
    return a;
  var t = a[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(a, e || "default");
    if (typeof s != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(a);
}
function An(a) {
  var e = Ln(a, "string");
  return typeof e == "symbol" ? e : String(e);
}
const M = Number.isFinite || function(a) {
  return typeof a == "number" && isFinite(a);
};
let m = /* @__PURE__ */ function(a) {
  return a.MEDIA_ATTACHING = "hlsMediaAttaching", a.MEDIA_ATTACHED = "hlsMediaAttached", a.MEDIA_DETACHING = "hlsMediaDetaching", a.MEDIA_DETACHED = "hlsMediaDetached", a.BUFFER_RESET = "hlsBufferReset", a.BUFFER_CODECS = "hlsBufferCodecs", a.BUFFER_CREATED = "hlsBufferCreated", a.BUFFER_APPENDING = "hlsBufferAppending", a.BUFFER_APPENDED = "hlsBufferAppended", a.BUFFER_EOS = "hlsBufferEos", a.BUFFER_FLUSHING = "hlsBufferFlushing", a.BUFFER_FLUSHED = "hlsBufferFlushed", a.MANIFEST_LOADING = "hlsManifestLoading", a.MANIFEST_LOADED = "hlsManifestLoaded", a.MANIFEST_PARSED = "hlsManifestParsed", a.LEVEL_SWITCHING = "hlsLevelSwitching", a.LEVEL_SWITCHED = "hlsLevelSwitched", a.LEVEL_LOADING = "hlsLevelLoading", a.LEVEL_LOADED = "hlsLevelLoaded", a.LEVEL_UPDATED = "hlsLevelUpdated", a.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", a.LEVELS_UPDATED = "hlsLevelsUpdated", a.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", a.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", a.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", a.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", a.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", a.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", a.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", a.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", a.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", a.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", a.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", a.CUES_PARSED = "hlsCuesParsed", a.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", a.INIT_PTS_FOUND = "hlsInitPtsFound", a.FRAG_LOADING = "hlsFragLoading", a.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", a.FRAG_LOADED = "hlsFragLoaded", a.FRAG_DECRYPTED = "hlsFragDecrypted", a.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", a.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", a.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", a.FRAG_PARSED = "hlsFragParsed", a.FRAG_BUFFERED = "hlsFragBuffered", a.FRAG_CHANGED = "hlsFragChanged", a.FPS_DROP = "hlsFpsDrop", a.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", a.ERROR = "hlsError", a.DESTROYING = "hlsDestroying", a.KEY_LOADING = "hlsKeyLoading", a.KEY_LOADED = "hlsKeyLoaded", a.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", a.BACK_BUFFER_REACHED = "hlsBackBufferReached", a;
}({}), U = /* @__PURE__ */ function(a) {
  return a.NETWORK_ERROR = "networkError", a.MEDIA_ERROR = "mediaError", a.KEY_SYSTEM_ERROR = "keySystemError", a.MUX_ERROR = "muxError", a.OTHER_ERROR = "otherError", a;
}({}), L = /* @__PURE__ */ function(a) {
  return a.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", a.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", a.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", a.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", a.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", a.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", a.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", a.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", a.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", a.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", a.MANIFEST_LOAD_ERROR = "manifestLoadError", a.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", a.MANIFEST_PARSING_ERROR = "manifestParsingError", a.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", a.LEVEL_EMPTY_ERROR = "levelEmptyError", a.LEVEL_LOAD_ERROR = "levelLoadError", a.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", a.LEVEL_PARSING_ERROR = "levelParsingError", a.LEVEL_SWITCH_ERROR = "levelSwitchError", a.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", a.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", a.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", a.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", a.FRAG_LOAD_ERROR = "fragLoadError", a.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", a.FRAG_DECRYPT_ERROR = "fragDecryptError", a.FRAG_PARSING_ERROR = "fragParsingError", a.FRAG_GAP = "fragGap", a.REMUX_ALLOC_ERROR = "remuxAllocError", a.KEY_LOAD_ERROR = "keyLoadError", a.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", a.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", a.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", a.BUFFER_APPEND_ERROR = "bufferAppendError", a.BUFFER_APPENDING_ERROR = "bufferAppendingError", a.BUFFER_STALLED_ERROR = "bufferStalledError", a.BUFFER_FULL_ERROR = "bufferFullError", a.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", a.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", a.INTERNAL_EXCEPTION = "internalException", a.INTERNAL_ABORTED = "aborted", a.UNKNOWN = "unknown", a;
}({});
const Je = function() {
}, Es = {
  trace: Je,
  debug: Je,
  log: Je,
  warn: Je,
  info: Je,
  error: Je
};
let yt = Es;
function Rn(a) {
  const e = self.console[a];
  return e ? e.bind(self.console, `[${a}] >`) : Je;
}
function In(a, ...e) {
  e.forEach(function(t) {
    yt[t] = a[t] ? a[t].bind(a) : Rn(t);
  });
}
function wn(a, e) {
  if (self.console && a === !0 || typeof a == "object") {
    In(
      a,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      yt.log(`Debug logs enabled for "${e}" in hls.js version 1.4.12`);
    } catch {
      yt = Es;
    }
  } else
    yt = Es;
}
const E = yt, _n = /^(\d+)x(\d+)$/, ai = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class ee {
  constructor(e) {
    typeof e == "string" && (e = ee.parseAttrList(e));
    for (const t in e)
      e.hasOwnProperty(t) && (t.substring(0, 2) === "X-" && (this.clientAttrs = this.clientAttrs || [], this.clientAttrs.push(t)), this[t] = e[t]);
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const s = new Uint8Array(t.length / 2);
      for (let i = 0; i < t.length / 2; i++)
        s[i] = parseInt(t.slice(i * 2, i * 2 + 2), 16);
      return s;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const s = this[e];
    return s ? parseFloat(s) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = _n.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e) {
    let t;
    const s = {}, i = '"';
    for (ai.lastIndex = 0; (t = ai.exec(e)) !== null; ) {
      let r = t[2];
      r.indexOf(i) === 0 && r.lastIndexOf(i) === r.length - 1 && (r = r.slice(1, -1));
      const n = t[1].trim();
      s[n] = r;
    }
    return s;
  }
}
function Cn(a) {
  return a !== "ID" && a !== "CLASS" && a !== "START-DATE" && a !== "DURATION" && a !== "END-DATE" && a !== "END-ON-NEXT";
}
function Dn(a) {
  return a === "SCTE35-OUT" || a === "SCTE35-IN";
}
class dr {
  constructor(e, t) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
      const s = t.attr;
      for (const i in s)
        if (Object.prototype.hasOwnProperty.call(e, i) && e[i] !== s[i]) {
          E.warn(`DATERANGE tag attribute: "${i}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = i;
          break;
        }
      e = ae(new ee({}), s, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const s = new Date(this.attr["END-DATE"]);
      M(s.getTime()) && (this._endDate = s);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (M(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && M(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class zt {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var q = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class ur {
  // baseurl is the URL to the playlist
  // relurl is the portion of the URL that comes from inside the playlist.
  // Holds the types of data this fragment supports
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [q.AUDIO]: null,
      [q.VIDEO]: null,
      [q.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const s = e.split("@", 2), i = [];
    s.length === 1 ? i[0] = t ? t.byteRangeEndOffset : 0 : i[0] = parseInt(s[1]), i[1] = parseInt(s[0]) + i[0], this._byteRange = i;
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = Ns.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class Qt extends ur {
  // EXTINF has to be present for a m3u8 to be considered valid
  // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
  // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
  // core difference from the private field _decryptdata is the lack of the initialized IV
  // _decryptdata will set the IV for this segment based on the segment number in the fragment
  // A string representing the fragment type
  // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
  // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
  // The level/track index to which the fragment belongs
  // The continuity counter of the fragment
  // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
  // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
  // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
  // Set by `updateFragPTSDTS` in level-helper
  // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
  // Load/parse timing information
  // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
  // #EXTINF  segment title
  // The Media Initialization Section for this segment
  // Fragment is the last fragment in the media playlist
  // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
  constructor(e, t) {
    super(t), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new zt(), this.urlId = 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const s = Object.keys(this.levelkeys);
        if (s.length === 1)
          return this._decryptdata = this.levelkeys[s[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !M(this.programDateTime))
      return null;
    const e = M(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), s = t.length;
      if (s > 1 || s === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, s, i, r, n = !1) {
    const {
      elementaryStreams: o
    } = this, l = o[e];
    if (!l) {
      o[e] = {
        startPTS: t,
        endPTS: s,
        startDTS: i,
        endDTS: r,
        partial: n
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, s), l.startDTS = Math.min(l.startDTS, i), l.endDTS = Math.max(l.endDTS, r);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[q.AUDIO] = null, e[q.VIDEO] = null, e[q.AUDIOVIDEO] = null;
  }
}
class kn extends ur {
  constructor(e, t, s, i, r) {
    super(s), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new zt(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = i;
    const n = e.enumeratedString("BYTERANGE");
    n && this.setByteRange(n, r), r && (this.fragOffset = r.fragOffset + r.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const Pn = 10;
class On {
  // Manifest reload synchronization
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, s = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!s || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && s > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? M(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || Pn;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function Us(a) {
  return Uint8Array.from(atob(a), (e) => e.charCodeAt(0));
}
function Fn(a) {
  const e = fr(a).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function Mn(a) {
  const e = function(s, i, r) {
    const n = s[i];
    s[i] = s[r], s[r] = n;
  };
  e(a, 0, 3), e(a, 1, 2), e(a, 4, 5), e(a, 6, 7);
}
function Nn(a) {
  const e = a.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const s = e[1].split(";"), i = s[s.length - 1].split(",");
    if (i.length === 2) {
      const r = i[0] === "base64", n = i[1];
      r ? (s.splice(-1, 1), t = Us(n)) : t = Fn(n);
    }
  }
  return t;
}
function fr(a) {
  return Uint8Array.from(unescape(encodeURIComponent(a)), (e) => e.charCodeAt(0));
}
var se = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, Ee = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function oi(a) {
  switch (a) {
    case Ee.FAIRPLAY:
      return se.FAIRPLAY;
    case Ee.PLAYREADY:
      return se.PLAYREADY;
    case Ee.WIDEVINE:
      return se.WIDEVINE;
    case Ee.CLEARKEY:
      return se.CLEARKEY;
  }
}
var gr = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function Un(a) {
  if (a === gr.WIDEVINE)
    return se.WIDEVINE;
}
function li(a) {
  switch (a) {
    case se.FAIRPLAY:
      return Ee.FAIRPLAY;
    case se.PLAYREADY:
      return Ee.PLAYREADY;
    case se.WIDEVINE:
      return Ee.WIDEVINE;
    case se.CLEARKEY:
      return Ee.CLEARKEY;
  }
}
function Jt(a) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = a, s = e ? [se.FAIRPLAY, se.WIDEVINE, se.PLAYREADY, se.CLEARKEY].filter((i) => !!e[i]) : [];
  return !s[se.WIDEVINE] && t && s.push(se.WIDEVINE), s;
}
const mr = function() {
  return typeof self < "u" && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function $n(a, e, t, s) {
  let i;
  switch (a) {
    case se.FAIRPLAY:
      i = ["cenc", "sinf"];
      break;
    case se.WIDEVINE:
    case se.PLAYREADY:
      i = ["cenc"];
      break;
    case se.CLEARKEY:
      i = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${a}`);
  }
  return Bn(i, e, t, s);
}
function Bn(a, e, t, s) {
  return [{
    initDataTypes: a,
    persistentState: s.persistentState || "not-allowed",
    distinctiveIdentifier: s.distinctiveIdentifier || "not-allowed",
    sessionTypes: s.sessionTypes || [s.sessionType || "temporary"],
    audioCapabilities: e.map((r) => ({
      contentType: `audio/mp4; codecs="${r}"`,
      robustness: s.audioRobustness || "",
      encryptionScheme: s.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((r) => ({
      contentType: `video/mp4; codecs="${r}"`,
      robustness: s.videoRobustness || "",
      encryptionScheme: s.videoEncryptionScheme || null
    }))
  }];
}
function et(a, e, t) {
  return Uint8Array.prototype.slice ? a.slice(e, t) : new Uint8Array(Array.prototype.slice.call(a, e, t));
}
const $s = (a, e) => e + 10 <= a.length && a[e] === 73 && a[e + 1] === 68 && a[e + 2] === 51 && a[e + 3] < 255 && a[e + 4] < 255 && a[e + 6] < 128 && a[e + 7] < 128 && a[e + 8] < 128 && a[e + 9] < 128, pr = (a, e) => e + 10 <= a.length && a[e] === 51 && a[e + 1] === 68 && a[e + 2] === 73 && a[e + 3] < 255 && a[e + 4] < 255 && a[e + 6] < 128 && a[e + 7] < 128 && a[e + 8] < 128 && a[e + 9] < 128, Ut = (a, e) => {
  const t = e;
  let s = 0;
  for (; $s(a, e); ) {
    s += 10;
    const i = jt(a, e + 6);
    s += i, pr(a, e + 10) && (s += 10), e += s;
  }
  if (s > 0)
    return a.subarray(t, t + s);
}, jt = (a, e) => {
  let t = 0;
  return t = (a[e] & 127) << 21, t |= (a[e + 1] & 127) << 14, t |= (a[e + 2] & 127) << 7, t |= a[e + 3] & 127, t;
}, Gn = (a, e) => $s(a, e) && jt(a, e + 6) + 10 <= a.length - e, Vn = (a) => {
  const e = yr(a);
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    if (vr(s))
      return jn(s);
  }
}, vr = (a) => a && a.key === "PRIV" && a.info === "com.apple.streaming.transportStreamTimestamp", Hn = (a) => {
  const e = String.fromCharCode(a[0], a[1], a[2], a[3]), t = jt(a, 4), s = 10;
  return {
    type: e,
    size: t,
    data: a.subarray(s, s + t)
  };
}, yr = (a) => {
  let e = 0;
  const t = [];
  for (; $s(a, e); ) {
    const s = jt(a, e + 6);
    e += 10;
    const i = e + s;
    for (; e + 8 < i; ) {
      const r = Hn(a.subarray(e)), n = Kn(r);
      n && t.push(n), e += r.size + 10;
    }
    pr(a, e) && (e += 10);
  }
  return t;
}, Kn = (a) => a.type === "PRIV" ? Wn(a) : a.type[0] === "W" ? zn(a) : Yn(a), Wn = (a) => {
  if (a.size < 2)
    return;
  const e = $e(a.data, !0), t = new Uint8Array(a.data.subarray(e.length + 1));
  return {
    key: a.type,
    info: e,
    data: t.buffer
  };
}, Yn = (a) => {
  if (a.size < 2)
    return;
  if (a.type === "TXXX") {
    let t = 1;
    const s = $e(a.data.subarray(t), !0);
    t += s.length + 1;
    const i = $e(a.data.subarray(t));
    return {
      key: a.type,
      info: s,
      data: i
    };
  }
  const e = $e(a.data.subarray(1));
  return {
    key: a.type,
    data: e
  };
}, zn = (a) => {
  if (a.type === "WXXX") {
    if (a.size < 2)
      return;
    let t = 1;
    const s = $e(a.data.subarray(t), !0);
    t += s.length + 1;
    const i = $e(a.data.subarray(t));
    return {
      key: a.type,
      info: s,
      data: i
    };
  }
  const e = $e(a.data);
  return {
    key: a.type,
    data: e
  };
}, jn = (a) => {
  if (a.data.byteLength === 8) {
    const e = new Uint8Array(a.data), t = e[3] & 1;
    let s = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return s /= 45, t && (s += 4772185884e-2), Math.round(s);
  }
}, $e = (a, e = !1) => {
  const t = qn();
  if (t) {
    const h = t.decode(a);
    if (e) {
      const c = h.indexOf("\0");
      return c !== -1 ? h.substring(0, c) : h;
    }
    return h.replace(/\0/g, "");
  }
  const s = a.length;
  let i, r, n, o = "", l = 0;
  for (; l < s; ) {
    if (i = a[l++], i === 0 && e)
      return o;
    if (i === 0 || i === 3)
      continue;
    switch (i >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        o += String.fromCharCode(i);
        break;
      case 12:
      case 13:
        r = a[l++], o += String.fromCharCode((i & 31) << 6 | r & 63);
        break;
      case 14:
        r = a[l++], n = a[l++], o += String.fromCharCode((i & 15) << 12 | (r & 63) << 6 | (n & 63) << 0);
        break;
    }
  }
  return o;
};
let es;
function qn() {
  return !es && typeof self.TextDecoder < "u" && (es = new self.TextDecoder("utf-8")), es;
}
const Me = {
  hexDump: function(a) {
    let e = "";
    for (let t = 0; t < a.length; t++) {
      let s = a[t].toString(16);
      s.length < 2 && (s = "0" + s), e += s;
    }
    return e;
  }
}, $t = Math.pow(2, 32) - 1, Xn = [].push, Tr = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function de(a) {
  return String.fromCharCode.apply(null, a);
}
function xr(a, e) {
  const t = a[e] << 8 | a[e + 1];
  return t < 0 ? 65536 + t : t;
}
function B(a, e) {
  const t = Er(a, e);
  return t < 0 ? 4294967296 + t : t;
}
function Er(a, e) {
  return a[e] << 24 | a[e + 1] << 16 | a[e + 2] << 8 | a[e + 3];
}
function ts(a, e, t) {
  a[e] = t >> 24, a[e + 1] = t >> 16 & 255, a[e + 2] = t >> 8 & 255, a[e + 3] = t & 255;
}
function H(a, e) {
  const t = [];
  if (!e.length)
    return t;
  const s = a.byteLength;
  for (let i = 0; i < s; ) {
    const r = B(a, i), n = de(a.subarray(i + 4, i + 8)), o = r > 1 ? i + r : s;
    if (n === e[0])
      if (e.length === 1)
        t.push(a.subarray(i + 8, o));
      else {
        const l = H(a.subarray(i + 8, o), e.slice(1));
        l.length && Xn.apply(t, l);
      }
    i = o;
  }
  return t;
}
function Zn(a) {
  const e = [], t = a[0];
  let s = 8;
  const i = B(a, s);
  s += 4;
  const r = 0, n = 0;
  t === 0 ? s += 8 : s += 16, s += 2;
  let o = a.length + n;
  const l = xr(a, s);
  s += 2;
  for (let h = 0; h < l; h++) {
    let c = s;
    const d = B(a, c);
    c += 4;
    const u = d & 2147483647;
    if ((d & 2147483648) >>> 31 === 1)
      return E.warn("SIDX has hierarchical references (not supported)"), null;
    const g = B(a, c);
    c += 4, e.push({
      referenceSize: u,
      subsegmentDuration: g,
      // unscaled
      info: {
        duration: g / i,
        start: o,
        end: o + u - 1
      }
    }), o += u, c += 4, s = c;
  }
  return {
    earliestPresentationTime: r,
    timescale: i,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Sr(a) {
  const e = [], t = H(a, ["moov", "trak"]);
  for (let i = 0; i < t.length; i++) {
    const r = t[i], n = H(r, ["tkhd"])[0];
    if (n) {
      let o = n[0], l = o === 0 ? 12 : 20;
      const h = B(n, l), c = H(r, ["mdia", "mdhd"])[0];
      if (c) {
        o = c[0], l = o === 0 ? 12 : 20;
        const d = B(c, l), u = H(r, ["mdia", "hdlr"])[0];
        if (u) {
          const f = de(u.subarray(8, 12)), g = {
            soun: q.AUDIO,
            vide: q.VIDEO
          }[f];
          if (g) {
            const p = H(r, ["mdia", "minf", "stbl", "stsd"])[0];
            let v;
            p && (v = de(p.subarray(12, 16))), e[h] = {
              timescale: d,
              type: g
            }, e[g] = {
              timescale: d,
              id: h,
              codec: v
            };
          }
        }
      }
    }
  }
  return H(a, ["moov", "mvex", "trex"]).forEach((i) => {
    const r = B(i, 4), n = e[r];
    n && (n.default = {
      duration: B(i, 12),
      flags: B(i, 20)
    });
  }), e;
}
function Qn(a, e) {
  if (!a || !e)
    return a;
  const t = e.keyId;
  return t && e.isCommonEncryption && H(a, ["moov", "trak"]).forEach((i) => {
    const n = H(i, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let o = H(n, ["enca"]);
    const l = o.length > 0;
    l || (o = H(n, ["encv"])), o.forEach((h) => {
      const c = l ? h.subarray(28) : h.subarray(78);
      H(c, ["sinf"]).forEach((u) => {
        const f = br(u);
        if (f) {
          const g = f.subarray(8, 24);
          g.some((p) => p !== 0) || (E.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${Me.hexDump(g)} -> ${Me.hexDump(t)}`), f.set(t, 8));
        }
      });
    });
  }), a;
}
function br(a) {
  const e = H(a, ["schm"])[0];
  if (e) {
    const t = de(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return H(a, ["schi", "tenc"])[0];
  }
  return E.error("[eme] missing 'schm' box"), null;
}
function Jn(a, e) {
  return H(e, ["moof", "traf"]).reduce((t, s) => {
    const i = H(s, ["tfdt"])[0], r = i[0], n = H(s, ["tfhd"]).reduce((o, l) => {
      const h = B(l, 4), c = a[h];
      if (c) {
        let d = B(i, 4);
        if (r === 1) {
          if (d === $t)
            return E.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), o;
          d *= $t + 1, d += B(i, 8);
        }
        const u = c.timescale || 9e4, f = d / u;
        if (isFinite(f) && (o === null || f < o))
          return f;
      }
      return o;
    }, null);
    return n !== null && isFinite(n) && (t === null || n < t) ? n : t;
  }, null);
}
function ea(a, e) {
  let t = 0, s = 0, i = 0;
  const r = H(a, ["moof", "traf"]);
  for (let n = 0; n < r.length; n++) {
    const o = r[n], l = H(o, ["tfhd"])[0], h = B(l, 4), c = e[h];
    if (!c)
      continue;
    const d = c.default, u = B(l, 0) | (d == null ? void 0 : d.flags);
    let f = d == null ? void 0 : d.duration;
    u & 8 && (u & 2 ? f = B(l, 12) : f = B(l, 8));
    const g = c.timescale || 9e4, p = H(o, ["trun"]);
    for (let v = 0; v < p.length; v++) {
      if (t = ta(p[v]), !t && f) {
        const y = B(p[v], 4);
        t = f * y;
      }
      c.type === q.VIDEO ? s += t / g : c.type === q.AUDIO && (i += t / g);
    }
  }
  if (s === 0 && i === 0) {
    let n = 0;
    const o = H(a, ["sidx"]);
    for (let l = 0; l < o.length; l++) {
      const h = Zn(o[l]);
      h != null && h.references && (n += h.references.reduce((c, d) => c + d.info.duration || 0, 0));
    }
    return n;
  }
  return s || i;
}
function ta(a) {
  const e = B(a, 0);
  let t = 8;
  e & 1 && (t += 4), e & 4 && (t += 4);
  let s = 0;
  const i = B(a, 4);
  for (let r = 0; r < i; r++) {
    if (e & 256) {
      const n = B(a, t);
      s += n, t += 4;
    }
    e & 512 && (t += 4), e & 1024 && (t += 4), e & 2048 && (t += 4);
  }
  return s;
}
function sa(a, e, t) {
  H(e, ["moof", "traf"]).forEach((s) => {
    H(s, ["tfhd"]).forEach((i) => {
      const r = B(i, 4), n = a[r];
      if (!n)
        return;
      const o = n.timescale || 9e4;
      H(s, ["tfdt"]).forEach((l) => {
        const h = l[0];
        let c = B(l, 4);
        if (h === 0)
          c -= t * o, c = Math.max(c, 0), ts(l, 4, c);
        else {
          c *= Math.pow(2, 32), c += B(l, 8), c -= t * o, c = Math.max(c, 0);
          const d = Math.floor(c / ($t + 1)), u = Math.floor(c % ($t + 1));
          ts(l, 4, d), ts(l, 8, u);
        }
      });
    });
  });
}
function ia(a) {
  const e = {
    valid: null,
    remainder: null
  }, t = H(a, ["moof"]);
  if (t) {
    if (t.length < 2)
      return e.remainder = a, e;
  } else
    return e;
  const s = t[t.length - 1];
  return e.valid = et(a, 0, s.byteOffset - 8), e.remainder = et(a, s.byteOffset - 8), e;
}
function tt(a, e) {
  const t = new Uint8Array(a.length + e.length);
  return t.set(a), t.set(e, a.length), t;
}
function hi(a, e) {
  const t = [], s = e.samples, i = e.timescale, r = e.id;
  let n = !1;
  return H(s, ["moof"]).map((l) => {
    const h = l.byteOffset - 8;
    H(l, ["traf"]).map((d) => {
      const u = H(d, ["tfdt"]).map((f) => {
        const g = f[0];
        let p = B(f, 4);
        return g === 1 && (p *= Math.pow(2, 32), p += B(f, 8)), p / i;
      })[0];
      return u !== void 0 && (a = u), H(d, ["tfhd"]).map((f) => {
        const g = B(f, 4), p = B(f, 0) & 16777215, v = (p & 1) !== 0, y = (p & 2) !== 0, T = (p & 8) !== 0;
        let x = 0;
        const A = (p & 16) !== 0;
        let b = 0;
        const C = (p & 32) !== 0;
        let I = 8;
        g === r && (v && (I += 8), y && (I += 4), T && (x = B(f, I), I += 4), A && (b = B(f, I), I += 4), C && (I += 4), e.type === "video" && (n = ra(e.codec)), H(d, ["trun"]).map((_) => {
          const D = _[0], R = B(_, 0) & 16777215, F = (R & 1) !== 0;
          let P = 0;
          const W = (R & 4) !== 0, le = (R & 256) !== 0;
          let V = 0;
          const Y = (R & 512) !== 0;
          let X = 0;
          const O = (R & 1024) !== 0, N = (R & 2048) !== 0;
          let Z = 0;
          const Q = B(_, 4);
          let z = 8;
          F && (P = B(_, z), z += 4), W && (z += 4);
          let ne = P + h;
          for (let Re = 0; Re < Q; Re++) {
            if (le ? (V = B(_, z), z += 4) : V = x, Y ? (X = B(_, z), z += 4) : X = b, O && (z += 4), N && (D === 0 ? Z = B(_, z) : Z = Er(_, z), z += 4), e.type === q.VIDEO) {
              let De = 0;
              for (; De < X; ) {
                const Ie = B(s, ne);
                if (ne += 4, na(n, s[ne])) {
                  const Ze = s.subarray(ne, ne + Ie);
                  Lr(Ze, n ? 2 : 1, a + Z / i, t);
                }
                ne += Ie, De += Ie + 4;
              }
            }
            a += V / i;
          }
        }));
      });
    });
  }), t;
}
function ra(a) {
  if (!a)
    return !1;
  const e = a.indexOf("."), t = e < 0 ? a : a.substring(0, e);
  return t === "hvc1" || t === "hev1" || // Dolby Vision
  t === "dvh1" || t === "dvhe";
}
function na(a, e) {
  if (a) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function Lr(a, e, t, s) {
  const i = Ar(a);
  let r = 0;
  r += e;
  let n = 0, o = 0, l = !1, h = 0;
  for (; r < i.length; ) {
    n = 0;
    do {
      if (r >= i.length)
        break;
      h = i[r++], n += h;
    } while (h === 255);
    o = 0;
    do {
      if (r >= i.length)
        break;
      h = i[r++], o += h;
    } while (h === 255);
    const c = i.length - r;
    if (!l && n === 4 && r < i.length) {
      if (l = !0, i[r++] === 181) {
        const u = xr(i, r);
        if (r += 2, u === 49) {
          const f = B(i, r);
          if (r += 4, f === 1195456820) {
            const g = i[r++];
            if (g === 3) {
              const p = i[r++], v = 31 & p, y = 64 & p, T = y ? 2 + v * 3 : 0, x = new Uint8Array(T);
              if (y) {
                x[0] = p;
                for (let A = 1; A < T; A++)
                  x[A] = i[r++];
              }
              s.push({
                type: g,
                payloadType: n,
                pts: t,
                bytes: x
              });
            }
          }
        }
      }
    } else if (n === 5 && o < c) {
      if (l = !0, o > 16) {
        const d = [];
        for (let g = 0; g < 16; g++) {
          const p = i[r++].toString(16);
          d.push(p.length == 1 ? "0" + p : p), (g === 3 || g === 5 || g === 7 || g === 9) && d.push("-");
        }
        const u = o - 16, f = new Uint8Array(u);
        for (let g = 0; g < u; g++)
          f[g] = i[r++];
        s.push({
          payloadType: n,
          pts: t,
          uuid: d.join(""),
          userData: $e(f),
          userDataBytes: f
        });
      }
    } else if (o < c)
      r += o;
    else if (o > c)
      break;
  }
}
function Ar(a) {
  const e = a.byteLength, t = [];
  let s = 1;
  for (; s < e - 2; )
    a[s] === 0 && a[s + 1] === 0 && a[s + 2] === 3 ? (t.push(s + 2), s += 2) : s++;
  if (t.length === 0)
    return a;
  const i = e - t.length, r = new Uint8Array(i);
  let n = 0;
  for (s = 0; s < i; n++, s++)
    n === t[0] && (n++, t.shift()), r[s] = a[n];
  return r;
}
function aa(a) {
  const e = a[0];
  let t = "", s = "", i = 0, r = 0, n = 0, o = 0, l = 0, h = 0;
  if (e === 0) {
    for (; de(a.subarray(h, h + 1)) !== "\0"; )
      t += de(a.subarray(h, h + 1)), h += 1;
    for (t += de(a.subarray(h, h + 1)), h += 1; de(a.subarray(h, h + 1)) !== "\0"; )
      s += de(a.subarray(h, h + 1)), h += 1;
    s += de(a.subarray(h, h + 1)), h += 1, i = B(a, 12), r = B(a, 16), o = B(a, 20), l = B(a, 24), h = 28;
  } else if (e === 1) {
    h += 4, i = B(a, h), h += 4;
    const d = B(a, h);
    h += 4;
    const u = B(a, h);
    for (h += 4, n = 2 ** 32 * d + u, Number.isSafeInteger(n) || (n = Number.MAX_SAFE_INTEGER, E.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), o = B(a, h), h += 4, l = B(a, h), h += 4; de(a.subarray(h, h + 1)) !== "\0"; )
      t += de(a.subarray(h, h + 1)), h += 1;
    for (t += de(a.subarray(h, h + 1)), h += 1; de(a.subarray(h, h + 1)) !== "\0"; )
      s += de(a.subarray(h, h + 1)), h += 1;
    s += de(a.subarray(h, h + 1)), h += 1;
  }
  const c = a.subarray(h, a.byteLength);
  return {
    schemeIdUri: t,
    value: s,
    timeScale: i,
    presentationTime: n,
    presentationTimeDelta: r,
    eventDuration: o,
    id: l,
    payload: c
  };
}
function oa(a, ...e) {
  const t = e.length;
  let s = 8, i = t;
  for (; i--; )
    s += e[i].byteLength;
  const r = new Uint8Array(s);
  for (r[0] = s >> 24 & 255, r[1] = s >> 16 & 255, r[2] = s >> 8 & 255, r[3] = s & 255, r.set(a, 4), i = 0, s = 8; i < t; i++)
    r.set(e[i], s), s += e[i].byteLength;
  return r;
}
function la(a, e, t) {
  if (a.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let s, i;
  if (e) {
    s = 1, i = new Uint8Array(e.length * 16);
    for (let o = 0; o < e.length; o++) {
      const l = e[o];
      if (l.byteLength !== 16)
        throw new RangeError("Invalid key");
      i.set(l, o * 16);
    }
  } else
    s = 0, i = new Uint8Array();
  let r;
  s > 0 ? (r = new Uint8Array(4), e.length > 0 && new DataView(r.buffer).setUint32(0, e.length, !1)) : r = new Uint8Array();
  const n = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(n.buffer).setUint32(0, t.byteLength, !1), oa(
    [112, 115, 115, 104],
    new Uint8Array([
      s,
      0,
      0,
      0
      // Flags
    ]),
    a,
    // 16 bytes
    r,
    i,
    n,
    t || new Uint8Array()
  );
}
function ha(a) {
  if (!(a instanceof ArrayBuffer) || a.byteLength < 32)
    return null;
  const e = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, t = new DataView(a), s = t.getUint32(0);
  if (a.byteLength !== s && s > 44 || t.getUint32(4) !== 1886614376 || (e.version = t.getUint32(8) >>> 24, e.version > 1))
    return null;
  e.systemId = Me.hexDump(new Uint8Array(a, 12, 16));
  const r = t.getUint32(28);
  if (e.version === 0) {
    if (s - 32 < r)
      return null;
    e.data = new Uint8Array(a, 32, r);
  } else if (e.version === 1) {
    e.kids = [];
    for (let n = 0; n < r; n++)
      e.kids.push(new Uint8Array(a, 32 + n * 16, 16));
  }
  return e;
}
let It = {};
class xt {
  static clearKeyUriToKeyIdMap() {
    It = {};
  }
  constructor(e, t, s, i = [1], r = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = s, this.keyFormatVersions = i, this.iv = r, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case Ee.FAIRPLAY:
        case Ee.WIDEVINE:
        case Ee.PLAYREADY:
        case Ee.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && E.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const s = ca(e);
      return new xt(this.method, this.uri, "identity", this.keyFormatVersions, s);
    }
    const t = Nn(this.uri);
    if (t)
      switch (this.keyFormat) {
        case Ee.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case Ee.PLAYREADY: {
          const s = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = la(s, null, t);
          const i = new Uint16Array(t.buffer, t.byteOffset, t.byteLength / 2), r = String.fromCharCode.apply(null, Array.from(i)), n = r.substring(r.indexOf("<"), r.length), h = new DOMParser().parseFromString(n, "text/xml").getElementsByTagName("KID")[0];
          if (h) {
            const c = h.childNodes[0] ? h.childNodes[0].nodeValue : h.getAttribute("VALUE");
            if (c) {
              const d = Us(c).subarray(0, 16);
              Mn(d), this.keyId = d;
            }
          }
          break;
        }
        default: {
          let s = t.subarray(0, 16);
          if (s.length !== 16) {
            const i = new Uint8Array(16);
            i.set(s, 16 - s.length), s = i;
          }
          this.keyId = s;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let s = It[this.uri];
      if (!s) {
        const i = Object.keys(It).length % Number.MAX_SAFE_INTEGER;
        s = new Uint8Array(16), new DataView(s.buffer, 12, 4).setUint32(0, i), It[this.uri] = s;
      }
      this.keyId = s;
    }
    return this;
  }
}
function ca(a) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = a >> 8 * (15 - t) & 255;
  return e;
}
const Rr = /\{\$([a-zA-Z0-9-_]+)\}/g;
function ci(a) {
  return Rr.test(a);
}
function xe(a, e, t) {
  if (a.variableList !== null || a.hasVariableRefs)
    for (let s = t.length; s--; ) {
      const i = t[s], r = e[i];
      r && (e[i] = Ss(a, r));
    }
}
function Ss(a, e) {
  if (a.variableList !== null || a.hasVariableRefs) {
    const t = a.variableList;
    return e.replace(Rr, (s) => {
      const i = s.substring(2, s.length - 1), r = t == null ? void 0 : t[i];
      return r === void 0 ? (a.playlistParsingError || (a.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${i}"`)), s) : r;
    });
  }
  return e;
}
function di(a, e, t) {
  let s = a.variableList;
  s || (a.variableList = s = {});
  let i, r;
  if ("QUERYPARAM" in e) {
    i = e.QUERYPARAM;
    try {
      const n = new self.URL(t).searchParams;
      if (n.has(i))
        r = n.get(i);
      else
        throw new Error(`"${i}" does not match any query parameter in URI: "${t}"`);
    } catch (n) {
      a.playlistParsingError || (a.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${n.message}`));
    }
  } else
    i = e.NAME, r = e.VALUE;
  i in s ? a.playlistParsingError || (a.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${i}"`)) : s[i] = r || "";
}
function da(a, e, t) {
  const s = e.IMPORT;
  if (t && s in t) {
    let i = a.variableList;
    i || (a.variableList = i = {}), i[s] = t[s];
  } else
    a.playlistParsingError || (a.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${s}"`));
}
function qt() {
  if (!(typeof self > "u"))
    return self.MediaSource || self.WebKitMediaSource;
}
const ua = {
  audio: {
    a3ds: !0,
    "ac-3": !0,
    "ac-4": !0,
    alac: !0,
    alaw: !0,
    dra1: !0,
    "dts+": !0,
    "dts-": !0,
    dtsc: !0,
    dtse: !0,
    dtsh: !0,
    "ec-3": !0,
    enca: !0,
    g719: !0,
    g726: !0,
    m4ae: !0,
    mha1: !0,
    mha2: !0,
    mhm1: !0,
    mhm2: !0,
    mlpa: !0,
    mp4a: !0,
    "raw ": !0,
    Opus: !0,
    opus: !0,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: !0,
    sawb: !0,
    sawp: !0,
    sevc: !0,
    sqcp: !0,
    ssmv: !0,
    twos: !0,
    ulaw: !0
  },
  video: {
    avc1: !0,
    avc2: !0,
    avc3: !0,
    avc4: !0,
    avcp: !0,
    av01: !0,
    drac: !0,
    dva1: !0,
    dvav: !0,
    dvh1: !0,
    dvhe: !0,
    encv: !0,
    hev1: !0,
    hvc1: !0,
    mjp2: !0,
    mp4v: !0,
    mvc1: !0,
    mvc2: !0,
    mvc3: !0,
    mvc4: !0,
    resv: !0,
    rv60: !0,
    s263: !0,
    svc1: !0,
    svc2: !0,
    "vc-1": !0,
    vp08: !0,
    vp09: !0
  },
  text: {
    stpp: !0,
    wvtt: !0
  }
}, ui = qt();
function fa(a, e) {
  const t = ua[e];
  return !!t && t[a.slice(0, 4)] === !0;
}
function ss(a, e) {
  var t;
  return (t = ui == null ? void 0 : ui.isTypeSupported(`${e || "video"}/mp4;codecs="${a}"`)) != null ? t : !1;
}
const fi = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, gi = /#EXT-X-MEDIA:(.*)/g, ga = /^#EXT(?:INF|-X-TARGETDURATION):/m, mi = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[\S ]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), ma = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Oe {
  static findGroup(e, t) {
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      if (i.id === t)
        return i;
    }
  }
  static convertAVC1ToAVCOTI(e) {
    const t = e.split(".");
    if (t.length > 2) {
      let s = t.shift() + ".";
      return s += parseInt(t.shift()).toString(16), s += ("000" + parseInt(t.shift()).toString(16)).slice(-4), s;
    }
    return e;
  }
  static resolve(e, t) {
    return Ns.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return ga.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const s = ci(e), i = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: s
    }, r = [];
    fi.lastIndex = 0;
    let n;
    for (; (n = fi.exec(e)) != null; )
      if (n[1]) {
        var o;
        const h = new ee(n[1]);
        xe(i, h, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const c = Ss(i, n[2]), d = {
          attrs: h,
          bitrate: h.decimalInteger("AVERAGE-BANDWIDTH") || h.decimalInteger("BANDWIDTH"),
          name: h.NAME,
          url: Oe.resolve(c, t)
        }, u = h.decimalResolution("RESOLUTION");
        u && (d.width = u.width, d.height = u.height), pa((h.CODECS || "").split(/[ ,]+/).filter((f) => f), d), d.videoCodec && d.videoCodec.indexOf("avc1") !== -1 && (d.videoCodec = Oe.convertAVC1ToAVCOTI(d.videoCodec)), (o = d.unknownCodecs) != null && o.length || r.push(d), i.levels.push(d);
      } else if (n[3]) {
        const h = n[3], c = n[4];
        switch (h) {
          case "SESSION-DATA": {
            const d = new ee(c);
            xe(i, d, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const u = d["DATA-ID"];
            u && (i.sessionData === null && (i.sessionData = {}), i.sessionData[u] = d);
            break;
          }
          case "SESSION-KEY": {
            const d = pi(c, t, i);
            d.encrypted && d.isSupported() ? (i.sessionKeys === null && (i.sessionKeys = []), i.sessionKeys.push(d)) : E.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${c}"`);
            break;
          }
          case "DEFINE": {
            {
              const d = new ee(c);
              xe(i, d, ["NAME", "VALUE", "QUERYPARAM"]), di(i, d, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const d = new ee(c);
            xe(i, d, ["SERVER-URI", "PATHWAY-ID"]), i.contentSteering = {
              uri: Oe.resolve(d["SERVER-URI"], t),
              pathwayId: d["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            i.startTimeOffset = vi(c);
            break;
          }
        }
      }
    const l = r.length > 0 && r.length < i.levels.length;
    return i.levels = l ? r : i.levels, i.levels.length === 0 && (i.playlistParsingError = new Error("no levels found in manifest")), i;
  }
  static parseMasterPlaylistMedia(e, t, s) {
    let i;
    const r = {}, n = s.levels, o = {
      AUDIO: n.map((h) => ({
        id: h.attrs.AUDIO,
        audioCodec: h.audioCodec
      })),
      SUBTITLES: n.map((h) => ({
        id: h.attrs.SUBTITLES,
        textCodec: h.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (gi.lastIndex = 0; (i = gi.exec(e)) !== null; ) {
      const h = new ee(i[1]), c = h.TYPE;
      if (c) {
        const d = o[c], u = r[c] || [];
        r[c] = u, xe(s, h, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const f = {
          attrs: h,
          bitrate: 0,
          id: l++,
          groupId: h["GROUP-ID"] || "",
          instreamId: h["INSTREAM-ID"],
          name: h.NAME || h.LANGUAGE || "",
          type: c,
          default: h.bool("DEFAULT"),
          autoselect: h.bool("AUTOSELECT"),
          forced: h.bool("FORCED"),
          lang: h.LANGUAGE,
          url: h.URI ? Oe.resolve(h.URI, t) : ""
        };
        if (d != null && d.length) {
          const g = Oe.findGroup(d, f.groupId) || d[0];
          yi(f, g, "audioCodec"), yi(f, g, "textCodec");
        }
        u.push(f);
      }
    }
    return r;
  }
  static parseLevelPlaylist(e, t, s, i, r, n) {
    const o = new On(t), l = o.fragments;
    let h = null, c = 0, d = 0, u = 0, f = 0, g = null, p = new Qt(i, t), v, y, T, x = -1, A = !1;
    for (mi.lastIndex = 0, o.m3u8 = e, o.hasVariableRefs = ci(e); (v = mi.exec(e)) !== null; ) {
      A && (A = !1, p = new Qt(i, t), p.start = u, p.sn = c, p.cc = f, p.level = s, h && (p.initSegment = h, p.rawProgramDateTime = h.rawProgramDateTime, h.rawProgramDateTime = null));
      const _ = v[1];
      if (_) {
        p.duration = parseFloat(_);
        const D = (" " + v[2]).slice(1);
        p.title = D || null, p.tagList.push(D ? ["INF", _, D] : ["INF", _]);
      } else if (v[3]) {
        if (M(p.duration)) {
          p.start = u, T && Ei(p, T, o), p.sn = c, p.level = s, p.cc = f, p.urlId = r, l.push(p);
          const D = (" " + v[3]).slice(1);
          p.relurl = Ss(o, D), Ti(p, g), g = p, u += p.duration, c++, d = 0, A = !0;
        }
      } else if (v[4]) {
        const D = (" " + v[4]).slice(1);
        g ? p.setByteRange(D, g) : p.setByteRange(D);
      } else if (v[5])
        p.rawProgramDateTime = (" " + v[5]).slice(1), p.tagList.push(["PROGRAM-DATE-TIME", p.rawProgramDateTime]), x === -1 && (x = l.length);
      else {
        if (v = v[0].match(ma), !v) {
          E.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (y = 1; y < v.length && !(typeof v[y] < "u"); y++)
          ;
        const D = (" " + v[y]).slice(1), R = (" " + v[y + 1]).slice(1), F = v[y + 2] ? (" " + v[y + 2]).slice(1) : "";
        switch (D) {
          case "PLAYLIST-TYPE":
            o.type = R.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            c = o.startSN = parseInt(R);
            break;
          case "SKIP": {
            const P = new ee(R);
            xe(o, P, ["RECENTLY-REMOVED-DATERANGES"]);
            const W = P.decimalInteger("SKIPPED-SEGMENTS");
            if (M(W)) {
              o.skippedSegments = W;
              for (let V = W; V--; )
                l.unshift(null);
              c += W;
            }
            const le = P.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            le && (o.recentlyRemovedDateranges = le.split("	"));
            break;
          }
          case "TARGETDURATION":
            o.targetduration = Math.max(parseInt(R), 1);
            break;
          case "VERSION":
            o.version = parseInt(R);
            break;
          case "EXTM3U":
            break;
          case "ENDLIST":
            o.live = !1;
            break;
          case "#":
            (R || F) && p.tagList.push(F ? [R, F] : [R]);
            break;
          case "DISCONTINUITY":
            f++, p.tagList.push(["DIS"]);
            break;
          case "GAP":
            p.gap = !0, p.tagList.push([D]);
            break;
          case "BITRATE":
            p.tagList.push([D, R]);
            break;
          case "DATERANGE": {
            const P = new ee(R);
            xe(o, P, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), xe(o, P, P.clientAttrs);
            const W = new dr(P, o.dateRanges[P.ID]);
            W.isValid || o.skippedSegments ? o.dateRanges[W.id] = W : E.warn(`Ignoring invalid DATERANGE tag: "${R}"`), p.tagList.push(["EXT-X-DATERANGE", R]);
            break;
          }
          case "DEFINE": {
            {
              const P = new ee(R);
              xe(o, P, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in P ? da(o, P, n) : di(o, P, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            f = parseInt(R);
            break;
          case "KEY": {
            const P = pi(R, t, o);
            if (P.isSupported()) {
              if (P.method === "NONE") {
                T = void 0;
                break;
              }
              T || (T = {}), T[P.keyFormat] && (T = ae({}, T)), T[P.keyFormat] = P;
            } else
              E.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${R}"`);
            break;
          }
          case "START":
            o.startTimeOffset = vi(R);
            break;
          case "MAP": {
            const P = new ee(R);
            if (xe(o, P, ["BYTERANGE", "URI"]), p.duration) {
              const W = new Qt(i, t);
              xi(W, P, s, T), h = W, p.initSegment = h, h.rawProgramDateTime && !p.rawProgramDateTime && (p.rawProgramDateTime = h.rawProgramDateTime);
            } else
              xi(p, P, s, T), h = p, A = !0;
            break;
          }
          case "SERVER-CONTROL": {
            const P = new ee(R);
            o.canBlockReload = P.bool("CAN-BLOCK-RELOAD"), o.canSkipUntil = P.optionalFloat("CAN-SKIP-UNTIL", 0), o.canSkipDateRanges = o.canSkipUntil > 0 && P.bool("CAN-SKIP-DATERANGES"), o.partHoldBack = P.optionalFloat("PART-HOLD-BACK", 0), o.holdBack = P.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const P = new ee(R);
            o.partTarget = P.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let P = o.partList;
            P || (P = o.partList = []);
            const W = d > 0 ? P[P.length - 1] : void 0, le = d++, V = new ee(R);
            xe(o, V, ["BYTERANGE", "URI"]);
            const Y = new kn(V, p, t, le, W);
            P.push(Y), p.duration += Y.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const P = new ee(R);
            xe(o, P, ["URI"]), o.preloadHint = P;
            break;
          }
          case "RENDITION-REPORT": {
            const P = new ee(R);
            xe(o, P, ["URI"]), o.renditionReports = o.renditionReports || [], o.renditionReports.push(P);
            break;
          }
          default:
            E.warn(`line parsed but not handled: ${v}`);
            break;
        }
      }
    }
    g && !g.relurl ? (l.pop(), u -= g.duration, o.partList && (o.fragmentHint = g)) : o.partList && (Ti(p, g), p.cc = f, o.fragmentHint = p, T && Ei(p, T, o));
    const b = l.length, C = l[0], I = l[b - 1];
    if (u += o.skippedSegments * o.targetduration, u > 0 && b && I) {
      o.averagetargetduration = u / b;
      const _ = I.sn;
      o.endSN = _ !== "initSegment" ? _ : 0, o.live || (I.endList = !0), C && (o.startCC = C.cc);
    } else
      o.endSN = 0, o.startCC = 0;
    return o.fragmentHint && (u += o.fragmentHint.duration), o.totalduration = u, o.endCC = f, x > 0 && va(l, x), o;
  }
}
function pi(a, e, t) {
  var s, i;
  const r = new ee(a);
  xe(t, r, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const n = (s = r.METHOD) != null ? s : "", o = r.URI, l = r.hexadecimalInteger("IV"), h = r.KEYFORMATVERSIONS, c = (i = r.KEYFORMAT) != null ? i : "identity";
  o && r.IV && !l && E.error(`Invalid IV: ${r.IV}`);
  const d = o ? Oe.resolve(o, e) : "", u = (h || "1").split("/").map(Number).filter(Number.isFinite);
  return new xt(n, d, c, u, l);
}
function vi(a) {
  const t = new ee(a).decimalFloatingPoint("TIME-OFFSET");
  return M(t) ? t : null;
}
function pa(a, e) {
  ["video", "audio", "text"].forEach((t) => {
    const s = a.filter((i) => fa(i, t));
    if (s.length) {
      const i = s.filter((r) => r.lastIndexOf("avc1", 0) === 0 || r.lastIndexOf("mp4a", 0) === 0);
      e[`${t}Codec`] = i.length > 0 ? i[0] : s[0], a = a.filter((r) => s.indexOf(r) === -1);
    }
  }), e.unknownCodecs = a;
}
function yi(a, e, t) {
  const s = e[t];
  s && (a[t] = s);
}
function va(a, e) {
  let t = a[e];
  for (let s = e; s--; ) {
    const i = a[s];
    if (!i)
      return;
    i.programDateTime = t.programDateTime - i.duration * 1e3, t = i;
  }
}
function Ti(a, e) {
  a.rawProgramDateTime ? a.programDateTime = Date.parse(a.rawProgramDateTime) : e != null && e.programDateTime && (a.programDateTime = e.endProgramDateTime), M(a.programDateTime) || (a.programDateTime = null, a.rawProgramDateTime = null);
}
function xi(a, e, t, s) {
  a.relurl = e.URI, e.BYTERANGE && a.setByteRange(e.BYTERANGE), a.level = t, a.sn = "initSegment", s && (a.levelkeys = s), a.initSegment = null;
}
function Ei(a, e, t) {
  a.levelkeys = e;
  const {
    encryptedFragments: s
  } = t;
  (!s.length || s[s.length - 1].levelkeys !== e) && Object.keys(e).some((i) => e[i].isCommonEncryption) && s.push(a);
}
var K = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, $ = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function Si(a) {
  const {
    type: e
  } = a;
  switch (e) {
    case K.AUDIO_TRACK:
      return $.AUDIO;
    case K.SUBTITLE_TRACK:
      return $.SUBTITLE;
    default:
      return $.MAIN;
  }
}
function is(a, e) {
  let t = a.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class ya {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.LEVEL_LOADING, this.onLevelLoading, this), e.on(m.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(m.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.LEVEL_LOADING, this.onLevelLoading, this), e.off(m.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(m.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, s = t.pLoader, i = t.loader, r = s || i, n = new r(t);
    return this.loaders[e.type] = n, n;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: s
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: K.MANIFEST,
      url: s,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: s,
      level: i,
      url: r,
      deliveryDirectives: n
    } = t;
    this.load({
      id: s,
      level: i,
      responseType: "text",
      type: K.LEVEL,
      url: r,
      deliveryDirectives: n
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: s,
      groupId: i,
      url: r,
      deliveryDirectives: n
    } = t;
    this.load({
      id: s,
      groupId: i,
      level: null,
      responseType: "text",
      type: K.AUDIO_TRACK,
      url: r,
      deliveryDirectives: n
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: s,
      groupId: i,
      url: r,
      deliveryDirectives: n
    } = t;
    this.load({
      id: s,
      groupId: i,
      level: null,
      responseType: "text",
      type: K.SUBTITLE_TRACK,
      url: r,
      deliveryDirectives: n
    });
  }
  load(e) {
    var t;
    const s = this.hls.config;
    let i = this.getInternalLoader(e);
    if (i) {
      const h = i.context;
      if (h && h.url === e.url) {
        E.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      E.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), i.abort();
    }
    let r;
    if (e.type === K.MANIFEST ? r = s.manifestLoadPolicy.default : r = ae({}, s.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), i = this.createInternalLoader(e), (t = e.deliveryDirectives) != null && t.part) {
      let h;
      if (e.type === K.LEVEL && e.level !== null ? h = this.hls.levels[e.level].details : e.type === K.AUDIO_TRACK && e.id !== null ? h = this.hls.audioTracks[e.id].details : e.type === K.SUBTITLE_TRACK && e.id !== null && (h = this.hls.subtitleTracks[e.id].details), h) {
        const c = h.partTarget, d = h.targetduration;
        if (c && d) {
          const u = Math.max(c * 3, d * 0.8) * 1e3;
          r = ae({}, r, {
            maxTimeToFirstByteMs: Math.min(u, r.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(u, r.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const n = r.errorRetry || r.timeoutRetry || {}, o = {
      loadPolicy: r,
      timeout: r.maxLoadTimeMs,
      maxRetry: n.maxNumRetry || 0,
      retryDelay: n.retryDelayMs || 0,
      maxRetryDelay: n.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (h, c, d, u) => {
        const f = this.getInternalLoader(d);
        this.resetInternalLoader(d.type);
        const g = h.data;
        if (g.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(h, d, new Error("no EXTM3U delimiter"), u || null, c);
          return;
        }
        c.parsing.start = performance.now(), Oe.isMediaPlaylist(g) ? this.handleTrackOrLevelPlaylist(h, c, d, u || null, f) : this.handleMasterPlaylist(h, c, d, u);
      },
      onError: (h, c, d, u) => {
        this.handleNetworkError(c, d, !1, h, u);
      },
      onTimeout: (h, c, d) => {
        this.handleNetworkError(c, d, !0, void 0, h);
      }
    };
    i.load(e, o, l);
  }
  handleMasterPlaylist(e, t, s, i) {
    const r = this.hls, n = e.data, o = is(e, s), l = Oe.parseMasterPlaylist(n, o);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, s, l.playlistParsingError, i, t);
      return;
    }
    const {
      contentSteering: h,
      levels: c,
      sessionData: d,
      sessionKeys: u,
      startTimeOffset: f,
      variableList: g
    } = l;
    this.variableList = g;
    const {
      AUDIO: p = [],
      SUBTITLES: v,
      "CLOSED-CAPTIONS": y
    } = Oe.parseMasterPlaylistMedia(n, o, l);
    p.length && !p.some((x) => !x.url) && c[0].audioCodec && !c[0].attrs.AUDIO && (E.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), p.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new ee({}),
      bitrate: 0,
      url: ""
    })), r.trigger(m.MANIFEST_LOADED, {
      levels: c,
      audioTracks: p,
      subtitles: v,
      captions: y,
      contentSteering: h,
      url: o,
      stats: t,
      networkDetails: i,
      sessionData: d,
      sessionKeys: u,
      startTimeOffset: f,
      variableList: g
    });
  }
  handleTrackOrLevelPlaylist(e, t, s, i, r) {
    const n = this.hls, {
      id: o,
      level: l,
      type: h
    } = s, c = is(e, s), d = M(o) ? o : 0, u = M(l) ? l : d, f = Si(s), g = Oe.parseLevelPlaylist(e.data, c, u, f, d, this.variableList);
    if (h === K.MANIFEST) {
      const p = {
        attrs: new ee({}),
        bitrate: 0,
        details: g,
        name: "",
        url: c
      };
      n.trigger(m.MANIFEST_LOADED, {
        levels: [p],
        audioTracks: [],
        url: c,
        stats: t,
        networkDetails: i,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), s.levelDetails = g, this.handlePlaylistLoaded(g, e, t, s, i, r);
  }
  handleManifestParsingError(e, t, s, i, r) {
    this.hls.trigger(m.ERROR, {
      type: U.NETWORK_ERROR,
      details: L.MANIFEST_PARSING_ERROR,
      fatal: t.type === K.MANIFEST,
      url: e.url,
      err: s,
      error: s,
      reason: s.message,
      response: e,
      context: t,
      networkDetails: i,
      stats: r
    });
  }
  handleNetworkError(e, t, s = !1, i, r) {
    let n = `A network ${s ? "timeout" : "error" + (i ? " (status " + i.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === K.LEVEL ? n += `: ${e.level} id: ${e.id}` : (e.type === K.AUDIO_TRACK || e.type === K.SUBTITLE_TRACK) && (n += ` id: ${e.id} group-id: "${e.groupId}"`);
    const o = new Error(n);
    E.warn(`[playlist-loader]: ${n}`);
    let l = L.UNKNOWN, h = !1;
    const c = this.getInternalLoader(e);
    switch (e.type) {
      case K.MANIFEST:
        l = s ? L.MANIFEST_LOAD_TIMEOUT : L.MANIFEST_LOAD_ERROR, h = !0;
        break;
      case K.LEVEL:
        l = s ? L.LEVEL_LOAD_TIMEOUT : L.LEVEL_LOAD_ERROR, h = !1;
        break;
      case K.AUDIO_TRACK:
        l = s ? L.AUDIO_TRACK_LOAD_TIMEOUT : L.AUDIO_TRACK_LOAD_ERROR, h = !1;
        break;
      case K.SUBTITLE_TRACK:
        l = s ? L.SUBTITLE_TRACK_LOAD_TIMEOUT : L.SUBTITLE_LOAD_ERROR, h = !1;
        break;
    }
    c && this.resetInternalLoader(e.type);
    const d = {
      type: U.NETWORK_ERROR,
      details: l,
      fatal: h,
      url: e.url,
      loader: c,
      context: e,
      error: o,
      networkDetails: t,
      stats: r
    };
    if (i) {
      const u = (t == null ? void 0 : t.url) || e.url;
      d.response = Le({
        url: u,
        data: void 0
      }, i);
    }
    this.hls.trigger(m.ERROR, d);
  }
  handlePlaylistLoaded(e, t, s, i, r, n) {
    const o = this.hls, {
      type: l,
      level: h,
      id: c,
      groupId: d,
      deliveryDirectives: u
    } = i, f = is(t, i), g = Si(i), p = typeof i.level == "number" && g === $.MAIN ? h : void 0;
    if (!e.fragments.length) {
      const y = new Error("No Segments found in Playlist");
      o.trigger(m.ERROR, {
        type: U.NETWORK_ERROR,
        details: L.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: f,
        error: y,
        reason: y.message,
        response: t,
        context: i,
        level: p,
        parent: g,
        networkDetails: r,
        stats: s
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const v = e.playlistParsingError;
    if (v) {
      o.trigger(m.ERROR, {
        type: U.NETWORK_ERROR,
        details: L.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: f,
        error: v,
        reason: v.message,
        response: t,
        context: i,
        level: p,
        parent: g,
        networkDetails: r,
        stats: s
      });
      return;
    }
    switch (e.live && n && (n.getCacheAge && (e.ageHeader = n.getCacheAge() || 0), (!n.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case K.MANIFEST:
      case K.LEVEL:
        o.trigger(m.LEVEL_LOADED, {
          details: e,
          level: p || 0,
          id: c || 0,
          stats: s,
          networkDetails: r,
          deliveryDirectives: u
        });
        break;
      case K.AUDIO_TRACK:
        o.trigger(m.AUDIO_TRACK_LOADED, {
          details: e,
          id: c || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: u
        });
        break;
      case K.SUBTITLE_TRACK:
        o.trigger(m.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: c || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: u
        });
        break;
    }
  }
}
function Ir(a, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = a, e.dispatchEvent(t);
}
function wr(a, e) {
  const t = a.mode;
  if (t === "disabled" && (a.mode = "hidden"), a.cues && !a.cues.getCueById(e.id))
    try {
      if (a.addCue(e), !a.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (s) {
      E.debug(`[texttrack-utils]: ${s}`);
      try {
        const i = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        i.id = e.id, a.addCue(i);
      } catch (i) {
        E.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${i}`);
      }
    }
  t === "disabled" && (a.mode = t);
}
function ht(a) {
  const e = a.mode;
  if (e === "disabled" && (a.mode = "hidden"), a.cues)
    for (let t = a.cues.length; t--; )
      a.removeCue(a.cues[t]);
  e === "disabled" && (a.mode = e);
}
function bs(a, e, t, s) {
  const i = a.mode;
  if (i === "disabled" && (a.mode = "hidden"), a.cues && a.cues.length > 0) {
    const r = xa(a.cues, e, t);
    for (let n = 0; n < r.length; n++)
      (!s || s(r[n])) && a.removeCue(r[n]);
  }
  i === "disabled" && (a.mode = i);
}
function Ta(a, e) {
  if (e < a[0].startTime)
    return 0;
  const t = a.length - 1;
  if (e > a[t].endTime)
    return -1;
  let s = 0, i = t;
  for (; s <= i; ) {
    const r = Math.floor((i + s) / 2);
    if (e < a[r].startTime)
      i = r - 1;
    else if (e > a[r].startTime && s < t)
      s = r + 1;
    else
      return r;
  }
  return a[s].startTime - e < e - a[i].startTime ? s : i;
}
function xa(a, e, t) {
  const s = [], i = Ta(a, e);
  if (i > -1)
    for (let r = i, n = a.length; r < n; r++) {
      const o = a[r];
      if (o.startTime >= e && o.endTime <= t)
        s.push(o);
      else if (o.startTime > t)
        return s;
    }
  return s;
}
var Pe = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const Ea = 0.25;
function Ls() {
  if (!(typeof self > "u"))
    return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
}
const wt = (() => {
  const a = Ls();
  try {
    new a(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function rs(a, e) {
  return a.getTime() / 1e3 - e;
}
function Sa(a) {
  return Uint8Array.from(a.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class ba {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(m.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(m.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, t) {
    this.media = t.media;
  }
  onMediaDetaching() {
    this.id3Track && (ht(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const s = e[t];
        if (s.kind === "metadata" && s.label === "id3")
          return Ir(s, this.media), s;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: s,
          enableID3MetadataCues: i
        }
      }
    } = this;
    if (!s && !i)
      return;
    const {
      samples: r
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const n = Ls();
    for (let o = 0; o < r.length; o++) {
      const l = r[o].type;
      if (l === Pe.emsg && !s || !i)
        continue;
      const h = yr(r[o].data);
      if (h) {
        const c = r[o].pts;
        let d = c + r[o].duration;
        d > wt && (d = wt), d - c <= 0 && (d = c + Ea);
        for (let f = 0; f < h.length; f++) {
          const g = h[f];
          if (!vr(g)) {
            this.updateId3CueEnds(c, l);
            const p = new n(c, d, "");
            p.value = g, l && (p.type = l), this.id3Track.addCue(p);
          }
        }
      }
    }
  }
  updateId3CueEnds(e, t) {
    var s;
    const i = (s = this.id3Track) == null ? void 0 : s.cues;
    if (i)
      for (let r = i.length; r--; ) {
        const n = i[r];
        n.type === t && n.startTime < e && n.endTime === wt && (n.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    type: i
  }) {
    const {
      id3Track: r,
      hls: n
    } = this;
    if (!n)
      return;
    const {
      config: {
        enableEmsgMetadataCues: o,
        enableID3MetadataCues: l
      }
    } = n;
    if (r && (o || l)) {
      let h;
      i === "audio" ? h = (c) => c.type === Pe.audioId3 && l : i === "video" ? h = (c) => c.type === Pe.emsg && o : h = (c) => c.type === Pe.audioId3 && l || c.type === Pe.emsg && o, bs(r, t, s, h);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    if (!this.media || !t.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: s,
      id3Track: i
    } = this, {
      dateRanges: r
    } = t, n = Object.keys(r);
    if (i) {
      const c = Object.keys(s).filter((d) => !n.includes(d));
      for (let d = c.length; d--; ) {
        const u = c[d];
        Object.keys(s[u].cues).forEach((f) => {
          i.removeCue(s[u].cues[f]);
        }), delete s[u];
      }
    }
    const o = t.fragments[t.fragments.length - 1];
    if (n.length === 0 || !M(o == null ? void 0 : o.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const l = o.programDateTime / 1e3 - o.start, h = Ls();
    for (let c = 0; c < n.length; c++) {
      const d = n[c], u = r[d], f = s[d], g = (f == null ? void 0 : f.cues) || {};
      let p = (f == null ? void 0 : f.durationKnown) || !1;
      const v = rs(u.startDate, l);
      let y = wt;
      const T = u.endDate;
      if (T)
        y = rs(T, l), p = !0;
      else if (u.endOnNext && !p) {
        const A = n.reduce((b, C) => {
          const I = r[C];
          return I.class === u.class && I.id !== C && I.startDate > u.startDate && b.push(I), b;
        }, []).sort((b, C) => b.startDate.getTime() - C.startDate.getTime())[0];
        A && (y = rs(A.startDate, l), p = !0);
      }
      const x = Object.keys(u.attr);
      for (let A = 0; A < x.length; A++) {
        const b = x[A];
        if (!Cn(b))
          continue;
        let C = g[b];
        if (C)
          p && !f.durationKnown && (C.endTime = y);
        else {
          let I = u.attr[b];
          C = new h(v, y, ""), Dn(b) && (I = Sa(I)), C.value = {
            key: b,
            data: I
          }, C.type = Pe.dateRange, C.id = d, this.id3Track.addCue(C), g[b] = C;
        }
      }
      s[d] = {
        cues: g,
        dateRange: u,
        durationKnown: p
      };
    }
  }
}
class La {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: t
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: s,
      targetduration: i
    } = e, {
      liveSyncDuration: r,
      liveSyncDurationCount: n,
      lowLatencyMode: o
    } = this.config, l = this.hls.userConfig;
    let h = o && s || t;
    (l.liveSyncDuration || l.liveSyncDurationCount || h === 0) && (h = r !== void 0 ? r : n * i);
    const c = i, d = 1;
    return h + Math.min(this.stallCount * d, c);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency, s = this.levelDetails;
    if (e === null || t === null || s === null)
      return null;
    const i = s.edge, r = e - t - this.edgeStalled, n = i - s.totalduration, o = i - (this.config.lowLatencyMode && s.partTarget || s.targetduration);
    return Math.min(Math.max(n, r), o);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return 0;
    const s = e.buffered.length;
    return (s ? e.buffered.end(s - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(m.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(m.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(m.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(m.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(m.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(m.ERROR, this.onError, this);
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.levelDetails = t, t.advanced && this.timeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, t) {
    var s;
    t.details === L.BUFFER_STALLED_ERROR && (this.stallCount++, (s = this.levelDetails) != null && s.live && E.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return;
    this.currentTime = e.currentTime;
    const s = this.computeLatency();
    if (s === null)
      return;
    this._latency = s;
    const {
      lowLatencyMode: i,
      maxLiveSyncPlaybackRate: r
    } = this.config;
    if (!i || r === 1)
      return;
    const n = this.targetLatency;
    if (n === null)
      return;
    const o = s - n, l = Math.min(this.maxLatency, n + t.targetduration), h = o < l;
    if (t.live && h && o > 0.05 && this.forwardBufferLength > 1) {
      const c = Math.min(2, Math.max(1, r)), d = Math.round(2 / (1 + Math.exp(-0.75 * o - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(c, Math.max(1, d));
    } else
      e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const As = ["NONE", "TYPE-0", "TYPE-1", null];
var Tt = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function Aa(a, e) {
  const {
    canSkipUntil: t,
    canSkipDateRanges: s,
    endSN: i
  } = a, r = e !== void 0 ? e - i : 0;
  return t && r < t ? s ? Tt.v2 : Tt.Yes : Tt.No;
}
class bi {
  constructor(e, t, s) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = s;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class Et {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.unknownCodecs = e.unknownCodecs, this.codecSet = [e.videoCodec, e.audioCodec].filter((t) => t).join(",").replace(/\.[^.,]+/g, "");
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get attrs() {
    return this._attrs[this._urlId];
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get uri() {
    return this.url[this._urlId] || "";
  }
  get urlId() {
    return this._urlId;
  }
  set urlId(e) {
    const t = e % this.url.length;
    this._urlId !== t && (this.fragmentError = 0, this.loadError = 0, this.details = void 0, this._urlId = t);
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroupIds) == null ? void 0 : e[this.urlId];
  }
  get textGroupId() {
    var e;
    return (e = this.textGroupIds) == null ? void 0 : e[this.urlId];
  }
  addFallback(e) {
    this.url.push(e.url), this._attrs.push(e.attrs);
  }
}
function ns(a, e) {
  const t = e.startPTS;
  if (M(t)) {
    let s = 0, i;
    e.sn > a.sn ? (s = t - a.start, i = a) : (s = a.start - t, i = e), i.duration !== s && (i.duration = s);
  } else
    e.sn > a.sn ? a.cc === e.cc && a.minEndPTS ? e.start = a.start + (a.minEndPTS - a.start) : e.start = a.start + a.duration : e.start = Math.max(a.start - e.duration, 0);
}
function _r(a, e, t, s, i, r) {
  s - t <= 0 && (E.warn("Fragment should have a positive duration", e), s = t + e.duration, r = i + e.duration);
  let o = t, l = s;
  const h = e.startPTS, c = e.endPTS;
  if (M(h)) {
    const v = Math.abs(h - t);
    M(e.deltaPTS) ? e.deltaPTS = Math.max(v, e.deltaPTS) : e.deltaPTS = v, o = Math.max(t, h), t = Math.min(t, h), i = Math.min(i, e.startDTS), l = Math.min(s, c), s = Math.max(s, c), r = Math.max(r, e.endDTS);
  }
  const d = t - e.start;
  e.start !== 0 && (e.start = t), e.duration = s - e.start, e.startPTS = t, e.maxStartPTS = o, e.startDTS = i, e.endPTS = s, e.minEndPTS = l, e.endDTS = r;
  const u = e.sn;
  if (!a || u < a.startSN || u > a.endSN)
    return 0;
  let f;
  const g = u - a.startSN, p = a.fragments;
  for (p[g] = e, f = g; f > 0; f--)
    ns(p[f], p[f - 1]);
  for (f = g; f < p.length - 1; f++)
    ns(p[f], p[f + 1]);
  return a.fragmentHint && ns(p[p.length - 1], a.fragmentHint), a.PTSKnown = a.alignedSliding = !0, d;
}
function Ra(a, e) {
  let t = null;
  const s = a.fragments;
  for (let l = s.length - 1; l >= 0; l--) {
    const h = s[l].initSegment;
    if (h) {
      t = h;
      break;
    }
  }
  a.fragmentHint && delete a.fragmentHint.endPTS;
  let i = 0, r;
  if (_a(a, e, (l, h) => {
    l.relurl && (i = l.cc - h.cc), M(l.startPTS) && M(l.endPTS) && (h.start = h.startPTS = l.startPTS, h.startDTS = l.startDTS, h.maxStartPTS = l.maxStartPTS, h.endPTS = l.endPTS, h.endDTS = l.endDTS, h.minEndPTS = l.minEndPTS, h.duration = l.endPTS - l.startPTS, h.duration && (r = h), e.PTSKnown = e.alignedSliding = !0), h.elementaryStreams = l.elementaryStreams, h.loader = l.loader, h.stats = l.stats, h.urlId = l.urlId, l.initSegment && (h.initSegment = l.initSegment, t = l.initSegment);
  }), t && (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach((h) => {
    var c;
    (!h.initSegment || h.initSegment.relurl === ((c = t) == null ? void 0 : c.relurl)) && (h.initSegment = t);
  }), e.skippedSegments)
    if (e.deltaUpdateFailed = e.fragments.some((l) => !l), e.deltaUpdateFailed) {
      E.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let l = e.skippedSegments; l--; )
        e.fragments.shift();
      e.startSN = e.fragments[0].sn, e.startCC = e.fragments[0].cc;
    } else
      e.canSkipDateRanges && (e.dateRanges = Ia(a.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
  const n = e.fragments;
  if (i) {
    E.warn("discontinuity sliding from playlist, take drift into account");
    for (let l = 0; l < n.length; l++)
      n[l].cc += i;
  }
  e.skippedSegments && (e.startCC = e.fragments[0].cc), wa(a.partList, e.partList, (l, h) => {
    h.elementaryStreams = l.elementaryStreams, h.stats = l.stats;
  }), r ? _r(e, r, r.startPTS, r.endPTS, r.startDTS, r.endDTS) : Cr(a, e), n.length && (e.totalduration = e.edge - n[0].start), e.driftStartTime = a.driftStartTime, e.driftStart = a.driftStart;
  const o = e.advancedDateTime;
  if (e.advanced && o) {
    const l = e.edge;
    e.driftStart || (e.driftStartTime = o, e.driftStart = l), e.driftEndTime = o, e.driftEnd = l;
  } else
    e.driftEndTime = a.driftEndTime, e.driftEnd = a.driftEnd, e.advancedDateTime = a.advancedDateTime;
}
function Ia(a, e, t) {
  const s = ae({}, a);
  return t && t.forEach((i) => {
    delete s[i];
  }), Object.keys(e).forEach((i) => {
    const r = new dr(e[i].attr, s[i]);
    r.isValid ? s[i] = r : E.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[i].attr)}"`);
  }), s;
}
function wa(a, e, t) {
  if (a && e) {
    let s = 0;
    for (let i = 0, r = a.length; i <= r; i++) {
      const n = a[i], o = e[i + s];
      n && o && n.index === o.index && n.fragment.sn === o.fragment.sn ? t(n, o) : s--;
    }
  }
}
function _a(a, e, t) {
  const s = e.skippedSegments, i = Math.max(a.startSN, e.startSN) - e.startSN, r = (a.fragmentHint ? 1 : 0) + (s ? e.endSN : Math.min(a.endSN, e.endSN)) - e.startSN, n = e.startSN - a.startSN, o = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = a.fragmentHint ? a.fragments.concat(a.fragmentHint) : a.fragments;
  for (let h = i; h <= r; h++) {
    const c = l[n + h];
    let d = o[h];
    s && !d && h < s && (d = e.fragments[h] = c), c && d && t(c, d);
  }
}
function Cr(a, e) {
  const t = e.startSN + e.skippedSegments - a.startSN, s = a.fragments;
  t < 0 || t >= s.length || Rs(e, s[t].start);
}
function Rs(a, e) {
  if (e) {
    const t = a.fragments;
    for (let s = a.skippedSegments; s < t.length; s++)
      t[s].start += e;
    a.fragmentHint && (a.fragmentHint.start += e);
  }
}
function Ca(a, e = 1 / 0) {
  let t = 1e3 * a.targetduration;
  if (a.updated) {
    const s = a.fragments, i = 4;
    if (s.length && t * i > e) {
      const r = s[s.length - 1].duration * 1e3;
      r < t && (t = r);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function Da(a, e, t) {
  if (!(a != null && a.details))
    return null;
  const s = a.details;
  let i = s.fragments[e - s.startSN];
  return i || (i = s.fragmentHint, i && i.sn === e) ? i : e < s.startSN && t && t.sn === e ? t : null;
}
function Li(a, e, t) {
  var s;
  return a != null && a.details ? Dr((s = a.details) == null ? void 0 : s.partList, e, t) : null;
}
function Dr(a, e, t) {
  if (a)
    for (let s = a.length; s--; ) {
      const i = a[s];
      if (i.index === t && i.fragment.sn === e)
        return i;
    }
  return null;
}
function Bt(a) {
  switch (a.details) {
    case L.FRAG_LOAD_TIMEOUT:
    case L.KEY_LOAD_TIMEOUT:
    case L.LEVEL_LOAD_TIMEOUT:
    case L.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function Ai(a, e) {
  const t = Bt(e);
  return a.default[`${t ? "timeout" : "error"}Retry`];
}
function Bs(a, e) {
  const t = a.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * a.retryDelayMs, a.maxRetryDelayMs);
}
function Ri(a) {
  return Le(Le({}, a), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function Gt(a, e, t, s) {
  return !!a && e < a.maxNumRetry && (ka(s) || !!t);
}
function ka(a) {
  return a === 0 && navigator.onLine === !1 || !!a && (a < 400 || a > 499);
}
const kr = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(a, e) {
    let t = 0, s = a.length - 1, i = null, r = null;
    for (; t <= s; ) {
      i = (t + s) / 2 | 0, r = a[i];
      const n = e(r);
      if (n > 0)
        t = i + 1;
      else if (n < 0)
        s = i - 1;
      else
        return r;
    }
    return null;
  }
};
function Pa(a, e, t) {
  if (e === null || !Array.isArray(a) || !a.length || !M(e))
    return null;
  const s = a[0].programDateTime;
  if (e < (s || 0))
    return null;
  const i = a[a.length - 1].endProgramDateTime;
  if (e >= (i || 0))
    return null;
  t = t || 0;
  for (let r = 0; r < a.length; ++r) {
    const n = a[r];
    if (Oa(e, t, n))
      return n;
  }
  return null;
}
function St(a, e, t = 0, s = 0) {
  let i = null;
  if (a ? i = e[a.sn - e[0].sn + 1] || null : t === 0 && e[0].start === 0 && (i = e[0]), i && Is(t, s, i) === 0)
    return i;
  const r = kr.search(e, Is.bind(null, t, s));
  return r && (r !== a || !i) ? r : i;
}
function Is(a = 0, e = 0, t) {
  if (t.start <= a && t.start + t.duration > a)
    return 0;
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - s <= a ? 1 : t.start - s > a && t.start ? -1 : 0;
}
function Oa(a, e, t) {
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - s > a;
}
function Fa(a, e) {
  return kr.search(a, (t) => t.cc < e ? 1 : t.cc > e ? -1 : 0);
}
const Ma = 3e5;
var ge = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
}, _e = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
};
class Na {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = E.log.bind(E, "[info]:"), this.warn = E.warn.bind(E, "[warning]:"), this.error = E.error.bind(E, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(m.ERROR, this.onError, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(m.ERROR, this.onError, this), e.off(m.ERROR, this.onErrorOut, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
    this.playlistError = 0;
  }
  stopLoad() {
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === $.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var s, i;
    if (t.fatal)
      return;
    const r = this.hls, n = t.context;
    switch (t.details) {
      case L.FRAG_LOAD_ERROR:
      case L.FRAG_LOAD_TIMEOUT:
      case L.KEY_LOAD_ERROR:
      case L.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case L.FRAG_PARSING_ERROR:
        if ((s = t.frag) != null && s.gap) {
          t.errorAction = {
            action: ge.DoNothing,
            flags: _e.None
          };
          return;
        }
      case L.FRAG_GAP:
      case L.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = ge.SendAlternateToPenaltyBox;
        return;
      }
      case L.LEVEL_EMPTY_ERROR:
      case L.LEVEL_PARSING_ERROR:
        {
          var o, l;
          const h = t.parent === $.MAIN ? t.level : r.loadLevel;
          t.details === L.LEVEL_EMPTY_ERROR && ((o = t.context) != null && (l = o.levelDetails) != null && l.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, h) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, h));
        }
        return;
      case L.LEVEL_LOAD_ERROR:
      case L.LEVEL_LOAD_TIMEOUT:
        typeof (n == null ? void 0 : n.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, n.level));
        return;
      case L.AUDIO_TRACK_LOAD_ERROR:
      case L.AUDIO_TRACK_LOAD_TIMEOUT:
      case L.SUBTITLE_LOAD_ERROR:
      case L.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (n) {
          const h = r.levels[r.loadLevel];
          if (h && (n.type === K.AUDIO_TRACK && n.groupId === h.audioGroupId || n.type === K.SUBTITLE_TRACK && n.groupId === h.textGroupId)) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, r.loadLevel), t.errorAction.action = ge.SendAlternateToPenaltyBox, t.errorAction.flags = _e.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case L.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const h = r.levels[r.loadLevel], c = h == null ? void 0 : h.attrs["HDCP-LEVEL"];
          c && (t.errorAction = {
            action: ge.SendAlternateToPenaltyBox,
            flags: _e.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: c
          });
        }
        return;
      case L.BUFFER_ADD_CODEC_ERROR:
      case L.REMUX_ALLOC_ERROR:
        t.errorAction = this.getLevelSwitchAction(t, (i = t.level) != null ? i : r.loadLevel);
        return;
      case L.INTERNAL_EXCEPTION:
      case L.BUFFER_APPENDING_ERROR:
      case L.BUFFER_APPEND_ERROR:
      case L.BUFFER_FULL_ERROR:
      case L.LEVEL_SWITCH_ERROR:
      case L.BUFFER_STALLED_ERROR:
      case L.BUFFER_SEEK_OVER_HOLE:
      case L.BUFFER_NUDGE_ON_STALL:
        t.errorAction = {
          action: ge.DoNothing,
          flags: _e.None
        };
        return;
    }
    if (t.type === U.KEY_SYSTEM_ERROR) {
      const h = this.getVariantLevelIndex(t.frag);
      t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, h);
      return;
    }
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    var s;
    const i = this.hls, r = Ai(i.config.playlistLoadPolicy, e), n = this.playlistError++, o = (s = e.response) == null ? void 0 : s.code;
    if (Gt(r, n, Bt(e), o))
      return {
        action: ge.RetryRequest,
        flags: _e.None,
        retryConfig: r,
        retryCount: n
      };
    const h = this.getLevelSwitchAction(e, t);
    return r && (h.retryConfig = r, h.retryCount = n), h;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, s = this.getVariantLevelIndex(e.frag), i = t.levels[s], {
      fragLoadPolicy: r,
      keyLoadPolicy: n
    } = t.config, o = Ai(e.details.startsWith("key") ? n : r, e), l = t.levels.reduce((d, u) => d + u.fragmentError, 0);
    if (i) {
      var h;
      e.details !== L.FRAG_GAP && i.fragmentError++;
      const d = (h = e.response) == null ? void 0 : h.code;
      if (Gt(o, l, Bt(e), d))
        return {
          action: ge.RetryRequest,
          flags: _e.None,
          retryConfig: o,
          retryCount: l
        };
    }
    const c = this.getLevelSwitchAction(e, s);
    return o && (c.retryConfig = o, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const s = this.hls;
    t == null && (t = s.loadLevel);
    const i = this.hls.levels[t];
    if (i && (i.loadError++, s.autoLevelEnabled)) {
      var r, n;
      let o = -1;
      const {
        levels: l,
        loadLevel: h,
        minAutoLevel: c,
        maxAutoLevel: d
      } = s, u = (r = e.frag) == null ? void 0 : r.type, {
        type: f,
        groupId: g
      } = (n = e.context) != null ? n : {};
      for (let p = l.length; p--; ) {
        const v = (p + h) % l.length;
        if (v !== h && v >= c && v <= d && l[v].loadError === 0) {
          const y = l[v];
          if (e.details === L.FRAG_GAP && e.frag) {
            const T = l[v].details;
            if (T) {
              const x = St(e.frag, T.fragments, e.frag.start);
              if (x != null && x.gap)
                continue;
            }
          } else {
            if (f === K.AUDIO_TRACK && g === y.audioGroupId || f === K.SUBTITLE_TRACK && g === y.textGroupId)
              continue;
            if (u === $.AUDIO && i.audioGroupId === y.audioGroupId || u === $.SUBTITLE && i.textGroupId === y.textGroupId)
              continue;
          }
          o = v;
          break;
        }
      }
      if (o > -1 && s.loadLevel !== o)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: ge.SendAlternateToPenaltyBox,
          flags: _e.None,
          nextAutoLevel: o
        };
    }
    return {
      action: ge.SendAlternateToPenaltyBox,
      flags: _e.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var s;
    switch ((s = t.errorAction) == null ? void 0 : s.action) {
      case ge.DoNothing:
        break;
      case ge.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== L.FRAG_GAP && (t.fatal = !0);
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, s = e.errorAction;
    if (!s)
      return;
    const {
      flags: i,
      hdcpLevel: r,
      nextAutoLevel: n
    } = s;
    switch (i) {
      case _e.None:
        this.switchLevel(e, n);
        break;
      case _e.MoveAllAlternatesMatchingHost:
        s.resolved || (s.resolved = this.redundantFailover(e));
        break;
      case _e.MoveAllAlternatesMatchingHDCP:
        r && (t.maxHdcpLevel = As[As.indexOf(r) - 1], s.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    s.resolved || this.switchLevel(e, n);
  }
  switchLevel(e, t) {
    t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
  redundantFailover(e) {
    const {
      hls: t,
      penalizedRenditions: s
    } = this, i = e.parent === $.MAIN ? e.level : t.loadLevel, r = t.levels[i], n = r.url.length, o = e.frag ? e.frag.urlId : r.urlId;
    r.urlId === o && (!e.frag || r.details) && this.penalizeRendition(r, e);
    for (let l = 1; l < n; l++) {
      const h = (o + l) % n, c = s[h];
      if (!c || Ua(c, e, s[o]))
        return this.warn(`Switching to Redundant Stream ${h + 1}/${n}: "${r.url[h]}" after ${e.details}`), this.playlistError = 0, t.levels.forEach((d) => {
          d.urlId = h;
        }), t.nextLoadLevel = i, !0;
    }
    return !1;
  }
  penalizeRendition(e, t) {
    const {
      penalizedRenditions: s
    } = this, i = s[e.urlId] || {
      lastErrorPerfMs: 0,
      errors: [],
      details: void 0
    };
    i.lastErrorPerfMs = performance.now(), i.errors.push(t), i.details = e.details, s[e.urlId] = i;
  }
}
function Ua(a, e, t) {
  if (performance.now() - a.lastErrorPerfMs > Ma)
    return !0;
  const s = a.details;
  if (e.details === L.FRAG_GAP && s && e.frag) {
    const i = e.frag.start, r = St(null, s.fragments, i);
    if (r && !r.gap)
      return !0;
  }
  if (t && a.errors.length < t.errors.length) {
    const i = a.errors[a.errors.length - 1];
    if (s && i.frag && e.frag && Math.abs(i.frag.start - e.frag.start) > s.targetduration * 3)
      return !0;
  }
  return !1;
}
class Gs {
  constructor(e, t) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = E.log.bind(E, `${t}:`), this.warn = E.warn.bind(E, `${t}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    clearTimeout(this.timer), this.timer = -1;
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t) {
    const s = t == null ? void 0 : t.renditionReports;
    if (s) {
      let i = -1;
      for (let r = 0; r < s.length; r++) {
        const n = s[r];
        let o;
        try {
          o = new self.URL(n.URI, t.url).href;
        } catch (l) {
          E.warn(`Could not construct new URL for Rendition Report: ${l}`), o = n.URI || "";
        }
        if (o === e) {
          i = r;
          break;
        } else
          o === e.substring(0, o.length) && (i = r);
      }
      if (i !== -1) {
        const r = s[i], n = parseInt(r["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let o = parseInt(r["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const l = Math.min(t.age - t.partTarget, t.targetduration);
          o >= 0 && l > t.partTarget && (o += 1);
        }
        return new bi(n, o >= 0 ? o : void 0, Tt.No);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, t, s) {
    const {
      details: i,
      stats: r
    } = t, n = self.performance.now(), o = r.loading.first ? Math.max(0, n - r.loading.first) : 0;
    if (i.advancedDateTime = Date.now() - o, i.live || s != null && s.live) {
      if (i.reloaded(s), s && this.log(`live playlist ${e} ${i.advanced ? "REFRESHED " + i.lastPartSn + "-" + i.lastPartIndex : i.updated ? "UPDATED" : "MISSED"}`), s && i.fragments.length > 0 && Ra(s, i), !this.canLoad || !i.live)
        return;
      let l, h, c;
      if (i.canBlockReload && i.endSN && i.advanced) {
        const v = this.hls.config.lowLatencyMode, y = i.lastPartSn, T = i.endSN, x = i.lastPartIndex, A = x !== -1, b = y === T, C = v ? 0 : x;
        A ? (h = b ? T + 1 : y, c = b ? C : x + 1) : h = T + 1;
        const I = i.age, _ = I + i.ageHeader;
        let D = Math.min(_ - i.partTarget, i.targetduration * 1.5);
        if (D > 0) {
          if (s && D > s.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${s.tuneInGoal} to: ${D} with playlist age: ${i.age}`), D = 0;
          else {
            const R = Math.floor(D / i.targetduration);
            if (h += R, c !== void 0) {
              const F = Math.round(D % i.targetduration / i.partTarget);
              c += F;
            }
            this.log(`CDN Tune-in age: ${i.ageHeader}s last advanced ${I.toFixed(2)}s goal: ${D} skip sn ${R} to part ${c}`);
          }
          i.tuneInGoal = D;
        }
        if (l = this.getDeliveryDirectives(i, t.deliveryDirectives, h, c), v || !b) {
          this.loadPlaylist(l);
          return;
        }
      } else
        (i.canBlockReload || i.canSkipUntil) && (l = this.getDeliveryDirectives(i, t.deliveryDirectives, h, c));
      const d = this.hls.mainForwardBufferInfo, u = d ? d.end - d.len : 0, f = (i.edge - u) * 1e3, g = Ca(i, f);
      i.updated && n > this.requestScheduled + g && (this.requestScheduled = r.loading.start), h !== void 0 && i.canBlockReload ? this.requestScheduled = r.loading.first + g - (i.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + g < n ? this.requestScheduled = n : this.requestScheduled - n <= 0 && (this.requestScheduled += g);
      let p = this.requestScheduled - n;
      p = Math.max(0, p), this.log(`reload live playlist ${e} in ${Math.round(p)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(l), p);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, t, s, i) {
    let r = Aa(e, s);
    return t != null && t.skip && e.deltaUpdateFailed && (s = t.msn, i = t.part, r = Tt.No), new bi(s, i, r);
  }
  checkRetry(e) {
    const t = e.details, s = Bt(e), i = e.errorAction, {
      action: r,
      retryCount: n = 0,
      retryConfig: o
    } = i || {}, l = !!i && !!o && (r === ge.RetryRequest || !i.resolved && r === ge.SendAlternateToPenaltyBox);
    if (l) {
      var h;
      if (this.requestScheduled = -1, n >= o.maxNumRetry)
        return !1;
      if (s && (h = e.context) != null && h.deliveryDirectives)
        this.warn(`Retrying playlist loading ${n + 1}/${o.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const c = Bs(o, n);
        this.timer = self.setTimeout(() => this.loadPlaylist(), c), this.warn(`Retrying playlist loading ${n + 1}/${o.maxNumRetry} after "${t}" in ${c}ms`);
      }
      e.levelRetry = !0, i.resolved = !0;
    }
    return l;
  }
}
let as;
class $a extends Gs {
  constructor(e, t) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(m.LEVEL_LOADED, this.onLevelLoaded, this), e.on(m.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(m.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(m.FRAG_LOADED, this.onFragLoaded, this), e.on(m.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(m.LEVEL_LOADED, this.onLevelLoaded, this), e.off(m.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(m.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(m.FRAG_LOADED, this.onFragLoaded, this), e.off(m.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  startLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.startLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [];
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const s = [], i = {};
    let r;
    t.levels.forEach((n) => {
      var o;
      const l = n.attrs;
      ((o = n.audioCodec) == null ? void 0 : o.indexOf("mp4a.40.34")) !== -1 && (as || (as = /chrome|firefox/i.test(navigator.userAgent)), as && (n.audioCodec = void 0));
      const {
        AUDIO: h,
        CODECS: c,
        "FRAME-RATE": d,
        "PATHWAY-ID": u,
        RESOLUTION: f,
        SUBTITLES: g
      } = l, v = `${`${u || "."}-`}${n.bitrate}-${f}-${d}-${c}`;
      r = i[v], r ? r.addFallback(n) : (r = new Et(n), i[v] = r, s.push(r)), Vt(r, "audio", h), Vt(r, "text", g);
    }), this.filterAndSortMediaOptions(s, t);
  }
  filterAndSortMediaOptions(e, t) {
    let s = [], i = [], r = !1, n = !1, o = !1, l = e.filter(({
      audioCodec: f,
      videoCodec: g,
      width: p,
      height: v,
      unknownCodecs: y
    }) => (r || (r = !!(p && v)), n || (n = !!g), o || (o = !!f), !(y != null && y.length) && (!f || ss(f, "audio")) && (!g || ss(g, "video"))));
    if ((r || n) && o && (l = l.filter(({
      videoCodec: f,
      width: g,
      height: p
    }) => !!f || !!(g && p))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          const f = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(m.ERROR, {
            type: U.MEDIA_ERROR,
            details: L.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: f,
            reason: f.message
          });
        }
      });
      return;
    }
    t.audioTracks && (s = t.audioTracks.filter((f) => !f.audioCodec || ss(f.audioCodec, "audio")), Ii(s)), t.subtitles && (i = t.subtitles, Ii(i));
    const h = l.slice(0);
    l.sort((f, g) => f.attrs["HDCP-LEVEL"] !== g.attrs["HDCP-LEVEL"] ? (f.attrs["HDCP-LEVEL"] || "") > (g.attrs["HDCP-LEVEL"] || "") ? 1 : -1 : f.bitrate !== g.bitrate ? f.bitrate - g.bitrate : f.attrs["FRAME-RATE"] !== g.attrs["FRAME-RATE"] ? f.attrs.decimalFloatingPoint("FRAME-RATE") - g.attrs.decimalFloatingPoint("FRAME-RATE") : f.attrs.SCORE !== g.attrs.SCORE ? f.attrs.decimalFloatingPoint("SCORE") - g.attrs.decimalFloatingPoint("SCORE") : r && f.height !== g.height ? f.height - g.height : 0);
    let c = h[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== h.length)) {
      for (let f = 0; f < h.length; f++)
        if (h[f].pathwayId === l[0].pathwayId) {
          c = h[f];
          break;
        }
    }
    this._levels = l;
    for (let f = 0; f < l.length; f++)
      if (l[f] === c) {
        this._firstLevel = f, this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${c.bitrate}`);
        break;
      }
    const d = o && !n, u = {
      levels: l,
      audioTracks: s,
      subtitleTracks: i,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: o,
      video: n,
      altAudio: !d && s.some((f) => !!f.url)
    };
    this.hls.trigger(m.MANIFEST_PARSED, u), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const c = new Error("invalid level idx"), d = e < 0;
      if (this.hls.trigger(m.ERROR, {
        type: U.OTHER_ERROR,
        details: L.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: d,
        error: c,
        reason: c.message
      }), d)
        return;
      e = Math.min(e, t.length - 1);
    }
    const s = this.currentLevelIndex, i = this.currentLevel, r = i ? i.attrs["PATHWAY-ID"] : void 0, n = t[e], o = n.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = n, s === e && n.details && i && r === o)
      return;
    this.log(`Switching to level ${e}${o ? " with Pathway " + o : ""} from level ${s}${r ? " with Pathway " + r : ""}`);
    const l = ae({}, n, {
      level: e,
      maxBitrate: n.maxBitrate,
      attrs: n.attrs,
      uri: n.uri,
      urlId: n.urlId
    });
    delete l._attrs, delete l._urlId, this.hls.trigger(m.LEVEL_SWITCHING, l);
    const h = n.details;
    if (!h || h.live) {
      const c = this.switchParams(n.uri, i == null ? void 0 : i.details);
      this.loadPlaylist(c);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this._firstLevel;
    } else
      return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === K.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragLoaded(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === $.MAIN) {
      const s = this._levels[t.level];
      s !== void 0 && (s.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      level: i,
      details: r
    } = t, n = this._levels[i];
    if (!n) {
      var o;
      this.warn(`Invalid level index ${i}`), (o = t.deliveryDirectives) != null && o.skip && (r.deltaUpdateFailed = !0);
      return;
    }
    i === this.currentLevelIndex ? (n.fragmentError === 0 && (n.loadError = 0), this.playlistLoaded(i, t, n.details)) : (s = t.deliveryDirectives) != null && s.skip && (r.deltaUpdateFailed = !0);
  }
  onAudioTrackSwitched(e, t) {
    const s = this.currentLevel;
    if (!s)
      return;
    const i = this.hls.audioTracks[t.id].groupId;
    if (s.audioGroupIds && s.audioGroupId !== i) {
      let r = -1;
      for (let n = 0; n < s.audioGroupIds.length; n++)
        if (s.audioGroupIds[n] === i) {
          r = n;
          break;
        }
      r !== -1 && r !== s.urlId && (s.urlId = r, this.canLoad && this.startLoad());
    }
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentLevelIndex, s = this.currentLevel;
    if (s && this.shouldLoadPlaylist(s)) {
      const i = s.urlId;
      let r = s.uri;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      const n = s.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${t}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${n ? " Pathway " + n : ""} URI ${i + 1}/${s.url.length} ${r}`), this.clearTimer(), this.hls.trigger(m.LEVEL_LOADING, {
        url: r,
        level: t,
        id: i,
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e, t) {
    const s = (r, n) => n !== t, i = this._levels.filter((r, n) => n !== e ? !0 : r.url.length > 1 && t !== void 0 ? (r.url = r.url.filter(s), r.audioGroupIds && (r.audioGroupIds = r.audioGroupIds.filter(s)), r.textGroupIds && (r.textGroupIds = r.textGroupIds.filter(s)), r.urlId = 0, !0) : (this.steering && this.steering.removeLevel(r), !1));
    this.hls.trigger(m.LEVELS_UPDATED, {
      levels: i
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    t.forEach((s, i) => {
      const {
        details: r
      } = s;
      r != null && r.fragments && r.fragments.forEach((n) => {
        n.level = i;
      });
    }), this._levels = t;
  }
}
function Vt(a, e, t) {
  t && (e === "audio" ? (a.audioGroupIds || (a.audioGroupIds = []), a.audioGroupIds[a.url.length - 1] = t) : e === "text" && (a.textGroupIds || (a.textGroupIds = []), a.textGroupIds[a.url.length - 1] = t));
}
function Ii(a) {
  const e = {};
  a.forEach((t) => {
    const s = t.groupId || "";
    t.id = e[s] = e[s] || 0, e[s]++;
  });
}
var he = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class Ba {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.BUFFER_APPENDED, this.onBufferAppended, this), e.on(m.FRAG_BUFFERED, this.onFragBuffered, this), e.on(m.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.BUFFER_APPENDED, this.onBufferAppended, this), e.off(m.FRAG_BUFFERED, this.onFragBuffered, this), e.off(m.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const s = this.activePartLists[t];
    if (s)
      for (let i = s.length; i--; ) {
        const r = s[i];
        if (!r)
          break;
        const n = r.end;
        if (r.start <= e && n !== null && e <= n)
          return r;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    const {
      fragments: s
    } = this, i = Object.keys(s);
    for (let r = i.length; r--; ) {
      const n = s[i[r]];
      if ((n == null ? void 0 : n.body.type) === t && n.buffered) {
        const o = n.body;
        if (o.start <= e && e <= o.end)
          return o;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, s, i) {
    this.timeRanges && (this.timeRanges[e] = t);
    const r = (i == null ? void 0 : i.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((n) => {
      const o = this.fragments[n];
      if (!o || r >= o.body.sn)
        return;
      if (!o.buffered && !o.loaded) {
        o.body.type === s && this.removeFragment(o.body);
        return;
      }
      const l = o.range[e];
      l && l.time.some((h) => {
        const c = !this.isTimeBuffered(h.startPTS, h.endPTS, t);
        return c && this.removeFragment(o.body), c;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges, {
      frag: s,
      part: i
    } = e;
    if (!t || s.sn === "initSegment")
      return;
    const r = rt(s), n = this.fragments[r];
    if (!n || n.buffered && s.gap)
      return;
    const o = !s.relurl;
    Object.keys(t).forEach((l) => {
      const h = s.elementaryStreams[l];
      if (!h)
        return;
      const c = t[l], d = o || h.partial === !0;
      n.range[l] = this.getBufferedTimes(s, i, d, c);
    }), n.loaded = null, Object.keys(n.range).length ? (n.buffered = !0, (n.body.endList = s.endList || n.body.endList) && (this.endListFragments[n.body.type] = n), _t(n) || this.removeParts(s.sn - 1, s.type)) : this.removeFragment(n.body);
  }
  removeParts(e, t) {
    const s = this.activePartLists[t];
    s && (this.activePartLists[t] = s.filter((i) => i.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const s = rt(e);
    let i = this.fragments[s];
    !i && t && (i = this.fragments[s] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), i && (i.loaded = null, i.buffered = !0);
  }
  getBufferedTimes(e, t, s, i) {
    const r = {
      time: [],
      partial: s
    }, n = e.start, o = e.end, l = e.minEndPTS || o, h = e.maxStartPTS || n;
    for (let c = 0; c < i.length; c++) {
      const d = i.start(c) - this.bufferPadding, u = i.end(c) + this.bufferPadding;
      if (h >= d && l <= u) {
        r.time.push({
          startPTS: Math.max(n, i.start(c)),
          endPTS: Math.min(o, i.end(c))
        });
        break;
      } else if (n < u && o > d)
        r.partial = !0, r.time.push({
          startPTS: Math.max(n, i.start(c)),
          endPTS: Math.min(o, i.end(c))
        });
      else if (o <= d)
        break;
    }
    return r;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, s, i, r, n = 0;
    const {
      bufferPadding: o,
      fragments: l
    } = this;
    return Object.keys(l).forEach((h) => {
      const c = l[h];
      c && _t(c) && (i = c.body.start - o, r = c.body.end + o, e >= i && e <= r && (s = Math.min(e - i, r - e), n <= s && (t = c.body, n = s)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || _t(t));
  }
  getState(e) {
    const t = rt(e), s = this.fragments[t];
    return s ? s.buffered ? _t(s) ? he.PARTIAL : he.OK : he.APPENDING : he.NOT_LOADED;
  }
  isTimeBuffered(e, t, s) {
    let i, r;
    for (let n = 0; n < s.length; n++) {
      if (i = s.start(n) - this.bufferPadding, r = s.end(n) + this.bufferPadding, e >= i && t <= r)
        return !0;
      if (t <= i)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s.sn === "initSegment" || s.bitrateTest)
      return;
    const r = i ? null : t, n = rt(s);
    this.fragments[n] = {
      body: s,
      appendedPTS: null,
      loaded: r,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: s,
      part: i,
      timeRanges: r
    } = t;
    if (s.sn === "initSegment")
      return;
    const n = s.type;
    if (i) {
      let o = this.activePartLists[n];
      o || (this.activePartLists[n] = o = []), o.push(i);
    }
    this.timeRanges = r, Object.keys(r).forEach((o) => {
      const l = r[o];
      this.detectEvictedFragments(o, l, n, i);
    });
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = rt(e);
    return !!this.fragments[t];
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, s, i, r) {
    i && !this.hasGaps || Object.keys(this.fragments).forEach((n) => {
      const o = this.fragments[n];
      if (!o)
        return;
      const l = o.body;
      l.type !== s || i && !l.gap || l.start < t && l.end > e && (o.buffered || r) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = rt(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const s = this.activePartLists[e.type];
    if (s) {
      const i = e.sn;
      this.activePartLists[e.type] = s.filter((r) => r.fragment.sn !== i);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function _t(a) {
  var e, t, s;
  return a.buffered && (a.body.gap || ((e = a.range.video) == null ? void 0 : e.partial) || ((t = a.range.audio) == null ? void 0 : t.partial) || ((s = a.range.audiovideo) == null ? void 0 : s.partial));
}
function rt(a) {
  return `${a.type}_${a.level}_${a.urlId}_${a.sn}`;
}
const wi = Math.pow(2, 17);
class Ga {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const s = e.url;
    if (!s)
      return Promise.reject(new Ge({
        type: U.NETWORK_ERROR,
        details: L.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${s ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const i = this.config, r = i.fLoader, n = i.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((f) => f[0] === "GAP")) {
          l(Ci(e));
          return;
        } else
          e.gap = !1;
      const h = this.loader = e.loader = r ? new r(i) : new n(i), c = _i(e), d = Ri(i.fragLoadPolicy.default), u = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : wi
      };
      e.stats = h.stats, h.load(c, u, {
        onSuccess: (f, g, p, v) => {
          this.resetLoader(e, h);
          let y = f.data;
          p.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(y.slice(0, 16)), y = y.slice(16)), o({
            frag: e,
            part: null,
            payload: y,
            networkDetails: v
          });
        },
        onError: (f, g, p, v) => {
          this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: Le({
              url: s,
              data: void 0
            }, f),
            error: new Error(`HTTP Error ${f.code} ${f.text}`),
            networkDetails: p,
            stats: v
          }));
        },
        onAbort: (f, g, p) => {
          this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: p,
            stats: f
          }));
        },
        onTimeout: (f, g, p) => {
          this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${u.timeout}ms`),
            networkDetails: p,
            stats: f
          }));
        },
        onProgress: (f, g, p, v) => {
          t && t({
            frag: e,
            part: null,
            payload: p,
            networkDetails: v
          });
        }
      });
    });
  }
  loadPart(e, t, s) {
    this.abort();
    const i = this.config, r = i.fLoader, n = i.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(Ci(e, t));
        return;
      }
      const h = this.loader = e.loader = r ? new r(i) : new n(i), c = _i(e, t), d = Ri(i.fragLoadPolicy.default), u = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: wi
      };
      t.stats = h.stats, h.load(c, u, {
        onSuccess: (f, g, p, v) => {
          this.resetLoader(e, h), this.updateStatsFromPart(e, t);
          const y = {
            frag: e,
            part: t,
            payload: f.data,
            networkDetails: v
          };
          s(y), o(y);
        },
        onError: (f, g, p, v) => {
          this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: Le({
              url: c.url,
              data: void 0
            }, f),
            error: new Error(`HTTP Error ${f.code} ${f.text}`),
            networkDetails: p,
            stats: v
          }));
        },
        onAbort: (f, g, p) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: p,
            stats: f
          }));
        },
        onTimeout: (f, g, p) => {
          this.resetLoader(e, h), l(new Ge({
            type: U.NETWORK_ERROR,
            details: L.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${u.timeout}ms`),
            networkDetails: p,
            stats: f
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const s = e.stats, i = t.stats, r = i.total;
    if (s.loaded += i.loaded, r) {
      const l = Math.round(e.duration / t.duration), h = Math.min(Math.round(s.loaded / r), l), d = (l - h) * Math.round(s.loaded / h);
      s.total = s.loaded + d;
    } else
      s.total = Math.max(s.loaded, s.total);
    const n = s.loading, o = i.loading;
    n.start ? n.first += o.first - o.start : (n.start = o.start, n.first = o.first), n.end = o.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function _i(a, e = null) {
  const t = e || a, s = {
    frag: a,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, i = t.byteRangeStartOffset, r = t.byteRangeEndOffset;
  if (M(i) && M(r)) {
    var n;
    let o = i, l = r;
    if (a.sn === "initSegment" && ((n = a.decryptdata) == null ? void 0 : n.method) === "AES-128") {
      const h = r - i;
      h % 16 && (l = r + (16 - h % 16)), i !== 0 && (s.resetIV = !0, o = i - 16);
    }
    s.rangeStart = o, s.rangeEnd = l;
  }
  return s;
}
function Ci(a, e) {
  const t = new Error(`GAP ${a.gap ? "tag" : "attribute"} found`), s = {
    type: U.MEDIA_ERROR,
    details: L.FRAG_GAP,
    fatal: !1,
    frag: a,
    error: t,
    networkDetails: null
  };
  return e && (s.part = e), (e || a).stats.aborted = !0, new Ge(s);
}
class Ge extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Va {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const t in this.keyUriToKeyInfo) {
      const s = this.keyUriToKeyInfo[t].loader;
      if (s) {
        if (e && e !== s.context.frag.type)
          return;
        s.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = L.KEY_LOAD_ERROR, s, i, r) {
    return new Ge({
      type: U.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: r,
      error: s,
      networkDetails: i
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: s,
        cc: i
      } = e;
      for (let r = 0; r < t.length; r++) {
        const n = t[r];
        if (i <= n.cc && (s === "initSegment" || n.sn === "initSegment" || s < n.sn)) {
          this.emeController.selectKeySystemFormat(n).then((o) => {
            n.setKeyFormat(o);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var s, i;
    t && e.setKeyFormat(t);
    const r = e.decryptdata;
    if (!r) {
      const h = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, L.KEY_LOAD_ERROR, h));
    }
    const n = r.uri;
    if (!n)
      return Promise.reject(this.createKeyLoadError(e, L.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${n}"`)));
    let o = this.keyUriToKeyInfo[n];
    if ((s = o) != null && s.decryptdata.key)
      return r.key = o.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: o
      });
    if ((i = o) != null && i.keyLoadPromise) {
      var l;
      switch ((l = o.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return o.keyLoadPromise.then((h) => (r.key = h.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: o
          }));
      }
    }
    switch (o = this.keyUriToKeyInfo[n] = {
      decryptdata: r,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, r.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return r.keyFormat === "identity" ? this.loadKeyHTTP(o, e) : this.loadKeyEME(o, e);
      case "AES-128":
        return this.loadKeyHTTP(o, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, L.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${r.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const s = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const i = this.emeController.loadKey(s);
      if (i)
        return (e.keyLoadPromise = i.then((r) => (e.mediaKeySessionContext = r, s))).catch((r) => {
          throw e.keyLoadPromise = null, r;
        });
    }
    return Promise.resolve(s);
  }
  loadKeyHTTP(e, t) {
    const s = this.config, i = s.loader, r = new i(s);
    return t.keyLoader = e.loader = r, e.keyLoadPromise = new Promise((n, o) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, h = s.keyLoadPolicy.default, c = {
        loadPolicy: h,
        timeout: h.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (u, f, g, p) => {
          const {
            frag: v,
            keyInfo: y,
            url: T
          } = g;
          if (!v.decryptdata || y !== this.keyUriToKeyInfo[T])
            return o(this.createKeyLoadError(v, L.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), p));
          y.decryptdata.key = v.decryptdata.key = new Uint8Array(u.data), v.keyLoader = null, y.loader = null, n({
            frag: v,
            keyInfo: y
          });
        },
        onError: (u, f, g, p) => {
          this.resetLoader(f), o(this.createKeyLoadError(t, L.KEY_LOAD_ERROR, new Error(`HTTP Error ${u.code} loading key ${u.text}`), g, Le({
            url: l.url,
            data: void 0
          }, u)));
        },
        onTimeout: (u, f, g) => {
          this.resetLoader(f), o(this.createKeyLoadError(t, L.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), g));
        },
        onAbort: (u, f, g) => {
          this.resetLoader(f), o(this.createKeyLoadError(t, L.INTERNAL_ABORTED, new Error("key loading aborted"), g));
        }
      };
      r.load(l, c, d);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: s,
      url: i
    } = e, r = s.loader;
    t.keyLoader === r && (t.keyLoader = null, s.loader = null), delete this.keyUriToKeyInfo[i], r && r.destroy();
  }
}
class Ha {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
const Ka = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class J {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    try {
      if (e) {
        const s = J.getBuffered(e);
        for (let i = 0; i < s.length; i++)
          if (t >= s.start(i) && t <= s.end(i))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(e, t, s) {
    try {
      if (e) {
        const i = J.getBuffered(e), r = [];
        let n;
        for (n = 0; n < i.length; n++)
          r.push({
            start: i.start(n),
            end: i.end(n)
          });
        return this.bufferedInfo(r, t, s);
      }
    } catch {
    }
    return {
      len: 0,
      start: t,
      end: t,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, t, s) {
    t = Math.max(0, t), e.sort(function(h, c) {
      const d = h.start - c.start;
      return d || c.end - h.end;
    });
    let i = [];
    if (s)
      for (let h = 0; h < e.length; h++) {
        const c = i.length;
        if (c) {
          const d = i[c - 1].end;
          e[h].start - d < s ? e[h].end > d && (i[c - 1].end = e[h].end) : i.push(e[h]);
        } else
          i.push(e[h]);
      }
    else
      i = e;
    let r = 0, n, o = t, l = t;
    for (let h = 0; h < i.length; h++) {
      const c = i[h].start, d = i[h].end;
      if (t + s >= c && t < d)
        o = c, l = d, r = l - t;
      else if (t + s < c) {
        n = c;
        break;
      }
    }
    return {
      len: r,
      start: o || 0,
      end: l || 0,
      nextStart: n
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (t) {
      return E.log("failed to get media.buffered", t), Ka;
    }
  }
}
class Vs {
  constructor(e, t, s, i = 0, r = -1, n = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = Ct(), this.buffering = {
      audio: Ct(),
      video: Ct(),
      audiovideo: Ct()
    }, this.level = e, this.sn = t, this.id = s, this.size = i, this.part = r, this.partial = n;
  }
}
function Ct() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function Pr(a, e) {
  let t = null;
  for (let s = 0, i = a.length; s < i; s++) {
    const r = a[s];
    if (r && r.cc === e) {
      t = r;
      break;
    }
  }
  return t;
}
function Wa(a, e, t) {
  return !!(e.details && (t.endCC > t.startCC || a && a.cc < t.startCC));
}
function Ya(a, e, t = 0) {
  const s = a.fragments, i = e.fragments;
  if (!i.length || !s.length) {
    E.log("No fragments to align");
    return;
  }
  const r = Pr(s, i[0].cc);
  if (!r || r && !r.startPTS) {
    E.log("No frag in previous level to align on");
    return;
  }
  return r;
}
function Di(a, e) {
  if (a) {
    const t = a.start + e;
    a.start = a.startPTS = t, a.endPTS = t + a.duration;
  }
}
function Hs(a, e) {
  const t = e.fragments;
  for (let s = 0, i = t.length; s < i; s++)
    Di(t[s], a);
  e.fragmentHint && Di(e.fragmentHint, a), e.alignedSliding = !0;
}
function za(a, e, t) {
  e && (ja(a, t, e), !t.alignedSliding && e.details && qa(t, e.details), !t.alignedSliding && e.details && !t.skippedSegments && Cr(e.details, t));
}
function ja(a, e, t) {
  if (Wa(a, t, e)) {
    const s = Ya(t.details, e);
    s && M(s.start) && (E.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), Hs(s.start, e));
  }
}
function qa(a, e) {
  if (!e.fragments.length || !a.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = e.fragments[0].programDateTime, s = a.fragments[0].programDateTime, i = (s - t) / 1e3 + e.fragments[0].start;
  i && M(i) && (E.log(`Adjusting PTS using programDateTime delta ${s - t}ms, sliding:${i.toFixed(3)} ${a.url} `), Hs(i, a));
}
function Or(a, e) {
  if (!a.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = a.fragments, s = e.fragments;
  if (!t.length || !s.length)
    return;
  const i = Math.round(s.length / 2) - 1, r = s[i], n = Pr(t, r.cc) || t[Math.round(t.length / 2) - 1], o = r.programDateTime, l = n.programDateTime;
  if (o === null || l === null)
    return;
  const h = (l - o) / 1e3 - (n.start - r.start);
  Hs(h, a);
}
class Xa {
  constructor(e, t) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
  }
  decrypt(e, t) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, t, e);
  }
}
class Za {
  constructor(e, t) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function Qa(a) {
  const e = a.byteLength, t = e && new DataView(a.buffer).getUint8(e - 1);
  return t ? et(a, 0, e - t) : a;
}
class Ja {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), s = new Uint32Array(4);
    for (let i = 0; i < 4; i++)
      s[i] = t.getUint32(i * 4);
    return s;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, s = this.subMix, i = s[0], r = s[1], n = s[2], o = s[3], l = this.invSubMix, h = l[0], c = l[1], d = l[2], u = l[3], f = new Uint32Array(256);
    let g = 0, p = 0, v = 0;
    for (v = 0; v < 256; v++)
      v < 128 ? f[v] = v << 1 : f[v] = v << 1 ^ 283;
    for (v = 0; v < 256; v++) {
      let y = p ^ p << 1 ^ p << 2 ^ p << 3 ^ p << 4;
      y = y >>> 8 ^ y & 255 ^ 99, e[g] = y, t[y] = g;
      const T = f[g], x = f[T], A = f[x];
      let b = f[y] * 257 ^ y * 16843008;
      i[g] = b << 24 | b >>> 8, r[g] = b << 16 | b >>> 16, n[g] = b << 8 | b >>> 24, o[g] = b, b = A * 16843009 ^ x * 65537 ^ T * 257 ^ g * 16843008, h[y] = b << 24 | b >>> 8, c[y] = b << 16 | b >>> 16, d[y] = b << 8 | b >>> 24, u[y] = b, g ? (g = T ^ f[f[f[A ^ T]]], p ^= f[f[p]]) : g = p = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let s = !0, i = 0;
    for (; i < t.length && s; )
      s = t[i] === this.key[i], i++;
    if (s)
      return;
    this.key = t;
    const r = this.keySize = t.length;
    if (r !== 4 && r !== 6 && r !== 8)
      throw new Error("Invalid aes key size=" + r);
    const n = this.ksRows = (r + 6 + 1) * 4;
    let o, l;
    const h = this.keySchedule = new Uint32Array(n), c = this.invKeySchedule = new Uint32Array(n), d = this.sBox, u = this.rcon, f = this.invSubMix, g = f[0], p = f[1], v = f[2], y = f[3];
    let T, x;
    for (o = 0; o < n; o++) {
      if (o < r) {
        T = h[o] = t[o];
        continue;
      }
      x = T, o % r === 0 ? (x = x << 8 | x >>> 24, x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255], x ^= u[o / r | 0] << 24) : r > 6 && o % r === 4 && (x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255]), h[o] = T = (h[o - r] ^ x) >>> 0;
    }
    for (l = 0; l < n; l++)
      o = n - l, l & 3 ? x = h[o] : x = h[o - 4], l < 4 || o <= 4 ? c[l] = x : c[l] = g[d[x >>> 24]] ^ p[d[x >>> 16 & 255]] ^ v[d[x >>> 8 & 255]] ^ y[d[x & 255]], c[l] = c[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, s) {
    const i = this.keySize + 6, r = this.invKeySchedule, n = this.invSBox, o = this.invSubMix, l = o[0], h = o[1], c = o[2], d = o[3], u = this.uint8ArrayToUint32Array_(s);
    let f = u[0], g = u[1], p = u[2], v = u[3];
    const y = new Int32Array(e), T = new Int32Array(y.length);
    let x, A, b, C, I, _, D, R, F, P, W, le, V, Y;
    const X = this.networkToHostOrderSwap;
    for (; t < y.length; ) {
      for (F = X(y[t]), P = X(y[t + 1]), W = X(y[t + 2]), le = X(y[t + 3]), I = F ^ r[0], _ = le ^ r[1], D = W ^ r[2], R = P ^ r[3], V = 4, Y = 1; Y < i; Y++)
        x = l[I >>> 24] ^ h[_ >> 16 & 255] ^ c[D >> 8 & 255] ^ d[R & 255] ^ r[V], A = l[_ >>> 24] ^ h[D >> 16 & 255] ^ c[R >> 8 & 255] ^ d[I & 255] ^ r[V + 1], b = l[D >>> 24] ^ h[R >> 16 & 255] ^ c[I >> 8 & 255] ^ d[_ & 255] ^ r[V + 2], C = l[R >>> 24] ^ h[I >> 16 & 255] ^ c[_ >> 8 & 255] ^ d[D & 255] ^ r[V + 3], I = x, _ = A, D = b, R = C, V = V + 4;
      x = n[I >>> 24] << 24 ^ n[_ >> 16 & 255] << 16 ^ n[D >> 8 & 255] << 8 ^ n[R & 255] ^ r[V], A = n[_ >>> 24] << 24 ^ n[D >> 16 & 255] << 16 ^ n[R >> 8 & 255] << 8 ^ n[I & 255] ^ r[V + 1], b = n[D >>> 24] << 24 ^ n[R >> 16 & 255] << 16 ^ n[I >> 8 & 255] << 8 ^ n[_ & 255] ^ r[V + 2], C = n[R >>> 24] << 24 ^ n[I >> 16 & 255] << 16 ^ n[_ >> 8 & 255] << 8 ^ n[D & 255] ^ r[V + 3], T[t] = X(x ^ f), T[t + 1] = X(C ^ g), T[t + 2] = X(b ^ p), T[t + 3] = X(A ^ v), f = F, g = P, p = W, v = le, t = t + 4;
    }
    return T.buffer;
  }
}
const eo = 16;
class Ks {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const s = self.crypto;
        s && (this.subtle = s.subtle || s.webkitSubtle);
      } catch {
      }
    this.subtle === null && (this.useSoftware = !0);
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const s = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? Qa(s) : s;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, s) {
    return this.useSoftware ? new Promise((i, r) => {
      this.softwareDecrypt(new Uint8Array(e), t, s);
      const n = this.flush();
      n ? i(n.buffer) : r(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, s);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, s) {
    const {
      currentIV: i,
      currentResult: r,
      remainderData: n
    } = this;
    this.logOnce("JS AES decrypt"), n && (e = tt(n, e), this.remainderData = null);
    const o = this.getValidChunk(e);
    if (!o.length)
      return null;
    i && (s = i);
    let l = this.softwareDecrypter;
    l || (l = this.softwareDecrypter = new Ja()), l.expandKey(t);
    const h = r;
    return this.currentResult = l.decrypt(o.buffer, 0, s), this.currentIV = et(o, -16).buffer, h || null;
  }
  webCryptoDecrypt(e, t, s) {
    const i = this.subtle;
    return (this.key !== t || !this.fastAesKey) && (this.key = t, this.fastAesKey = new Za(i, t)), this.fastAesKey.expandKey().then((r) => i ? (this.logOnce("WebCrypto AES decrypt"), new Xa(i, new Uint8Array(s)).decrypt(e.buffer, r)) : Promise.reject(new Error("web crypto not initialized"))).catch((r) => (E.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${r.name}: ${r.message}`), this.onWebCryptoError(e, t, s)));
  }
  onWebCryptoError(e, t, s) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, s);
    const i = this.flush();
    if (i)
      return i.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const s = e.length - e.length % eo;
    return s !== e.length && (t = et(e, 0, s), this.remainderData = et(e, s)), t;
  }
  logOnce(e) {
    this.logEnabled && (E.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const to = {
  toString: function(a) {
    let e = "";
    const t = a.length;
    for (let s = 0; s < t; s++)
      e += `[${a.start(s).toFixed(3)}-${a.end(s).toFixed(3)}]`;
    return e;
  }
}, w = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class Ws extends Ha {
  constructor(e, t, s, i, r) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = w.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = r, this.logPrefix = i, this.log = E.log.bind(E, `${i}:`), this.warn = E.warn.bind(E, `${i}:`), this.hls = e, this.fragmentLoader = new Ga(e.config), this.keyLoader = s, this.fragmentTracker = t, this.config = e.config, this.decrypter = new Ks(e.config), e.on(m.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = w.STOPPED;
  }
  _streamEnded(e, t) {
    if (t.live || e.nextStart || !e.end || !this.media)
      return !1;
    const s = t.partList;
    if (s != null && s.length) {
      const r = s[s.length - 1];
      return J.isBuffered(this.media, r.start + r.duration / 2);
    }
    const i = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(i);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levels[this.levelLastLoaded]) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, t) {
    const s = this.media = this.mediaBuffer = t.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), s.addEventListener("seeking", this.onvseeking), s.addEventListener("ended", this.onvended);
    const i = this.config;
    this.levels && i.autoStartLoad && this.state === w.STOPPED && this.startLoad(i.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: t,
      media: s,
      mediaBuffer: i,
      state: r
    } = this, n = s ? s.currentTime : 0, o = J.bufferInfo(i || s, n, e.maxBufferHole);
    if (this.log(`media seeking to ${M(n) ? n.toFixed(3) : n}, state: ${r}`), this.state === w.ENDED)
      this.resetLoadingState();
    else if (t) {
      const l = e.maxFragLookUpTolerance, h = t.start - l, c = t.start + t.duration + l;
      if (!o.len || c < o.start || h > o.end) {
        const d = n > c;
        (n < h || d) && (d && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    s && (this.fragmentTracker.removeFragmentsInRange(n, 1 / 0, this.playlistType, !0), this.lastCurrentTime = n), !this.loadedmetadata && !o.len && (this.nextLoadPosition = this.startPosition = n), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.stopLoad(), super.onHandlerDestroying();
  }
  onHandlerDestroyed() {
    this.state = w.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, s) {
    this._loadFragForPlayback(e, t, s);
  }
  _loadFragForPlayback(e, t, s) {
    const i = (r) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${r.part ? " p: " + r.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(r);
    };
    this._doFragLoad(e, t, s, i).then((r) => {
      if (!r)
        return;
      const n = this.state;
      if (this.fragContextChanged(e)) {
        (n === w.FRAG_LOADING || !this.fragCurrent && n === w.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = w.IDLE);
        return;
      }
      "payload" in r && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(m.FRAG_LOADED, r)), this._handleFragmentLoadComplete(r);
    }).catch((r) => {
      this.state === w.STOPPED || this.state === w.ERROR || (this.warn(r), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: s
    } = this;
    if (s.getState(e) === he.APPENDING) {
      const r = e.type, n = this.getFwdBufferInfo(this.mediaBuffer, r), o = Math.max(e.duration, n ? n.len : this.config.maxBufferLength);
      this.reduceMaxBufferLength(o) && s.removeFragment(e);
    } else
      ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? s.removeAllFragments() : s.hasParts(e.type) && (s.detectPartialFragments({
        frag: e,
        part: null,
        stats: e.stats,
        id: e.type
      }), s.getState(e) === he.PARTIAL && s.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  flushMainBuffer(e, t, s = null) {
    if (!(e - t))
      return;
    const i = {
      startOffset: e,
      endOffset: t,
      type: s
    };
    this.hls.trigger(m.BUFFER_FLUSHING, i);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((s) => {
      if (!s || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return s;
    }).then((s) => {
      const {
        hls: i
      } = this, {
        payload: r
      } = s, n = e.decryptdata;
      if (r && r.byteLength > 0 && n && n.key && n.iv && n.method === "AES-128") {
        const o = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(r), n.key.buffer, n.iv.buffer).catch((l) => {
          throw i.trigger(m.ERROR, {
            type: U.MEDIA_ERROR,
            details: L.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: l,
            reason: l.message,
            frag: e
          }), l;
        }).then((l) => {
          const h = self.performance.now();
          return i.trigger(m.FRAG_DECRYPTED, {
            frag: e,
            payload: l,
            stats: {
              tstart: o,
              tdecrypt: h
            }
          }), s.payload = l, s;
        });
      }
      return s;
    }).then((s) => {
      const {
        fragCurrent: i,
        hls: r,
        levels: n
      } = this;
      if (!n)
        throw new Error("init load aborted, missing levels");
      const o = e.stats;
      this.state = w.IDLE, t.fragmentError = 0, e.data = new Uint8Array(s.payload), o.parsing.start = o.buffering.start = self.performance.now(), o.parsing.end = o.buffering.end = self.performance.now(), s.frag === i && r.trigger(m.FRAG_BUFFERED, {
        stats: o,
        frag: i,
        part: null,
        id: e.type
      }), this.tick();
    }).catch((s) => {
      this.state === w.STOPPED || this.state === w.ERROR || (this.warn(s), this.resetFragmentLoading(e));
    });
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.level !== t.level || e.sn !== t.sn || e.urlId !== t.urlId;
  }
  fragBufferedComplete(e, t) {
    var s, i, r, n;
    const o = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.playlistType === $.MAIN ? "level" : "track"} ${e.level} (frag:[${((s = e.startPTS) != null ? s : NaN).toFixed(3)}-${((i = e.endPTS) != null ? i : NaN).toFixed(3)}] > buffer:${o ? to.toString(J.getBuffered(o)) : "(detached)"})`), this.state = w.IDLE, o && (!this.loadedmetadata && e.type == $.MAIN && o.buffered.length && ((r = this.fragCurrent) == null ? void 0 : r.sn) === ((n = this.fragPrevious) == null ? void 0 : n.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: s,
      part: i,
      partsLoaded: r
    } = e, n = !r || r.length === 0 || r.some((l) => !l), o = new Vs(s.level, s.sn, s.stats.chunkCount + 1, 0, i ? i.index : -1, !n);
    t.flush(o);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, s = null, i) {
    var r;
    const n = t == null ? void 0 : t.details;
    if (!this.levels || !n)
      throw new Error(`frag load aborted, missing level${n ? "" : " detail"}s`);
    let o = null;
    if (e.encrypted && !((r = e.decryptdata) != null && r.key) ? (this.log(`Loading key for ${e.sn} of [${n.startSN}-${n.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = w.KEY_LOADING, this.fragCurrent = e, o = this.keyLoader.load(e).then((c) => {
      if (!this.fragContextChanged(c.frag))
        return this.hls.trigger(m.KEY_LOADED, c), this.state === w.KEY_LOADING && (this.state = w.IDLE), c;
    }), this.hls.trigger(m.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (o = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && n.encryptedFragments.length && this.keyLoader.loadClear(e, n.encryptedFragments), s = Math.max(e.start, s || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const c = n.partList;
      if (c && i) {
        s > e.end && n.fragmentHint && (e = n.fragmentHint);
        const d = this.getNextPart(c, e, s);
        if (d > -1) {
          const u = c[d];
          this.log(`Loading part sn: ${e.sn} p: ${u.index} cc: ${e.cc} of playlist [${n.startSN}-${n.endSN}] parts [0-${d}-${c.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), this.nextLoadPosition = u.start + u.duration, this.state = w.FRAG_LOADING;
          let f;
          return o ? f = o.then((g) => !g || this.fragContextChanged(g.frag) ? null : this.doFragPartsLoad(e, u, t, i)).catch((g) => this.handleFragLoadError(g)) : f = this.doFragPartsLoad(e, u, t, i).catch((g) => this.handleFragLoadError(g)), this.hls.trigger(m.FRAG_LOADING, {
            frag: e,
            part: u,
            targetBufferTime: s
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : f;
        } else if (!e.url || this.loadedEndOfParts(c, s))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${n ? "of [" + n.startSN + "-" + n.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), M(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = w.FRAG_LOADING;
    const l = this.config.progressive;
    let h;
    return l && o ? h = o.then((c) => !c || this.fragContextChanged(c == null ? void 0 : c.frag) ? null : this.fragmentLoader.load(e, i)).catch((c) => this.handleFragLoadError(c)) : h = Promise.all([this.fragmentLoader.load(e, l ? i : void 0), o]).then(([c]) => (!l && c && i && i(c), c)).catch((c) => this.handleFragLoadError(c)), this.hls.trigger(m.FRAG_LOADING, {
      frag: e,
      targetBufferTime: s
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : h;
  }
  doFragPartsLoad(e, t, s, i) {
    return new Promise((r, n) => {
      var o;
      const l = [], h = (o = s.details) == null ? void 0 : o.partList, c = (d) => {
        this.fragmentLoader.loadPart(e, d, i).then((u) => {
          l[d.index] = u;
          const f = u.part;
          this.hls.trigger(m.FRAG_LOADED, u);
          const g = Li(s, e.sn, d.index + 1) || Dr(h, e.sn, d.index + 1);
          if (g)
            c(g);
          else
            return r({
              frag: e,
              part: f,
              partsLoaded: l
            });
        }).catch(n);
      };
      c(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === L.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(m.ERROR, t);
    } else
      this.hls.trigger(m.ERROR, {
        type: U.OTHER_ERROR,
        details: L.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== w.PARSING) {
      !this.fragCurrent && this.state !== w.STOPPED && this.state !== w.ERROR && (this.state = w.IDLE);
      return;
    }
    const {
      frag: s,
      part: i,
      level: r
    } = t, n = self.performance.now();
    s.stats.parsing.end = n, i && (i.stats.parsing.end = n), this.updateLevelTiming(s, i, r, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: s
    } = this, {
      level: i,
      sn: r,
      part: n
    } = e;
    if (!(t != null && t[i]))
      return this.warn(`Levels object was unset while buffering fragment ${r} of level ${i}. The current chunk will not be buffered.`), null;
    const o = t[i], l = n > -1 ? Li(o, r, n) : null, h = l ? l.fragment : Da(o, r, s);
    return h ? (s && s !== h && (h.stats = s.stats), {
      frag: h,
      part: l,
      level: o
    }) : null;
  }
  bufferFragmentData(e, t, s, i, r) {
    var n;
    if (!e || this.state !== w.PARSING)
      return;
    const {
      data1: o,
      data2: l
    } = e;
    let h = o;
    if (o && l && (h = tt(o, l)), !((n = h) != null && n.length))
      return;
    const c = {
      type: e.type,
      frag: t,
      part: s,
      chunkMeta: i,
      parent: t.type,
      data: h
    };
    if (this.hls.trigger(m.BUFFER_APPENDING, c), e.dropped && e.independent && !s) {
      if (r)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!J.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const s = t.currentTime, i = J.bufferInfo(t, s, 0), r = e.duration, n = Math.min(this.config.maxFragLookUpTolerance * 2, r * 0.25), o = Math.max(Math.min(e.start - n, i.end - n), s + n);
    e.start - o > n && this.flushMainBuffer(o, e.start);
  }
  getFwdBufferInfo(e, t) {
    const s = this.getLoadPosition();
    return M(s) ? this.getFwdBufferInfoAtPos(e, s, t) : null;
  }
  getFwdBufferInfoAtPos(e, t, s) {
    const {
      config: {
        maxBufferHole: i
      }
    } = this, r = J.bufferInfo(e, t, i);
    if (r.len === 0 && r.nextStart !== void 0) {
      const n = this.fragmentTracker.getBufferedFrag(t, s);
      if (n && r.nextStart < n.end)
        return J.bufferInfo(e, t, Math.max(r.nextStart, i));
    }
    return r;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let s;
    return e ? s = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : s = t.maxBufferLength, Math.min(s, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e) {
    const t = this.config, s = e || t.maxBufferLength;
    return t.maxMaxBufferLength >= s ? (t.maxMaxBufferLength /= 2, this.warn(`Reduce max buffer length to ${t.maxMaxBufferLength}s`), !0) : !1;
  }
  getAppendedFrag(e, t = $.MAIN) {
    const s = this.fragmentTracker.getAppendedFrag(e, $.MAIN);
    return s && "fragment" in s ? s.fragment : s;
  }
  getNextFragment(e, t) {
    const s = t.fragments, i = s.length;
    if (!i)
      return null;
    const {
      config: r
    } = this, n = s[0].start;
    let o;
    if (t.live) {
      const l = r.initialLiveManifestSize;
      if (i < l)
        return this.warn(`Not enough fragments to start playback (have: ${i}, need: ${l})`), null;
      !t.PTSKnown && !this.startFragRequested && this.startPosition === -1 && (o = this.getInitialLiveFragment(t, s), this.startPosition = o ? this.hls.liveSyncPosition || o.start : e);
    } else
      e <= n && (o = s[0]);
    if (!o) {
      const l = r.lowLatencyMode ? t.partEnd : t.fragmentEnd;
      o = this.getFragmentAtPosition(e, l, t);
    }
    return this.mapToInitFragWhenRequired(o);
  }
  isLoopLoading(e, t) {
    const s = this.fragmentTracker.getState(e);
    return (s === he.OK || s === he.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, s, i, r) {
    const n = e.gap, o = this.getNextFragment(this.nextLoadPosition, t);
    if (o === null)
      return o;
    if (e = o, n && e && !e.gap && s.nextStart) {
      const l = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, s.nextStart, i);
      if (l !== null && s.len + l.len >= r)
        return this.log(`buffer full after gaps in "${i}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, s) {
    let i = -1, r = !1, n = !0;
    for (let o = 0, l = e.length; o < l; o++) {
      const h = e[o];
      if (n = n && !h.independent, i > -1 && s < h.start)
        break;
      const c = h.loaded;
      c ? i = -1 : (r || h.independent || n) && h.fragment === t && (i = o), r = c;
    }
    return i;
  }
  loadedEndOfParts(e, t) {
    const s = e[e.length - 1];
    return s && t > s.start && s.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, t) {
    const s = this.fragPrevious;
    let i = null;
    if (s) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${s.programDateTime}`), i = Pa(t, s.endProgramDateTime, this.config.maxFragLookUpTolerance)), !i) {
        const r = s.sn + 1;
        if (r >= e.startSN && r <= e.endSN) {
          const n = t[r - e.startSN];
          s.cc === n.cc && (i = n, this.log(`Live playlist, switching playlist, load frag with next SN: ${i.sn}`));
        }
        i || (i = Fa(t, s.cc), i && this.log(`Live playlist, switching playlist, load frag with same CC: ${i.sn}`));
      }
    } else {
      const r = this.hls.liveSyncPosition;
      r !== null && (i = this.getFragmentAtPosition(r, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return i;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, s) {
    const {
      config: i
    } = this;
    let {
      fragPrevious: r
    } = this, {
      fragments: n,
      endSN: o
    } = s;
    const {
      fragmentHint: l
    } = s, h = i.maxFragLookUpTolerance, c = s.partList, d = !!(i.lowLatencyMode && c != null && c.length && l);
    d && l && !this.bitrateTest && (n = n.concat(l), o = l.sn);
    let u;
    if (e < t) {
      const f = e > t - h ? 0 : h;
      u = St(r, n, e, f);
    } else
      u = n[n.length - 1];
    if (u) {
      const f = u.sn - s.startSN, g = this.fragmentTracker.getState(u);
      if ((g === he.OK || g === he.PARTIAL && u.gap) && (r = u), r && u.sn === r.sn && (!d || c[0].fragment.sn > u.sn) && r && u.level === r.level) {
        const v = n[f + 1];
        u.sn < o && this.fragmentTracker.getState(v) !== he.OK ? u = v : u = null;
      }
    }
    return u;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: s
    } = this;
    if (!s)
      return;
    const i = this.hls.liveSyncPosition, r = s.currentTime, n = e.fragments[0].start, o = e.edge, l = r >= n - t.maxFragLookUpTolerance && r <= o;
    if (i !== null && s.duration > i && (r < i || !l)) {
      const h = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      (!l && s.readyState < 4 || r < o - h) && (this.loadedmetadata || (this.nextLoadPosition = i), s.readyState && (this.warn(`Playback: ${r.toFixed(3)} is located too far from the end of live sliding playlist: ${o}, reset currentTime to : ${i.toFixed(3)}`), s.currentTime = i));
    }
  }
  alignPlaylists(e, t) {
    const {
      levels: s,
      levelLastLoaded: i,
      fragPrevious: r
    } = this, n = i !== null ? s[i] : null, o = e.fragments.length;
    if (!o)
      return this.warn("No fragments in live playlist"), 0;
    const l = e.fragments[0].start, h = !t, c = e.alignedSliding && M(l);
    if (h || !c && !l) {
      za(r, n, e);
      const d = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${d.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} prev-sn: ${r ? r.sn : "na"} fragments: ${o}`), d;
    }
    return l;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let s = this.startPosition;
    if (s < t && (s = -1), s === -1 || this.lastCurrentTime === -1) {
      const i = this.startTimeOffset !== null, r = i ? this.startTimeOffset : e.startTimeOffset;
      r !== null && M(r) ? (s = t + r, r < 0 && (s += e.totalduration), s = Math.min(Math.max(t, s), t + e.totalduration), this.log(`Start time offset ${r} found in ${i ? "multivariant" : "media"} playlist, adjust startPosition to ${s}`), this.startPosition = s) : e.live ? s = this.hls.liveSyncPosition || t : this.startPosition = s = 0, this.lastCurrentTime = s;
    }
    this.nextLoadPosition = s;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let t = 0;
    return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== w.FRAG_LOADING_WAITING_RETRY) && (this.state = w.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const d = this.getCurrentContext(t.chunkMeta);
      d && (t.frag = d.frag);
    }
    const s = t.frag;
    if (!s || s.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(s)) {
      var i;
      this.warn(`Frag load error must match current frag to retry ${s.url} > ${(i = this.fragCurrent) == null ? void 0 : i.url}`);
      return;
    }
    const r = t.details === L.FRAG_GAP;
    r && this.fragmentTracker.fragBuffered(s, !0);
    const n = t.errorAction, {
      action: o,
      retryCount: l = 0,
      retryConfig: h
    } = n || {};
    if (n && o === ge.RetryRequest && h) {
      var c;
      this.resetStartWhenNotLoaded((c = this.levelLastLoaded) != null ? c : s.level);
      const d = Bs(h, l);
      this.warn(`Fragment ${s.sn} of ${e} ${s.level} errored with ${t.details}, retrying loading ${l + 1}/${h.maxNumRetry} in ${d}ms`), n.resolved = !0, this.retryDate = self.performance.now() + d, this.state = w.FRAG_LOADING_WAITING_RETRY;
    } else
      h && n ? (this.resetFragmentErrors(e), l < h.maxNumRetry ? r || (n.resolved = !0) : E.warn(`${t.details} reached or exceeded max retry (${l})`)) : (n == null ? void 0 : n.action) === ge.SendAlternateToPenaltyBox ? this.state = w.WAITING_LEVEL : this.state = w.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === w.PARSING || this.state === w.PARSED) {
      const t = e.parent, s = this.getFwdBufferInfo(this.mediaBuffer, t), i = s && s.len > 0.5;
      i && this.reduceMaxBufferLength(s.len);
      const r = !i;
      return r && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${t} buffer`), e.frag && (this.fragmentTracker.removeFragment(e.frag), this.nextLoadPosition = e.frag.start), this.resetLoadingState(), r;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === $.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== w.STOPPED && (this.state = w.IDLE);
  }
  afterBufferFlushed(e, t, s) {
    if (!e)
      return;
    const i = J.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, i, s), this.state === w.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = w.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const t = this.levels ? this.levels[e].details : null;
      t != null && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    var t;
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded((t = this.levelLastLoaded) != null ? t : e.level), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, s, i) {
    var r;
    const n = s.details;
    if (!n) {
      this.warn("level.details undefined");
      return;
    }
    if (Object.keys(e.elementaryStreams).reduce((l, h) => {
      const c = e.elementaryStreams[h];
      if (c) {
        const d = c.endPTS - c.startPTS;
        if (d <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${h} duration reliably (${d})`), l || !1;
        const u = i ? 0 : _r(n, e, c.startPTS, c.endPTS, c.startDTS, c.endDTS);
        return this.hls.trigger(m.LEVEL_PTS_UPDATED, {
          details: n,
          level: s,
          drift: u,
          type: h,
          frag: e,
          start: c.startPTS,
          end: c.endPTS
        }), !0;
      }
      return l;
    }, !1))
      s.fragmentError = 0;
    else if (((r = this.transmuxer) == null ? void 0 : r.error) === null) {
      const l = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (s.fragmentError === 0 && (s.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(l.message), this.hls.trigger(m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.FRAG_PARSING_ERROR,
        fatal: !1,
        error: l,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${s.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = w.PARSED, this.hls.trigger(m.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    if (e.event === "demuxerWorker") {
      var t, s, i;
      this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded((t = (s = this.levelLastLoaded) != null ? s : (i = this.fragCurrent) == null ? void 0 : i.level) != null ? t : 0), this.resetLoadingState();
    }
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
function Fr() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function so() {
  const a = qt();
  if (!a)
    return !1;
  const e = Fr(), t = a && typeof a.isTypeSupported == "function" && a.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), s = !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
  return !!t && !!s;
}
function io() {
  var a;
  const e = Fr();
  return typeof (e == null || (a = e.prototype) == null ? void 0 : a.changeType) == "function";
}
function ro() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function no() {
  const a = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(a);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function ao(a) {
  const e = new self.URL(a, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function Ue(a = "", e = 9e4) {
  return {
    type: a,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class Mr {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, s, i) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, s) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = tt(this.cachedData, e), this.cachedData = null);
    let s = Ut(e, 0), i = s ? s.length : 0, r;
    const n = this._audioTrack, o = this._id3Track, l = s ? Vn(s) : void 0, h = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && M(l)) && (this.basePTS = oo(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), s && s.length > 0 && o.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: s,
      type: Pe.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); i < h; ) {
      if (this.canParse(e, i)) {
        const c = this.appendFrame(n, e, i);
        c ? (this.frameIndex++, this.lastPTS = c.sample.pts, i += c.length, r = i) : i = h;
      } else
        Gn(e, i) ? (s = Ut(e, i), o.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: s,
          type: Pe.audioId3,
          duration: Number.POSITIVE_INFINITY
        }), i += s.length, r = i) : i++;
      if (i === h && r !== h) {
        const c = et(e, r);
        this.cachedData ? this.cachedData = tt(this.cachedData, c) : this.cachedData = c;
      }
    }
    return {
      audioTrack: n,
      videoTrack: Ue(),
      id3Track: o,
      textTrack: Ue()
    };
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: Ue(),
      id3Track: this._id3Track,
      textTrack: Ue()
    };
  }
  destroy() {
  }
}
const oo = (a, e, t) => {
  if (M(a))
    return a * 90;
  const s = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + s;
};
function lo(a, e, t, s) {
  let i, r, n, o;
  const l = navigator.userAgent.toLowerCase(), h = s, c = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  i = ((e[t + 2] & 192) >>> 6) + 1;
  const d = (e[t + 2] & 60) >>> 2;
  if (d > c.length - 1) {
    a.trigger(m.ERROR, {
      type: U.MEDIA_ERROR,
      details: L.FRAG_PARSING_ERROR,
      fatal: !0,
      reason: `invalid ADTS sampling index:${d}`
    });
    return;
  }
  return n = (e[t + 2] & 1) << 2, n |= (e[t + 3] & 192) >>> 6, E.log(`manifest codec:${s}, ADTS type:${i}, samplingIndex:${d}`), /firefox/i.test(l) ? d >= 6 ? (i = 5, o = new Array(4), r = d - 3) : (i = 2, o = new Array(2), r = d) : l.indexOf("android") !== -1 ? (i = 2, o = new Array(2), r = d) : (i = 5, o = new Array(4), s && (s.indexOf("mp4a.40.29") !== -1 || s.indexOf("mp4a.40.5") !== -1) || !s && d >= 6 ? r = d - 3 : ((s && s.indexOf("mp4a.40.2") !== -1 && (d >= 6 && n === 1 || /vivaldi/i.test(l)) || !s && n === 1) && (i = 2, o = new Array(2)), r = d)), o[0] = i << 3, o[0] |= (d & 14) >> 1, o[1] |= (d & 1) << 7, o[1] |= n << 3, i === 5 && (o[1] |= (r & 14) >> 1, o[2] = (r & 1) << 7, o[2] |= 8, o[3] = 0), {
    config: o,
    samplerate: c[d],
    channelCount: n,
    codec: "mp4a.40." + i,
    manifestCodec: h
  };
}
function Nr(a, e) {
  return a[e] === 255 && (a[e + 1] & 246) === 240;
}
function Ur(a, e) {
  return a[e + 1] & 1 ? 7 : 9;
}
function Ys(a, e) {
  return (a[e + 3] & 3) << 11 | a[e + 4] << 3 | (a[e + 5] & 224) >>> 5;
}
function ho(a, e) {
  return e + 5 < a.length;
}
function Ht(a, e) {
  return e + 1 < a.length && Nr(a, e);
}
function co(a, e) {
  return ho(a, e) && Nr(a, e) && Ys(a, e) <= a.length - e;
}
function uo(a, e) {
  if (Ht(a, e)) {
    const t = Ur(a, e);
    if (e + t >= a.length)
      return !1;
    const s = Ys(a, e);
    if (s <= t)
      return !1;
    const i = e + s;
    return i === a.length || Ht(a, i);
  }
  return !1;
}
function $r(a, e, t, s, i) {
  if (!a.samplerate) {
    const r = lo(e, t, s, i);
    if (!r)
      return;
    a.config = r.config, a.samplerate = r.samplerate, a.channelCount = r.channelCount, a.codec = r.codec, a.manifestCodec = r.manifestCodec, E.log(`parsed codec:${a.codec}, rate:${r.samplerate}, channels:${r.channelCount}`);
  }
}
function Br(a) {
  return 1024 * 9e4 / a;
}
function fo(a, e) {
  const t = Ur(a, e);
  if (e + t <= a.length) {
    const s = Ys(a, e) - t;
    if (s > 0)
      return {
        headerLength: t,
        frameLength: s
      };
  }
}
function Gr(a, e, t, s, i) {
  const r = Br(a.samplerate), n = s + i * r, o = fo(e, t);
  let l;
  if (o) {
    const {
      frameLength: d,
      headerLength: u
    } = o, f = u + d, g = Math.max(0, t + f - e.length);
    g ? (l = new Uint8Array(f - u), l.set(e.subarray(t + u, e.length), 0)) : l = e.subarray(t + u, t + f);
    const p = {
      unit: l,
      pts: n
    };
    return g || a.samples.push(p), {
      sample: p,
      length: f,
      missing: g
    };
  }
  const h = e.length - t;
  return l = new Uint8Array(h), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: n
    },
    length: h,
    missing: -1
  };
}
class go extends Mr {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, s, i) {
    super.resetInitSegment(e, t, s, i), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    let s = (Ut(e, 0) || []).length;
    for (let i = e.length; s < i; s++)
      if (uo(e, s))
        return E.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return co(e, t);
  }
  appendFrame(e, t, s) {
    $r(e, this.observer, t, s, e.manifestCodec);
    const i = Gr(e, t, s, this.basePTS, this.frameIndex);
    if (i && i.missing === 0)
      return i;
  }
}
const mo = /\/emsg[-/]ID3/i;
class po {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, s, i) {
    const r = this.videoTrack = Ue("video", 1), n = this.audioTrack = Ue("audio", 1), o = this.txtTrack = Ue("text", 1);
    if (this.id3Track = Ue("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Sr(e);
    if (l.video) {
      const {
        id: h,
        timescale: c,
        codec: d
      } = l.video;
      r.id = h, r.timescale = o.timescale = c, r.codec = d;
    }
    if (l.audio) {
      const {
        id: h,
        timescale: c,
        codec: d
      } = l.audio;
      n.id = h, n.timescale = c, n.codec = d;
    }
    o.id = Tr.text, r.sampleDuration = 0, r.duration = n.duration = i;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return e = e.length > 16384 ? e.subarray(0, 16384) : e, H(e, ["moof"]).length > 0;
  }
  demux(e, t) {
    this.timeOffset = t;
    let s = e;
    const i = this.videoTrack, r = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (s = tt(this.remainderData, e));
      const o = ia(s);
      this.remainderData = o.remainder, i.samples = o.valid || new Uint8Array();
    } else
      i.samples = s;
    const n = this.extractID3Track(i, t);
    return r.samples = hi(t, i), {
      videoTrack: i,
      audioTrack: this.audioTrack,
      id3Track: n,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, s = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const i = this.extractID3Track(t, this.timeOffset);
    return s.samples = hi(e, t), {
      videoTrack: t,
      audioTrack: Ue(),
      id3Track: i,
      textTrack: Ue()
    };
  }
  extractID3Track(e, t) {
    const s = this.id3Track;
    if (e.samples.length) {
      const i = H(e.samples, ["emsg"]);
      i && i.forEach((r) => {
        const n = aa(r);
        if (mo.test(n.schemeIdUri)) {
          const o = M(n.presentationTime) ? n.presentationTime / n.timeScale : t + n.presentationTimeDelta / n.timeScale;
          let l = n.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : n.eventDuration / n.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const h = n.payload;
          s.samples.push({
            data: h,
            len: h.byteLength,
            dts: o,
            pts: o,
            type: Pe.emsg,
            duration: l
          });
        }
      });
    }
    return s;
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
let Dt = null;
const vo = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], yo = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], To = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], xo = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function Vr(a, e, t, s, i) {
  if (t + 24 > e.length)
    return;
  const r = Hr(e, t);
  if (r && t + r.frameLength <= e.length) {
    const n = r.samplesPerFrame * 9e4 / r.sampleRate, o = s + i * n, l = {
      unit: e.subarray(t, t + r.frameLength),
      pts: o,
      dts: o
    };
    return a.config = [], a.channelCount = r.channelCount, a.samplerate = r.sampleRate, a.samples.push(l), {
      sample: l,
      length: r.frameLength,
      missing: 0
    };
  }
}
function Hr(a, e) {
  const t = a[e + 1] >> 3 & 3, s = a[e + 1] >> 1 & 3, i = a[e + 2] >> 4 & 15, r = a[e + 2] >> 2 & 3;
  if (t !== 1 && i !== 0 && i !== 15 && r !== 3) {
    const n = a[e + 2] >> 1 & 1, o = a[e + 3] >> 6, l = t === 3 ? 3 - s : s === 3 ? 3 : 4, h = vo[l * 14 + i - 1] * 1e3, d = yo[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + r], u = o === 3 ? 1 : 2, f = To[t][s], g = xo[s], p = f * 8 * g, v = Math.floor(f * h / d + n) * g;
    if (Dt === null) {
      const x = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Dt = x ? parseInt(x[1]) : 0;
    }
    return !!Dt && Dt <= 87 && s === 2 && h >= 224e3 && o === 0 && (a[e + 3] = a[e + 3] | 128), {
      sampleRate: d,
      channelCount: u,
      frameLength: v,
      samplesPerFrame: p
    };
  }
}
function zs(a, e) {
  return a[e] === 255 && (a[e + 1] & 224) === 224 && (a[e + 1] & 6) !== 0;
}
function Kr(a, e) {
  return e + 1 < a.length && zs(a, e);
}
function Eo(a, e) {
  return zs(a, e) && 4 <= a.length - e;
}
function So(a, e) {
  if (e + 1 < a.length && zs(a, e)) {
    const s = Hr(a, e);
    let i = 4;
    s != null && s.frameLength && (i = s.frameLength);
    const r = e + i;
    return r === a.length || Kr(a, r);
  }
  return !1;
}
class ki {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, s = e.byteLength - t, i = new Uint8Array(4), r = Math.min(4, t);
    if (r === 0)
      throw new Error("no bytes available");
    i.set(e.subarray(s, s + r)), this.word = new DataView(i.buffer).getUint32(0), this.bitsAvailable = r * 8, this.bytesAvailable -= r;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const s = this.word >>> 32 - t;
    if (e > 32 && E.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? s << t | this.readBits(t) : s;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if (this.word & 2147483648 >>> e)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let t = 8, s = 8, i;
    for (let r = 0; r < e; r++)
      s !== 0 && (i = this.readEG(), s = (t + i + 256) % 256), t = s === 0 ? t : s;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, t = 0, s = 0, i = 0, r, n, o;
    const l = this.readUByte.bind(this), h = this.readBits.bind(this), c = this.readUEG.bind(this), d = this.readBoolean.bind(this), u = this.skipBits.bind(this), f = this.skipEG.bind(this), g = this.skipUEG.bind(this), p = this.skipScalingList.bind(this);
    l();
    const v = l();
    if (h(5), u(3), l(), g(), v === 100 || v === 110 || v === 122 || v === 244 || v === 44 || v === 83 || v === 86 || v === 118 || v === 128) {
      const C = c();
      if (C === 3 && u(1), g(), g(), u(1), d())
        for (n = C !== 3 ? 8 : 12, o = 0; o < n; o++)
          d() && (o < 6 ? p(16) : p(64));
    }
    g();
    const y = c();
    if (y === 0)
      c();
    else if (y === 1)
      for (u(1), f(), f(), r = c(), o = 0; o < r; o++)
        f();
    g(), u(1);
    const T = c(), x = c(), A = h(1);
    A === 0 && u(1), u(1), d() && (e = c(), t = c(), s = c(), i = c());
    let b = [1, 1];
    if (d() && d())
      switch (l()) {
        case 1:
          b = [1, 1];
          break;
        case 2:
          b = [12, 11];
          break;
        case 3:
          b = [10, 11];
          break;
        case 4:
          b = [16, 11];
          break;
        case 5:
          b = [40, 33];
          break;
        case 6:
          b = [24, 11];
          break;
        case 7:
          b = [20, 11];
          break;
        case 8:
          b = [32, 11];
          break;
        case 9:
          b = [80, 33];
          break;
        case 10:
          b = [18, 11];
          break;
        case 11:
          b = [15, 11];
          break;
        case 12:
          b = [64, 33];
          break;
        case 13:
          b = [160, 99];
          break;
        case 14:
          b = [4, 3];
          break;
        case 15:
          b = [3, 2];
          break;
        case 16:
          b = [2, 1];
          break;
        case 255: {
          b = [l() << 8 | l(), l() << 8 | l()];
          break;
        }
      }
    return {
      width: Math.ceil((T + 1) * 16 - e * 2 - t * 2),
      height: (2 - A) * (x + 1) * 16 - (A ? 2 : 4) * (s + i),
      pixelRatio: b
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class bo {
  constructor(e, t, s) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = s, this.decrypter = new Ks(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, s) {
    const i = e[t].unit;
    if (i.length <= 16)
      return;
    const r = i.subarray(16, i.length - i.length % 16), n = r.buffer.slice(r.byteOffset, r.byteOffset + r.length);
    this.decryptBuffer(n).then((o) => {
      const l = new Uint8Array(o);
      i.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, s);
    });
  }
  decryptAacSamples(e, t, s) {
    for (; ; t++) {
      if (t >= e.length) {
        s();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, s), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, s = new Int8Array(t);
    let i = 0;
    for (let r = 32; r < e.length - 16; r += 160, i += 16)
      s.set(e.subarray(r, r + 16), i);
    return s;
  }
  getAvcDecryptedUnit(e, t) {
    const s = new Uint8Array(t);
    let i = 0;
    for (let r = 32; r < e.length - 16; r += 160, i += 16)
      e.set(s.subarray(i, i + 16), r);
    return e;
  }
  decryptAvcSample(e, t, s, i, r) {
    const n = Ar(r.data), o = this.getAvcEncryptedData(n);
    this.decryptBuffer(o.buffer).then((l) => {
      r.data = this.getAvcDecryptedUnit(n, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, s + 1, i);
    });
  }
  decryptAvcSamples(e, t, s, i) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, s = 0) {
      if (t >= e.length) {
        i();
        return;
      }
      const r = e[t].units;
      for (; !(s >= r.length); s++) {
        const n = r[s];
        if (!(n.data.length <= 48 || n.type !== 1 && n.type !== 5) && (this.decryptAvcSample(e, t, s, i, n), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const fe = 188;
class Ye {
  constructor(e, t, s) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._avcTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.observer = e, this.config = t, this.typeSupported = s;
  }
  static probe(e) {
    const t = Ye.syncOffset(e);
    return t > 0 && E.warn(`MPEG2-TS detected but first sync word found @ offset ${t}`), t !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let s = Math.min(fe * 5, e.length - fe) + 1, i = 0;
    for (; i < s; ) {
      let r = !1, n = -1, o = 0;
      for (let l = i; l < t; l += fe)
        if (e[l] === 71) {
          if (o++, n === -1 && (n = l, n !== 0 && (s = Math.min(n + fe * 99, e.length - fe) + 1)), r || (r = ws(e, l) === 0), r && o > 1 && (n === 0 && o > 2 || l + fe > s))
            return n;
        } else {
          if (o)
            return -1;
          break;
        }
      i++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Tr[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, s, i) {
    this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = Ye.createTrack("video"), this._audioTrack = Ye.createTrack("audio", i), this._id3Track = Ye.createTrack("id3"), this._txtTrack = Ye.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = s, this._duration = i;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _avcTrack: t,
      _id3Track: s
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), s && (s.pesData = null), this.aacOverFlow = null, this.avcSample = null, this.remainderData = null;
  }
  demux(e, t, s = !1, i = !1) {
    s || (this.sampleAes = null);
    let r;
    const n = this._avcTrack, o = this._audioTrack, l = this._id3Track, h = this._txtTrack;
    let c = n.pid, d = n.pesData, u = o.pid, f = l.pid, g = o.pesData, p = l.pesData, v = null, y = this.pmtParsed, T = this._pmtId, x = e.length;
    if (this.remainderData && (e = tt(this.remainderData, e), x = e.length, this.remainderData = null), x < fe && !i)
      return this.remainderData = e, {
        audioTrack: o,
        videoTrack: n,
        id3Track: l,
        textTrack: h
      };
    const A = Math.max(0, Ye.syncOffset(e));
    x -= (x - A) % fe, x < e.byteLength && !i && (this.remainderData = new Uint8Array(e.buffer, x, e.buffer.byteLength - x));
    let b = 0;
    for (let I = A; I < x; I += fe)
      if (e[I] === 71) {
        const _ = !!(e[I + 1] & 64), D = ws(e, I), R = (e[I + 3] & 48) >> 4;
        let F;
        if (R > 1) {
          if (F = I + 5 + e[I + 4], F === I + fe)
            continue;
        } else
          F = I + 4;
        switch (D) {
          case c:
            _ && (d && (r = nt(d)) && this.parseAVCPES(n, h, r, !1), d = {
              data: [],
              size: 0
            }), d && (d.data.push(e.subarray(F, I + fe)), d.size += I + fe - F);
            break;
          case u:
            if (_) {
              if (g && (r = nt(g)))
                switch (o.segmentCodec) {
                  case "aac":
                    this.parseAACPES(o, r);
                    break;
                  case "mp3":
                    this.parseMPEGPES(o, r);
                    break;
                }
              g = {
                data: [],
                size: 0
              };
            }
            g && (g.data.push(e.subarray(F, I + fe)), g.size += I + fe - F);
            break;
          case f:
            _ && (p && (r = nt(p)) && this.parseID3PES(l, r), p = {
              data: [],
              size: 0
            }), p && (p.data.push(e.subarray(F, I + fe)), p.size += I + fe - F);
            break;
          case 0:
            _ && (F += e[F] + 1), T = this._pmtId = Lo(e, F);
            break;
          case T: {
            _ && (F += e[F] + 1);
            const P = Ao(e, F, this.typeSupported, s);
            c = P.avc, c > 0 && (n.pid = c), u = P.audio, u > 0 && (o.pid = u, o.segmentCodec = P.segmentCodec), f = P.id3, f > 0 && (l.pid = f), v !== null && !y && (E.warn(`MPEG-TS PMT found at ${I} after unknown PID '${v}'. Backtracking to sync byte @${A} to parse all TS packets.`), v = null, I = A - 188), y = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            v = D;
            break;
        }
      } else
        b++;
    if (b > 0) {
      const I = new Error(`Found ${b} TS packet/s that do not start with 0x47`);
      this.observer.emit(m.ERROR, m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.FRAG_PARSING_ERROR,
        fatal: !1,
        error: I,
        reason: I.message
      });
    }
    n.pesData = d, o.pesData = g, l.pesData = p;
    const C = {
      audioTrack: o,
      videoTrack: n,
      id3Track: l,
      textTrack: h
    };
    return i && this.extractRemainingSamples(C), C;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._avcTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: s,
      id3Track: i,
      textTrack: r
    } = e, n = s.pesData, o = t.pesData, l = i.pesData;
    let h;
    if (n && (h = nt(n)) ? (this.parseAVCPES(s, r, h, !0), s.pesData = null) : s.pesData = n, o && (h = nt(o))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, h);
          break;
        case "mp3":
          this.parseMPEGPES(t, h);
          break;
      }
      t.pesData = null;
    } else
      o != null && o.size && E.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = o;
    l && (h = nt(l)) ? (this.parseID3PES(i, h), i.pesData = null) : i.pesData = l;
  }
  demuxSampleAes(e, t, s) {
    const i = this.demux(e, s, !0, !this.config.progressive), r = this.sampleAes = new bo(this.observer, this.config, t);
    return this.decrypt(i, r);
  }
  decrypt(e, t) {
    return new Promise((s) => {
      const {
        audioTrack: i,
        videoTrack: r
      } = e;
      i.samples && i.segmentCodec === "aac" ? t.decryptAacSamples(i.samples, 0, () => {
        r.samples ? t.decryptAvcSamples(r.samples, 0, 0, () => {
          s(e);
        }) : s(e);
      }) : r.samples && t.decryptAvcSamples(r.samples, 0, 0, () => {
        s(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAVCPES(e, t, s, i) {
    const r = this.parseAVCNALu(e, s.data);
    let n = this.avcSample, o, l = !1;
    s.data = null, n && r.length && !e.audFound && (mt(n, e), n = this.avcSample = kt(!1, s.pts, s.dts, "")), r.forEach((h) => {
      var c;
      switch (h.type) {
        case 1: {
          let u = !1;
          o = !0;
          const f = h.data;
          if (l && f.length > 4) {
            const g = new ki(f).readSliceType();
            (g === 2 || g === 4 || g === 7 || g === 9) && (u = !0);
          }
          if (u) {
            var d;
            (d = n) != null && d.frame && !n.key && (mt(n, e), n = this.avcSample = null);
          }
          n || (n = this.avcSample = kt(!0, s.pts, s.dts, "")), n.frame = !0, n.key = u;
          break;
        }
        case 5:
          o = !0, (c = n) != null && c.frame && !n.key && (mt(n, e), n = this.avcSample = null), n || (n = this.avcSample = kt(!0, s.pts, s.dts, "")), n.key = !0, n.frame = !0;
          break;
        case 6: {
          o = !0, Lr(h.data, 1, s.pts, t.samples);
          break;
        }
        case 7:
          if (o = !0, l = !0, !e.sps) {
            const u = h.data, g = new ki(u).readSPS();
            e.width = g.width, e.height = g.height, e.pixelRatio = g.pixelRatio, e.sps = [u], e.duration = this._duration;
            const p = u.subarray(1, 4);
            let v = "avc1.";
            for (let y = 0; y < 3; y++) {
              let T = p[y].toString(16);
              T.length < 2 && (T = "0" + T), v += T;
            }
            e.codec = v;
          }
          break;
        case 8:
          o = !0, e.pps || (e.pps = [h.data]);
          break;
        case 9:
          o = !1, e.audFound = !0, n && mt(n, e), n = this.avcSample = kt(!1, s.pts, s.dts, "");
          break;
        case 12:
          o = !0;
          break;
        default:
          o = !1, n && (n.debug += "unknown NAL " + h.type + " ");
          break;
      }
      n && o && n.units.push(h);
    }), i && n && (mt(n, e), this.avcSample = null);
  }
  getLastNalUnit(e) {
    var t;
    let s = this.avcSample, i;
    if ((!s || s.units.length === 0) && (s = e[e.length - 1]), (t = s) != null && t.units) {
      const r = s.units;
      i = r[r.length - 1];
    }
    return i;
  }
  parseAVCNALu(e, t) {
    const s = t.byteLength;
    let i = e.naluState || 0;
    const r = i, n = [];
    let o = 0, l, h, c, d = -1, u = 0;
    for (i === -1 && (d = 0, u = t[0] & 31, i = 0, o = 1); o < s; ) {
      if (l = t[o++], !i) {
        i = l ? 0 : 1;
        continue;
      }
      if (i === 1) {
        i = l ? 0 : 2;
        continue;
      }
      if (!l)
        i = 3;
      else if (l === 1) {
        if (d >= 0) {
          const f = {
            data: t.subarray(d, o - i - 1),
            type: u
          };
          n.push(f);
        } else {
          const f = this.getLastNalUnit(e.samples);
          if (f && (r && o <= 4 - r && f.state && (f.data = f.data.subarray(0, f.data.byteLength - r)), h = o - i - 1, h > 0)) {
            const g = new Uint8Array(f.data.byteLength + h);
            g.set(f.data, 0), g.set(t.subarray(0, h), f.data.byteLength), f.data = g, f.state = 0;
          }
        }
        o < s ? (c = t[o] & 31, d = o, u = c, i = 0) : i = -1;
      } else
        i = 0;
    }
    if (d >= 0 && i >= 0) {
      const f = {
        data: t.subarray(d, s),
        type: u,
        state: i
      };
      n.push(f);
    }
    if (n.length === 0) {
      const f = this.getLastNalUnit(e.samples);
      if (f) {
        const g = new Uint8Array(f.data.byteLength + t.byteLength);
        g.set(f.data, 0), g.set(t, f.data.byteLength), f.data = g;
      }
    }
    return e.naluState = i, n;
  }
  parseAACPES(e, t) {
    let s = 0;
    const i = this.aacOverFlow;
    let r = t.data;
    if (i) {
      this.aacOverFlow = null;
      const d = i.missing, u = i.sample.unit.byteLength;
      if (d === -1) {
        const f = new Uint8Array(u + r.byteLength);
        f.set(i.sample.unit, 0), f.set(r, u), r = f;
      } else {
        const f = u - d;
        i.sample.unit.set(r.subarray(0, d), f), e.samples.push(i.sample), s = i.missing;
      }
    }
    let n, o;
    for (n = s, o = r.length; n < o - 1 && !Ht(r, n); n++)
      ;
    if (n !== s) {
      let d;
      const u = n < o - 1;
      u ? d = `AAC PES did not start with ADTS header,offset:${n}` : d = "No ADTS header found in AAC PES";
      const f = new Error(d);
      if (E.warn(`parsing error: ${d}`), this.observer.emit(m.ERROR, m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.FRAG_PARSING_ERROR,
        fatal: !1,
        levelRetry: u,
        error: f,
        reason: d
      }), !u)
        return;
    }
    $r(e, this.observer, r, n, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (i) {
      const d = Br(e.samplerate);
      l = i.sample.pts + d;
    } else {
      E.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let h = 0, c;
    for (; n < o; )
      if (c = Gr(e, r, n, l, h), n += c.length, c.missing) {
        this.aacOverFlow = c;
        break;
      } else
        for (h++; n < o - 1 && !Ht(r, n); n++)
          ;
  }
  parseMPEGPES(e, t) {
    const s = t.data, i = s.length;
    let r = 0, n = 0;
    const o = t.pts;
    if (o === void 0) {
      E.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; n < i; )
      if (Kr(s, n)) {
        const l = Vr(e, s, n, o, r);
        if (l)
          n += l.length, r++;
        else
          break;
      } else
        n++;
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      E.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const s = ae({}, t, {
      type: this._avcTrack ? Pe.emsg : Pe.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(s);
  }
}
function kt(a, e, t, s) {
  return {
    key: a,
    frame: !1,
    pts: e,
    dts: t,
    units: [],
    debug: s,
    length: 0
  };
}
function ws(a, e) {
  return ((a[e + 1] & 31) << 8) + a[e + 2];
}
function Lo(a, e) {
  return (a[e + 10] & 31) << 8 | a[e + 11];
}
function Ao(a, e, t, s) {
  const i = {
    audio: -1,
    avc: -1,
    id3: -1,
    segmentCodec: "aac"
  }, r = (a[e + 1] & 15) << 8 | a[e + 2], n = e + 3 + r - 4, o = (a[e + 10] & 15) << 8 | a[e + 11];
  for (e += 12 + o; e < n; ) {
    const l = ws(a, e);
    switch (a[e]) {
      case 207:
        if (!s) {
          E.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
          break;
        }
      case 15:
        i.audio === -1 && (i.audio = l);
        break;
      case 21:
        i.id3 === -1 && (i.id3 = l);
        break;
      case 219:
        if (!s) {
          E.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
          break;
        }
      case 27:
        i.avc === -1 && (i.avc = l);
        break;
      case 3:
      case 4:
        t.mpeg !== !0 && t.mp3 !== !0 ? E.log("MPEG audio found, not supported in this browser") : i.audio === -1 && (i.audio = l, i.segmentCodec = "mp3");
        break;
      case 36:
        E.warn("Unsupported HEVC stream type found");
        break;
    }
    e += ((a[e + 3] & 15) << 8 | a[e + 4]) + 5;
  }
  return i;
}
function nt(a) {
  let e = 0, t, s, i, r, n;
  const o = a.data;
  if (!a || a.size === 0)
    return null;
  for (; o[0].length < 19 && o.length > 1; ) {
    const h = new Uint8Array(o[0].length + o[1].length);
    h.set(o[0]), h.set(o[1], o[0].length), o[0] = h, o.splice(1, 1);
  }
  if (t = o[0], (t[0] << 16) + (t[1] << 8) + t[2] === 1) {
    if (s = (t[4] << 8) + t[5], s && s > a.size - 6)
      return null;
    const h = t[7];
    h & 192 && (r = (t[9] & 14) * 536870912 + // 1 << 29
    (t[10] & 255) * 4194304 + // 1 << 22
    (t[11] & 254) * 16384 + // 1 << 14
    (t[12] & 255) * 128 + // 1 << 7
    (t[13] & 254) / 2, h & 64 ? (n = (t[14] & 14) * 536870912 + // 1 << 29
    (t[15] & 255) * 4194304 + // 1 << 22
    (t[16] & 254) * 16384 + // 1 << 14
    (t[17] & 255) * 128 + // 1 << 7
    (t[18] & 254) / 2, r - n > 60 * 9e4 && (E.warn(`${Math.round((r - n) / 9e4)}s delta between PTS and DTS, align them`), r = n)) : n = r), i = t[8];
    let c = i + 9;
    if (a.size <= c)
      return null;
    a.size -= c;
    const d = new Uint8Array(a.size);
    for (let u = 0, f = o.length; u < f; u++) {
      t = o[u];
      let g = t.byteLength;
      if (c)
        if (c > g) {
          c -= g;
          continue;
        } else
          t = t.subarray(c), g -= c, c = 0;
      d.set(t, e), e += g;
    }
    return s && (s -= i + 3), {
      data: d,
      pts: r,
      dts: n,
      len: s
    };
  }
  return null;
}
function mt(a, e) {
  if (a.units.length && a.frame) {
    if (a.pts === void 0) {
      const t = e.samples, s = t.length;
      if (s) {
        const i = t[s - 1];
        a.pts = i.pts, a.dts = i.dts;
      } else {
        e.dropped++;
        return;
      }
    }
    e.samples.push(a);
  }
  a.debug.length && E.log(a.pts + "/" + a.dts + ":" + a.debug);
}
class Ro extends Mr {
  resetInitSegment(e, t, s, i) {
    super.resetInitSegment(e, t, s, i), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    let s = (Ut(e, 0) || []).length;
    for (let i = e.length; s < i; s++)
      if (So(e, s))
        return E.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Eo(e, t);
  }
  appendFrame(e, t, s) {
    if (this.basePTS !== null)
      return Vr(e, t, s, this.basePTS, this.frameIndex);
  }
}
class Pi {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const We = Math.pow(2, 32) - 1;
class S {
  static init() {
    S.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in S.types)
      S.types.hasOwnProperty(e) && (S.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    S.HDLR_TYPES = {
      video: t,
      audio: s
    };
    const i = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), r = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    S.STTS = S.STSC = S.STCO = r, S.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), S.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), S.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), S.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const n = new Uint8Array([105, 115, 111, 109]), o = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    S.FTYP = S.box(S.types.ftyp, n, l, n, o), S.DINF = S.box(S.types.dinf, S.box(S.types.dref, i));
  }
  static box(e, ...t) {
    let s = 8, i = t.length;
    const r = i;
    for (; i--; )
      s += t[i].byteLength;
    const n = new Uint8Array(s);
    for (n[0] = s >> 24 & 255, n[1] = s >> 16 & 255, n[2] = s >> 8 & 255, n[3] = s & 255, n.set(e, 4), i = 0, s = 8; i < r; i++)
      n.set(t[i], s), s += t[i].byteLength;
    return n;
  }
  static hdlr(e) {
    return S.box(S.types.hdlr, S.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return S.box(S.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const s = Math.floor(t / (We + 1)), i = Math.floor(t % (We + 1));
    return S.box(S.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return S.box(S.types.mdia, S.mdhd(e.timescale, e.duration), S.hdlr(e.type), S.minf(e));
  }
  static mfhd(e) {
    return S.box(S.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? S.box(S.types.minf, S.box(S.types.smhd, S.SMHD), S.DINF, S.stbl(e)) : S.box(S.types.minf, S.box(S.types.vmhd, S.VMHD), S.DINF, S.stbl(e));
  }
  static moof(e, t, s) {
    return S.box(S.types.moof, S.mfhd(e), S.traf(s, t));
  }
  static moov(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = S.trak(e[t]);
    return S.box.apply(null, [S.types.moov, S.mvhd(e[0].timescale, e[0].duration)].concat(s).concat(S.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = S.trex(e[t]);
    return S.box.apply(null, [S.types.mvex, ...s]);
  }
  static mvhd(e, t) {
    t *= e;
    const s = Math.floor(t / (We + 1)), i = Math.floor(t % (We + 1)), r = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return S.box(S.types.mvhd, r);
  }
  static sdtp(e) {
    const t = e.samples || [], s = new Uint8Array(4 + t.length);
    let i, r;
    for (i = 0; i < t.length; i++)
      r = t[i].flags, s[i + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
    return S.box(S.types.sdtp, s);
  }
  static stbl(e) {
    return S.box(S.types.stbl, S.stsd(e), S.box(S.types.stts, S.STTS), S.box(S.types.stsc, S.STSC), S.box(S.types.stsz, S.STSZ), S.box(S.types.stco, S.STCO));
  }
  static avc1(e) {
    let t = [], s = [], i, r, n;
    for (i = 0; i < e.sps.length; i++)
      r = e.sps[i], n = r.byteLength, t.push(n >>> 8 & 255), t.push(n & 255), t = t.concat(Array.prototype.slice.call(r));
    for (i = 0; i < e.pps.length; i++)
      r = e.pps[i], n = r.byteLength, s.push(n >>> 8 & 255), s.push(n & 255), s = s.concat(Array.prototype.slice.call(r));
    const o = S.box(S.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(s))), l = e.width, h = e.height, c = e.pixelRatio[0], d = e.pixelRatio[1];
    return S.box(
      S.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        h >> 8 & 255,
        h & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      o,
      S.box(S.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      S.box(S.types.pasp, new Uint8Array([
        c >> 24,
        // hSpacing
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        d >> 24,
        // vSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + t,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + t,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([t]).concat(e.config).concat([6, 1, 2]));
  }
  static mp4a(e) {
    const t = e.samplerate;
    return S.box(S.types.mp4a, new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]), S.box(S.types.esds, S.esds(e)));
  }
  static mp3(e) {
    const t = e.samplerate;
    return S.box(S.types[".mp3"], new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? S.box(S.types.stsd, S.STSD, S.mp3(e)) : S.box(S.types.stsd, S.STSD, S.mp4a(e)) : S.box(S.types.stsd, S.STSD, S.avc1(e));
  }
  static tkhd(e) {
    const t = e.id, s = e.duration * e.timescale, i = e.width, r = e.height, n = Math.floor(s / (We + 1)), o = Math.floor(s % (We + 1));
    return S.box(S.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      i >> 8 & 255,
      i & 255,
      0,
      0,
      // width
      r >> 8 & 255,
      r & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const s = S.sdtp(e), i = e.id, r = Math.floor(t / (We + 1)), n = Math.floor(t % (We + 1));
    return S.box(
      S.types.traf,
      S.box(S.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        i >> 24,
        i >> 16 & 255,
        i >> 8 & 255,
        i & 255
        // track_ID
      ])),
      S.box(S.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        n >> 24,
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255
      ])),
      S.trun(e, s.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      s
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, S.box(S.types.trak, S.tkhd(e), S.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return S.box(S.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const s = e.samples || [], i = s.length, r = 12 + 16 * i, n = new Uint8Array(r);
    let o, l, h, c, d, u;
    for (t += 8 + r, n.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      i >>> 24 & 255,
      i >>> 16 & 255,
      i >>> 8 & 255,
      i & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), o = 0; o < i; o++)
      l = s[o], h = l.duration, c = l.size, d = l.flags, u = l.cts, n.set([
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255,
        // sample_duration
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_size
        d.isLeading << 2 | d.dependsOn,
        d.isDependedOn << 6 | d.hasRedundancy << 4 | d.paddingValue << 1 | d.isNonSync,
        d.degradPrio & 61440,
        d.degradPrio & 15,
        // sample_flags
        u >>> 24 & 255,
        u >>> 16 & 255,
        u >>> 8 & 255,
        u & 255
        // sample_composition_time_offset
      ], 12 + 16 * o);
    return S.box(S.types.trun, n);
  }
  static initSegment(e) {
    S.types || S.init();
    const t = S.moov(e), s = new Uint8Array(S.FTYP.byteLength + t.byteLength);
    return s.set(S.FTYP), s.set(t, S.FTYP.byteLength), s;
  }
}
S.types = void 0;
S.HDLR_TYPES = void 0;
S.STTS = void 0;
S.STSC = void 0;
S.STCO = void 0;
S.STSZ = void 0;
S.VMHD = void 0;
S.SMHD = void 0;
S.STSD = void 0;
S.FTYP = void 0;
S.DINF = void 0;
const Wr = 9e4;
function js(a, e, t = 1, s = !1) {
  const i = a * e * t;
  return s ? Math.round(i) : i;
}
function Io(a, e, t = 1, s = !1) {
  return js(a, e, 1 / t, s);
}
function pt(a, e = !1) {
  return js(a, 1e3, 1 / Wr, e);
}
function wo(a, e = 1) {
  return js(a, Wr, 1 / e);
}
const _o = 10 * 1e3, Oi = 1024, Co = 1152;
let Pt = null, os = null;
class ls {
  constructor(e, t, s, i = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.observer = e, this.config = t, this.typeSupported = s, this.ISGenerated = !1, Pt === null) {
      const n = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Pt = n ? parseInt(n[1]) : 0;
    }
    if (os === null) {
      const r = navigator.userAgent.match(/Safari\/(\d+)/i);
      os = r ? parseInt(r[1]) : 0;
    }
  }
  destroy() {
  }
  resetTimeStamp(e) {
    E.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    E.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    E.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1;
  }
  getVideoStartPts(e) {
    let t = !1;
    const s = e.reduce((i, r) => {
      const n = r.pts - i;
      return n < -4294967296 ? (t = !0, Ce(i, r.pts)) : n > 0 ? i : r.pts;
    }, e[0].pts);
    return t && E.debug("PTS rollover detected"), s;
  }
  remux(e, t, s, i, r, n, o, l) {
    let h, c, d, u, f, g, p = r, v = r;
    const y = e.pid > -1, T = t.pid > -1, x = t.samples.length, A = e.samples.length > 0, b = o && x > 0 || x > 1;
    if ((!y || A) && (!T || b) || this.ISGenerated || o) {
      this.ISGenerated || (d = this.generateIS(e, t, r, n));
      const I = this.isVideoContiguous;
      let _ = -1, D;
      if (b && (_ = Do(t.samples), !I && this.config.forceKeyFrameOnDiscontinuity))
        if (g = !0, _ > 0) {
          E.warn(`[mp4-remuxer]: Dropped ${_} out of ${x} video samples due to a missing keyframe`);
          const R = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(_), t.dropped += _, v += (t.samples[0].pts - R) / t.inputTimeScale, D = v;
        } else
          _ === -1 && (E.warn(`[mp4-remuxer]: No keyframe found out of ${x} video samples`), g = !1);
      if (this.ISGenerated) {
        if (A && b) {
          const R = this.getVideoStartPts(t.samples), P = (Ce(e.samples[0].pts, R) - R) / t.inputTimeScale;
          p += Math.max(0, P), v += Math.max(0, -P);
        }
        if (A) {
          if (e.samplerate || (E.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), d = this.generateIS(e, t, r, n)), c = this.remuxAudio(e, p, this.isAudioContiguous, n, T || b || l === $.AUDIO ? v : void 0), b) {
            const R = c ? c.endPTS - c.startPTS : 0;
            t.inputTimeScale || (E.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), d = this.generateIS(e, t, r, n)), h = this.remuxVideo(t, v, I, R);
          }
        } else
          b && (h = this.remuxVideo(t, v, I, 0));
        h && (h.firstKeyFrame = _, h.independent = _ !== -1, h.firstKeyFramePTS = D);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (s.samples.length && (f = Yr(s, r, this._initPTS, this._initDTS)), i.samples.length && (u = zr(i, r, this._initPTS))), {
      audio: c,
      video: h,
      initSegment: d,
      independent: g,
      text: u,
      id3: f
    };
  }
  generateIS(e, t, s, i) {
    const r = e.samples, n = t.samples, o = this.typeSupported, l = {}, h = this._initPTS;
    let c = !h || i, d = "audio/mp4", u, f, g;
    if (c && (u = f = 1 / 0), e.config && r.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          o.mpeg ? (d = "audio/mpeg", e.codec = "") : o.mp3 && (e.codec = "mp3");
          break;
      }
      l.audio = {
        id: "audio",
        container: d,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && o.mpeg ? new Uint8Array(0) : S.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, c && (g = e.inputTimeScale, !h || g !== h.timescale ? u = f = r[0].pts - Math.round(g * s) : c = !1);
    }
    if (t.sps && t.pps && n.length && (t.timescale = t.inputTimeScale, l.video = {
      id: "main",
      container: "video/mp4",
      codec: t.codec,
      initSegment: S.initSegment([t]),
      metadata: {
        width: t.width,
        height: t.height
      }
    }, c))
      if (g = t.inputTimeScale, !h || g !== h.timescale) {
        const p = this.getVideoStartPts(n), v = Math.round(g * s);
        f = Math.min(f, Ce(n[0].dts, p) - v), u = Math.min(u, p - v);
      } else
        c = !1;
    if (Object.keys(l).length)
      return this.ISGenerated = !0, c ? (this._initPTS = {
        baseTime: u,
        timescale: g
      }, this._initDTS = {
        baseTime: f,
        timescale: g
      }) : u = g = void 0, {
        tracks: l,
        initPTS: u,
        timescale: g
      };
  }
  remuxVideo(e, t, s, i) {
    const r = e.inputTimeScale, n = e.samples, o = [], l = n.length, h = this._initPTS;
    let c = this.nextAvcDts, d = 8, u = this.videoSampleDuration, f, g, p = Number.POSITIVE_INFINITY, v = Number.NEGATIVE_INFINITY, y = !1;
    if (!s || c === null) {
      const O = t * r, N = n[0].pts - Ce(n[0].dts, n[0].pts);
      c = O - N;
    }
    const T = h.baseTime * r / h.timescale;
    for (let O = 0; O < l; O++) {
      const N = n[O];
      N.pts = Ce(N.pts - T, c), N.dts = Ce(N.dts - T, c), N.dts < n[O > 0 ? O - 1 : O].dts && (y = !0);
    }
    y && n.sort(function(O, N) {
      const Z = O.dts - N.dts, Q = O.pts - N.pts;
      return Z || Q;
    }), f = n[0].dts, g = n[n.length - 1].dts;
    const x = g - f, A = x ? Math.round(x / (l - 1)) : u || e.inputTimeScale / 30;
    if (s) {
      const O = f - c, N = O > A, Z = O < -1;
      if ((N || Z) && (N ? E.warn(`AVC: ${pt(O, !0)} ms (${O}dts) hole between fragments detected, filling it`) : E.warn(`AVC: ${pt(-O, !0)} ms (${O}dts) overlapping between fragments detected`), !Z || c >= n[0].pts)) {
        f = c;
        const Q = n[0].pts - O;
        n[0].dts = f, n[0].pts = Q, E.log(`Video: First PTS/DTS adjusted: ${pt(Q, !0)}/${pt(f, !0)}, delta: ${pt(O, !0)} ms`);
      }
    }
    f = Math.max(0, f);
    let b = 0, C = 0;
    for (let O = 0; O < l; O++) {
      const N = n[O], Z = N.units, Q = Z.length;
      let z = 0;
      for (let ne = 0; ne < Q; ne++)
        z += Z[ne].data.length;
      C += z, b += Q, N.length = z, N.dts = Math.max(N.dts, f), p = Math.min(N.pts, p), v = Math.max(N.pts, v);
    }
    g = n[l - 1].dts;
    const I = C + 4 * b + 8;
    let _;
    try {
      _ = new Uint8Array(I);
    } catch (O) {
      this.observer.emit(m.ERROR, m.ERROR, {
        type: U.MUX_ERROR,
        details: L.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: O,
        bytes: I,
        reason: `fail allocating video mdat ${I}`
      });
      return;
    }
    const D = new DataView(_.buffer);
    D.setUint32(0, I), _.set(S.types.mdat, 4);
    let R = !1, F = Number.POSITIVE_INFINITY, P = Number.POSITIVE_INFINITY, W = Number.NEGATIVE_INFINITY, le = Number.NEGATIVE_INFINITY;
    for (let O = 0; O < l; O++) {
      const N = n[O], Z = N.units;
      let Q = 0;
      for (let Re = 0, De = Z.length; Re < De; Re++) {
        const Ie = Z[Re], Ze = Ie.data, Zt = Ie.data.byteLength;
        D.setUint32(d, Zt), d += 4, _.set(Ze, d), d += Zt, Q += 4 + Zt;
      }
      let z;
      if (O < l - 1)
        u = n[O + 1].dts - N.dts, z = n[O + 1].pts - N.pts;
      else {
        const Re = this.config, De = O > 0 ? N.dts - n[O - 1].dts : A;
        if (z = O > 0 ? N.pts - n[O - 1].pts : A, Re.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const Ie = Math.floor(Re.maxBufferHole * r), Ze = (i ? p + i * r : this.nextAudioPts) - N.pts;
          Ze > Ie ? (u = Ze - De, u < 0 ? u = De : R = !0, E.log(`[mp4-remuxer]: It is approximately ${Ze / 90} ms to the next segment; using duration ${u / 90} ms for the last video frame.`)) : u = De;
        } else
          u = De;
      }
      const ne = Math.round(N.pts - N.dts);
      F = Math.min(F, u), W = Math.max(W, u), P = Math.min(P, z), le = Math.max(le, z), o.push(new Fi(N.key, u, Q, ne));
    }
    if (o.length) {
      if (Pt) {
        if (Pt < 70) {
          const O = o[0].flags;
          O.dependsOn = 2, O.isNonSync = 0;
        }
      } else if (os && le - P < W - F && A / W < 0.025 && o[0].cts === 0) {
        E.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let O = f;
        for (let N = 0, Z = o.length; N < Z; N++) {
          const Q = O + o[N].duration, z = O + o[N].cts;
          if (N < Z - 1) {
            const ne = Q + o[N + 1].cts;
            o[N].duration = ne - z;
          } else
            o[N].duration = N ? o[N - 1].duration : A;
          o[N].cts = 0, O = Q;
        }
      }
    }
    u = R || !u ? A : u, this.nextAvcDts = c = g + u, this.videoSampleDuration = u, this.isVideoContiguous = !0;
    const V = S.moof(e.sequenceNumber++, f, ae({}, e, {
      samples: o
    })), Y = "video", X = {
      data1: V,
      data2: _,
      startPTS: p / r,
      endPTS: (v + u) / r,
      startDTS: f / r,
      endDTS: c / r,
      type: Y,
      hasAudio: !1,
      hasVideo: !0,
      nb: o.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, X;
  }
  remuxAudio(e, t, s, i, r) {
    const n = e.inputTimeScale, o = e.samplerate ? e.samplerate : n, l = n / o, h = e.segmentCodec === "aac" ? Oi : Co, c = h * l, d = this._initPTS, u = e.segmentCodec === "mp3" && this.typeSupported.mpeg, f = [], g = r !== void 0;
    let p = e.samples, v = u ? 0 : 8, y = this.nextAudioPts || -1;
    const T = t * n, x = d.baseTime * n / d.timescale;
    if (this.isAudioContiguous = s = s || p.length && y > 0 && (i && Math.abs(T - y) < 9e3 || Math.abs(Ce(p[0].pts - x, T) - y) < 20 * c), p.forEach(function(Y) {
      Y.pts = Ce(Y.pts - x, T);
    }), !s || y < 0) {
      if (p = p.filter((Y) => Y.pts >= 0), !p.length)
        return;
      r === 0 ? y = 0 : i && !g ? y = Math.max(0, T) : y = p[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const Y = this.config.maxAudioFramesDrift;
      for (let X = 0, O = y; X < p.length; X++) {
        const N = p[X], Z = N.pts, Q = Z - O, z = Math.abs(1e3 * Q / n);
        if (Q <= -Y * c && g)
          X === 0 && (E.warn(`Audio frame @ ${(Z / n).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * Q / n)} ms.`), this.nextAudioPts = y = O = Z);
        else if (Q >= Y * c && z < _o && g) {
          let ne = Math.round(Q / c);
          O = Z - ne * c, O < 0 && (ne--, O += c), X === 0 && (this.nextAudioPts = y = O), E.warn(`[mp4-remuxer]: Injecting ${ne} audio frame @ ${(O / n).toFixed(3)}s due to ${Math.round(1e3 * Q / n)} ms gap.`);
          for (let Re = 0; Re < ne; Re++) {
            const De = Math.max(O, 0);
            let Ie = Pi.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            Ie || (E.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), Ie = N.unit.subarray()), p.splice(X, 0, {
              unit: Ie,
              pts: De
            }), O += c, X++;
          }
        }
        N.pts = O, O += c;
      }
    }
    let A = null, b = null, C, I = 0, _ = p.length;
    for (; _--; )
      I += p[_].unit.byteLength;
    for (let Y = 0, X = p.length; Y < X; Y++) {
      const O = p[Y], N = O.unit;
      let Z = O.pts;
      if (b !== null) {
        const z = f[Y - 1];
        z.duration = Math.round((Z - b) / l);
      } else if (s && e.segmentCodec === "aac" && (Z = y), A = Z, I > 0) {
        I += v;
        try {
          C = new Uint8Array(I);
        } catch (z) {
          this.observer.emit(m.ERROR, m.ERROR, {
            type: U.MUX_ERROR,
            details: L.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: z,
            bytes: I,
            reason: `fail allocating audio mdat ${I}`
          });
          return;
        }
        u || (new DataView(C.buffer).setUint32(0, I), C.set(S.types.mdat, 4));
      } else
        return;
      C.set(N, v);
      const Q = N.byteLength;
      v += Q, f.push(new Fi(!0, h, Q, 0)), b = Z;
    }
    const D = f.length;
    if (!D)
      return;
    const R = f[f.length - 1];
    this.nextAudioPts = y = b + l * R.duration;
    const F = u ? new Uint8Array(0) : S.moof(e.sequenceNumber++, A / l, ae({}, e, {
      samples: f
    }));
    e.samples = [];
    const P = A / n, W = y / n, V = {
      data1: F,
      data2: C,
      startPTS: P,
      endPTS: W,
      startDTS: P,
      endDTS: W,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: D
    };
    return this.isAudioContiguous = !0, V;
  }
  remuxEmptyAudio(e, t, s, i) {
    const r = e.inputTimeScale, n = e.samplerate ? e.samplerate : r, o = r / n, l = this.nextAudioPts, h = this._initDTS, c = h.baseTime * 9e4 / h.timescale, d = (l !== null ? l : i.startDTS * r) + c, u = i.endDTS * r + c, f = o * Oi, g = Math.ceil((u - d) / f), p = Pi.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (E.warn("[mp4-remuxer]: remux empty Audio"), !p) {
      E.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const v = [];
    for (let y = 0; y < g; y++) {
      const T = d + y * f;
      v.push({
        unit: p,
        pts: T,
        dts: T
      });
    }
    return e.samples = v, this.remuxAudio(e, t, s, !1);
  }
}
function Ce(a, e) {
  let t;
  if (e === null)
    return a;
  for (e < a ? t = -8589934592 : t = 8589934592; Math.abs(a - e) > 4294967296; )
    a += t;
  return a;
}
function Do(a) {
  for (let e = 0; e < a.length; e++)
    if (a[e].key)
      return e;
  return -1;
}
function Yr(a, e, t, s) {
  const i = a.samples.length;
  if (!i)
    return;
  const r = a.inputTimeScale;
  for (let o = 0; o < i; o++) {
    const l = a.samples[o];
    l.pts = Ce(l.pts - t.baseTime * r / t.timescale, e * r) / r, l.dts = Ce(l.dts - s.baseTime * r / s.timescale, e * r) / r;
  }
  const n = a.samples;
  return a.samples = [], {
    samples: n
  };
}
function zr(a, e, t) {
  const s = a.samples.length;
  if (!s)
    return;
  const i = a.inputTimeScale;
  for (let n = 0; n < s; n++) {
    const o = a.samples[n];
    o.pts = Ce(o.pts - t.baseTime * i / t.timescale, e * i) / i;
  }
  a.samples.sort((n, o) => n.pts - o.pts);
  const r = a.samples;
  return a.samples = [], {
    samples: r
  };
}
class Fi {
  constructor(e, t, s, i) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = s, this.cts = i, this.flags = new ko(e);
  }
}
class ko {
  constructor(e) {
    this.isLeading = 0, this.isDependedOn = 0, this.hasRedundancy = 0, this.degradPrio = 0, this.dependsOn = 1, this.isNonSync = 1, this.dependsOn = e ? 2 : 1, this.isNonSync = e ? 0 : 1;
  }
}
class Po {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, t, s, i) {
    this.audioCodec = t, this.videoCodec = s, this.generateInitSegment(Qn(e, i)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: s
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const i = this.initData = Sr(e);
    t || (t = Mi(i.audio, q.AUDIO)), s || (s = Mi(i.video, q.VIDEO));
    const r = {};
    i.audio && i.video ? r.audiovideo = {
      container: "video/mp4",
      codec: t + "," + s,
      initSegment: e,
      id: "main"
    } : i.audio ? r.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : i.video ? r.video = {
      container: "video/mp4",
      codec: s,
      initSegment: e,
      id: "main"
    } : E.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = r;
  }
  remux(e, t, s, i, r, n) {
    var o, l;
    let {
      initPTS: h,
      lastEndTime: c
    } = this;
    const d = {
      audio: void 0,
      video: void 0,
      text: i,
      id3: s,
      initSegment: void 0
    };
    M(c) || (c = this.lastEndTime = r || 0);
    const u = t.samples;
    if (!(u != null && u.length))
      return d;
    const f = {
      initPTS: void 0,
      timescale: 1
    };
    let g = this.initData;
    if ((o = g) != null && o.length || (this.generateInitSegment(u), g = this.initData), !((l = g) != null && l.length))
      return E.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), d;
    this.emitInitSegment && (f.tracks = this.initTracks, this.emitInitSegment = !1);
    const p = ea(u, g), v = Jn(g, u), y = v === null ? r : v;
    (Oo(h, y, r, p) || f.timescale !== h.timescale && n) && (f.initPTS = y - r, h && h.timescale === 1 && E.warn(`Adjusting initPTS by ${f.initPTS - h.baseTime}`), this.initPTS = h = {
      baseTime: f.initPTS,
      timescale: 1
    });
    const T = e ? y - h.baseTime / h.timescale : c, x = T + p;
    sa(g, u, h.baseTime / h.timescale), p > 0 ? this.lastEndTime = x : (E.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const A = !!g.audio, b = !!g.video;
    let C = "";
    A && (C += "audio"), b && (C += "video");
    const I = {
      data1: u,
      startPTS: T,
      startDTS: T,
      endPTS: x,
      endDTS: x,
      type: C,
      hasAudio: A,
      hasVideo: b,
      nb: 1,
      dropped: 0
    };
    return d.audio = I.type === "audio" ? I : void 0, d.video = I.type !== "audio" ? I : void 0, d.initSegment = f, d.id3 = Yr(s, r, h, h), i.samples.length && (d.text = zr(i, r, h)), d;
  }
}
function Oo(a, e, t, s) {
  if (a === null)
    return !0;
  const i = Math.max(s, 1), r = e - a.baseTime / a.timescale;
  return Math.abs(r - t) > i;
}
function Mi(a, e) {
  const t = a == null ? void 0 : a.codec;
  return t && t.length > 4 ? t : t === "hvc1" || t === "hev1" ? "hvc1.1.6.L120.90" : t === "av01" ? "av01.0.04M.08" : t === "avc1" || e === q.VIDEO ? "avc1.42e01e" : "mp4a.40.5";
}
let Ve;
try {
  Ve = self.performance.now.bind(self.performance);
} catch {
  E.debug("Unable to use Performance API on this environment"), Ve = typeof self < "u" && self.Date.now;
}
const hs = [{
  demux: po,
  remux: Po
}, {
  demux: Ye,
  remux: ls
}, {
  demux: go,
  remux: ls
}, {
  demux: Ro,
  remux: ls
}];
class Ni {
  constructor(e, t, s, i, r) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = s, this.vendor = i, this.id = r;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, s, i) {
    const r = s.transmuxing;
    r.executeStart = Ve();
    let n = new Uint8Array(e);
    const {
      currentTransmuxState: o,
      transmuxConfig: l
    } = this;
    i && (this.currentTransmuxState = i);
    const {
      contiguous: h,
      discontinuity: c,
      trackSwitch: d,
      accurateTimeOffset: u,
      timeOffset: f,
      initSegmentChange: g
    } = i || o, {
      audioCodec: p,
      videoCodec: v,
      defaultInitPts: y,
      duration: T,
      initSegmentData: x
    } = l, A = Fo(n, t);
    if (A && A.method === "AES-128") {
      const _ = this.getDecrypter();
      if (_.isSync()) {
        let D = _.softwareDecrypt(n, A.key.buffer, A.iv.buffer);
        if (s.part > -1 && (D = _.flush()), !D)
          return r.executeEnd = Ve(), cs(s);
        n = new Uint8Array(D);
      } else
        return this.decryptionPromise = _.webCryptoDecrypt(n, A.key.buffer, A.iv.buffer).then((D) => {
          const R = this.push(D, null, s);
          return this.decryptionPromise = null, R;
        }), this.decryptionPromise;
    }
    const b = this.needsProbing(c, d);
    if (b) {
      const _ = this.configureTransmuxer(n);
      if (_)
        return E.warn(`[transmuxer] ${_.message}`), this.observer.emit(m.ERROR, m.ERROR, {
          type: U.MEDIA_ERROR,
          details: L.FRAG_PARSING_ERROR,
          fatal: !1,
          error: _,
          reason: _.message
        }), r.executeEnd = Ve(), cs(s);
    }
    (c || d || g || b) && this.resetInitSegment(x, p, v, T, t), (c || g || b) && this.resetInitialTimestamp(y), h || this.resetContiguity();
    const C = this.transmux(n, A, f, u, s), I = this.currentTransmuxState;
    return I.contiguous = !0, I.discontinuity = !1, I.trackSwitch = !1, r.executeEnd = Ve(), C;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = Ve();
    const {
      decrypter: s,
      currentTransmuxState: i,
      decryptionPromise: r
    } = this;
    if (r)
      return r.then(() => this.flush(e));
    const n = [], {
      timeOffset: o
    } = i;
    if (s) {
      const d = s.flush();
      d && n.push(this.push(d, null, e));
    }
    const {
      demuxer: l,
      remuxer: h
    } = this;
    if (!l || !h)
      return t.executeEnd = Ve(), [cs(e)];
    const c = l.flush(o);
    return Nt(c) ? c.then((d) => (this.flushRemux(n, d, e), n)) : (this.flushRemux(n, c, e), n);
  }
  flushRemux(e, t, s) {
    const {
      audioTrack: i,
      videoTrack: r,
      id3Track: n,
      textTrack: o
    } = t, {
      accurateTimeOffset: l,
      timeOffset: h
    } = this.currentTransmuxState;
    E.log(`[transmuxer.ts]: Flushed fragment ${s.sn}${s.part > -1 ? " p: " + s.part : ""} of level ${s.level}`);
    const c = this.remuxer.remux(i, r, n, o, h, l, !0, this.id);
    e.push({
      remuxResult: c,
      chunkMeta: s
    }), s.transmuxing.executeEnd = Ve();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: s
    } = this;
    !t || !s || (t.resetTimeStamp(e), s.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, s, i, r) {
    const {
      demuxer: n,
      remuxer: o
    } = this;
    !n || !o || (n.resetInitSegment(e, t, s, i), o.resetInitSegment(e, t, s, r));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, s, i, r) {
    let n;
    return t && t.method === "SAMPLE-AES" ? n = this.transmuxSampleAes(e, t, s, i, r) : n = this.transmuxUnencrypted(e, s, i, r), n;
  }
  transmuxUnencrypted(e, t, s, i) {
    const {
      audioTrack: r,
      videoTrack: n,
      id3Track: o,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(r, n, o, l, t, s, !1, this.id),
      chunkMeta: i
    };
  }
  transmuxSampleAes(e, t, s, i, r) {
    return this.demuxer.demuxSampleAes(e, t, s).then((n) => ({
      remuxResult: this.remuxer.remux(n.audioTrack, n.videoTrack, n.id3Track, n.textTrack, s, i, !1, this.id),
      chunkMeta: r
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: s,
      typeSupported: i,
      vendor: r
    } = this;
    let n;
    for (let d = 0, u = hs.length; d < u; d++)
      if (hs[d].demux.probe(e)) {
        n = hs[d];
        break;
      }
    if (!n)
      return new Error("Failed to find demuxer by probing fragment data");
    const o = this.demuxer, l = this.remuxer, h = n.remux, c = n.demux;
    (!l || !(l instanceof h)) && (this.remuxer = new h(s, t, i, r)), (!o || !(o instanceof c)) && (this.demuxer = new c(s, t, i), this.probe = c.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new Ks(this.config)), e;
  }
}
function Fo(a, e) {
  let t = null;
  return a.byteLength > 0 && e != null && e.key != null && e.iv !== null && e.method != null && (t = e), t;
}
const cs = (a) => ({
  remuxResult: {},
  chunkMeta: a
});
function Nt(a) {
  return "then" in a && a.then instanceof Function;
}
class Mo {
  constructor(e, t, s, i, r) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = s, this.duration = i, this.defaultInitPts = r || null;
  }
}
class No {
  constructor(e, t, s, i, r, n) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = s, this.trackSwitch = i, this.timeOffset = r, this.initSegmentChange = n;
  }
}
var jr = { exports: {} };
(function(a) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (t = !1));
  function i(l, h, c) {
    this.fn = l, this.context = h, this.once = c || !1;
  }
  function r(l, h, c, d, u) {
    if (typeof c != "function")
      throw new TypeError("The listener must be a function");
    var f = new i(c, d || l, u), g = t ? t + h : h;
    return l._events[g] ? l._events[g].fn ? l._events[g] = [l._events[g], f] : l._events[g].push(f) : (l._events[g] = f, l._eventsCount++), l;
  }
  function n(l, h) {
    --l._eventsCount === 0 ? l._events = new s() : delete l._events[h];
  }
  function o() {
    this._events = new s(), this._eventsCount = 0;
  }
  o.prototype.eventNames = function() {
    var h = [], c, d;
    if (this._eventsCount === 0)
      return h;
    for (d in c = this._events)
      e.call(c, d) && h.push(t ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? h.concat(Object.getOwnPropertySymbols(c)) : h;
  }, o.prototype.listeners = function(h) {
    var c = t ? t + h : h, d = this._events[c];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var u = 0, f = d.length, g = new Array(f); u < f; u++)
      g[u] = d[u].fn;
    return g;
  }, o.prototype.listenerCount = function(h) {
    var c = t ? t + h : h, d = this._events[c];
    return d ? d.fn ? 1 : d.length : 0;
  }, o.prototype.emit = function(h, c, d, u, f, g) {
    var p = t ? t + h : h;
    if (!this._events[p])
      return !1;
    var v = this._events[p], y = arguments.length, T, x;
    if (v.fn) {
      switch (v.once && this.removeListener(h, v.fn, void 0, !0), y) {
        case 1:
          return v.fn.call(v.context), !0;
        case 2:
          return v.fn.call(v.context, c), !0;
        case 3:
          return v.fn.call(v.context, c, d), !0;
        case 4:
          return v.fn.call(v.context, c, d, u), !0;
        case 5:
          return v.fn.call(v.context, c, d, u, f), !0;
        case 6:
          return v.fn.call(v.context, c, d, u, f, g), !0;
      }
      for (x = 1, T = new Array(y - 1); x < y; x++)
        T[x - 1] = arguments[x];
      v.fn.apply(v.context, T);
    } else {
      var A = v.length, b;
      for (x = 0; x < A; x++)
        switch (v[x].once && this.removeListener(h, v[x].fn, void 0, !0), y) {
          case 1:
            v[x].fn.call(v[x].context);
            break;
          case 2:
            v[x].fn.call(v[x].context, c);
            break;
          case 3:
            v[x].fn.call(v[x].context, c, d);
            break;
          case 4:
            v[x].fn.call(v[x].context, c, d, u);
            break;
          default:
            if (!T)
              for (b = 1, T = new Array(y - 1); b < y; b++)
                T[b - 1] = arguments[b];
            v[x].fn.apply(v[x].context, T);
        }
    }
    return !0;
  }, o.prototype.on = function(h, c, d) {
    return r(this, h, c, d, !1);
  }, o.prototype.once = function(h, c, d) {
    return r(this, h, c, d, !0);
  }, o.prototype.removeListener = function(h, c, d, u) {
    var f = t ? t + h : h;
    if (!this._events[f])
      return this;
    if (!c)
      return n(this, f), this;
    var g = this._events[f];
    if (g.fn)
      g.fn === c && (!u || g.once) && (!d || g.context === d) && n(this, f);
    else {
      for (var p = 0, v = [], y = g.length; p < y; p++)
        (g[p].fn !== c || u && !g[p].once || d && g[p].context !== d) && v.push(g[p]);
      v.length ? this._events[f] = v.length === 1 ? v[0] : v : n(this, f);
    }
    return this;
  }, o.prototype.removeAllListeners = function(h) {
    var c;
    return h ? (c = t ? t + h : h, this._events[c] && n(this, c)) : (this._events = new s(), this._eventsCount = 0), this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, a.exports = o;
})(jr);
var Uo = jr.exports, qs = /* @__PURE__ */ Sn(Uo);
const ds = qt() || {
  isTypeSupported: () => !1
};
class qr {
  constructor(e, t, s, i) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const r = e.config;
    this.hls = e, this.id = t, this.useWorker = !!r.enableWorker, this.onTransmuxComplete = s, this.onFlush = i;
    const n = (h, c) => {
      c = c || {}, c.frag = this.frag, c.id = this.id, h === m.ERROR && (this.error = c.error), this.hls.trigger(h, c);
    };
    this.observer = new qs(), this.observer.on(m.FRAG_DECRYPTED, n), this.observer.on(m.ERROR, n);
    const o = {
      mp4: ds.isTypeSupported("video/mp4"),
      mpeg: ds.isTypeSupported("audio/mpeg"),
      mp3: ds.isTypeSupported('audio/mp4; codecs="mp3"')
    }, l = navigator.vendor;
    if (this.useWorker && typeof Worker < "u" && (r.workerPath || ro())) {
      try {
        r.workerPath ? (E.log(`loading Web Worker ${r.workerPath} for "${t}"`), this.workerContext = ao(r.workerPath)) : (E.log(`injecting Web Worker for "${t}"`), this.workerContext = no()), this.onwmsg = (d) => this.onWorkerMessage(d);
        const {
          worker: c
        } = this.workerContext;
        c.addEventListener("message", this.onwmsg), c.onerror = (d) => {
          const u = new Error(`${d.message}  (${d.filename}:${d.lineno})`);
          r.enableWorker = !1, E.warn(`Error in "${t}" Web Worker, fallback to inline`), this.hls.trigger(m.ERROR, {
            type: U.OTHER_ERROR,
            details: L.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: u
          });
        }, c.postMessage({
          cmd: "init",
          typeSupported: o,
          vendor: l,
          id: t,
          config: JSON.stringify(r)
        });
      } catch (c) {
        E.warn(`Error setting up "${t}" Web Worker, fallback to inline`, c), this.resetWorker(), this.error = null, this.transmuxer = new Ni(this.observer, o, r, l, t);
      }
      return;
    }
    this.transmuxer = new Ni(this.observer, o, r, l, t);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: t
      } = this.workerContext;
      t && self.URL.revokeObjectURL(t), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, t, s, i, r, n, o, l, h, c) {
    var d, u;
    h.transmuxing.start = self.performance.now();
    const {
      transmuxer: f
    } = this, g = n ? n.start : r.start, p = r.decryptdata, v = this.frag, y = !(v && r.cc === v.cc), T = !(v && h.level === v.level), x = v ? h.sn - v.sn : -1, A = this.part ? h.part - this.part.index : -1, b = x === 0 && h.id > 1 && h.id === (v == null ? void 0 : v.stats.chunkCount), C = !T && (x === 1 || x === 0 && (A === 1 || b && A <= 0)), I = self.performance.now();
    (T || x || r.stats.parsing.start === 0) && (r.stats.parsing.start = I), n && (A || !C) && (n.stats.parsing.start = I);
    const _ = !(v && ((d = r.initSegment) == null ? void 0 : d.url) === ((u = v.initSegment) == null ? void 0 : u.url)), D = new No(y, C, l, T, g, _);
    if (!C || y || _) {
      E.log(`[transmuxer-interface, ${r.type}]: Starting new transmux session for sn: ${h.sn} p: ${h.part} level: ${h.level} id: ${h.id}
        discontinuity: ${y}
        trackSwitch: ${T}
        contiguous: ${C}
        accurateTimeOffset: ${l}
        timeOffset: ${g}
        initSegmentChange: ${_}`);
      const R = new Mo(s, i, t, o, c);
      this.configureTransmuxer(R);
    }
    if (this.frag = r, this.part = n, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: p,
        chunkMeta: h,
        state: D
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (f) {
      const R = f.push(e, p, h, D);
      Nt(R) ? (f.async = !0, R.then((F) => {
        this.handleTransmuxComplete(F);
      }).catch((F) => {
        this.transmuxerError(F, h, "transmuxer-interface push error");
      })) : (f.async = !1, this.handleTransmuxComplete(R));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: t
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (t) {
      let s = t.flush(e);
      Nt(s) || t.async ? (Nt(s) || (s = Promise.resolve(s)), s.then((r) => {
        this.handleFlushResult(r, e);
      }).catch((r) => {
        this.transmuxerError(r, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(s, e);
    }
  }
  transmuxerError(e, t, s) {
    this.hls && (this.error = e, this.hls.trigger(m.ERROR, {
      type: U.MEDIA_ERROR,
      details: L.FRAG_PARSING_ERROR,
      chunkMeta: t,
      fatal: !1,
      error: e,
      err: e,
      reason: s
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((s) => {
      this.handleTransmuxComplete(s);
    }), this.onFlush(t);
  }
  onWorkerMessage(e) {
    const t = e.data, s = this.hls;
    switch (t.event) {
      case "init": {
        var i;
        const r = (i = this.workerContext) == null ? void 0 : i.objectURL;
        r && self.URL.revokeObjectURL(r);
        break;
      }
      case "transmuxComplete": {
        this.handleTransmuxComplete(t.data);
        break;
      }
      case "flush": {
        this.onFlush(t.data);
        break;
      }
      case "workerLog":
        E[t.data.logType] && E[t.data.logType](t.data.message);
        break;
      default: {
        t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, s.trigger(t.event, t.data);
        break;
      }
    }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: t
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : t && t.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const $o = 250, us = 2, Bo = 0.1, Go = 0.05;
class Vo {
  constructor(e, t, s, i) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = s, this.hls = i;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    const {
      config: s,
      media: i,
      stalled: r
    } = this;
    if (i === null)
      return;
    const {
      currentTime: n,
      seeking: o
    } = i, l = this.seeking && !o, h = !this.seeking && o;
    if (this.seeking = o, n !== e) {
      if (this.moved = !0, r !== null) {
        if (this.stallReported) {
          const y = self.performance.now() - r;
          E.warn(`playback not stuck anymore @${n}, after ${Math.round(y)}ms`), this.stallReported = !1;
        }
        this.stalled = null, this.nudgeRetry = 0;
      }
      return;
    }
    if (h || l) {
      this.stalled = null;
      return;
    }
    if (i.paused && !o || i.ended || i.playbackRate === 0 || !J.getBuffered(i).length)
      return;
    const c = J.bufferInfo(i, n, 0), d = c.len > 0, u = c.nextStart || 0;
    if (!d && !u)
      return;
    if (o) {
      const y = c.len > us, T = !u || t && t.start <= n || u - n > us && !this.fragmentTracker.getPartialFragment(n);
      if (y || T)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var f;
      const y = Math.max(u, c.start || 0) - n, T = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, A = (T == null || (f = T.details) == null ? void 0 : f.live) ? T.details.targetduration * 2 : us, b = this.fragmentTracker.getPartialFragment(n);
      if (y > 0 && (y <= A || b)) {
        this._trySkipBufferHole(b);
        return;
      }
    }
    const g = self.performance.now();
    if (r === null) {
      this.stalled = g;
      return;
    }
    const p = g - r;
    if (!o && p >= $o && (this._reportStall(c), !this.media))
      return;
    const v = J.bufferInfo(i, n, s.maxBufferHole);
    this._tryFixBufferStall(v, p);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t) {
    const {
      config: s,
      fragmentTracker: i,
      media: r
    } = this;
    if (r === null)
      return;
    const n = r.currentTime, o = i.getPartialFragment(n);
    o && (this._trySkipBufferHole(o) || !this.media) || (e.len > s.maxBufferHole || e.nextStart && e.nextStart - n < s.maxBufferHole) && t > s.highBufferWatchdogPeriod * 1e3 && (E.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: s,
      stallReported: i
    } = this;
    if (!i && s) {
      this.stallReported = !0;
      const r = new Error(`Playback stalling at @${s.currentTime} due to low buffer (${JSON.stringify(e)})`);
      E.warn(r.message), t.trigger(m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: r,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: t,
      hls: s,
      media: i
    } = this;
    if (i === null)
      return 0;
    const r = i.currentTime, n = J.bufferInfo(i, r, 0), o = r < n.start ? n.start : n.nextStart;
    if (o) {
      const l = n.len <= t.maxBufferHole, h = n.len > 0 && n.len < 1 && i.readyState < 3, c = o - r;
      if (c > 0 && (l || h)) {
        if (c > t.maxBufferHole) {
          const {
            fragmentTracker: u
          } = this;
          let f = !1;
          if (r === 0) {
            const g = u.getAppendedFrag(0, $.MAIN);
            g && o < g.end && (f = !0);
          }
          if (!f) {
            const g = e || u.getAppendedFrag(r, $.MAIN);
            if (g) {
              let p = !1, v = g.end;
              for (; v < o; ) {
                const y = u.getPartialFragment(v);
                if (y)
                  v += y.duration;
                else {
                  p = !0;
                  break;
                }
              }
              if (p)
                return 0;
            }
          }
        }
        const d = Math.max(o + Go, r + Bo);
        if (E.warn(`skipping hole, adjusting currentTime from ${r} to ${d}`), this.moved = !0, this.stalled = null, i.currentTime = d, e && !e.gap) {
          const u = new Error(`fragment loaded with buffer holes, seeking from ${r} to ${d}`);
          s.trigger(m.ERROR, {
            type: U.MEDIA_ERROR,
            details: L.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: u,
            reason: u.message,
            frag: e
          });
        }
        return d;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: t,
      media: s,
      nudgeRetry: i
    } = this;
    if (s === null)
      return;
    const r = s.currentTime;
    if (this.nudgeRetry++, i < e.nudgeMaxRetry) {
      const n = r + (i + 1) * e.nudgeOffset, o = new Error(`Nudging 'currentTime' from ${r} to ${n}`);
      E.warn(o.message), s.currentTime = n, t.trigger(m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.BUFFER_NUDGE_ON_STALL,
        error: o,
        fatal: !1
      });
    } else {
      const n = new Error(`Playhead still not moving while enough data buffered @${r} after ${e.nudgeMaxRetry} nudges`);
      E.error(n.message), t.trigger(m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.BUFFER_STALLED_ERROR,
        error: n,
        fatal: !0
      });
    }
  }
}
const Ho = 100;
class Ko extends Ws {
  constructor(e, t, s) {
    super(e, t, s, "[stream-controller]", $.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.LEVEL_LOADING, this.onLevelLoading, this), e.on(m.LEVEL_LOADED, this.onLevelLoaded, this), e.on(m.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(m.ERROR, this.onError, this), e.on(m.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(m.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(m.BUFFER_CREATED, this.onBufferCreated, this), e.on(m.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(m.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.LEVEL_LOADED, this.onLevelLoaded, this), e.off(m.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(m.ERROR, this.onError, this), e.off(m.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(m.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(m.BUFFER_CREATED, this.onBufferCreated, this), e.off(m.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(m.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.onMediaDetaching();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: t,
        hls: s
      } = this;
      if (this.stopLoad(), this.setInterval(Ho), this.level = -1, !this.startFragRequested) {
        let i = s.startLevel;
        i === -1 && (s.config.testBandwidth && this.levels.length > 1 ? (i = 0, this.bitrateTest = !0) : i = s.nextAutoLevel), this.level = s.nextLoadLevel = i, this.loadedmetadata = !1;
      }
      t > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t), this.state = w.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = w.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case w.WAITING_LEVEL: {
        var e;
        const {
          levels: s,
          level: i
        } = this, r = s == null || (e = s[i]) == null ? void 0 : e.details;
        if (r && (!r.live || this.levelLastLoaded === this.level)) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = w.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = w.IDLE;
          break;
        }
        break;
      }
      case w.FRAG_LOADING_WAITING_RETRY:
        {
          var t;
          const s = self.performance.now(), i = this.retryDate;
          (!i || s >= i || (t = this.media) != null && t.seeking) && (this.resetStartWhenNotLoaded(this.level), this.state = w.IDLE);
        }
        break;
    }
    this.state === w.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: s,
      media: i
    } = this, {
      config: r,
      nextLoadLevel: n
    } = e;
    if (t === null || !i && (this.startFragRequested || !r.startFragPrefetch) || this.altAudio && this.audioOnly || !(s != null && s[n]))
      return;
    const o = s[n], l = this.getMainFwdBufferInfo();
    if (l === null)
      return;
    const h = this.getLevelDetails();
    if (h && this._streamEnded(l, h)) {
      const v = {};
      this.altAudio && (v.type = "video"), this.hls.trigger(m.BUFFER_EOS, v), this.state = w.ENDED;
      return;
    }
    e.loadLevel !== n && e.manualLevel === -1 && this.log(`Adapting to level ${n} from level ${this.level}`), this.level = e.nextLoadLevel = n;
    const c = o.details;
    if (!c || this.state === w.WAITING_LEVEL || c.live && this.levelLastLoaded !== n) {
      this.level = n, this.state = w.WAITING_LEVEL;
      return;
    }
    const d = l.len, u = this.getMaxBufferLength(o.maxBitrate);
    if (d >= u)
      return;
    this.backtrackFragment && this.backtrackFragment.start > l.end && (this.backtrackFragment = null);
    const f = this.backtrackFragment ? this.backtrackFragment.start : l.end;
    let g = this.getNextFragment(f, c);
    if (this.couldBacktrack && !this.fragPrevious && g && g.sn !== "initSegment" && this.fragmentTracker.getState(g) !== he.OK) {
      var p;
      const y = ((p = this.backtrackFragment) != null ? p : g).sn - c.startSN, T = c.fragments[y - 1];
      T && g.cc === T.cc && (g = T, this.fragmentTracker.removeFragment(T));
    } else
      this.backtrackFragment && l.len && (this.backtrackFragment = null);
    if (g && this.isLoopLoading(g, f)) {
      if (!g.gap) {
        const y = this.audioOnly && !this.altAudio ? q.AUDIO : q.VIDEO, T = (y === q.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        T && this.afterBufferFlushed(T, y, $.MAIN);
      }
      g = this.getNextFragmentLoopLoading(g, c, l, $.MAIN, u);
    }
    g && (g.initSegment && !g.initSegment.data && !this.bitrateTest && (g = g.initSegment), this.loadFragment(g, o, f));
  }
  loadFragment(e, t, s) {
    const i = this.fragmentTracker.getState(e);
    this.fragCurrent = e, i === he.NOT_LOADED || i === he.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, t) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : (this.startFragRequested = !0, super.loadFragment(e, t, s)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, $.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let s;
      const i = this.getAppendedFrag(t.currentTime);
      i && i.start > 1 && this.flushMainBuffer(0, i.start - 1);
      const r = this.getLevelDetails();
      if (r != null && r.live) {
        const o = this.getMainFwdBufferInfo();
        if (!o || o.len < r.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const o = this.hls.nextLoadLevel, l = e[o], h = this.fragLastKbps;
        h && this.fragCurrent ? s = this.fragCurrent.duration * l.maxBitrate / (1e3 * h) + 1 : s = 0;
      } else
        s = 0;
      const n = this.getBufferedFrag(t.currentTime + s);
      if (n) {
        const o = this.followingBufferedFrag(n);
        if (o) {
          this.abortCurrentFrag();
          const l = o.maxStartPTS ? o.maxStartPTS : o.start, h = o.duration, c = Math.max(n.end, l + Math.min(Math.max(h - this.config.maxFragLookUpTolerance, h * 0.5), h * 0.75));
          this.flushMainBuffer(c, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case w.KEY_LOADING:
      case w.FRAG_LOADING:
      case w.FRAG_LOADING_WAITING_RETRY:
      case w.PARSING:
      case w.PARSED:
        this.state = w.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const s = t.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), s.addEventListener("playing", this.onvplaying), s.addEventListener("seeked", this.onvseeked), this.gapController = new Vo(this.config, s, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, t = e ? e.currentTime : null;
    M(t) && this.log(`Media seeked to ${t.toFixed(3)}`);
    const s = this.getMainFwdBufferInfo();
    if (s === null || s.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${s ? s.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(m.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = 0, this.levels = this.fragPlaying = this.backtrackFragment = null, this.altAudio = this.audioOnly = !1;
  }
  onManifestParsed(e, t) {
    let s = !1, i = !1, r;
    t.levels.forEach((n) => {
      r = n.audioCodec, r && (r.indexOf("mp4a.40.2") !== -1 && (s = !0), r.indexOf("mp4a.40.5") !== -1 && (i = !0));
    }), this.audioCodecSwitch = s && i && !io(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: s
    } = this;
    if (!s || this.state !== w.IDLE)
      return;
    const i = s[t.level];
    (!i.details || i.details.live && this.levelLastLoaded !== t.level || this.waitForCdnTuneIn(i.details)) && (this.state = w.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      levels: i
    } = this, r = t.level, n = t.details, o = n.totalduration;
    if (!i) {
      this.warn(`Levels were reset while loading level ${r}`);
      return;
    }
    this.log(`Level ${r} loaded [${n.startSN},${n.endSN}]${n.lastPartSn ? `[part-${n.lastPartSn}-${n.lastPartIndex}]` : ""}, cc [${n.startCC}, ${n.endCC}] duration:${o}`);
    const l = i[r], h = this.fragCurrent;
    h && (this.state === w.FRAG_LOADING || this.state === w.FRAG_LOADING_WAITING_RETRY) && (h.level !== t.level || h.urlId !== l.urlId) && h.loader && this.abortCurrentFrag();
    let c = 0;
    if (n.live || (s = l.details) != null && s.live) {
      if (this.checkLiveUpdate(n), n.deltaUpdateFailed)
        return;
      c = this.alignPlaylists(n, l.details);
    }
    if (l.details = n, this.levelLastLoaded = r, this.hls.trigger(m.LEVEL_UPDATED, {
      details: n,
      level: r
    }), this.state === w.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(n))
        return;
      this.state = w.IDLE;
    }
    this.startFragRequested ? n.live && this.synchronizeToLiveEdge(n) : this.setStartPosition(n, c), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: i,
      payload: r
    } = e, {
      levels: n
    } = this;
    if (!n) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const o = n[s.level], l = o.details;
    if (!l) {
      this.warn(`Dropping fragment ${s.sn} of level ${s.level} after level details were reset`), this.fragmentTracker.removeFragment(s);
      return;
    }
    const h = o.videoCodec, c = l.PTSKnown || !l.live, d = (t = s.initSegment) == null ? void 0 : t.data, u = this._getAudioCodec(o), f = this.transmuxer = this.transmuxer || new qr(this.hls, $.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), g = i ? i.index : -1, p = g !== -1, v = new Vs(s.level, s.sn, s.stats.chunkCount, r.byteLength, g, p), y = this.initPTS[s.cc];
    f.push(r, d, u, h, s, i, l.totalduration, c, v, y);
  }
  onAudioTrackSwitching(e, t) {
    const s = this.altAudio;
    if (!!!t.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const n = this.fragCurrent;
        n && (this.log("Switching to main audio track, cancel main fragment load"), n.abortRequests(), this.fragmentTracker.removeFragment(n)), this.resetTransmuxer(), this.resetLoadingState();
      } else
        this.audioOnly && this.resetTransmuxer();
      const r = this.hls;
      s && (r.trigger(m.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), r.trigger(m.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const s = t.id, i = !!this.hls.audioTracks[s].url;
    if (i) {
      const r = this.videoBuffer;
      r && this.mediaBuffer !== r && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = r);
    }
    this.altAudio = i, this.tick();
  }
  onBufferCreated(e, t) {
    const s = t.tracks;
    let i, r, n = !1;
    for (const o in s) {
      const l = s[o];
      if (l.id === "main") {
        if (r = o, i = l, o === "video") {
          const h = s[o];
          h && (this.videoBuffer = h.buffer);
        }
      } else
        n = !0;
    }
    n && i ? (this.log(`Alternate track found, use ${r}.buffered to schedule main fragment loading`), this.mediaBuffer = i.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s && s.type !== $.MAIN)
      return;
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${i ? " p: " + i.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}`), this.state === w.PARSED && (this.state = w.IDLE);
      return;
    }
    const r = i ? i.stats : s.stats;
    this.fragLastKbps = Math.round(8 * r.total / (r.buffering.end - r.loading.first)), s.sn !== "initSegment" && (this.fragPrevious = s), this.fragBufferedComplete(s, i);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = w.ERROR;
      return;
    }
    switch (t.details) {
      case L.FRAG_GAP:
      case L.FRAG_PARSING_ERROR:
      case L.FRAG_DECRYPT_ERROR:
      case L.FRAG_LOAD_ERROR:
      case L.FRAG_LOAD_TIMEOUT:
      case L.KEY_LOAD_ERROR:
      case L.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError($.MAIN, t);
        break;
      case L.LEVEL_LOAD_ERROR:
      case L.LEVEL_LOAD_TIMEOUT:
      case L.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === w.WAITING_LEVEL && ((s = t.context) == null ? void 0 : s.type) === K.LEVEL && (this.state = w.IDLE);
        break;
      case L.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case L.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: t
    } = this;
    if (!(!e || !t || !e.readyState)) {
      if (this.loadedmetadata || !J.getBuffered(e).length) {
        const s = this.state !== w.IDLE ? this.fragCurrent : null;
        t.poll(this.lastCurrentTime, s);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = w.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== q.AUDIO || this.audioOnly && !this.altAudio) {
      const s = (t === q.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(s, t, $.MAIN);
    }
  }
  onLevelsUpdated(e, t) {
    this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let s = this.startPosition;
    if (s >= 0 && t < s) {
      if (e.seeking) {
        this.log(`could not seek to ${s}, already seeking at ${t}`);
        return;
      }
      const i = J.getBuffered(e), n = (i.length ? i.start(0) : 0) - s;
      n > 0 && (n < this.config.maxBufferHole || n < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${n} to match buffer start`), s += n, this.startPosition = s), this.log(`seek to target start position ${s} from current time ${t}`), e.currentTime = s;
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((s) => {
      const {
        hls: i
      } = this;
      if (!s || this.fragContextChanged(e))
        return;
      t.fragmentError = 0, this.state = w.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const r = e.stats;
      r.parsing.start = r.parsing.end = r.buffering.start = r.buffering.end = self.performance.now(), i.trigger(m.FRAG_LOADED, s), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "main", {
      hls: i
    } = this, {
      remuxResult: r,
      chunkMeta: n
    } = e, o = this.getCurrentContext(n);
    if (!o) {
      this.resetWhenMissingContext(n);
      return;
    }
    const {
      frag: l,
      part: h,
      level: c
    } = o, {
      video: d,
      text: u,
      id3: f,
      initSegment: g
    } = r, {
      details: p
    } = c, v = this.altAudio ? void 0 : r.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = w.PARSING, g) {
      if (g != null && g.tracks) {
        const x = l.initSegment || l;
        this._bufferInitSegment(c, g.tracks, x, n), i.trigger(m.FRAG_PARSING_INIT_SEGMENT, {
          frag: x,
          id: s,
          tracks: g.tracks
        });
      }
      const y = g.initPTS, T = g.timescale;
      M(y) && (this.initPTS[l.cc] = {
        baseTime: y,
        timescale: T
      }, i.trigger(m.INIT_PTS_FOUND, {
        frag: l,
        id: s,
        initPTS: y,
        timescale: T
      }));
    }
    if (d && p && l.sn !== "initSegment") {
      const y = p.fragments[l.sn - 1 - p.startSN], T = l.sn === p.startSN, x = !y || l.cc > y.cc;
      if (r.independent !== !1) {
        const {
          startPTS: A,
          endPTS: b,
          startDTS: C,
          endDTS: I
        } = d;
        if (h)
          h.elementaryStreams[d.type] = {
            startPTS: A,
            endPTS: b,
            startDTS: C,
            endDTS: I
          };
        else if (d.firstKeyFrame && d.independent && n.id === 1 && !x && (this.couldBacktrack = !0), d.dropped && d.independent) {
          const _ = this.getMainFwdBufferInfo(), D = (_ ? _.end : this.getLoadPosition()) + this.config.maxBufferHole, R = d.firstKeyFramePTS ? d.firstKeyFramePTS : A;
          if (!T && D < R - this.config.maxBufferHole && !x) {
            this.backtrack(l);
            return;
          } else
            x && (l.gap = !0);
          l.setElementaryStreamInfo(d.type, l.start, b, l.start, I, !0);
        }
        l.setElementaryStreamInfo(d.type, A, b, C, I), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(d, l, h, n, T || x);
      } else if (T || x)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (v) {
      const {
        startPTS: y,
        endPTS: T,
        startDTS: x,
        endDTS: A
      } = v;
      h && (h.elementaryStreams[q.AUDIO] = {
        startPTS: y,
        endPTS: T,
        startDTS: x,
        endDTS: A
      }), l.setElementaryStreamInfo(q.AUDIO, y, T, x, A), this.bufferFragmentData(v, l, h, n);
    }
    if (p && f != null && (t = f.samples) != null && t.length) {
      const y = {
        id: s,
        frag: l,
        details: p,
        samples: f.samples
      };
      i.trigger(m.FRAG_PARSING_METADATA, y);
    }
    if (p && u) {
      const y = {
        id: s,
        frag: l,
        details: p,
        samples: u.samples
      };
      i.trigger(m.FRAG_PARSING_USERDATA, y);
    }
  }
  _bufferInitSegment(e, t, s, i) {
    if (this.state !== w.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
    const {
      audio: r,
      video: n,
      audiovideo: o
    } = t;
    if (r) {
      let l = e.audioCodec;
      const h = navigator.userAgent.toLowerCase();
      this.audioCodecSwitch && (l && (l.indexOf("mp4a.40.5") !== -1 ? l = "mp4a.40.2" : l = "mp4a.40.5"), r.metadata.channelCount !== 1 && h.indexOf("firefox") === -1 && (l = "mp4a.40.5")), h.indexOf("android") !== -1 && r.container !== "audio/mpeg" && (l = "mp4a.40.2", this.log(`Android: force audio codec to ${l}`)), e.audioCodec && e.audioCodec !== l && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${l}"`), r.levelCodec = l, r.id = "main", this.log(`Init audio buffer, container:${r.container}, codecs[selected/level/parsed]=[${l || ""}/${e.audioCodec || ""}/${r.codec}]`);
    }
    n && (n.levelCodec = e.videoCodec, n.id = "main", this.log(`Init video buffer, container:${n.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${n.codec}]`)), o && this.log(`Init audiovideo buffer, container:${o.container}, codecs[level/parsed]=[${e.attrs.CODECS || ""}/${o.codec}]`), this.hls.trigger(m.BUFFER_CODECS, t), Object.keys(t).forEach((l) => {
      const c = t[l].initSegment;
      c != null && c.byteLength && this.hls.trigger(m.BUFFER_APPENDING, {
        type: l,
        data: c,
        frag: s,
        part: null,
        chunkMeta: i,
        parent: s.type
      });
    }), this.tick();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, $.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = w.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const s = e.currentTime;
      if (J.isBuffered(e, s) ? t = this.getAppendedFrag(s) : J.isBuffered(e, s + 0.1) && (t = this.getAppendedFrag(s + 0.1)), t) {
        this.backtrackFragment = null;
        const i = this.fragPlaying, r = t.level;
        (!i || t.sn !== i.sn || i.level !== r || t.urlId !== i.urlId) && (this.fragPlaying = t, this.hls.trigger(m.FRAG_CHANGED, {
          frag: t
        }), (!i || i.level !== r) && this.hls.trigger(m.LEVEL_SWITCHED, {
          level: r
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const t = e.currentTime, s = this.currentFrag;
      if (s && M(t) && M(s.programDateTime)) {
        const i = s.programDateTime + (t - s.start) * 1e3;
        return new Date(i);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class at {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, s = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = s;
  }
  sample(e, t) {
    const s = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - s) + s * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class Wo {
  constructor(e, t, s, i = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = s, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new at(e), this.fast_ = new at(t), this.defaultTTFB_ = i, this.ttfb_ = new at(e);
  }
  update(e, t) {
    const {
      slow_: s,
      fast_: i,
      ttfb_: r
    } = this;
    s.halfLife !== e && (this.slow_ = new at(e, s.getEstimate(), s.getTotalWeight())), i.halfLife !== t && (this.fast_ = new at(t, i.getEstimate(), i.getTotalWeight())), r.halfLife !== e && (this.ttfb_ = new at(e, r.getEstimate(), r.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const s = 8 * t, i = e / 1e3, r = s / i;
    this.fast_.sample(i, r), this.slow_.sample(i, r);
  }
  sampleTTFB(e) {
    const t = e / 1e3, s = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(s, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
class Yo {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = 0, this._nextAutoLevel = -1, this.timer = -1, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = e;
    const t = e.config;
    this.bwEstimator = new Wo(t.abrEwmaSlowVoD, t.abrEwmaFastVoD, t.abrEwmaDefaultEstimate), this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.FRAG_LOADING, this.onFragLoading, this), e.on(m.FRAG_LOADED, this.onFragLoaded, this), e.on(m.FRAG_BUFFERED, this.onFragBuffered, this), e.on(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(m.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.FRAG_LOADING, this.onFragLoading, this), e.off(m.FRAG_LOADED, this.onFragLoaded, this), e.off(m.FRAG_BUFFERED, this.onFragBuffered, this), e.off(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(m.LEVEL_LOADED, this.onLevelLoaded, this);
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onFragLoading(e, t) {
    var s;
    const i = t.frag;
    this.ignoreFragment(i) || (this.fragCurrent = i, this.partCurrent = (s = t.part) != null ? s : null, this.clearTimer(), this.timer = self.setInterval(this.onCheck, 100));
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  getTimeToLoadFrag(e, t, s, i) {
    const r = e + s / t, n = i ? this.lastLevelLoadSec : 0;
    return r + n;
  }
  onLevelLoaded(e, t) {
    const s = this.hls.config, {
      total: i,
      bwEstimate: r
    } = t.stats;
    M(i) && M(r) && (this.lastLevelLoadSec = 8 * i / r), t.details.live ? this.bwEstimator.update(s.abrEwmaSlowLive, s.abrEwmaFastLive) : this.bwEstimator.update(s.abrEwmaSlowVoD, s.abrEwmaFastVoD);
  }
  /*
      This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
      quickly enough to prevent underbuffering
    */
  _abandonRulesCheck() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: s
    } = this, {
      autoLevelEnabled: i,
      media: r
    } = s;
    if (!e || !r)
      return;
    const n = performance.now(), o = t ? t.stats : e.stats, l = t ? t.duration : e.duration, h = n - o.loading.start;
    if (o.aborted || o.loaded && o.loaded === o.total || e.level === 0) {
      this.clearTimer(), this._nextAutoLevel = -1;
      return;
    }
    if (!i || r.paused || !r.playbackRate || !r.readyState)
      return;
    const c = s.mainForwardBufferInfo;
    if (c === null)
      return;
    const d = this.bwEstimator.getEstimateTTFB(), u = Math.abs(r.playbackRate);
    if (h <= Math.max(d, 1e3 * (l / (u * 2))))
      return;
    const f = c.len / u;
    if (f >= 2 * l / u)
      return;
    const g = o.loading.first ? o.loading.first - o.loading.start : -1, p = o.loaded && g > -1, v = this.bwEstimator.getEstimate(), {
      levels: y,
      minAutoLevel: T
    } = s, x = y[e.level], A = o.total || Math.max(o.loaded, Math.round(l * x.maxBitrate / 8));
    let b = h - g;
    b < 1 && p && (b = Math.min(h, o.loaded * 8 / v));
    const C = p ? o.loaded * 1e3 / b : 0, I = C ? (A - o.loaded) / C : A * 8 / v + d / 1e3;
    if (I <= f)
      return;
    const _ = C ? C * 8 : v;
    let D = Number.POSITIVE_INFINITY, R;
    for (R = e.level - 1; R > T; R--) {
      const F = y[R].maxBitrate;
      if (D = this.getTimeToLoadFrag(d / 1e3, _, l * F, !y[R].details), D < f)
        break;
    }
    D >= I || D > l * 10 || (s.nextLoadLevel = R, p ? this.bwEstimator.sample(h - Math.min(d, g), o.loaded) : this.bwEstimator.sampleTTFB(h), this.clearTimer(), E.warn(`[abr] Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} is loading too slowly;
      Time to underbuffer: ${f.toFixed(3)} s
      Estimated load time for current fragment: ${I.toFixed(3)} s
      Estimated load time for down switch fragment: ${D.toFixed(3)} s
      TTFB estimate: ${g}
      Current BW estimate: ${M(v) ? (v / 1024).toFixed(3) : "Unknown"} Kb/s
      New BW estimate: ${(this.bwEstimator.getEstimate() / 1024).toFixed(3)} Kb/s
      Aborting and switching to level ${R}`), e.loader && (this.fragCurrent = this.partCurrent = null, e.abortRequests()), s.trigger(m.FRAG_LOAD_EMERGENCY_ABORTED, {
      frag: e,
      part: t,
      stats: o
    }));
  }
  onFragLoaded(e, {
    frag: t,
    part: s
  }) {
    const i = s ? s.stats : t.stats;
    if (t.type === $.MAIN && this.bwEstimator.sampleTTFB(i.loading.first - i.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), this.lastLoadedFragLevel = t.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
        const r = s ? s.duration : t.duration, n = this.hls.levels[t.level], o = (n.loaded ? n.loaded.bytes : 0) + i.loaded, l = (n.loaded ? n.loaded.duration : 0) + r;
        n.loaded = {
          bytes: o,
          duration: l
        }, n.realBitrate = Math.round(8 * o / l);
      }
      if (t.bitrateTest) {
        const r = {
          stats: i,
          frag: t,
          part: s,
          id: t.type
        };
        this.onFragBuffered(m.FRAG_BUFFERED, r), t.bitrateTest = !1;
      }
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t, r = i != null && i.stats.loaded ? i.stats : s.stats;
    if (r.aborted || this.ignoreFragment(s))
      return;
    const n = r.parsing.end - r.loading.start - Math.min(r.loading.first - r.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(n, r.loaded), r.bwEstimate = this.bwEstimator.getEstimate(), s.bitrateTest ? this.bitrateTestDelay = n / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== $.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    self.clearInterval(this.timer);
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this._nextAutoLevel, t = this.bwEstimator;
    if (e !== -1 && !t.canEstimate())
      return e;
    let s = this.getNextABRAutoLevel();
    if (e !== -1) {
      const i = this.hls.levels;
      if (i.length > Math.max(e, s) && i[e].loadError <= i[s].loadError)
        return e;
    }
    return e !== -1 && (s = Math.min(e, s)), s;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: s
    } = this, {
      maxAutoLevel: i,
      config: r,
      minAutoLevel: n,
      media: o
    } = s, l = t ? t.duration : e ? e.duration : 0, h = o && o.playbackRate !== 0 ? Math.abs(o.playbackRate) : 1, c = this.bwEstimator ? this.bwEstimator.getEstimate() : r.abrEwmaDefaultEstimate, d = s.mainForwardBufferInfo, u = (d ? d.len : 0) / h;
    let f = this.findBestLevel(c, n, i, u, r.abrBandWidthFactor, r.abrBandWidthUpFactor);
    if (f >= 0)
      return f;
    E.trace(`[abr] ${u ? "rebuffering expected" : "buffer is empty"}, finding optimal quality level`);
    let g = l ? Math.min(l, r.maxStarvationDelay) : r.maxStarvationDelay, p = r.abrBandWidthFactor, v = r.abrBandWidthUpFactor;
    if (!u) {
      const y = this.bitrateTestDelay;
      y && (g = (l ? Math.min(l, r.maxLoadingDelay) : r.maxLoadingDelay) - y, E.trace(`[abr] bitrate test took ${Math.round(1e3 * y)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * g)} ms`), p = v = 1);
    }
    return f = this.findBestLevel(c, n, i, u + g, p, v), Math.max(f, 0);
  }
  findBestLevel(e, t, s, i, r, n) {
    var o;
    const {
      fragCurrent: l,
      partCurrent: h,
      lastLoadedFragLevel: c
    } = this, {
      levels: d
    } = this.hls, u = d[c], f = !!(u != null && (o = u.details) != null && o.live), g = u == null ? void 0 : u.codecSet, p = h ? h.duration : l ? l.duration : 0, v = this.bwEstimator.getEstimateTTFB() / 1e3;
    let y = t, T = -1;
    for (let x = s; x >= t; x--) {
      const A = d[x];
      if (!A || g && A.codecSet !== g) {
        A && (y = Math.min(x, y), T = Math.max(x, T));
        continue;
      }
      T !== -1 && E.trace(`[abr] Skipped level(s) ${y}-${T} with CODECS:"${d[T].attrs.CODECS}"; not compatible with "${u.attrs.CODECS}"`);
      const b = A.details, C = (h ? b == null ? void 0 : b.partTarget : b == null ? void 0 : b.averagetargetduration) || p;
      let I;
      x <= c ? I = r * e : I = n * e;
      const _ = d[x].maxBitrate, D = this.getTimeToLoadFrag(v, I, _ * C, b === void 0);
      if (E.trace(`[abr] level:${x} adjustedbw-bitrate:${Math.round(I - _)} avgDuration:${C.toFixed(1)} maxFetchDuration:${i.toFixed(1)} fetchDuration:${D.toFixed(1)}`), I > _ && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      (D === 0 || !M(D) || f && !this.bitrateTestDelay || D < i))
        return x;
    }
    return -1;
  }
  set nextAutoLevel(e) {
    this._nextAutoLevel = e;
  }
}
class Xr {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let s;
    if (e.length)
      e.length === 1 ? s = e[0] : s = zo(e, t);
    else
      return new Uint8Array(0);
    return this.reset(), s;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function zo(a, e) {
  const t = new Uint8Array(e);
  let s = 0;
  for (let i = 0; i < a.length; i++) {
    const r = a[i];
    t.set(r, s), s += r.length;
  }
  return t;
}
const Ui = 100;
class jo extends Ws {
  constructor(e, t, s) {
    super(e, t, s, "[audio-stream-controller]", $.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.LEVEL_LOADED, this.onLevelLoaded, this), e.on(m.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(m.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(m.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(m.ERROR, this.onError, this), e.on(m.BUFFER_RESET, this.onBufferReset, this), e.on(m.BUFFER_CREATED, this.onBufferCreated, this), e.on(m.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(m.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.LEVEL_LOADED, this.onLevelLoaded, this), e.off(m.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(m.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(m.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(m.ERROR, this.onError, this), e.off(m.BUFFER_RESET, this.onBufferReset, this), e.off(m.BUFFER_CREATED, this.onBufferCreated, this), e.off(m.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(m.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: i,
    timescale: r
  }) {
    if (s === "main") {
      const n = t.cc;
      this.initPTS[t.cc] = {
        baseTime: i,
        timescale: r
      }, this.log(`InitPTS for cc: ${n} found from main: ${i}`), this.videoTrackCC = n, this.state === w.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = w.STOPPED;
      return;
    }
    const t = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(Ui), t > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t, this.state = w.IDLE) : (this.loadedmetadata = !1, this.state = w.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case w.IDLE:
        this.doTickIdle();
        break;
      case w.WAITING_TRACK: {
        var e;
        const {
          levels: s,
          trackId: i
        } = this, r = s == null || (e = s[i]) == null ? void 0 : e.details;
        if (r) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = w.WAITING_INIT_PTS;
        }
        break;
      }
      case w.FRAG_LOADING_WAITING_RETRY: {
        var t;
        const s = performance.now(), i = this.retryDate;
        (!i || s >= i || (t = this.media) != null && t.seeking) && (this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.trackId), this.state = w.IDLE);
        break;
      }
      case w.WAITING_INIT_PTS: {
        const s = this.waitingData;
        if (s) {
          const {
            frag: i,
            part: r,
            cache: n,
            complete: o
          } = s;
          if (this.initPTS[i.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = w.FRAG_LOADING;
            const l = n.flush(), h = {
              frag: i,
              part: r,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(h), o && super._handleFragmentLoadComplete(h);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${i.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const l = this.getLoadPosition(), h = J.bufferInfo(this.mediaBuffer, l, this.config.maxBufferHole);
            Is(h.end, this.config.maxFragLookUpTolerance, i) < 0 && (this.log(`Waiting fragment cc (${i.cc}) @ ${i.start} cancelled because another fragment at ${h.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = w.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = w.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: t,
      media: s,
      trackId: i
    } = this, r = e.config;
    if (!(t != null && t[i]) || !s && (this.startFragRequested || !r.startFragPrefetch))
      return;
    const n = t[i], o = n.details;
    if (!o || o.live && this.levelLastLoaded !== i || this.waitForCdnTuneIn(o)) {
      this.state = w.WAITING_TRACK;
      return;
    }
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && l && (this.bufferFlushed = !1, this.afterBufferFlushed(l, q.AUDIO, $.AUDIO));
    const h = this.getFwdBufferInfo(l, $.AUDIO);
    if (h === null)
      return;
    const {
      bufferedTrack: c,
      switchingTrack: d
    } = this;
    if (!d && this._streamEnded(h, o)) {
      e.trigger(m.BUFFER_EOS, {
        type: "audio"
      }), this.state = w.ENDED;
      return;
    }
    const u = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, $.MAIN), f = h.len, g = this.getMaxBufferLength(u == null ? void 0 : u.len);
    if (f >= g && !d)
      return;
    const v = o.fragments[0].start;
    let y = h.end;
    if (d && s) {
      const b = this.getLoadPosition();
      c && d.attrs !== c.attrs && (y = b), o.PTSKnown && b < v && (h.end > v || h.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), s.currentTime = v + 0.05);
    }
    let T = this.getNextFragment(y, o), x = !1;
    if (T && this.isLoopLoading(T, y) && (x = !!T.gap, T = this.getNextFragmentLoopLoading(T, o, h, $.MAIN, g)), !T) {
      this.bufferFlushed = !0;
      return;
    }
    const A = u && T.start > u.end + o.targetduration;
    if (A || // Or wait for main buffer after buffing some audio
    !(u != null && u.len) && h.len) {
      const b = this.getAppendedFrag(T.start, $.MAIN);
      if (b === null || (x || (x = !!b.gap || !!A && u.len === 0), A && !x || x && h.nextStart && h.nextStart < b.end))
        return;
    }
    this.loadFragment(T, n, y);
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.min(Math.max(t, e), this.config.maxMaxBufferLength) : t;
  }
  onMediaDetaching() {
    this.videoBuffer = null, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((s) => new Et(s));
  }
  onAudioTrackSwitching(e, t) {
    const s = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: i
    } = this;
    i && (i.abortRequests(), this.removeUnbufferedFrags(i.start)), this.resetLoadingState(), s ? this.setInterval(Ui) : this.resetTransmuxer(), s ? (this.switchingTrack = t, this.state = w.IDLE) : (this.switchingTrack = null, this.bufferedTrack = t, this.state = w.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(m.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, t) {
    var s;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = t;
      return;
    }
    const {
      levels: i
    } = this, {
      details: r,
      id: n
    } = t;
    if (!i) {
      this.warn(`Audio tracks were reset while loading level ${n}`);
      return;
    }
    this.log(`Track ${n} loaded [${r.startSN},${r.endSN}]${r.lastPartSn ? `[part-${r.lastPartSn}-${r.lastPartIndex}]` : ""},duration:${r.totalduration}`);
    const o = i[n];
    let l = 0;
    if (r.live || (s = o.details) != null && s.live) {
      this.checkLiveUpdate(r);
      const h = this.mainDetails;
      if (r.deltaUpdateFailed || !h)
        return;
      !o.details && r.hasProgramDateTime && h.hasProgramDateTime ? (Or(r, h), l = r.fragments[0].start) : l = this.alignPlaylists(r, o.details);
    }
    o.details = r, this.levelLastLoaded = n, !this.startFragRequested && (this.mainDetails || !r.live) && this.setStartPosition(o.details, l), this.state === w.WAITING_TRACK && !this.waitForCdnTuneIn(r) && (this.state = w.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: i,
      payload: r
    } = e, {
      config: n,
      trackId: o,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const h = l[o];
    if (!h) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const c = h.details;
    if (!c) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(s.start);
      return;
    }
    const d = n.defaultAudioCodec || h.audioCodec || "mp4a.40.2";
    let u = this.transmuxer;
    u || (u = this.transmuxer = new qr(this.hls, $.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const f = this.initPTS[s.cc], g = (t = s.initSegment) == null ? void 0 : t.data;
    if (f !== void 0) {
      const v = i ? i.index : -1, y = v !== -1, T = new Vs(s.level, s.sn, s.stats.chunkCount, r.byteLength, v, y);
      u.push(r, g, d, "", s, i, c.totalduration, !1, T, f);
    } else {
      this.log(`Unknown video PTS for cc ${s.cc}, waiting for video PTS before demuxing audio frag ${s.sn} of [${c.startSN} ,${c.endSN}],track ${o}`);
      const {
        cache: p
      } = this.waitingData = this.waitingData || {
        frag: s,
        part: i,
        cache: new Xr(),
        complete: !1
      };
      p.push(new Uint8Array(r)), this.waitingVideoCC = this.videoTrackCC, this.state = w.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, t) {
    const s = t.tracks.audio;
    s && (this.mediaBuffer = s.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s.type !== $.AUDIO) {
      if (!this.loadedmetadata && s.type === $.MAIN) {
        const r = this.videoBuffer || this.media;
        r && J.getBuffered(r).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${i ? " p: " + i.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (s.sn !== "initSegment") {
      this.fragPrevious = s;
      const r = this.switchingTrack;
      r && (this.bufferedTrack = r, this.switchingTrack = null, this.hls.trigger(m.AUDIO_TRACK_SWITCHED, Le({}, r)));
    }
    this.fragBufferedComplete(s, i);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = w.ERROR;
      return;
    }
    switch (t.details) {
      case L.FRAG_GAP:
      case L.FRAG_PARSING_ERROR:
      case L.FRAG_DECRYPT_ERROR:
      case L.FRAG_LOAD_ERROR:
      case L.FRAG_LOAD_TIMEOUT:
      case L.KEY_LOAD_ERROR:
      case L.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError($.AUDIO, t);
        break;
      case L.AUDIO_TRACK_LOAD_ERROR:
      case L.AUDIO_TRACK_LOAD_TIMEOUT:
      case L.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === w.WAITING_TRACK && ((s = t.context) == null ? void 0 : s.type) === K.AUDIO_TRACK && (this.state = w.IDLE);
        break;
      case L.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case L.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushed(e, {
    type: t
  }) {
    t === q.AUDIO && (this.bufferFlushed = !0, this.state === w.ENDED && (this.state = w.IDLE));
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "audio", {
      hls: i
    } = this, {
      remuxResult: r,
      chunkMeta: n
    } = e, o = this.getCurrentContext(n);
    if (!o) {
      this.resetWhenMissingContext(n);
      return;
    }
    const {
      frag: l,
      part: h,
      level: c
    } = o, {
      details: d
    } = c, {
      audio: u,
      text: f,
      id3: g,
      initSegment: p
    } = r;
    if (this.fragContextChanged(l) || !d) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = w.PARSING, this.switchingTrack && u && this.completeAudioSwitch(this.switchingTrack), p != null && p.tracks) {
      const v = l.initSegment || l;
      this._bufferInitSegment(p.tracks, v, n), i.trigger(m.FRAG_PARSING_INIT_SEGMENT, {
        frag: v,
        id: s,
        tracks: p.tracks
      });
    }
    if (u) {
      const {
        startPTS: v,
        endPTS: y,
        startDTS: T,
        endDTS: x
      } = u;
      h && (h.elementaryStreams[q.AUDIO] = {
        startPTS: v,
        endPTS: y,
        startDTS: T,
        endDTS: x
      }), l.setElementaryStreamInfo(q.AUDIO, v, y, T, x), this.bufferFragmentData(u, l, h, n);
    }
    if (g != null && (t = g.samples) != null && t.length) {
      const v = ae({
        id: s,
        frag: l,
        details: d
      }, g);
      i.trigger(m.FRAG_PARSING_METADATA, v);
    }
    if (f) {
      const v = ae({
        id: s,
        frag: l,
        details: d
      }, f);
      i.trigger(m.FRAG_PARSING_USERDATA, v);
    }
  }
  _bufferInitSegment(e, t, s) {
    if (this.state !== w.PARSING)
      return;
    e.video && delete e.video;
    const i = e.audio;
    if (!i)
      return;
    i.levelCodec = i.codec, i.id = "audio", this.log(`Init audio buffer, container:${i.container}, codecs[parsed]=[${i.codec}]`), this.hls.trigger(m.BUFFER_CODECS, e);
    const r = i.initSegment;
    if (r != null && r.byteLength) {
      const n = {
        type: "audio",
        frag: t,
        part: null,
        chunkMeta: s,
        parent: t.type,
        data: r
      };
      this.hls.trigger(m.BUFFER_APPENDING, n);
    }
    this.tick();
  }
  loadFragment(e, t, s) {
    const i = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || i === he.NOT_LOADED || i === he.PARTIAL) {
      var r;
      e.sn === "initSegment" ? this._loadInitSegment(e, t) : (r = t.details) != null && r.live && !this.initPTS[e.cc] ? (this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = w.WAITING_INIT_PTS) : (this.startFragRequested = !0, super.loadFragment(e, t, s));
    } else
      this.clearTrackerIfNeeded(e);
  }
  completeAudioSwitch(e) {
    const {
      hls: t,
      media: s,
      bufferedTrack: i
    } = this, r = i == null ? void 0 : i.attrs, n = e.attrs;
    s && r && (r.CHANNELS !== n.CHANNELS || r.NAME !== n.NAME || r.LANGUAGE !== n.LANGUAGE) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio")), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(m.AUDIO_TRACK_SWITCHED, Le({}, e));
  }
}
class qo extends Gs {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.LEVEL_LOADING, this.onLevelLoading, this), e.on(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(m.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(m.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.LEVEL_LOADING, this.onLevelLoading, this), e.off(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(m.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(m.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: s,
      groupId: i,
      details: r
    } = t, n = this.tracksInGroup[s];
    if (!n || n.groupId !== i) {
      this.warn(`Track with id:${s} and group:${i} not found in active group ${n.groupId}`);
      return;
    }
    const o = n.details;
    n.details = t.details, this.log(`audio-track ${s} "${n.name}" lang:${n.lang} group:${i} loaded [${r.startSN}-${r.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!(t != null && t.audioGroupIds))
      return;
    const s = t.audioGroupIds[t.urlId];
    if (this.groupId !== s) {
      this.groupId = s || null;
      const i = this.tracks.filter((n) => !s || n.groupId === s);
      this.selectDefaultTrack && !i.some((n) => n.default) && (this.selectDefaultTrack = !1), this.tracksInGroup = i;
      const r = {
        audioTracks: i
      };
      this.log(`Updating audio tracks, ${i.length} track(s) found in group:${s}`), this.hls.trigger(m.AUDIO_TRACKS_UPDATED, r), this.selectInitialTrack();
    } else
      this.shouldReloadPlaylist(this.currentTrack) && this.setAudioTrack(this.trackId);
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === K.AUDIO_TRACK && t.context.id === this.trackId && t.context.groupId === this.groupId && (this.requestScheduled = -1, this.checkRetry(t));
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn("Invalid id passed to audio-track controller");
      return;
    }
    this.clearTimer();
    const s = this.currentTrack;
    t[this.trackId];
    const i = t[e], {
      groupId: r,
      name: n
    } = i;
    if (this.log(`Switching to audio-track ${e} "${n}" lang:${i.lang} group:${r}`), this.trackId = e, this.currentTrack = i, this.selectDefaultTrack = !1, this.hls.trigger(m.AUDIO_TRACK_SWITCHING, Le({}, i)), i.details && !i.details.live)
      return;
    const o = this.switchParams(i.url, s == null ? void 0 : s.details);
    this.loadPlaylist(o);
  }
  selectInitialTrack() {
    const e = this.tracksInGroup, t = this.findTrackId(this.currentTrack) | this.findTrackId(null);
    if (t !== -1)
      this.setAudioTrack(t);
    else {
      const s = new Error(`No track found for running audio group-ID: ${this.groupId} track count: ${e.length}`);
      this.warn(s.message), this.hls.trigger(m.ERROR, {
        type: U.MEDIA_ERROR,
        details: L.AUDIO_TRACK_LOAD_ERROR,
        fatal: !0,
        error: s
      });
    }
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      if ((!this.selectDefaultTrack || i.default) && (!e || e.attrs["STABLE-RENDITION-ID"] !== void 0 && e.attrs["STABLE-RENDITION-ID"] === i.attrs["STABLE-RENDITION-ID"] || e.name === i.name && e.lang === i.lang))
        return i.id;
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(t)) {
      const s = t.id, i = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (n) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${n}`);
        }
      this.log(`loading audio-track playlist ${s} "${t.name}" lang:${t.lang} group:${i}`), this.clearTimer(), this.hls.trigger(m.AUDIO_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: i,
        deliveryDirectives: e || null
      });
    }
  }
}
function Zr(a, e) {
  if (a.length !== e.length)
    return !1;
  for (let t = 0; t < a.length; t++)
    if (!Xo(a[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Xo(a, e) {
  const t = a["STABLE-RENDITION-ID"];
  return t ? t === e["STABLE-RENDITION-ID"] : !["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED"].some((s) => a[s] !== e[s]);
}
const $i = 500;
class Zo extends Ws {
  constructor(e, t, s) {
    super(e, t, s, "[subtitle-stream-controller]", $.SUBTITLE), this.levels = [], this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.LEVEL_LOADED, this.onLevelLoaded, this), e.on(m.ERROR, this.onError, this), e.on(m.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(m.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(m.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(m.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.LEVEL_LOADED, this.onLevelLoaded, this), e.off(m.ERROR, this.onError, this), e.off(m.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(m.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(m.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(m.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(m.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = w.IDLE, this.setInterval($i), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: s,
      success: i
    } = t;
    if (this.fragPrevious = s, this.state = w.IDLE, !i)
      return;
    const r = this.tracksBuffered[this.currentTrackId];
    if (!r)
      return;
    let n;
    const o = s.start;
    for (let h = 0; h < r.length; h++)
      if (o >= r[h].start && o <= r[h].end) {
        n = r[h];
        break;
      }
    const l = s.start + s.duration;
    n ? n.end = l : (n = {
      start: o,
      end: l
    }, r.push(n)), this.fragmentTracker.fragBuffered(s);
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: s,
      endOffset: i
    } = t;
    if (s === 0 && i !== Number.POSITIVE_INFINITY) {
      const r = i - 1;
      if (r <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, r), this.tracksBuffered.forEach((n) => {
        for (let o = 0; o < n.length; ) {
          if (n[o].end <= r) {
            n.shift();
            continue;
          } else if (n[o].start < r)
            n[o].start = r;
          else
            break;
          o++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(s, r, $.SUBTITLE);
    }
  }
  onFragBuffered(e, t) {
    if (!this.loadedmetadata && t.frag.type === $.MAIN) {
      var s;
      (s = this.media) != null && s.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const s = t.frag;
    (s == null ? void 0 : s.type) === $.SUBTITLE && (this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== w.STOPPED && (this.state = w.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (Zr(this.levels, t)) {
      this.levels = t.map((s) => new Et(s));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((s) => {
      const i = new Et(s);
      return this.tracksBuffered[i.id] = [], i;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, $.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    if (this.currentTrackId = t.id, !this.levels.length || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const s = this.levels[this.currentTrackId];
    s != null && s.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, s && this.setInterval($i);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var s;
    const {
      details: i,
      id: r
    } = t, {
      currentTrackId: n,
      levels: o
    } = this;
    if (!o.length)
      return;
    const l = o[n];
    if (r >= o.length || r !== n || !l)
      return;
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let h = 0;
    if (i.live || (s = l.details) != null && s.live) {
      const c = this.mainDetails;
      if (i.deltaUpdateFailed || !c)
        return;
      const d = c.fragments[0];
      l.details ? (h = this.alignPlaylists(i, l.details), h === 0 && d && (h = d.start, Rs(i, h))) : i.hasProgramDateTime && c.hasProgramDateTime ? (Or(i, c), h = i.fragments[0].start) : d && (h = d.start, Rs(i, h));
    }
    l.details = i, this.levelLastLoaded = r, !this.startFragRequested && (this.mainDetails || !i.live) && this.setStartPosition(l.details, h), this.tick(), i.live && !this.fragCurrent && this.media && this.state === w.IDLE && (St(null, i.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: s
    } = e, i = t.decryptdata, r = this.hls;
    if (!this.fragContextChanged(t) && s && s.byteLength > 0 && i && i.key && i.iv && i.method === "AES-128") {
      const n = performance.now();
      this.decrypter.decrypt(new Uint8Array(s), i.key.buffer, i.iv.buffer).catch((o) => {
        throw r.trigger(m.ERROR, {
          type: U.MEDIA_ERROR,
          details: L.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: o,
          reason: o.message,
          frag: t
        }), o;
      }).then((o) => {
        const l = performance.now();
        r.trigger(m.FRAG_DECRYPTED, {
          frag: t,
          payload: o,
          stats: {
            tstart: n,
            tdecrypt: l
          }
        });
      }).catch((o) => {
        this.warn(`${o.name}: ${o.message}`), this.state = w.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = w.IDLE;
      return;
    }
    if (this.state === w.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, s = t[e];
      if (!t.length || !s || !s.details)
        return;
      const {
        config: i
      } = this, r = this.getLoadPosition(), n = J.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], r, i.maxBufferHole), {
        end: o,
        len: l
      } = n, h = this.getFwdBufferInfo(this.media, $.MAIN), c = s.details, d = this.getMaxBufferLength(h == null ? void 0 : h.len) + c.levelTargetDuration;
      if (l > d)
        return;
      const u = c.fragments, f = u.length, g = c.edge;
      let p = null;
      const v = this.fragPrevious;
      if (o < g) {
        const y = i.maxFragLookUpTolerance, T = o > g - y ? 0 : y;
        p = St(v, u, Math.max(u[0].start, o), T), !p && v && v.start < u[0].start && (p = u[0]);
      } else
        p = u[f - 1];
      if (!p)
        return;
      if (p = this.mapToInitFragWhenRequired(p), p.sn !== "initSegment") {
        const y = p.sn - c.startSN, T = u[y - 1];
        T && T.cc === p.cc && this.fragmentTracker.getState(T) === he.NOT_LOADED && (p = T);
      }
      this.fragmentTracker.getState(p) === he.NOT_LOADED && this.loadFragment(p, s, o);
    }
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.max(t, e) : t;
  }
  loadFragment(e, t, s) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, t) : (this.startFragRequested = !0, super.loadFragment(e, t, s));
  }
  get mediaBufferTimeRanges() {
    return new Qo(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class Qo {
  constructor(e) {
    this.buffered = void 0;
    const t = (s, i, r) => {
      if (i = i >>> 0, i > r - 1)
        throw new DOMException(`Failed to execute '${s}' on 'TimeRanges': The index provided (${i}) is greater than the maximum bound (${r})`);
      return e[i][s];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(s) {
        return t("end", s, e.length);
      },
      start(s) {
        return t("start", s, e.length);
      }
    };
  }
}
class Jo extends Gs {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.trackChangeListener = () => this.onTextTracksChanged(), this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes(this.trackId);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.LEVEL_LOADING, this.onLevelLoading, this), e.on(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(m.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(m.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.LEVEL_LOADING, this.onLevelLoading, this), e.off(m.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(m.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(m.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), fs(this.media.textTracks).forEach((t) => {
      ht(t);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: s,
      details: i
    } = t, {
      trackId: r
    } = this, n = this.tracksInGroup[r];
    if (!n) {
      this.warn(`Invalid subtitle track id ${s}`);
      return;
    }
    const o = n.details;
    n.details = t.details, this.log(`subtitle track ${s} loaded [${i.startSN}-${i.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!(t != null && t.textGroupIds))
      return;
    const s = t.textGroupIds[t.urlId], i = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    if (this.groupId !== s) {
      const r = this.tracks.filter((l) => !s || l.groupId === s);
      this.tracksInGroup = r;
      const n = this.findTrackId(i == null ? void 0 : i.name) || this.findTrackId();
      this.groupId = s || null;
      const o = {
        subtitleTracks: r
      };
      this.log(`Updating subtitle tracks, ${r.length} track(s) found in "${s}" group-id`), this.hls.trigger(m.SUBTITLE_TRACKS_UPDATED, o), n !== -1 && this.setSubtitleTrack(n, i);
    } else
      this.shouldReloadPlaylist(i) && this.setSubtitleTrack(this.trackId, i);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      if ((!this.selectDefaultTrack || i.default) && (!e || e === i.name))
        return i.id;
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === K.SUBTITLE_TRACK && t.context.id === this.trackId && t.context.groupId === this.groupId && this.checkRetry(t);
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1;
    const t = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    this.setSubtitleTrack(e, t);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(t)) {
      const s = t.id, i = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (n) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${n}`);
        }
      this.log(`Loading subtitle playlist for id ${s}`), this.hls.trigger(m.SUBTITLE_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: i,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes(e) {
    const {
      media: t,
      trackId: s
    } = this;
    if (!t)
      return;
    const i = fs(t.textTracks), r = i.filter((o) => o.groupId === this.groupId);
    if (e === -1)
      [].slice.call(i).forEach((o) => {
        o.mode = "disabled";
      });
    else {
      const o = r[s];
      o && (o.mode = "disabled");
    }
    const n = r[e];
    n && (n.mode = this.subtitleDisplay ? "showing" : "hidden");
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e, t) {
    var s;
    const i = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (this.trackId !== e && this.toggleTrackModes(e), this.trackId === e && (e === -1 || (s = i[e]) != null && s.details) || e < -1 || e >= i.length)
      return;
    this.clearTimer();
    const r = i[e];
    if (this.log(`Switching to subtitle-track ${e}` + (r ? ` "${r.name}" lang:${r.lang} group:${r.groupId}` : "")), this.trackId = e, r) {
      const {
        id: n,
        groupId: o = "",
        name: l,
        type: h,
        url: c
      } = r;
      this.hls.trigger(m.SUBTITLE_TRACK_SWITCH, {
        id: n,
        groupId: o,
        name: l,
        type: h,
        url: c
      });
      const d = this.switchParams(r.url, t == null ? void 0 : t.details);
      this.loadPlaylist(d);
    } else
      this.hls.trigger(m.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
  }
  onTextTracksChanged() {
    if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
      return;
    let e = -1;
    const t = fs(this.media.textTracks);
    for (let s = 0; s < t.length; s++)
      if (t[s].mode === "hidden")
        e = s;
      else if (t[s].mode === "showing") {
        e = s;
        break;
      }
    this.subtitleTrack !== e && (this.subtitleTrack = e);
  }
}
function fs(a) {
  const e = [];
  for (let t = 0; t < a.length; t++) {
    const s = a[t];
    (s.kind === "subtitles" || s.kind === "captions") && s.label && e.push(a[t]);
  }
  return e;
}
class el {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, t) {
    const s = this.queues[t];
    s.push(e), s.length === 1 && this.buffers[t] && this.executeNext(t);
  }
  insertAbort(e, t) {
    this.queues[t].unshift(e), this.executeNext(t);
  }
  appendBlocker(e) {
    let t;
    const s = new Promise((r) => {
      t = r;
    }), i = {
      execute: t,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(i, e), s;
  }
  executeNext(e) {
    const {
      buffers: t,
      queues: s
    } = this, i = t[e], r = s[e];
    if (r.length) {
      const n = r[0];
      try {
        n.execute();
      } catch (o) {
        E.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"), n.onError(o), i != null && i.updating || (r.shift(), this.executeNext(e));
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
const Bi = qt(), Gi = /([ha]vc.)(?:\.[^.,]+)+/;
class tl {
  // The level details used to determine duration, target-duration and live
  // cache the self generated object url to detect hijack of video tag
  // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
  // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
  // The number of BUFFER_CODEC events received before any sourceBuffers are created
  // The total number of BUFFER_CODEC events received
  // A reference to the attached media element
  // A reference to the active media source
  // Last MP3 audio chunk appended
  // counters
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendError = 0, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this._onMediaSourceOpen = () => {
      const {
        media: t,
        mediaSource: s
      } = this;
      E.log("[buffer-controller]: Media source opened"), t && (t.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(m.MEDIA_ATTACHED, {
        media: t
      })), s && s.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      E.log("[buffer-controller]: Media source closed");
    }, this._onMediaSourceEnded = () => {
      E.log("[buffer-controller]: Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        media: t,
        _objectUrl: s
      } = this;
      t && t.src !== s && E.error(`Media element src was set while attaching MediaSource (${s} > ${t.src})`);
    }, this.hls = e, this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.BUFFER_RESET, this.onBufferReset, this), e.on(m.BUFFER_APPENDING, this.onBufferAppending, this), e.on(m.BUFFER_CODECS, this.onBufferCodecs, this), e.on(m.BUFFER_EOS, this.onBufferEos, this), e.on(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(m.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(m.FRAG_PARSED, this.onFragParsed, this), e.on(m.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.BUFFER_RESET, this.onBufferReset, this), e.off(m.BUFFER_APPENDING, this.onBufferAppending, this), e.off(m.BUFFER_CODECS, this.onBufferCodecs, this), e.off(m.BUFFER_EOS, this.onBufferEos, this), e.off(m.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(m.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(m.FRAG_PARSED, this.onFragParsed, this), e.off(m.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new el(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    let s = 2;
    (t.audio && !t.video || !t.altAudio) && (s = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = s, E.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, t) {
    const s = this.media = t.media;
    if (s && Bi) {
      const i = this.mediaSource = new Bi();
      i.addEventListener("sourceopen", this._onMediaSourceOpen), i.addEventListener("sourceended", this._onMediaSourceEnded), i.addEventListener("sourceclose", this._onMediaSourceClose), s.src = self.URL.createObjectURL(i), this._objectUrl = s.src, s.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: t,
      _objectUrl: s
    } = this;
    if (t) {
      if (E.log("[buffer-controller]: media source detaching"), t.readyState === "open")
        try {
          t.endOfStream();
        } catch (i) {
          E.warn(`[buffer-controller]: onMediaDetaching: ${i.message} while calling endOfStream`);
        }
      this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), e && (e.removeEventListener("emptied", this._onMediaEmptied), s && self.URL.revokeObjectURL(s), e.src === s ? (e.removeAttribute("src"), e.load()) : E.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(m.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      const t = this.sourceBuffer[e];
      try {
        t && (this.removeBufferListeners(e), this.mediaSource && this.mediaSource.removeSourceBuffer(t), this.sourceBuffer[e] = void 0);
      } catch (s) {
        E.warn(`[buffer-controller]: Failed to reset the ${e} buffer`, s);
      }
    }), this._initSourceBuffer();
  }
  onBufferCodecs(e, t) {
    const s = this.getSourceBufferTypes().length;
    Object.keys(t).forEach((i) => {
      if (s) {
        const r = this.tracks[i];
        if (r && typeof r.buffer.changeType == "function") {
          const {
            id: n,
            codec: o,
            levelCodec: l,
            container: h,
            metadata: c
          } = t[i], d = (r.levelCodec || r.codec).replace(Gi, "$1"), u = (l || o).replace(Gi, "$1");
          if (d !== u) {
            const f = `${h};codecs=${l || o}`;
            this.appendChangeType(i, f), E.log(`[buffer-controller]: switching codec ${d} to ${u}`), this.tracks[i] = {
              buffer: r.buffer,
              codec: o,
              container: h,
              levelCodec: l,
              metadata: c,
              id: n
            };
          }
        }
      } else
        this.pendingTracks[i] = t[i];
    }), !s && (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
  }
  appendChangeType(e, t) {
    const {
      operationQueue: s
    } = this, i = {
      execute: () => {
        const r = this.sourceBuffer[e];
        r && (E.log(`[buffer-controller]: changing ${e} sourceBuffer type to ${t}`), r.changeType(t)), s.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (r) => {
        E.warn(`[buffer-controller]: Failed to change ${e} SourceBuffer type`, r);
      }
    };
    s.append(i, e);
  }
  onBufferAppending(e, t) {
    const {
      hls: s,
      operationQueue: i,
      tracks: r
    } = this, {
      data: n,
      type: o,
      frag: l,
      part: h,
      chunkMeta: c
    } = t, d = c.buffering[o], u = self.performance.now();
    d.start = u;
    const f = l.stats.buffering, g = h ? h.stats.buffering : null;
    f.start === 0 && (f.start = u), g && g.start === 0 && (g.start = u);
    const p = r.audio;
    let v = !1;
    o === "audio" && (p == null ? void 0 : p.container) === "audio/mpeg" && (v = !this.lastMpegAudioChunk || c.id === 1 || this.lastMpegAudioChunk.sn !== c.sn, this.lastMpegAudioChunk = c);
    const y = l.start, T = {
      execute: () => {
        if (d.executeStart = self.performance.now(), v) {
          const x = this.sourceBuffer[o];
          if (x) {
            const A = y - x.timestampOffset;
            Math.abs(A) >= 0.1 && (E.log(`[buffer-controller]: Updating audio SourceBuffer timestampOffset to ${y} (delta: ${A}) sn: ${l.sn})`), x.timestampOffset = y);
          }
        }
        this.appendExecutor(n, o);
      },
      onStart: () => {
      },
      onComplete: () => {
        const x = self.performance.now();
        d.executeEnd = d.end = x, f.first === 0 && (f.first = x), g && g.first === 0 && (g.first = x);
        const {
          sourceBuffer: A
        } = this, b = {};
        for (const C in A)
          b[C] = J.getBuffered(A[C]);
        this.appendError = 0, this.hls.trigger(m.BUFFER_APPENDED, {
          type: o,
          frag: l,
          part: h,
          chunkMeta: c,
          parent: l.type,
          timeRanges: b
        });
      },
      onError: (x) => {
        E.error(`[buffer-controller]: Error encountered while trying to append to the ${o} SourceBuffer`, x);
        const A = {
          type: U.MEDIA_ERROR,
          parent: l.type,
          details: L.BUFFER_APPEND_ERROR,
          frag: l,
          part: h,
          chunkMeta: c,
          error: x,
          err: x,
          fatal: !1
        };
        x.code === DOMException.QUOTA_EXCEEDED_ERR ? A.details = L.BUFFER_FULL_ERROR : (this.appendError++, A.details = L.BUFFER_APPEND_ERROR, this.appendError > s.config.appendErrorMaxRetry && (E.error(`[buffer-controller]: Failed ${s.config.appendErrorMaxRetry} times to append segment in sourceBuffer`), A.fatal = !0)), s.trigger(m.ERROR, A);
      }
    };
    i.append(T, o);
  }
  onBufferFlushing(e, t) {
    const {
      operationQueue: s
    } = this, i = (r) => ({
      execute: this.removeExecutor.bind(this, r, t.startOffset, t.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(m.BUFFER_FLUSHED, {
          type: r
        });
      },
      onError: (n) => {
        E.warn(`[buffer-controller]: Failed to remove from ${r} SourceBuffer`, n);
      }
    });
    t.type ? s.append(i(t.type), t.type) : this.getSourceBufferTypes().forEach((r) => {
      s.append(i(r), r);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: s,
      part: i
    } = t, r = [], n = i ? i.elementaryStreams : s.elementaryStreams;
    n[q.AUDIOVIDEO] ? r.push("audiovideo") : (n[q.AUDIO] && r.push("audio"), n[q.VIDEO] && r.push("video"));
    const o = () => {
      const l = self.performance.now();
      s.stats.buffering.end = l, i && (i.stats.buffering.end = l);
      const h = i ? i.stats : s.stats;
      this.hls.trigger(m.FRAG_BUFFERED, {
        frag: s,
        part: i,
        stats: h,
        id: s.type
      });
    };
    r.length === 0 && E.warn(`Fragments must have at least one ElementaryStreamType set. type: ${s.type} level: ${s.level} sn: ${s.sn}`), this.blockBuffers(o, r);
  }
  onFragChanged(e, t) {
    this.flushBackBuffer();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    this.getSourceBufferTypes().reduce((i, r) => {
      const n = this.sourceBuffer[r];
      return n && (!t.type || t.type === r) && (n.ending = !0, n.ended || (n.ended = !0, E.log(`[buffer-controller]: ${r} sourceBuffer now EOS`))), i && !!(!n || n.ended);
    }, !0) && (E.log("[buffer-controller]: Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((r) => {
        const n = this.sourceBuffer[r];
        n && (n.ending = !1);
      });
      const {
        mediaSource: i
      } = this;
      if (!i || i.readyState !== "open") {
        i && E.info(`[buffer-controller]: Could not call mediaSource.endOfStream(). mediaSource.readyState: ${i.readyState}`);
        return;
      }
      E.log("[buffer-controller]: Calling mediaSource.endOfStream()"), i.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  flushBackBuffer() {
    const {
      hls: e,
      details: t,
      media: s,
      sourceBuffer: i
    } = this;
    if (!s || t === null)
      return;
    const r = this.getSourceBufferTypes();
    if (!r.length)
      return;
    const n = t.live && e.config.liveBackBufferLength !== null ? e.config.liveBackBufferLength : e.config.backBufferLength;
    if (!M(n) || n < 0)
      return;
    const o = s.currentTime, l = t.levelTargetDuration, h = Math.max(n, l), c = Math.floor(o / l) * l - h;
    r.forEach((d) => {
      const u = i[d];
      if (u) {
        const f = J.getBuffered(u);
        if (f.length > 0 && c > f.start(0)) {
          if (e.trigger(m.BACK_BUFFER_REACHED, {
            bufferEnd: c
          }), t.live)
            e.trigger(m.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: c
            });
          else if (u.ended && f.end(f.length - 1) - o < l * 2) {
            E.info(`[buffer-controller]: Cannot flush ${d} back buffer while SourceBuffer is in ended state`);
            return;
          }
          e.trigger(m.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: c,
            type: d
          });
        }
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: t,
      media: s,
      mediaSource: i
    } = this, r = e.fragments[0].start + e.totalduration, n = s.duration, o = M(i.duration) ? i.duration : 0;
    e.live && t.config.liveDurationInfinity ? (E.log("[buffer-controller]: Media Source duration is set to Infinity"), i.duration = 1 / 0, this.updateSeekableRange(e)) : (r > o && r > n || !M(n)) && (E.log(`[buffer-controller]: Updating Media Source duration to ${r.toFixed(3)}`), i.duration = r);
  }
  updateSeekableRange(e) {
    const t = this.mediaSource, s = e.fragments;
    if (s.length && e.live && t != null && t.setLiveSeekableRange) {
      const r = Math.max(0, s[0].start), n = Math.max(r, r + e.totalduration);
      t.setLiveSeekableRange(r, n);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: t,
      pendingTracks: s
    } = this, i = Object.keys(s).length;
    if (i && !e || i === 2) {
      this.createSourceBuffers(s), this.pendingTracks = {};
      const r = this.getSourceBufferTypes();
      if (r.length)
        this.hls.trigger(m.BUFFER_CREATED, {
          tracks: this.tracks
        }), r.forEach((n) => {
          t.executeNext(n);
        });
      else {
        const n = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(m.ERROR, {
          type: U.MEDIA_ERROR,
          details: L.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: n,
          reason: n.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: t,
      mediaSource: s
    } = this;
    if (!s)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const i in e)
      if (!t[i]) {
        const r = e[i];
        if (!r)
          throw Error(`source buffer exists for track ${i}, however track does not`);
        const n = r.levelCodec || r.codec, o = `${r.container};codecs=${n}`;
        E.log(`[buffer-controller]: creating sourceBuffer(${o})`);
        try {
          const l = t[i] = s.addSourceBuffer(o), h = i;
          this.addBufferListener(h, "updatestart", this._onSBUpdateStart), this.addBufferListener(h, "updateend", this._onSBUpdateEnd), this.addBufferListener(h, "error", this._onSBUpdateError), this.tracks[i] = {
            buffer: l,
            codec: n,
            container: r.container,
            levelCodec: r.levelCodec,
            metadata: r.metadata,
            id: r.id
          };
        } catch (l) {
          E.error(`[buffer-controller]: error while trying to add sourceBuffer: ${l.message}`), this.hls.trigger(m.ERROR, {
            type: U.MEDIA_ERROR,
            details: L.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: l,
            mimeType: o
          });
        }
      }
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onComplete(), t.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, t) {
    const s = new Error(`${e} SourceBuffer error`);
    E.error(`[buffer-controller]: ${s}`, t), this.hls.trigger(m.ERROR, {
      type: U.MEDIA_ERROR,
      details: L.BUFFER_APPENDING_ERROR,
      error: s,
      fatal: !1
    });
    const i = this.operationQueue.current(e);
    i && i.onError(t);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, t, s) {
    const {
      media: i,
      mediaSource: r,
      operationQueue: n,
      sourceBuffer: o
    } = this, l = o[e];
    if (!i || !r || !l) {
      E.warn(`[buffer-controller]: Attempting to remove from the ${e} SourceBuffer, but it does not exist`), n.shiftAndExecuteNext(e);
      return;
    }
    const h = M(i.duration) ? i.duration : 1 / 0, c = M(r.duration) ? r.duration : 1 / 0, d = Math.max(0, t), u = Math.min(s, h, c);
    u > d && !l.ending ? (l.ended = !1, E.log(`[buffer-controller]: Removing [${d},${u}] from the ${e} SourceBuffer`), l.remove(d, u)) : n.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const {
      operationQueue: s,
      sourceBuffer: i
    } = this, r = i[t];
    if (!r) {
      E.warn(`[buffer-controller]: Attempting to append to the ${t} SourceBuffer, but it does not exist`), s.shiftAndExecuteNext(t);
      return;
    }
    r.ended = !1, r.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.getSourceBufferTypes()) {
    if (!t.length) {
      E.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: s
    } = this, i = t.map((r) => s.appendBlocker(r));
    Promise.all(i).then(() => {
      e(), t.forEach((r) => {
        const n = this.sourceBuffer[r];
        n != null && n.updating || s.shiftAndExecuteNext(r);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, t, s) {
    const i = this.sourceBuffer[e];
    if (!i)
      return;
    const r = s.bind(this, e);
    this.listeners[e].push({
      event: t,
      listener: r
    }), i.addEventListener(t, r);
  }
  removeBufferListeners(e) {
    const t = this.sourceBuffer[e];
    t && this.listeners[e].forEach((s) => {
      t.removeEventListener(s.event, s.listener);
    });
  }
}
const Vi = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, Qr = function(e) {
  let t = e;
  return Vi.hasOwnProperty(e) && (t = Vi[e]), String.fromCharCode(t);
}, ke = 15, Be = 100, sl = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, il = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, rl = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, nl = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, al = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class ol {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const s = typeof t == "function" ? t() : t;
      E.log(`${this.time} [${e}] ${s}`);
    }
  }
}
const Qe = function(e) {
  const t = [];
  for (let s = 0; s < e.length; s++)
    t.push(e[s].toString(16));
  return t;
};
class Jr {
  constructor(e, t, s, i, r) {
    this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = e || "white", this.underline = t || !1, this.italics = s || !1, this.background = i || "black", this.flash = r || !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      e.hasOwnProperty(i) && (this[i] = e[i]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class ll {
  constructor(e, t, s, i, r, n) {
    this.uchar = void 0, this.penState = void 0, this.uchar = e || " ", this.penState = new Jr(t, s, i, r, n);
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class hl {
  constructor(e) {
    this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];
    for (let t = 0; t < Be; t++)
      this.chars.push(new ll());
    this.logger = e, this.pos = 0, this.currPenState = new Jr();
  }
  equals(e) {
    let t = !0;
    for (let s = 0; s < Be; s++)
      if (!this.chars[s].equals(e.chars[s])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < Be; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Be; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Be && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = Be);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let s = this.pos + 1; s < t + 1; s++)
        this.chars[s].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = Qr(e);
    if (this.pos >= Be) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < Be; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let s = 0; s < Be; s++) {
      const i = this.chars[s].uchar;
      i !== " " && (t = !1), e.push(i);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class gs {
  constructor(e) {
    this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];
    for (let t = 0; t < ke; t++)
      this.rows.push(new hl(e));
    this.logger = e, this.currRow = ke - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
  }
  reset() {
    for (let e = 0; e < ke; e++)
      this.rows[e].clear();
    this.currRow = ke - 1;
  }
  equals(e) {
    let t = !0;
    for (let s = 0; s < ke; s++)
      if (!this.rows[s].equals(e.rows[s])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < ke; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < ke; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let o = 0; o < ke; o++)
        this.rows[o].clear();
      const r = this.currRow + 1 - this.nrRollUpRows, n = this.lastOutputScreen;
      if (n) {
        const o = n.rows[r].cueStartTime, l = this.logger.time;
        if (o && l !== null && o < l)
          for (let h = 0; h < this.nrRollUpRows; h++)
            this.rows[t - this.nrRollUpRows + h + 1].copy(n.rows[r + h]);
      }
    }
    this.currRow = t;
    const s = this.rows[this.currRow];
    if (e.indent !== null) {
      const r = e.indent, n = Math.max(r - 1, 0);
      s.setCursor(e.indent), e.color = s.chars[n].penState.foreground;
    }
    const i = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(i);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let s = "", i = -1;
    for (let r = 0; r < ke; r++) {
      const n = this.rows[r].getTextString();
      n && (i = r + 1, e ? t.push("Row " + i + ": '" + n + "'") : t.push(n.trim()));
    }
    return t.length > 0 && (e ? s = "[" + t.join(" | ") + "]" : s = t.join(`
`)), s;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class Hi {
  constructor(e, t, s) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new gs(s), this.nonDisplayedMemory = new gs(s), this.lastOutputScreen = new gs(s), this.currRollUpRow = this.displayedMemory.rows[ke - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = s;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[ke - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let s = 0; s < e.length; s++)
      this.writeScreen.insertChar(e[s]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const s = Math.floor(e / 2) - 16, i = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = i[s];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class Ki {
  constructor(e, t, s) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
    const i = new ol();
    this.channels = [null, new Hi(e, t, i), new Hi(e + 1, s, i)], this.cmdHistory = Yi(), this.logger = i;
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    let s, i, r, n = !1;
    this.logger.time = e;
    for (let o = 0; o < t.length; o += 2)
      if (i = t[o] & 127, r = t[o + 1] & 127, !(i === 0 && r === 0)) {
        if (this.logger.log(3, "[" + Qe([t[o], t[o + 1]]) + "] -> (" + Qe([i, r]) + ")"), s = this.parseCmd(i, r), s || (s = this.parseMidrow(i, r)), s || (s = this.parsePAC(i, r)), s || (s = this.parseBackgroundAttributes(i, r)), !s && (n = this.parseChars(i, r), n)) {
          const l = this.currentChannel;
          l && l > 0 ? this.channels[l].insertChars(n) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
        }
        !s && !n && this.logger.log(2, "Couldn't parse cleaned data " + Qe([i, r]) + " orig: " + Qe([t[o], t[o + 1]]));
      }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const {
      cmdHistory: s
    } = this, i = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, r = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(i || r))
      return !1;
    if (Wi(e, t, s))
      return ot(null, null, s), this.logger.log(3, "Repeated command (" + Qe([e, t]) + ") is dropped"), !0;
    const n = e === 20 || e === 21 || e === 23 ? 1 : 2, o = this.channels[n];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? o.ccRCL() : t === 33 ? o.ccBS() : t === 34 ? o.ccAOF() : t === 35 ? o.ccAON() : t === 36 ? o.ccDER() : t === 37 ? o.ccRU(2) : t === 38 ? o.ccRU(3) : t === 39 ? o.ccRU(4) : t === 40 ? o.ccFON() : t === 41 ? o.ccRDC() : t === 42 ? o.ccTR() : t === 43 ? o.ccRTD() : t === 44 ? o.ccEDM() : t === 45 ? o.ccCR() : t === 46 ? o.ccENM() : t === 47 && o.ccEOC() : o.ccTO(t - 32), ot(e, t, s), this.currentChannel = n, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let s = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? s = 1 : s = 2, s !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const i = this.channels[s];
      return i ? (i.ccMIDROW(t), this.logger.log(3, "MIDROW (" + Qe([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let s;
    const i = this.cmdHistory, r = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, n = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(r || n))
      return !1;
    if (Wi(e, t, i))
      return ot(null, null, i), !0;
    const o = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? s = o === 1 ? sl[e] : rl[e] : s = o === 1 ? il[e] : nl[e];
    const l = this.channels[o];
    return l ? (l.setPAC(this.interpretPAC(s, t)), ot(e, t, i), this.currentChannel = o, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let s;
    const i = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? s = t - 96 : s = t - 64, i.underline = (s & 1) === 1, s <= 13 ? i.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(s / 2)] : s <= 15 ? (i.italics = !0, i.color = "white") : i.indent = Math.floor((s - 16) / 2) * 4, i;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let s, i = null, r = null;
    if (e >= 25 ? (s = 2, r = e - 8) : (s = 1, r = e), r >= 17 && r <= 19) {
      let n;
      r === 17 ? n = t + 80 : r === 18 ? n = t + 112 : n = t + 144, this.logger.log(2, "Special char '" + Qr(n) + "' in channel " + s), i = [n];
    } else
      e >= 32 && e <= 127 && (i = t === 0 ? [e] : [e, t]);
    if (i) {
      const n = Qe(i);
      this.logger.log(3, "Char codes =  " + n.join(",")), ot(e, t, this.cmdHistory);
    }
    return i;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const s = (e === 16 || e === 24) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(s || i))
      return !1;
    let r;
    const n = {};
    e === 16 || e === 24 ? (r = Math.floor((t - 32) / 2), n.background = al[r], t % 2 === 1 && (n.background = n.background + "_semi")) : t === 45 ? n.background = "transparent" : (n.foreground = "black", t === 47 && (n.underline = !0));
    const o = e <= 23 ? 1 : 2;
    return this.channels[o].setBkgData(n), ot(e, t, this.cmdHistory), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    this.cmdHistory = Yi();
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const s = this.channels[t];
      s && s.cueSplitAtTime(e);
    }
  }
}
function ot(a, e, t) {
  t.a = a, t.b = e;
}
function Wi(a, e, t) {
  return t.a === a && t.b === e;
}
function Yi() {
  return {
    a: null,
    b: null
  };
}
class Ot {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, s) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = s, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var Xs = function() {
  if (typeof self < "u" && self.VTTCue)
    return self.VTTCue;
  const a = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(o, l) {
    if (typeof l != "string" || !Array.isArray(o))
      return !1;
    const h = l.toLowerCase();
    return ~o.indexOf(h) ? h : !1;
  }
  function s(o) {
    return t(a, o);
  }
  function i(o) {
    return t(e, o);
  }
  function r(o, ...l) {
    let h = 1;
    for (; h < arguments.length; h++) {
      const c = arguments[h];
      for (const d in c)
        o[d] = c[d];
    }
    return o;
  }
  function n(o, l, h) {
    const c = this, d = {
      enumerable: !0
    };
    c.hasBeenReset = !1;
    let u = "", f = !1, g = o, p = l, v = h, y = null, T = "", x = !0, A = "auto", b = "start", C = 50, I = "middle", _ = 50, D = "middle";
    Object.defineProperty(c, "id", r({}, d, {
      get: function() {
        return u;
      },
      set: function(R) {
        u = "" + R;
      }
    })), Object.defineProperty(c, "pauseOnExit", r({}, d, {
      get: function() {
        return f;
      },
      set: function(R) {
        f = !!R;
      }
    })), Object.defineProperty(c, "startTime", r({}, d, {
      get: function() {
        return g;
      },
      set: function(R) {
        if (typeof R != "number")
          throw new TypeError("Start time must be set to a number.");
        g = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "endTime", r({}, d, {
      get: function() {
        return p;
      },
      set: function(R) {
        if (typeof R != "number")
          throw new TypeError("End time must be set to a number.");
        p = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "text", r({}, d, {
      get: function() {
        return v;
      },
      set: function(R) {
        v = "" + R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "region", r({}, d, {
      get: function() {
        return y;
      },
      set: function(R) {
        y = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "vertical", r({}, d, {
      get: function() {
        return T;
      },
      set: function(R) {
        const F = s(R);
        if (F === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        T = F, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "snapToLines", r({}, d, {
      get: function() {
        return x;
      },
      set: function(R) {
        x = !!R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "line", r({}, d, {
      get: function() {
        return A;
      },
      set: function(R) {
        if (typeof R != "number" && R !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        A = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "lineAlign", r({}, d, {
      get: function() {
        return b;
      },
      set: function(R) {
        const F = i(R);
        if (!F)
          throw new SyntaxError("An invalid or illegal string was specified.");
        b = F, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "position", r({}, d, {
      get: function() {
        return C;
      },
      set: function(R) {
        if (R < 0 || R > 100)
          throw new Error("Position must be between 0 and 100.");
        C = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "positionAlign", r({}, d, {
      get: function() {
        return I;
      },
      set: function(R) {
        const F = i(R);
        if (!F)
          throw new SyntaxError("An invalid or illegal string was specified.");
        I = F, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "size", r({}, d, {
      get: function() {
        return _;
      },
      set: function(R) {
        if (R < 0 || R > 100)
          throw new Error("Size must be between 0 and 100.");
        _ = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(c, "align", r({}, d, {
      get: function() {
        return D;
      },
      set: function(R) {
        const F = i(R);
        if (!F)
          throw new SyntaxError("An invalid or illegal string was specified.");
        D = F, this.hasBeenReset = !0;
      }
    })), c.displayState = void 0;
  }
  return n.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, n;
}();
class cl {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function en(a) {
  function e(s, i, r, n) {
    return (s | 0) * 3600 + (i | 0) * 60 + (r | 0) + parseFloat(n || 0);
  }
  const t = a.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class dl {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, s) {
    return s ? this.has(e) ? this.values[e] : t[s] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, s) {
    for (let i = 0; i < s.length; ++i)
      if (t === s[i]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const s = parseFloat(t);
      if (s >= 0 && s <= 100)
        return this.set(e, s), !0;
    }
    return !1;
  }
}
function tn(a, e, t, s) {
  const i = s ? a.split(s) : [a];
  for (const r in i) {
    if (typeof i[r] != "string")
      continue;
    const n = i[r].split(t);
    if (n.length !== 2)
      continue;
    const o = n[0], l = n[1];
    e(o, l);
  }
}
const _s = new Xs(0, 0, ""), Ft = _s.align === "middle" ? "middle" : "center";
function ul(a, e, t) {
  const s = a;
  function i() {
    const o = en(a);
    if (o === null)
      throw new Error("Malformed timestamp: " + s);
    return a = a.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function r(o, l) {
    const h = new dl();
    tn(o, function(u, f) {
      let g;
      switch (u) {
        case "region":
          for (let p = t.length - 1; p >= 0; p--)
            if (t[p].id === f) {
              h.set(u, t[p].region);
              break;
            }
          break;
        case "vertical":
          h.alt(u, f, ["rl", "lr"]);
          break;
        case "line":
          g = f.split(","), h.integer(u, g[0]), h.percent(u, g[0]) && h.set("snapToLines", !1), h.alt(u, g[0], ["auto"]), g.length === 2 && h.alt("lineAlign", g[1], ["start", Ft, "end"]);
          break;
        case "position":
          g = f.split(","), h.percent(u, g[0]), g.length === 2 && h.alt("positionAlign", g[1], ["start", Ft, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          h.percent(u, f);
          break;
        case "align":
          h.alt(u, f, ["start", Ft, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = h.get("region", null), l.vertical = h.get("vertical", "");
    let c = h.get("line", "auto");
    c === "auto" && _s.line === -1 && (c = -1), l.line = c, l.lineAlign = h.get("lineAlign", "start"), l.snapToLines = h.get("snapToLines", !0), l.size = h.get("size", 100), l.align = h.get("align", Ft);
    let d = h.get("position", "auto");
    d === "auto" && _s.position === 50 && (d = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = d;
  }
  function n() {
    a = a.replace(/^\s+/, "");
  }
  if (n(), e.startTime = i(), n(), a.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + s);
  a = a.slice(3), n(), e.endTime = i(), n(), r(a, e);
}
function sn(a) {
  return a.replace(/<br(?: \/)?>/gi, `
`);
}
class fl {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new cl(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function s() {
      let r = t.buffer, n = 0;
      for (r = sn(r); n < r.length && r[n] !== "\r" && r[n] !== `
`; )
        ++n;
      const o = r.slice(0, n);
      return r[n] === "\r" && ++n, r[n] === `
` && ++n, t.buffer = r.slice(n), o;
    }
    function i(r) {
      tn(r, function(n, o) {
      }, /:/);
    }
    try {
      let r = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        r = s();
        const o = r.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(o != null && o[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let n = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (n ? n = !1 : r = s(), t.state) {
          case "HEADER":
            /:/.test(r) ? i(r) : r || (t.state = "ID");
            continue;
          case "NOTE":
            r || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(r)) {
              t.state = "NOTE";
              break;
            }
            if (!r)
              continue;
            if (t.cue = new Xs(0, 0, ""), t.state = "CUE", r.indexOf("-->") === -1) {
              t.cue.id = r;
              continue;
            }
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              ul(r, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const o = r.indexOf("-->") !== -1;
              if (!r || o && (n = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += r;
            }
            continue;
          case "BADCUE":
            r || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const gl = /\r\n|\n\r|\n|\r/g, ms = function(e, t, s = 0) {
  return e.slice(s, s + t.length) === t;
}, ml = function(e) {
  let t = parseInt(e.slice(-3));
  const s = parseInt(e.slice(-6, -4)), i = parseInt(e.slice(-9, -7)), r = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!M(t) || !M(s) || !M(i) || !M(r))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * s, t += 60 * 1e3 * i, t += 60 * 60 * 1e3 * r, t;
}, ps = function(e) {
  let t = 5381, s = e.length;
  for (; s; )
    t = t * 33 ^ e.charCodeAt(--s);
  return (t >>> 0).toString();
};
function Zs(a, e, t) {
  return ps(a.toString()) + ps(e.toString()) + ps(t);
}
const pl = function(e, t, s) {
  let i = e[t], r = e[i.prevCC];
  if (!r || !r.new && i.new) {
    e.ccOffset = e.presentationOffset = i.start, i.new = !1;
    return;
  }
  for (; (n = r) != null && n.new; ) {
    var n;
    e.ccOffset += i.start - r.start, i.new = !1, i = r, r = e[i.prevCC];
  }
  e.presentationOffset = s;
};
function vl(a, e, t, s, i, r, n) {
  const o = new fl(), l = $e(new Uint8Array(a)).trim().replace(gl, `
`).split(`
`), h = [], c = e ? wo(e.baseTime, e.timescale) : 0;
  let d = "00:00.000", u = 0, f = 0, g, p = !0;
  o.oncue = function(v) {
    const y = t[s];
    let T = t.ccOffset;
    const x = (u - c) / 9e4;
    if (y != null && y.new && (f !== void 0 ? T = t.ccOffset = y.start : pl(t, s, x)), x) {
      if (!e) {
        g = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      T = x - t.presentationOffset;
    }
    const A = v.endTime - v.startTime, b = Ce((v.startTime + T - f) * 9e4, i * 9e4) / 9e4;
    v.startTime = Math.max(b, 0), v.endTime = Math.max(b + A, 0);
    const C = v.text.trim();
    v.text = decodeURIComponent(encodeURIComponent(C)), v.id || (v.id = Zs(v.startTime, v.endTime, C)), v.endTime > 0 && h.push(v);
  }, o.onparsingerror = function(v) {
    g = v;
  }, o.onflush = function() {
    if (g) {
      n(g);
      return;
    }
    r(h);
  }, l.forEach((v) => {
    if (p)
      if (ms(v, "X-TIMESTAMP-MAP=")) {
        p = !1, v.slice(16).split(",").forEach((y) => {
          ms(y, "LOCAL:") ? d = y.slice(6) : ms(y, "MPEGTS:") && (u = parseInt(y.slice(7)));
        });
        try {
          f = ml(d) / 1e3;
        } catch (y) {
          g = y;
        }
        return;
      } else
        v === "" && (p = !1);
    o.parse(v + `
`);
  }), o.flush();
}
const vs = "stpp.ttml.im1t", rn = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, nn = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, yl = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function zi(a, e, t, s) {
  const i = H(new Uint8Array(a), ["mdat"]);
  if (i.length === 0) {
    s(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const r = i.map((o) => $e(o)), n = Io(e.baseTime, 1, e.timescale);
  try {
    r.forEach((o) => t(Tl(o, n)));
  } catch (o) {
    s(o);
  }
}
function Tl(a, e) {
  const i = new DOMParser().parseFromString(a, "text/xml").getElementsByTagName("tt")[0];
  if (!i)
    throw new Error("Invalid ttml");
  const r = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, n = Object.keys(r).reduce((d, u) => (d[u] = i.getAttribute(`ttp:${u}`) || r[u], d), {}), o = i.getAttribute("xml:space") !== "preserve", l = ji(ys(i, "styling", "style")), h = ji(ys(i, "layout", "region")), c = ys(i, "body", "[begin]");
  return [].map.call(c, (d) => {
    const u = an(d, o);
    if (!u || !d.hasAttribute("begin"))
      return null;
    const f = xs(d.getAttribute("begin"), n), g = xs(d.getAttribute("dur"), n);
    let p = xs(d.getAttribute("end"), n);
    if (f === null)
      throw qi(d);
    if (p === null) {
      if (g === null)
        throw qi(d);
      p = f + g;
    }
    const v = new Xs(f - e, p - e, u);
    v.id = Zs(v.startTime, v.endTime, v.text);
    const y = h[d.getAttribute("region")], T = l[d.getAttribute("style")], x = xl(y, T, l), {
      textAlign: A
    } = x;
    if (A) {
      const b = yl[A];
      b && (v.lineAlign = b), v.align = A;
    }
    return ae(v, x), v;
  }).filter((d) => d !== null);
}
function ys(a, e, t) {
  const s = a.getElementsByTagName(e)[0];
  return s ? [].slice.call(s.querySelectorAll(t)) : [];
}
function ji(a) {
  return a.reduce((e, t) => {
    const s = t.getAttribute("xml:id");
    return s && (e[s] = t), e;
  }, {});
}
function an(a, e) {
  return [].slice.call(a.childNodes).reduce((t, s, i) => {
    var r;
    return s.nodeName === "br" && i ? t + `
` : (r = s.childNodes) != null && r.length ? an(s, e) : e ? t + s.textContent.trim().replace(/\s+/g, " ") : t + s.textContent;
  }, "");
}
function xl(a, e, t) {
  const s = "http://www.w3.org/ns/ttml#styling";
  let i = null;
  const r = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], n = a != null && a.hasAttribute("style") ? a.getAttribute("style") : null;
  return n && t.hasOwnProperty(n) && (i = t[n]), r.reduce((o, l) => {
    const h = Ts(e, s, l) || Ts(a, s, l) || Ts(i, s, l);
    return h && (o[l] = h), o;
  }, {});
}
function Ts(a, e, t) {
  return a && a.hasAttributeNS(e, t) ? a.getAttributeNS(e, t) : null;
}
function qi(a) {
  return new Error(`Could not parse ttml timestamp ${a}`);
}
function xs(a, e) {
  if (!a)
    return null;
  let t = en(a);
  return t === null && (rn.test(a) ? t = El(a, e) : nn.test(a) && (t = Sl(a, e))), t;
}
function El(a, e) {
  const t = rn.exec(a), s = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + s / e.frameRate;
}
function Sl(a, e) {
  const t = nn.exec(a), s = Number(t[1]);
  switch (t[2]) {
    case "h":
      return s * 3600;
    case "m":
      return s * 60;
    case "ms":
      return s * 1e3;
    case "f":
      return s / e.frameRate;
    case "t":
      return s / e.tickRate;
  }
  return s;
}
class bl {
  constructor(e) {
    if (this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = Xi(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, this.config.enableCEA708Captions) {
      const t = new Ot(this, "textTrack1"), s = new Ot(this, "textTrack2"), i = new Ot(this, "textTrack3"), r = new Ot(this, "textTrack4");
      this.cea608Parser1 = new Ki(1, t, s), this.cea608Parser2 = new Ki(3, i, r);
    }
    e.on(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(m.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(m.FRAG_LOADING, this.onFragLoading, this), e.on(m.FRAG_LOADED, this.onFragLoaded, this), e.on(m.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(m.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(m.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(m.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(m.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(m.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(m.FRAG_LOADING, this.onFragLoading, this), e.off(m.FRAG_LOADED, this.onFragLoaded, this), e.off(m.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(m.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(m.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(m.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(m.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
  }
  addCues(e, t, s, i, r) {
    let n = !1;
    for (let o = r.length; o--; ) {
      const l = r[o], h = Al(l[0], l[1], t, s);
      if (h >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], s), n = !0, h / (s - t) > 0.5))
        return;
    }
    if (n || r.push([t, s]), this.config.renderTextTracksNatively) {
      const o = this.captionsTracks[e];
      this.Cues.newCue(o, t, s, i);
    } else {
      const o = this.Cues.newCue(null, t, s, i);
      this.hls.trigger(m.CUES_PARSED, {
        type: "captions",
        cues: o,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: i,
    timescale: r
  }) {
    const {
      unparsedVttFrags: n
    } = this;
    s === "main" && (this.initPTS[t.cc] = {
      baseTime: i,
      timescale: r
    }), n.length && (this.unparsedVttFrags = [], n.forEach((o) => {
      this.onFragLoaded(m.FRAG_LOADED, o);
    }));
  }
  getExistingTrack(e) {
    const {
      media: t
    } = this;
    if (t)
      for (let s = 0; s < t.textTracks.length; s++) {
        const i = t.textTracks[s];
        if (i[e])
          return i;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: s,
      media: i
    } = this, {
      label: r,
      languageCode: n
    } = t[e], o = this.getExistingTrack(e);
    if (o)
      s[e] = o, ht(s[e]), Ir(s[e], i);
    else {
      const l = this.createTextTrack("captions", r, n);
      l && (l[e] = !0, s[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const s = t.label, i = {
      _id: e,
      label: s,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = i, this.hls.trigger(m.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [i]
    });
  }
  createTextTrack(e, t, s) {
    const i = this.media;
    if (i)
      return i.addTextTrack(e, t, s);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((t) => {
      ht(e[t]), delete e[t];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = Xi(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let s = 0; s < t.length; s++)
        ht(t[s]);
  }
  onSubtitleTracksUpdated(e, t) {
    const s = t.subtitleTracks || [], i = s.some((r) => r.textCodec === vs);
    if (this.config.enableWebVTT || i && this.config.enableIMSC1) {
      if (Zr(this.tracks, s)) {
        this.tracks = s;
        return;
      }
      if (this.textTracks = [], this.tracks = s, this.config.renderTextTracksNatively) {
        const n = this.media ? this.media.textTracks : null;
        this.tracks.forEach((o, l) => {
          let h;
          if (n && l < n.length) {
            let c = null;
            for (let d = 0; d < n.length; d++)
              if (Ll(n[d], o)) {
                c = n[d];
                break;
              }
            c && (h = c);
          }
          if (h)
            ht(h);
          else {
            const c = this._captionsOrSubtitlesFromCharacteristics(o);
            h = this.createTextTrack(c, o.name, o.lang), h && (h.mode = "disabled");
          }
          h && (h.groupId = o.groupId, this.textTracks.push(h));
        });
      } else if (this.tracks.length) {
        const n = this.tracks.map((o) => ({
          label: o.name,
          kind: o.type.toLowerCase(),
          default: o.default,
          subtitleTrack: o
        }));
        this.hls.trigger(m.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: n
        });
      }
    }
  }
  _captionsOrSubtitlesFromCharacteristics(e) {
    if (e.attrs.CHARACTERISTICS) {
      const t = /transcribes-spoken-dialog/gi.test(e.attrs.CHARACTERISTICS), s = /describes-music-and-sound/gi.test(e.attrs.CHARACTERISTICS);
      if (t && s)
        return "captions";
    }
    return "subtitles";
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((s) => {
      const i = /(?:CC|SERVICE)([1-4])/.exec(s.instreamId);
      if (!i)
        return;
      const r = `textTrack${i[1]}`, n = this.captionsProperties[r];
      n && (n.label = s.name, s.lang && (n.languageCode = s.lang), n.media = s);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    const {
      cea608Parser1: s,
      cea608Parser2: i,
      lastSn: r,
      lastPartIndex: n
    } = this;
    if (!(!this.enabled || !(s && i)) && t.frag.type === $.MAIN) {
      var o, l;
      const h = t.frag.sn, c = (o = t == null || (l = t.part) == null ? void 0 : l.index) != null ? o : -1;
      h === r + 1 || h === r && c === n + 1 || (s.reset(), i.reset()), this.lastSn = h, this.lastPartIndex = c;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      payload: i
    } = t;
    if (s.type === $.SUBTITLE)
      if (i.byteLength) {
        const r = s.decryptdata, n = "stats" in t;
        if (r == null || !r.encrypted || n) {
          const o = this.tracks[s.level], l = this.vttCCs;
          l[s.cc] || (l[s.cc] = {
            start: s.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = s.cc), o && o.textCodec === vs ? this._parseIMSC1(s, i) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(m.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: s,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const s = this.hls;
    zi(t, this.initPTS[e.cc], (i) => {
      this._appendCues(i, e.level), s.trigger(m.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (i) => {
      E.log(`Failed to parse IMSC1: ${i}`), s.trigger(m.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: i
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: s,
      payload: i
    } = e, {
      initPTS: r,
      unparsedVttFrags: n
    } = this, o = r.length - 1;
    if (!r[s.cc] && o === -1) {
      n.push(e);
      return;
    }
    const l = this.hls, h = (t = s.initSegment) != null && t.data ? tt(s.initSegment.data, new Uint8Array(i)) : i;
    vl(h, this.initPTS[s.cc], this.vttCCs, s.cc, s.start, (c) => {
      this._appendCues(c, s.level), l.trigger(m.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: s
      });
    }, (c) => {
      const d = c.message === "Missing initPTS for VTT MPEGTS";
      d ? n.push(e) : this._fallbackToIMSC1(s, i), E.log(`Failed to parse VTT cue: ${c}`), !(d && o > s.cc) && l.trigger(m.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: s,
        error: c
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const s = this.tracks[e.level];
    s.textCodec || zi(t, this.initPTS[e.cc], () => {
      s.textCodec = vs, this._parseIMSC1(e, t);
    }, () => {
      s.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const s = this.hls;
    if (this.config.renderTextTracksNatively) {
      const i = this.textTracks[t];
      if (!i || i.mode === "disabled")
        return;
      e.forEach((r) => wr(i, r));
    } else {
      const i = this.tracks[t];
      if (!i)
        return;
      const r = i.default ? "default" : "subtitles" + t;
      s.trigger(m.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: r
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: s
    } = t;
    s.type === $.SUBTITLE && this.onFragLoaded(m.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    const {
      cea608Parser1: s,
      cea608Parser2: i
    } = this;
    if (!this.enabled || !(s && i))
      return;
    const {
      frag: r,
      samples: n
    } = t;
    if (!(r.type === $.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let o = 0; o < n.length; o++) {
        const l = n[o].bytes;
        if (l) {
          const h = this.extractCea608Data(l);
          s.addData(n[o].pts, h[0]), i.addData(n[o].pts, h[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    endOffsetSubtitles: i,
    type: r
  }) {
    const {
      media: n
    } = this;
    if (!(!n || n.currentTime < s)) {
      if (!r || r === "video") {
        const {
          captionsTracks: o
        } = this;
        Object.keys(o).forEach((l) => bs(o[l], t, s));
      }
      if (this.config.renderTextTracksNatively && t === 0 && i !== void 0) {
        const {
          textTracks: o
        } = this;
        Object.keys(o).forEach((l) => bs(o[l], t, i));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], s = e[0] & 31;
    let i = 2;
    for (let r = 0; r < s; r++) {
      const n = e[i++], o = 127 & e[i++], l = 127 & e[i++];
      if (o === 0 && l === 0)
        continue;
      if ((4 & n) !== 0) {
        const c = 3 & n;
        (c === 0 || c === 1) && (t[c].push(o), t[c].push(l));
      }
    }
    return t;
  }
}
function Ll(a, e) {
  return !!a && a.label === e.name && !(a.textTrack1 || a.textTrack2);
}
function Al(a, e, t, s) {
  return Math.min(e, s) - Math.max(a, t);
}
function Xi() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class Qs {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.unregisterListener(), this.hls.config.capLevelToPlayerSize && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(m.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.BUFFER_CODECS, this.onBufferCodecs, this), e.on(m.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(m.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(m.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.BUFFER_CODECS, this.onBufferCodecs, this), e.off(m.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const s = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(s) && this.restrictedLevels.push({
      bitrate: s.bitrate,
      height: s.height,
      width: s.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null;
  }
  onManifestParsed(e, t) {
    const s = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, s.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls;
        t.autoLevelCapping = this.getMaxLevel(e.length - 1), t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const s = t.filter((i, r) => this.isLevelAllowed(i) && r <= e);
    return this.clientRect = null, Qs.getMaxLevelByMediaSize(s, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const s = e.getBoundingClientRect();
      t.width = s.width, t.height = s.height, !t.width && !t.height && (t.width = s.right - s.left || e.width || 0, t.height = s.bottom - s.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((s) => e.bitrate === s.bitrate && e.width === s.width && e.height === s.height);
  }
  static getMaxLevelByMediaSize(e, t, s) {
    if (!(e != null && e.length))
      return -1;
    const i = (n, o) => o ? n.width !== o.width || n.height !== o.height : !0;
    let r = e.length - 1;
    for (let n = 0; n < e.length; n += 1) {
      const o = e[n];
      if ((o.width >= t || o.height >= s) && i(o, e[n + 1])) {
        r = n;
        break;
      }
    }
    return r;
  }
}
class Rl {
  // stream controller must be provided as a dependency!
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(m.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(m.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const s = this.hls.config;
    if (s.capLevelOnFPSDrop) {
      const i = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = i, i && typeof i.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), s.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, t, s) {
    const i = performance.now();
    if (t) {
      if (this.lastTime) {
        const r = i - this.lastTime, n = s - this.lastDroppedFrames, o = t - this.lastDecodedFrames, l = 1e3 * n / r, h = this.hls;
        if (h.trigger(m.FPS_DROP, {
          currentDropped: n,
          currentDecoded: o,
          totalDroppedFrames: s
        }), l > 0 && n > h.config.fpsDroppedMonitoringThreshold * o) {
          let c = h.currentLevel;
          E.warn("drop FPS ratio greater than max allowed value for currentLevel: " + c), c > 0 && (h.autoLevelCapping === -1 || h.autoLevelCapping >= c) && (c = c - 1, h.trigger(m.FPS_DROP_LEVEL_CAPPING, {
            level: c,
            droppedLevel: h.currentLevel
          }), h.autoLevelCapping = c, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = i, this.lastDroppedFrames = s, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Mt = "[eme]";
class dt {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = dt.CDMCleanupPromise ? [dt.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = E.debug.bind(E, Mt), this.log = E.log.bind(E, Mt), this.warn = E.warn.bind(E, Mt), this.error = E.error.bind(E, Mt), this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(m.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(m.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(m.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(m.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(m.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(m.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: s
    } = this.config, i = t[e];
    if (i)
      return i.licenseUrl;
    if (e === se.WIDEVINE && s)
      return s;
    throw new Error(`no license server URL configured for key-system "${e}"`);
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, s = t[e];
    if (s)
      return s.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, s = (n, o, l) => !!n && l.indexOf(n) === o, i = t.map((n) => n.audioCodec).filter(s), r = t.map((n) => n.videoCodec).filter(s);
    return i.length + r.length === 0 && r.push("avc1.42e01e"), new Promise((n, o) => {
      const l = (h) => {
        const c = h.shift();
        this.getMediaKeysPromise(c, i, r).then((d) => n({
          keySystem: c,
          mediaKeys: d
        })).catch((d) => {
          h.length ? l(h) : d instanceof we ? o(d) : o(new we({
            type: U.KEY_SYSTEM_ERROR,
            details: L.KEY_SYSTEM_NO_ACCESS,
            error: d,
            fatal: !0
          }, d.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: s
    } = this.config;
    if (typeof s != "function") {
      let i = `Configured requestMediaKeySystemAccess is not a function ${s}`;
      return mr === null && self.location.protocol === "http:" && (i = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(i));
    }
    return s(e, t);
  }
  getMediaKeysPromise(e, t, s) {
    const i = $n(e, t, s, this.config.drmSystemOptions), r = this.keySystemAccessPromises[e];
    let n = r == null ? void 0 : r.keySystemAccess;
    if (!n) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(i)}`), n = this.requestMediaKeySystemAccess(e, i);
      const o = this.keySystemAccessPromises[e] = {
        keySystemAccess: n
      };
      return n.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), n.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const h = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), o.mediaKeys = l.createMediaKeys().then((c) => (this.log(`Media-keys created for "${e}"`), h.then((d) => d ? this.setMediaKeysServerCertificate(c, e, d) : c))), o.mediaKeys.catch((c) => {
          this.error(`Failed to create media-keys for "${e}"}: ${c}`);
        }), o.mediaKeys;
      });
    }
    return n.then(() => r.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: s
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${Me.hexDump(e.keyId || [])}`);
    const i = s.createSession(), r = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: s,
      mediaKeysSession: i,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(r), r;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const s = this.createMediaKeySessionContext(e), i = this.getKeyIdString(t), r = "cenc";
      this.keyIdToKeySessionPromise[i] = this.generateRequestWithPreferredKeySession(s, r, t.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return Me.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var s;
    const i = e.mediaKeysSession;
    return this.log(`Updating key-session "${i.sessionId}" for keyID ${Me.hexDump(((s = e.decryptdata) == null ? void 0 : s.keyId) || [])}
      } (data length: ${t && t.byteLength})`), i.update(t);
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((t, s) => {
      const i = Jt(this.config), r = e.map(oi).filter((n) => !!n && i.indexOf(n) !== -1);
      return this.getKeySystemSelectionPromise(r).then(({
        keySystem: n
      }) => {
        const o = li(n);
        o ? t(o) : s(new Error(`Unable to find format for key-system "${n}"`));
      }).catch(s);
    });
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, s = this.getKeyIdString(t), i = `(keyId: ${s} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${i}`);
    let r = this.keyIdToKeySessionPromise[s];
    return r || (r = this.keyIdToKeySessionPromise[s] = this.getKeySystemForKeyPromise(t).then(({
      keySystem: n,
      mediaKeys: o
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${i}`), this.attemptSetMediaKeys(n, o).then(() => {
      this.throwIfDestroyed();
      const l = this.createMediaKeySessionContext({
        keySystem: n,
        mediaKeys: o,
        decryptdata: t
      }), h = "cenc";
      return this.generateRequestWithPreferredKeySession(l, h, t.pssh, "playlist-key");
    }))), r.catch((n) => this.handleError(n))), r;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof we ? this.hls.trigger(m.ERROR, e.data) : this.hls.trigger(m.ERROR, {
      type: U.KEY_SYSTEM_ERROR,
      details: L.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), s = this.keyIdToKeySessionPromise[t];
    if (!s) {
      const i = oi(e.keyFormat), r = i ? [i] : Jt(this.config);
      return this.attemptKeySystemAccess(r);
    }
    return s;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = Jt(this.config)), e.length === 0)
      throw new we({
        type: U.KEY_SYSTEM_ERROR,
        details: L.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  _onMediaEncrypted(e) {
    const {
      initDataType: t,
      initData: s
    } = e;
    if (this.debug(`"${e.type}" event: init data type: "${t}"`), s === null)
      return;
    let i, r;
    if (t === "sinf" && this.config.drmSystems[se.FAIRPLAY]) {
      const c = de(new Uint8Array(s));
      try {
        const d = Us(JSON.parse(c).sinf), u = br(new Uint8Array(d));
        if (!u)
          return;
        i = u.subarray(8, 24), r = se.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const c = ha(s);
      if (c === null)
        return;
      c.version === 0 && c.systemId === gr.WIDEVINE && c.data && (i = c.data.subarray(8, 24)), r = Un(c.systemId);
    }
    if (!r || !i)
      return;
    const n = Me.hexDump(i), {
      keyIdToKeySessionPromise: o,
      mediaKeySessions: l
    } = this;
    let h = o[n];
    for (let c = 0; c < l.length; c++) {
      const d = l[c], u = d.decryptdata;
      if (u.pssh || !u.keyId)
        continue;
      const f = Me.hexDump(u.keyId);
      if (n === f || u.uri.replace(/-/g, "").indexOf(n) !== -1) {
        h = o[f], delete o[f], u.pssh = new Uint8Array(s), u.keyId = i, h = o[n] = h.then(() => this.generateRequestWithPreferredKeySession(d, t, s, "encrypted-event-key-match"));
        break;
      }
    }
    h || (h = o[n] = this.getKeySystemSelectionPromise([r]).then(({
      keySystem: c,
      mediaKeys: d
    }) => {
      var u;
      this.throwIfDestroyed();
      const f = new xt("ISO-23001-7", n, (u = li(c)) != null ? u : "");
      return f.pssh = new Uint8Array(s), f.keyId = i, this.attemptSetMediaKeys(c, d).then(() => {
        this.throwIfDestroyed();
        const g = this.createMediaKeySessionContext({
          decryptdata: f,
          keySystem: c,
          mediaKeys: d
        });
        return this.generateRequestWithPreferredKeySession(g, t, s, "encrypted-event-no-match");
      });
    })), h.catch((c) => this.handleError(c));
  }
  _onWaitingForKey(e) {
    this.log(`"${e.type}" event`);
  }
  attemptSetMediaKeys(e, t) {
    const s = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const i = Promise.all(s).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.setMediaKeysQueue.push(i), i.then(() => {
      this.log(`Media-keys set for "${e}"`), s.push(i), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((r) => s.indexOf(r) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, s, i) {
    var r, n;
    const o = (r = this.config.drmSystems) == null || (n = r[e.keySystem]) == null ? void 0 : n.generateRequest;
    if (o)
      try {
        const u = o.call(this.hls, t, s, e);
        if (!u)
          throw new Error("Invalid response from configured generateRequest filter");
        t = u.initDataType, s = e.decryptdata.pssh = u.initData ? new Uint8Array(u.initData) : null;
      } catch (u) {
        var l;
        if (this.warn(u.message), (l = this.hls) != null && l.config.debug)
          throw u;
      }
    if (s === null)
      return this.log(`Skipping key-session request for "${i}" (no initData)`), Promise.resolve(e);
    const h = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${i}": ${h} (init data type: ${t} length: ${s ? s.byteLength : null})`);
    const c = new qs();
    e.mediaKeysSession.onmessage = (u) => {
      const f = e.mediaKeysSession;
      if (!f) {
        c.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: g,
        message: p
      } = u;
      this.log(`"${g}" message event for session "${f.sessionId}" message size: ${p.byteLength}`), g === "license-request" || g === "license-renewal" ? this.renewLicense(e, p).catch((v) => {
        this.handleError(v), c.emit("error", v);
      }) : g === "license-release" ? e.keySystem === se.FAIRPLAY && (this.updateKeySession(e, fr("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${g}"`);
    }, e.mediaKeysSession.onkeystatuseschange = (u) => {
      if (!e.mediaKeysSession) {
        c.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const g = e.keyStatus;
      c.emit("keyStatus", g), g === "expired" && (this.warn(`${e.keySystem} expired for key ${h}`), this.renewKeySession(e));
    };
    const d = new Promise((u, f) => {
      c.on("error", f), c.on("keyStatus", (g) => {
        g.startsWith("usable") ? u() : g === "output-restricted" ? f(new we({
          type: U.KEY_SYSTEM_ERROR,
          details: L.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : g === "internal-error" ? f(new we({
          type: U.KEY_SYSTEM_ERROR,
          details: L.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${g}"`)) : g === "expired" ? f(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${g}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, s).then(() => {
      var u;
      this.log(`Request generated for key-session "${(u = e.mediaKeysSession) == null ? void 0 : u.sessionId}" keyId: ${h}`);
    }).catch((u) => {
      throw new we({
        type: U.KEY_SYSTEM_ERROR,
        details: L.KEY_SYSTEM_NO_SESSION,
        error: u,
        fatal: !1
      }, `Error generating key-session request: ${u}`);
    }).then(() => d).catch((u) => {
      throw c.removeAllListeners(), this.removeSession(e), u;
    }).then(() => (c.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, s) => {
      this.log(`key status change "${t}" for keyStatuses keyId: ${Me.hexDump("buffer" in s ? new Uint8Array(s.buffer, s.byteOffset, s.byteLength) : new Uint8Array(s))} session keyId: ${Me.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, s = t.loader, i = new s(t), r = this.getServerCertificateUrl(e);
    return r ? (this.log(`Fetching serverCertificate for "${e}"`), new Promise((n, o) => {
      const l = {
        responseType: "arraybuffer",
        url: r
      }, h = t.certLoadPolicy.default, c = {
        loadPolicy: h,
        timeout: h.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (u, f, g, p) => {
          n(u.data);
        },
        onError: (u, f, g, p) => {
          o(new we({
            type: U.KEY_SYSTEM_ERROR,
            details: L.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: g,
            response: Le({
              url: l.url,
              data: void 0
            }, u)
          }, `"${e}" certificate request failed (${r}). Status: ${u.code} (${u.text})`));
        },
        onTimeout: (u, f, g) => {
          o(new we({
            type: U.KEY_SYSTEM_ERROR,
            details: L.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: g,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${r})`));
        },
        onAbort: (u, f, g) => {
          o(new Error("aborted"));
        }
      };
      i.load(l, c, d);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, s) {
    return new Promise((i, r) => {
      e.setServerCertificate(s).then((n) => {
        this.log(`setServerCertificate ${n ? "success" : "not supported by CDM"} (${s == null ? void 0 : s.byteLength}) on "${t}"`), i(e);
      }).catch((n) => {
        r(new we({
          type: U.KEY_SYSTEM_ERROR,
          details: L.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: n,
          fatal: !0
        }, n.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((s) => this.updateKeySession(e, new Uint8Array(s)).catch((i) => {
      throw new we({
        type: U.KEY_SYSTEM_ERROR,
        details: L.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: i,
        fatal: !0
      }, i.message);
    }));
  }
  setupLicenseXHR(e, t, s, i) {
    const r = this.config.licenseXhrSetup;
    return r ? Promise.resolve().then(() => {
      if (!s.decryptdata)
        throw new Error("Key removed");
      return r.call(this.hls, e, t, s, i);
    }).catch((n) => {
      if (!s.decryptdata)
        throw n;
      return e.open("POST", t, !0), r.call(this.hls, e, t, s, i);
    }).then((n) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: n || i
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: i
    }));
  }
  requestLicense(e, t) {
    const s = this.config.keyLoadPolicy.default;
    return new Promise((i, r) => {
      const n = this.getLicenseServerUrl(e.keySystem);
      this.log(`Sending license request to URL: ${n}`);
      const o = new XMLHttpRequest();
      o.responseType = "arraybuffer", o.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return r(new Error("invalid state"));
        if (o.readyState === 4)
          if (o.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = o.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const h = this.config.licenseResponseCallback;
            if (h)
              try {
                l = h.call(this.hls, o, n, e);
              } catch (c) {
                this.error(c);
              }
            i(l);
          } else {
            const l = s.errorRetry, h = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > h || o.status >= 400 && o.status < 500)
              r(new we({
                type: U.KEY_SYSTEM_ERROR,
                details: L.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: o,
                response: {
                  url: n,
                  data: void 0,
                  code: o.status,
                  text: o.statusText
                }
              }, `License Request XHR failed (${n}). Status: ${o.status} (${o.statusText})`));
            else {
              const c = h - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${c} attempts left`), this.requestLicense(e, t).then(i, r);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = o, this.setupLicenseXHR(o, n, e, t).then(({
        xhr: l,
        licenseChallenge: h
      }) => {
        l.send(h);
      });
    });
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const s = t.media;
    this.media = s, s.addEventListener("encrypted", this.onMediaEncrypted), s.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, t = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, xt.clearKeyUriToKeyIdMap();
    const s = t.length;
    dt.CDMCleanupPromise = Promise.all(t.map((i) => this.removeSession(i)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((i) => {
      this.log(`Could not clear media keys: ${i}. media.src: ${e == null ? void 0 : e.src}`);
    }))).then(() => {
      s && (this.log("finished closing key sessions and clearing media keys"), t.length = 0);
    }).catch((i) => {
      this.log(`Could not close sessions and clear media keys: ${i}. media.src: ${e == null ? void 0 : e.src}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const s = t.reduce((i, r) => (i.indexOf(r.keyFormat) === -1 && i.push(r.keyFormat), i), []);
      this.log(`Selecting key-system from session-keys ${s.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(s);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: s
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), t.onmessage = null, t.onkeystatuseschange = null, s && s.readyState !== XMLHttpRequest.DONE && s.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const i = this.mediaKeySessions.indexOf(e);
      return i > -1 && this.mediaKeySessions.splice(i, 1), t.remove().catch((r) => {
        this.log(`Could not remove session: ${r}`);
      }).then(() => t.close()).catch((r) => {
        this.log(`Could not close session: ${r}`);
      });
    }
  }
}
dt.CDMCleanupPromise = void 0;
class we extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
const Il = 1;
var Te = {
  MANIFEST: "m",
  AUDIO: "a",
  VIDEO: "v",
  MUXED: "av",
  INIT: "i",
  CAPTION: "c",
  TIMED_TEXT: "tt",
  KEY: "k",
  OTHER: "o"
};
const wl = "h";
class ze {
  // eslint-disable-line no-restricted-globals
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (i) => {
      try {
        this.apply(i, {
          ot: Te.MANIFEST,
          su: !this.initialized
        });
      } catch (r) {
        E.warn("Could not generate manifest CMCD data.", r);
      }
    }, this.applyFragmentData = (i) => {
      try {
        const r = i.frag, n = this.hls.levels[r.level], o = this.getObjectType(r), l = {
          d: r.duration * 1e3,
          ot: o
        };
        (o === Te.VIDEO || o === Te.AUDIO || o == Te.MUXED) && (l.br = n.bitrate / 1e3, l.tb = this.getTopBandwidth(o) / 1e3, l.bl = this.getBufferLength(o)), this.apply(i, l);
      } catch (r) {
        E.warn("Could not generate segment CMCD data.", r);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: s
    } = t;
    s != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = s.sessionId || ze.uuid(), this.cid = s.contentId, this.useHeaders = s.useHeaders === !0, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(m.MEDIA_DETACHED, this.onMediaDetached, this), e.on(m.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(m.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(m.MEDIA_DETACHED, this.onMediaDetached, this), e.off(m.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var s, i;
    this.audioBuffer = (s = t.tracks.audio) == null ? void 0 : s.buffer, this.videoBuffer = (i = t.tracks.video) == null ? void 0 : i.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: Il,
      sf: wl,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    ae(t, this.createData());
    const s = t.ot === Te.INIT || t.ot === Te.VIDEO || t.ot === Te.MUXED;
    if (this.starved && s && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering), this.useHeaders) {
      const i = ze.toHeaders(t);
      if (!Object.keys(i).length)
        return;
      e.headers || (e.headers = {}), ae(e.headers, i);
    } else {
      const i = ze.toQuery(t);
      if (!i)
        return;
      e.url = ze.appendQueryToUri(e.url, i);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return Te.TIMED_TEXT;
    if (e.sn === "initSegment")
      return Te.INIT;
    if (t === "audio")
      return Te.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? Te.VIDEO : Te.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, s;
    const i = this.hls;
    if (e === Te.AUDIO)
      s = i.audioTracks;
    else {
      const r = i.maxAutoLevel, n = r > -1 ? r + 1 : i.levels.length;
      s = i.levels.slice(0, n);
    }
    for (const r of s)
      r.bitrate > t && (t = r.bitrate);
    return t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.hls.media, s = e === Te.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !s || !t ? NaN : J.bufferInfo(s, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, n, o) {
        t(r), this.loader.load(r, n, o);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, n, o) {
        t(r), this.loader.load(r, n, o);
      }
    };
  }
  /**
   * Generate a random v4 UUI
   *
   * @returns {string}
   */
  static uuid() {
    const e = URL.createObjectURL(new Blob()), t = e.toString();
    return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
  }
  /**
   * Serialize a CMCD data object according to the rules defined in the
   * section 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static serialize(e) {
    const t = [], s = (h) => !Number.isNaN(h) && h != null && h !== "" && h !== !1, i = (h) => Math.round(h), r = (h) => i(h / 100) * 100, o = {
      br: i,
      d: i,
      bl: r,
      dl: r,
      mtp: r,
      nor: (h) => encodeURIComponent(h),
      rtp: r,
      tb: i
    }, l = Object.keys(e || {}).sort();
    for (const h of l) {
      let c = e[h];
      if (!s(c) || h === "v" && c === 1 || h == "pr" && c === 1)
        continue;
      const d = o[h];
      d && (c = d(c));
      const u = typeof c;
      let f;
      h === "ot" || h === "sf" || h === "st" ? f = `${h}=${c}` : u === "boolean" ? f = h : u === "number" ? f = `${h}=${c}` : f = `${h}=${JSON.stringify(c)}`, t.push(f);
    }
    return t.join(",");
  }
  /**
   * Convert a CMCD data object to request headers according to the rules
   * defined in the section 2.1 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toHeaders(e) {
    const t = Object.keys(e), s = {}, i = ["Object", "Request", "Session", "Status"], r = [{}, {}, {}, {}], n = {
      br: 0,
      d: 0,
      ot: 0,
      tb: 0,
      bl: 1,
      dl: 1,
      mtp: 1,
      nor: 1,
      nrr: 1,
      su: 1,
      cid: 2,
      pr: 2,
      sf: 2,
      sid: 2,
      st: 2,
      v: 2,
      bs: 3,
      rtp: 3
    };
    for (const o of t) {
      const l = n[o] != null ? n[o] : 1;
      r[l][o] = e[o];
    }
    for (let o = 0; o < r.length; o++) {
      const l = ze.serialize(r[o]);
      l && (s[`CMCD-${i[o]}`] = l);
    }
    return s;
  }
  /**
   * Convert a CMCD data object to query args according to the rules
   * defined in the section 2.2 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toQuery(e) {
    return `CMCD=${encodeURIComponent(ze.serialize(e))}`;
  }
  /**
   * Append query args to a uri.
   */
  static appendQueryToUri(e, t) {
    if (!t)
      return e;
    const s = e.includes("?") ? "&" : "?";
    return `${e}${s}${t}`;
  }
}
const _l = 3e5;
class Cl {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = E.log.bind(E, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(m.MANIFEST_LOADING, this.onManifestLoading, this), e.on(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(m.MANIFEST_PARSED, this.onManifestParsed, this), e.on(m.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(m.MANIFEST_LOADING, this.onManifestLoading, this), e.off(m.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(m.MANIFEST_PARSED, this.onManifestParsed, this), e.off(m.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, self.clearTimeout(this.reloadTimer), this.enabled && this.uri)
      if (this.updated) {
        const e = Math.max(this.timeToLoad * 1e3 - (performance.now() - this.updated), 0);
        this.scheduleRefresh(this.uri, e);
      } else
        this.loadSteeringManifest(this.uri);
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), self.clearTimeout(this.reloadTimer);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((s) => s !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: s
    } = t;
    s !== null && (this.pathwayId = s.pathwayId, this.uri = s.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: s
    } = t;
    if ((s == null ? void 0 : s.action) === ge.SendAlternateToPenaltyBox && s.flags === _e.MoveAllAlternatesMatchingHost) {
      let i = this.pathwayPriority;
      const r = this.pathwayId;
      this.penalizedPathways[r] || (this.penalizedPathways[r] = performance.now()), !i && this.levels && (i = this.levels.reduce((n, o) => (n.indexOf(o.pathwayId) === -1 && n.push(o.pathwayId), n), [])), i && i.length > 1 && (this.updatePathwayPriority(i), s.resolved = this.pathwayId !== r);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const s = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${s}"`), t = this.getLevelsForPathway(s), this.pathwayId = s;
    }
    return t.length !== e.length ? (this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t) : e;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let t;
    const s = this.penalizedPathways, i = performance.now();
    Object.keys(s).forEach((r) => {
      i - s[r] > _l && delete s[r];
    });
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      if (s[n])
        continue;
      if (n === this.pathwayId)
        return;
      const o = this.hls.nextLoadLevel, l = this.hls.levels[o];
      if (t = this.getLevelsForPathway(n), t.length > 0) {
        this.log(`Setting Pathway to "${n}"`), this.pathwayId = n, this.hls.trigger(m.LEVELS_UPDATED, {
          levels: t
        });
        const h = this.hls.levels[o];
        l && h && this.levels && (h.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && h.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${h.bitrate}`), this.hls.nextLoadLevel = o);
        break;
      }
    }
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const s = {}, i = {};
    e.forEach((r) => {
      const {
        ID: n,
        "BASE-ID": o,
        "URI-REPLACEMENT": l
      } = r;
      if (t.some((c) => c.pathwayId === n))
        return;
      const h = this.getLevelsForPathway(o).map((c) => {
        const d = ae({}, c);
        d.details = void 0, d.url = on(c.uri, c.attrs["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l);
        const u = new ee(c.attrs);
        u["PATHWAY-ID"] = n;
        const f = u.AUDIO && `${u.AUDIO}_clone_${n}`, g = u.SUBTITLES && `${u.SUBTITLES}_clone_${n}`;
        f && (s[u.AUDIO] = f, u.AUDIO = f), g && (i[u.SUBTITLES] = g, u.SUBTITLES = g), d.attrs = u;
        const p = new Et(d);
        return Vt(p, "audio", f), Vt(p, "text", g), p;
      });
      t.push(...h), Zi(this.audioTracks, s, l, n), Zi(this.subtitleTracks, i, l, n);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, s = t.loader;
    this.loader && this.loader.destroy(), this.loader = new s(t);
    let i;
    try {
      i = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (i.protocol !== "data:") {
      const c = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      i.searchParams.set("_HLS_pathway", this.pathwayId), i.searchParams.set("_HLS_throughput", "" + c);
    }
    const r = {
      responseType: "json",
      url: i.href
    }, n = t.steeringManifestLoadPolicy.default, o = n.errorRetry || n.timeoutRetry || {}, l = {
      loadPolicy: n,
      timeout: n.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, h = {
      onSuccess: (c, d, u, f) => {
        this.log(`Loaded steering manifest: "${i}"`);
        const g = c.data;
        if (g.VERSION !== 1) {
          this.log(`Steering VERSION ${g.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = g.TTL;
        const {
          "RELOAD-URI": p,
          "PATHWAY-CLONES": v,
          "PATHWAY-PRIORITY": y
        } = g;
        if (p)
          try {
            this.uri = new self.URL(p, i).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${p}`);
            return;
          }
        this.scheduleRefresh(this.uri || u.url), v && this.clonePathways(v), y && this.updatePathwayPriority(y);
      },
      onError: (c, d, u, f) => {
        if (this.log(`Error loading steering manifest: ${c.code} ${c.text} (${d.url})`), this.stopLoad(), c.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${d.url} no longer available`);
          return;
        }
        let g = this.timeToLoad * 1e3;
        if (c.code === 429) {
          const p = this.loader;
          if (typeof (p == null ? void 0 : p.getResponseHeader) == "function") {
            const v = p.getResponseHeader("Retry-After");
            v && (g = parseFloat(v) * 1e3);
          }
          this.log(`Steering manifest ${d.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || d.url, g);
      },
      onTimeout: (c, d, u) => {
        this.log(`Timeout loading steering manifest (${d.url})`), this.scheduleRefresh(this.uri || d.url);
      }
    };
    this.log(`Requesting steering manifest: ${i}`), this.loader.load(r, l, h);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    self.clearTimeout(this.reloadTimer), this.reloadTimer = self.setTimeout(() => {
      this.loadSteeringManifest(e);
    }, t);
  }
}
function Zi(a, e, t, s) {
  a && Object.keys(e).forEach((i) => {
    const r = a.filter((n) => n.groupId === i).map((n) => {
      const o = ae({}, n);
      return o.details = void 0, o.attrs = new ee(o.attrs), o.url = o.attrs.URI = on(n.url, n.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), o.groupId = o.attrs["GROUP-ID"] = e[i], o.attrs["PATHWAY-ID"] = s, o;
    });
    a.push(...r);
  });
}
function on(a, e, t, s) {
  const {
    HOST: i,
    PARAMS: r,
    [t]: n
  } = s;
  let o;
  e && (o = n == null ? void 0 : n[e], o && (a = o));
  const l = new self.URL(a);
  return i && !o && (l.host = i), r && Object.keys(r).sort().forEach((h) => {
    h && l.searchParams.set(h, r[h]);
  }), l.href;
}
const Dl = /^age:\s*[\d.]+\s*$/im;
class ln {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = void 0, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new zt(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, s) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = s, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e)
      return;
    const s = this.loader = new self.XMLHttpRequest(), i = this.stats;
    i.loading.first = 0, i.loaded = 0, i.aborted = !1;
    const r = this.xhrSetup;
    r ? Promise.resolve().then(() => {
      if (!this.stats.aborted)
        return r(s, t.url);
    }).catch((n) => (s.open("GET", t.url, !0), r(s, t.url))).then(() => {
      this.stats.aborted || this.openAndSendXhr(s, t, e);
    }).catch((n) => {
      this.callbacks.onError({
        code: s.status,
        text: n.message
      }, t, s, i);
    }) : this.openAndSendXhr(s, t, e);
  }
  openAndSendXhr(e, t, s) {
    e.readyState || e.open("GET", t.url, !0);
    const i = this.context.headers, {
      maxTimeToFirstByteMs: r,
      maxLoadTimeMs: n
    } = s.loadPolicy;
    if (i)
      for (const o in i)
        e.setRequestHeader(o, i[o]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), s.timeout = r && M(r) ? r : n, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: s
    } = this;
    if (!e || !t)
      return;
    const i = t.readyState, r = this.config;
    if (!s.aborted && i >= 2 && (s.loading.first === 0 && (s.loading.first = Math.max(self.performance.now(), s.loading.start), r.timeout !== r.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), r.timeout = r.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.loadPolicy.maxLoadTimeMs - (s.loading.first - s.loading.start)))), i === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const n = t.status, o = t.responseType !== "text";
      if (n >= 200 && n < 300 && (o && t.response || t.responseText !== null)) {
        s.loading.end = Math.max(self.performance.now(), s.loading.first);
        const l = o ? t.response : t.responseText, h = t.responseType === "arraybuffer" ? l.byteLength : l.length;
        if (s.loaded = s.total = h, s.bwEstimate = s.total * 8e3 / (s.loading.end - s.loading.first), !this.callbacks)
          return;
        const c = this.callbacks.onProgress;
        if (c && c(s, e, l, t), !this.callbacks)
          return;
        const d = {
          url: t.responseURL,
          data: l,
          code: n
        };
        this.callbacks.onSuccess(d, s, e, t);
      } else {
        const l = r.loadPolicy.errorRetry, h = s.retry;
        Gt(l, h, !1, n) ? this.retry(l) : (E.error(`${n} while loading ${e.url}`), this.callbacks.onError({
          code: n,
          text: t.statusText
        }, e, t, s));
      }
    }
  }
  loadtimeout() {
    var e;
    const t = (e = this.config) == null ? void 0 : e.loadPolicy.timeoutRetry, s = this.stats.retry;
    if (Gt(t, s, !0))
      this.retry(t);
    else {
      E.warn(`timeout while loading ${this.context.url}`);
      const i = this.callbacks;
      i && (this.abortInternal(), i.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: s
    } = this;
    this.retryDelay = Bs(e, s.retry), s.retry++, E.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t.url}, retrying ${s.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && Dl.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function kl() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const Pl = /(\d+)-(\d+)\/(\d+)/;
class Qi {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = void 0, this.response = void 0, this.controller = void 0, this.context = void 0, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || Nl, this.controller = new self.AbortController(), this.stats = new zt();
  }
  destroy() {
    this.loader = this.callbacks = null, this.abortInternal();
  }
  abortInternal() {
    const e = this.response;
    e != null && e.ok || (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, s) {
    const i = this.stats;
    if (i.loading.start)
      throw new Error("Loader can only be used once.");
    i.loading.start = self.performance.now();
    const r = Ol(e, this.controller.signal), n = s.onProgress, o = e.responseType === "arraybuffer", l = o ? "byteLength" : "length", {
      maxTimeToFirstByteMs: h,
      maxLoadTimeMs: c
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = s, this.request = this.fetchSetup(e, r), self.clearTimeout(this.requestTimeout), t.timeout = h && M(h) ? h : c, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), s.onTimeout(i, e, this.response);
    }, t.timeout), self.fetch(this.request).then((d) => {
      this.response = this.loader = d;
      const u = Math.max(self.performance.now(), i.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = c, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), s.onTimeout(i, e, this.response);
      }, c - (u - i.loading.start)), !d.ok) {
        const {
          status: f,
          statusText: g
        } = d;
        throw new Ul(g || "fetch, bad network response", f, d);
      }
      return i.loading.first = u, i.total = Ml(d.headers) || i.total, n && M(t.highWaterMark) ? this.loadProgressively(d, i, e, t.highWaterMark, n) : o ? d.arrayBuffer() : e.responseType === "json" ? d.json() : d.text();
    }).then((d) => {
      const {
        response: u
      } = this;
      self.clearTimeout(this.requestTimeout), i.loading.end = Math.max(self.performance.now(), i.loading.first);
      const f = d[l];
      f && (i.loaded = i.total = f);
      const g = {
        url: u.url,
        data: d,
        code: u.status
      };
      n && !M(t.highWaterMark) && n(i, e, d, u), s.onSuccess(g, i, e, u);
    }).catch((d) => {
      if (self.clearTimeout(this.requestTimeout), i.aborted)
        return;
      const u = d && d.code || 0, f = d ? d.message : null;
      s.onError({
        code: u,
        text: f
      }, e, d ? d.details : null, i);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, s, i = 0, r) {
    const n = new Xr(), o = e.body.getReader(), l = () => o.read().then((h) => {
      if (h.done)
        return n.dataLength && r(t, s, n.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const c = h.value, d = c.length;
      return t.loaded += d, d < i || n.dataLength ? (n.push(c), n.dataLength >= i && r(t, s, n.flush(), e)) : r(t, s, c, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function Ol(a, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(ae({}, a.headers))
  };
  return a.rangeEnd && t.headers.set("Range", "bytes=" + a.rangeStart + "-" + String(a.rangeEnd - 1)), t;
}
function Fl(a) {
  const e = Pl.exec(a);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function Ml(a) {
  const e = a.get("Content-Range");
  if (e) {
    const s = Fl(e);
    if (M(s))
      return s;
  }
  const t = a.get("Content-Length");
  if (t)
    return parseInt(t);
}
function Nl(a, e) {
  return new self.Request(a.url, e);
}
class Ul extends Error {
  constructor(e, t, s) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = s;
  }
}
const $l = /\s/, Bl = {
  newCue(a, e, t, s) {
    const i = [];
    let r, n, o, l, h;
    const c = self.VTTCue || self.TextTrackCue;
    for (let u = 0; u < s.rows.length; u++)
      if (r = s.rows[u], o = !0, l = 0, h = "", !r.isEmpty()) {
        var d;
        for (let p = 0; p < r.chars.length; p++)
          $l.test(r.chars[p].uchar) && o ? l++ : (h += r.chars[p].uchar, o = !1);
        r.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const f = sn(h.trim()), g = Zs(e, t, f);
        a != null && (d = a.cues) != null && d.getCueById(g) || (n = new c(e, t, f), n.id = g, n.line = u + 1, n.align = "left", n.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), i.push(n));
      }
    return a && i.length && (i.sort((u, f) => u.line === "auto" || f.line === "auto" ? 0 : u.line > 8 && f.line > 8 ? f.line - u.line : u.line - f.line), i.forEach((u) => wr(a, u))), i;
  }
}, Gl = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Vl = Le(Le({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: ln,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: Yo,
  bufferController: tl,
  capLevelController: Qs,
  errorController: Na,
  fpsController: Rl,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: mr,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  certLoadPolicy: {
    default: Gl
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, Hl()), {}, {
  subtitleStreamController: Zo,
  subtitleTrackController: Jo,
  timelineController: bl,
  audioStreamController: jo,
  audioTrackController: qo,
  emeController: dt,
  cmcdController: ze,
  contentSteeringController: Cl
});
function Hl() {
  return {
    cueHandler: Bl,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function Kl(a, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const t = Cs(a), s = ["manifest", "level", "frag"], i = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return s.forEach((r) => {
    const n = `${r === "level" ? "playlist" : r}LoadPolicy`, o = e[n] === void 0, l = [];
    i.forEach((h) => {
      const c = `${r}Loading${h}`, d = e[c];
      if (d !== void 0 && o) {
        l.push(c);
        const u = t[n].default;
        switch (e[n] = {
          default: u
        }, h) {
          case "TimeOut":
            u.maxLoadTimeMs = d, u.maxTimeToFirstByteMs = d;
            break;
          case "MaxRetry":
            u.errorRetry.maxNumRetry = d, u.timeoutRetry.maxNumRetry = d;
            break;
          case "RetryDelay":
            u.errorRetry.retryDelayMs = d, u.timeoutRetry.retryDelayMs = d;
            break;
          case "MaxRetryTimeout":
            u.errorRetry.maxRetryDelayMs = d, u.timeoutRetry.maxRetryDelayMs = d;
            break;
        }
      }
    }), l.length && E.warn(`hls.js config: "${l.join('", "')}" setting(s) are deprecated, use "${n}": ${JSON.stringify(e[n])}`);
  }), Le(Le({}, t), e);
}
function Cs(a) {
  return a && typeof a == "object" ? Array.isArray(a) ? a.map(Cs) : Object.keys(a).reduce((e, t) => (e[t] = Cs(a[t]), e), {}) : a;
}
function Wl(a) {
  const e = a.loader;
  e !== Qi && e !== ln ? (E.log("[config]: Custom loader detected, cannot enable progressive streaming"), a.progressive = !1) : kl() && (a.loader = Qi, a.progressive = !0, a.enableSoftwareAES = !0, E.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
class He {
  /**
   * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
   */
  /**
   * The configuration object provided on player instantiation.
   */
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.4.12";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isSupported() {
    return so();
  }
  static get Events() {
    return m;
  }
  static get ErrorTypes() {
    return U;
  }
  static get ErrorDetails() {
    return L;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return He.defaultConfig ? He.defaultConfig : Vl;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    He.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new qs(), this._autoLevelCapping = void 0, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, wn(e.debug || !1, "Hls instance");
    const t = this.config = Kl(He.DefaultConfig, e);
    this.userConfig = e, this._autoLevelCapping = -1, t.progressive && Wl(t);
    const {
      abrController: s,
      bufferController: i,
      capLevelController: r,
      errorController: n,
      fpsController: o
    } = t, l = new n(this), h = this.abrController = new s(this), c = this.bufferController = new i(this), d = this.capLevelController = new r(this), u = new o(this), f = new ya(this), g = new ba(this), p = t.contentSteeringController, v = p ? new p(this) : null, y = this.levelController = new $a(this, v), T = new Ba(this), x = new Va(this.config), A = this.streamController = new Ko(this, T, x);
    d.setStreamController(A), u.setStreamController(A);
    const b = [f, y, A];
    v && b.splice(1, 0, v), this.networkControllers = b;
    const C = [h, c, d, u, g, T];
    this.audioTrackController = this.createController(t.audioTrackController, b);
    const I = t.audioStreamController;
    I && b.push(new I(this, T, x)), this.subtitleTrackController = this.createController(t.subtitleTrackController, b);
    const _ = t.subtitleStreamController;
    _ && b.push(new _(this, T, x)), this.createController(t.timelineController, C), x.emeController = this.emeController = this.createController(t.emeController, C), this.cmcdController = this.createController(t.cmcdController, C), this.latencyController = this.createController(La, C), this.coreComponents = C, b.push(l);
    const D = l.onErrorOut;
    typeof D == "function" && this.on(m.ERROR, D, l);
  }
  createController(e, t) {
    if (e) {
      const s = new e(this);
      return t && t.push(s), s;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, s = this) {
    this._emitter.on(e, t, s);
  }
  once(e, t, s = this) {
    this._emitter.once(e, t, s);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, s = this, i) {
    this._emitter.off(e, t, s, i);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, s) {
    return this._emitter.emit(e, t, s);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (s) {
      E.error("An internal error happened while handling event " + e + '. Error message: "' + s.message + '". Here is a stacktrace:', s), this.trigger(m.ERROR, {
        type: U.OTHER_ERROR,
        details: L.INTERNAL_EXCEPTION,
        fatal: !1,
        event: e,
        error: s
      });
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    E.log("destroy"), this.trigger(m.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    E.log("attachMedia"), this._media = e, this.trigger(m.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    E.log("detachMedia"), this.trigger(m.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, s = this.url, i = this.url = Ns.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    E.log(`loadSource:${i}`), t && s && (s !== i || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(m.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    E.log(`startLoad(${e})`), this.networkControllers.forEach((t) => {
      t.startLoad(e);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    E.log("stopLoad"), this.networkControllers.forEach((e) => {
      e.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    E.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    E.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e, t = 0) {
    this.levelController.removeLevel(e, t);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, BANDWIDTH, SCORE, and RESOLUTION (height)
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    E.log(`set currentLevel:${e}`), this.loadLevel = e, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    E.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    E.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    E.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  get startLevel() {
    return this.levelController.startLevel;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    E.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (E.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e);
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    As.indexOf(e) > -1 && (this._maxHdcpLevel = e);
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e)
      return 0;
    const s = e.length;
    for (let i = 0; i < s; i++)
      if (e[i].maxBitrate >= t)
        return i;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: s
    } = this;
    let i;
    if (t === -1 && e && e.length ? i = e.length - 1 : i = t, s)
      for (let r = i; r--; ) {
        const n = e[r].attrs["HDCP-LEVEL"];
        if (n && n <= s)
          return r;
      }
    return i;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, e);
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
He.defaultConfig = void 0;
function Yl() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function zl() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function Ds(a) {
  const { id: e, key: t, src: s, playlist: i, duration: r } = a;
  return new Promise((n) => {
    let o = null;
    const l = document.createElement("video");
    if (l.playsInline = !0, l.muted = !0, l.loop = !1, i && !Yl() && He.isSupported()) {
      let h = !1;
      o = new He({
        autoStartLoad: !0,
        xhrSetup: (c) => {
          const { open: d } = c, u = i.split("?")[1];
          c.open = function(f, g, p) {
            g.toString().includes("?") || (g += "?" + u), d.apply(this, [f, g, p]);
          };
        }
      }), o.loadSource(i), o.attachMedia(l), o.startLoadOnce = (c = -1, d) => {
        if (o && !h) {
          const u = o == null ? void 0 : o.levels.findIndex((f) => Math.min(f.height, f.width) === d);
          o.startLevel = o.firstLevel, o.startLoad(c), h = !0, o.currentLevel = u !== -1 ? u : o.firstLevel;
        }
      }, o.on(He.Events.LEVEL_LOADED, async () => {
        h || o == null || o.stopLoad(), n({
          id: e,
          key: t,
          hls: o,
          config: a,
          node: l
        });
      });
    } else {
      l.src = s;
      let h = !1;
      if (l.startLoadOnce = () => {
        h || (l.preload = "auto", l.load(), h = !0);
      }, r)
        l.preload = "none", n({
          id: e,
          key: t,
          hls: o,
          config: a,
          node: l
        });
      else {
        l.preload = "metadata";
        const c = async () => {
          n({
            id: e,
            key: t,
            hls: o,
            config: a,
            node: l
          }), l.removeEventListener("loadedmetadata", c);
        };
        l.addEventListener("loadedmetadata", c);
      }
    }
  });
}
async function hn(a) {
  return a.duration === 1 / 0 ? new Promise((e) => {
    a.currentTime = Number.MAX_SAFE_INTEGER, a.ontimeupdate = () => {
      a.ontimeupdate = null, e(a.duration), a.currentTime = 0;
    };
  }) : a.duration;
}
const jl = ct(
  async function(e) {
    return new FontFace(e.name, `url(${e.woff2 ?? e.url})`, {
      style: e.style,
      weight: e.weight
    }).load();
  },
  {
    cacheKey: ([a]) => JSON.stringify(a)
  }
);
let ql = class {
  constructor(e) {
    this._hasPlayed = !1, this._memoKey = null, this._lastDeps = null, this._duration = 0, this._scenes = null, this._videos = {}, this._videoMeta = {}, this._videoState = {}, this._resolveVideo = ct(
      async (t) => {
        const { id: s, key: i } = t, r = await Ds(t);
        r.node.volume = this.host.volume, r.node.playbackRate = this.host.playbackRate;
        const n = {
          loadeddata: this._handleLoadedData,
          waiting: this._handleWaiting,
          canplay: this._handleCanPlay,
          progress: this._handleProgress,
          seeking: this._handleSeeking,
          seeked: this._handleSeeked,
          play: this._handlePlay,
          playing: this._handlePlaying,
          pause: this._handlePause,
          stalled: this._handleStalled,
          timeupdate: this._handleTimeUpdate,
          ended: this._handleEnded,
          error: this._handleError
        }, o = Object.keys(n).reduce((l, h) => {
          const c = h, d = n[c]({ id: s, key: i, node: r.node });
          return l[c] = d, r.node.addEventListener(h, d), l;
        }, {});
        return {
          ...r,
          listeners: o
        };
      },
      {
        cacheKey: ([{ id: t, key: s, src: i, playlist: r }]) => JSON.stringify({ id: t, key: s, src: i == null ? void 0 : i.split("?")[0], playlist: r == null ? void 0 : r.split("?")[0] })
      }
    ), this._resolveVideoMeta = ct(
      async (t, s) => {
        const { id: i, captions: r, duration: n, startOffset: o, endOffset: l } = t, h = n ?? await hn(s), c = (o ?? 0) * h, d = (1 - (l ?? 0)) * h;
        return {
          id: i,
          captions: r,
          start: c,
          duration: d - c
        };
      },
      {
        cacheKey: ([{ id: t, key: s, captions: i, duration: r, startOffset: n, endOffset: o }]) => JSON.stringify({ id: t, key: s, captions: i, duration: r, startOffset: n, endOffset: o })
      }
    ), this._handleLoadedData = ({ id: t, key: s, node: i }) => () => {
      var n, o;
      const r = this.videoState[s];
      if (!(r != null && r.initialised)) {
        this.videoState = {
          ...this.videoState,
          [s]: {
            ...r,
            initialised: !0,
            waiting: !1,
            // Sometimes the video seems to buffer before the onloadeddata callback is fired :/
            buffered: (r == null ? void 0 : r.buffered) ?? []
          }
        };
        const l = (o = (n = this.scenes) == null ? void 0 : n.scenes) == null ? void 0 : o.find(({ video: h }) => {
          h == null || h.key;
        });
        l && this._setVideoCurrentTime({
          scene: l,
          time: this.host.currentTime
        }), this.host.dispatchEvent(new CustomEvent("video:loadeddata", { detail: { id: t, key: s, node: i } }));
      }
    }, this._handleWaiting = ({ key: t }) => () => {
      const s = this.videoState[t];
      s != null && s.initialised && !(s != null && s.waiting) && (this.videoState = {
        ...this.videoState,
        [t]: {
          ...s,
          waiting: !0
        }
      });
    }, this._handleCanPlay = ({ key: t }) => () => {
      const s = this.videoState[t];
      s != null && s.initialised && (s != null && s.waiting) && (this.videoState = {
        ...this.videoState,
        [t]: {
          ...s,
          waiting: !1
        }
      }), this.host.paused && this.host.draw();
    }, this._handleProgress = ({ key: t, node: s }) => () => {
      const i = this.videoState[t], r = this._getBufferSegments({ key: t, node: s, duration: this.host.duration });
      this.videoState = {
        ...this.videoState,
        [t]: {
          ...i,
          buffered: r
        }
      };
    }, this._handleSeeking = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:seeking", { detail: { id: t, key: s, node: i } }));
    }, this._handleSeeked = ({ id: t, key: s, node: i }) => () => {
      const r = this.videoState[s];
      r != null && r.initialised && (this.host.draw(), this.host.dispatchEvent(new CustomEvent("video:seeked", { detail: { id: t, key: s, node: i } })));
    }, this._handlePlay = ({ id: t, key: s, node: i }) => () => {
      this.hasPlayed = !0, this.host.dispatchEvent(new CustomEvent("video:play", { detail: { id: t, key: s, node: i } }));
    }, this._handlePlaying = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:playing", { detail: { id: t, key: s, node: i } }));
    }, this._handlePause = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:pause", { detail: { id: t, key: s, node: i } }));
    }, this._handleStalled = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:stalled", { detail: { id: t, key: s, node: i } }));
    }, this._handleTimeUpdate = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:timeupdate", { detail: { id: t, key: s, node: i } }));
    }, this._handleEnded = ({ id: t, key: s, node: i }) => () => {
      this.host.dispatchEvent(new CustomEvent("video:ended", { detail: { id: t, key: s, node: i } }));
    }, this._handleError = ({ id: t, key: s, node: i }) => () => {
      const r = new Ne(`Video error - answer ${t} failed to load`);
      this.host.dispatchEvent(
        new ErrorEvent("error", { bubbles: !0, composed: !0, error: r, message: r.message })
      ), this.host.dispatchEvent(new CustomEvent("video:error", { detail: { id: t, key: s, node: i } }));
    }, this._cleanupVideo = (t) => {
      var i;
      const s = this.videos[t];
      s && (s.node.pause(), s.node.src = "", (i = s.hls) == null || i.destroy(), Object.keys(s.listeners ?? {}).forEach((r) => {
        var n, o;
        if ((n = this.videos) != null && n[t]) {
          const l = (o = s.listeners) == null ? void 0 : o[r];
          l && s.node.removeEventListener(r, l);
        }
      }), delete this.videos[t]);
    }, this.host = e, this.host.addController(this);
  }
  set hasPlayed(e) {
    e !== this._hasPlayed && (this._hasPlayed = e, this.host.requestUpdate());
  }
  get hasPlayed() {
    return this._hasPlayed;
  }
  set duration(e) {
    !isNaN(e) && e !== this._duration && (this._duration = e, this.host.requestUpdate(), this.host.dispatchEvent(new CustomEvent("durationchange", { detail: this._duration })));
  }
  get duration() {
    return this._duration;
  }
  set scenes(e) {
    e !== this._scenes && (this._scenes = e, this.host.requestUpdate());
  }
  get scenes() {
    return this._scenes;
  }
  set videos(e) {
    e !== this._videos && (this._videos = e, this.host.requestUpdate());
  }
  get videos() {
    return this._videos;
  }
  set videoMeta(e) {
    e !== this._videoMeta && (this._videoMeta = e, this.host.requestUpdate());
  }
  get videoMeta() {
    return this._videoMeta;
  }
  set videoState(e) {
    e !== this._videoState && (this._videoState = e, this.host.requestUpdate());
  }
  get videoState() {
    return this._videoState;
  }
  _getBufferSegments({
    key: e,
    node: t,
    duration: s
  }) {
    var h;
    const i = t == null ? void 0 : t.buffered, r = [], { start: n, video: o, videoMeta: l } = ((h = this.scenes) == null ? void 0 : h.scenes.find(({ video: c }) => e === (c == null ? void 0 : c.key))) ?? {};
    if (t && i && o && l && typeof n < "u")
      for (let c = 0; c < i.length; c++) {
        const d = i.start(c), u = i.end(c);
        Math.max(d, l.start) <= Math.min(u, l.start + l.duration) && r.push({
          // We need to offset the start and end of the buffer by the start time of this video's place in the compilation
          start: Math.max(0, (Math.max(d - l.start, 0) + n) / s * 100),
          end: Math.min((Math.min(u - l.start, l.duration) + n) / s * 100, 100)
        });
      }
    return r;
  }
  _setupTask() {
    new ar(
      this.host,
      async ([e, t, s, i, r, n]) => {
        try {
          let o = null;
          if (this.host._errors = [], s || e) {
            if (this.host._processing = !0, s) {
              let c = null;
              if (i)
                try {
                  c = await (await fetch(i, { method: "GET" })).text();
                } catch (f) {
                  const g = new Ne("Track failed to fetch", f);
                  this.host.dispatchEvent(
                    new ErrorEvent("error", {
                      composed: !0,
                      bubbles: !0,
                      error: g,
                      message: g.message
                    })
                  );
                }
              const u = {
                questions: {
                  items: [
                    {
                      answer: {
                        id: "source",
                        media: {
                          [s.includes(".m3u8") ? "playlist" : "video"]: s
                        },
                        captions: {
                          current: c
                        }
                      }
                    }
                  ]
                }
              };
              try {
                this.scenes = await lt(
                  {
                    data: u,
                    template: t,
                    burnCaptions: r,
                    debug: n
                  },
                  this._resolveVideo,
                  this._resolveVideoMeta
                );
              } catch (f) {
                try {
                  this.scenes = await lt(
                    {
                      data: u,
                      burnCaptions: r,
                      debug: n
                    },
                    this._resolveVideo,
                    this._resolveVideoMeta
                  );
                } catch (g) {
                  throw new Ne("Fatal source template error", g, !0);
                }
                o = new Ne("Source template error", f);
              }
            } else
              try {
                this.scenes = await lt(
                  { data: e, template: t, burnCaptions: r, debug: n },
                  this._resolveVideo,
                  this._resolveVideoMeta
                );
              } catch (c) {
                try {
                  this.scenes = await lt(
                    { data: e, burnCaptions: r, debug: n },
                    this._resolveVideo,
                    this._resolveVideoMeta
                  );
                } catch (d) {
                  throw new Ne("Fatal data template error", d, !0);
                }
                o = new Ne("Data template error", c);
              }
            Object.keys(this.videos).forEach((c) => {
              this.scenes.scenes.find(({ video: d }) => c === (d == null ? void 0 : d.key)) || this._videos[c].node.pause();
            });
            const l = this.scenes.scenes.reduce((c, { video: d }) => (d && (c[d.key] = d), c), {});
            Object.keys(this.videos).join("|") !== Object.keys(l).join("|") && this.host.reset(0, !1), this.videos = l, this.videoState = {
              ...this.videoState,
              ...this.scenes.scenes.reduce((c, { video: d, start: u, duration: f }) => {
                var v;
                const g = (d == null ? void 0 : d.key) ?? `${u}-${f}`, p = this._getBufferSegments({
                  key: g,
                  node: d == null ? void 0 : d.node,
                  duration: this.scenes.duration
                });
                return c[g] = {
                  // @ts-ignore
                  initialised: !d,
                  // @ts-ignore
                  waiting: !!d,
                  ...this.videoState[g],
                  buffered: d ? p : (v = this.videoState[g]) == null ? void 0 : v.buffered
                }, c;
              }, {})
            }, this.videoMeta = this.scenes.scenes.reduce((c, { video: d, videoMeta: u }) => (d && u && (c[d.key] = u), c), {}), (await Promise.all(this.scenes.fonts.map((c) => jl(c)))).forEach((c) => {
              document.fonts.add(c);
            }), this.duration = this.scenes.duration, this.host.paused && this.host.reset(this.host.currentTime, !this.host.paused);
          }
          o && this.host.dispatchEvent(
            new ErrorEvent("error", {
              composed: !0,
              bubbles: !0,
              error: o,
              message: o.message
            })
          );
        } catch (o) {
          this.scenes = null, this.duration = 0, this.host.dispatchEvent(
            new ErrorEvent("error", { composed: !0, bubbles: !0, error: o, message: o.message })
          );
        } finally {
          this.host._processing = !1;
        }
      },
      () => {
        const e = JSON.stringify({
          data: this.host.data,
          template: this.host.template,
          src: this.host.src,
          track: this.host.track,
          burnCaptions: this.host.burnCaptions,
          debug: this.host.debug
        });
        if (this._lastDeps && this._memoKey === e)
          return this._lastDeps;
        const t = [
          this.host.data,
          this.host.template,
          this.host.src,
          this.host.track,
          this.host.burnCaptions,
          this.host.debug
        ];
        return this._memoKey = e, this._lastDeps = t, t;
      }
    );
  }
  _setVideoCurrentTime({ time: e, scene: t }) {
    const { start: s, video: i, videoMeta: r } = t;
    if (i && i.node && r && typeof s < "u") {
      const n = e - s;
      i.node.currentTime = Math.max(
        // The lower bound is the trimmed video start
        r.start,
        Math.min(
          // The upper bound is the trimmed video end
          r.start + r.duration,
          // This is the time of the video as it's active
          n + r.start
        )
      );
    }
  }
  setVideosCurrentTime(e) {
    var t;
    (t = this.scenes) == null || t.scenes.forEach((s) => {
      this._setVideoCurrentTime({ time: e, scene: s });
    });
  }
  hostConnected() {
    this._setupTask();
  }
  hostDisconnected() {
    Object.keys(this.videos).forEach((e) => {
      this._cleanupVideo(e);
    }), this.videos = {};
  }
};
function Xl(a) {
  a.requestFullscreen ? a.requestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen ? a.webkitRequestFullscreen() : a.msRequestFullscreen && a.msRequestFullscreen();
}
function Zl() {
  document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
}
const Js = [
  "progress",
  "play-large",
  "navigation",
  "play",
  "volume",
  "current-time",
  "duration",
  "speed",
  "captions",
  "fullscreen",
  "preview"
], Ql = {
  id: "captions",
  event: "captions:click",
  label: "Closed Captions"
}, Jl = {
  id: "fullscreen",
  event: "fullscreen:click",
  label: "Full Screen"
}, cn = {
  title: "Playback Speed",
  items: [
    {
      id: "playback-rate-0.5",
      event: "playbackRate:click",
      label: "0.5x",
      value: 0.5
    },
    {
      id: "playback-rate-1",
      event: "playbackRate:click",
      label: "1.0x",
      value: 1
    },
    {
      id: "playback-rate-1.5",
      event: "playbackRate:click",
      label: "1.5x",
      value: 1.5
    },
    {
      id: "playback-rate-2",
      event: "playbackRate:click",
      label: "2.0x",
      value: 2
    }
  ]
}, eh = {
  id: "playbackRate",
  label: "Playback playbackRate",
  subItems: cn
};
class th extends vn {
  constructor(e) {
    if (super(e), this.element = null, this.observer = void 0, e.type !== lr.ELEMENT)
      throw new Error("Resize directive must be used in an Element expression");
  }
  disconnected() {
    var e;
    (e = this.observer) == null || e.disconnect(), this.observer = void 0;
  }
  reconnected() {
    var e;
    this.element && ((e = this.observer) == null || e.observe(this.element));
  }
  update(e, [t]) {
    return this.isConnected && !this.observer && (this.observer = new ResizeObserver(t), this.element = e.element, this.observer.observe(this.element)), nr;
  }
}
const ei = or(th);
var Ji = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function sh(a, e) {
  return !!(a === e || Ji(a) && Ji(e));
}
function ih(a, e) {
  if (a.length !== e.length)
    return !1;
  for (var t = 0; t < a.length; t++)
    if (!sh(a[t], e[t]))
      return !1;
  return !0;
}
function rh(a, e) {
  e === void 0 && (e = ih);
  var t = null;
  function s() {
    for (var i = [], r = 0; r < arguments.length; r++)
      i[r] = arguments[r];
    if (t && t.lastThis === this && e(i, t.lastArgs))
      return t.lastResult;
    var n = a.apply(this, i);
    return t = {
      lastResult: n,
      lastArgs: i,
      lastThis: this
    }, n;
  }
  return s.clear = function() {
    t = null;
  }, s;
}
const nh = rh(() => {
  const a = new FontFace(
    "Roobert",
    "url(https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/Roobert-Regular.woff2)",
    {
      style: "normal",
      weight: "400"
    }
  ), e = new FontFace(
    "Roobert",
    "url(https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/Roobert-SemiBold.woff2)",
    {
      style: "normal",
      weight: "600"
    }
  ), t = new FontFace(
    "Roobert Captions",
    "url(https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/Roobert-Regular.woff2)",
    {
      style: "normal",
      weight: "400"
    }
  ), s = gn.map((i) => ({
    load: !1,
    font: new FontFace(i.family, `url(${i.url})`, {
      style: i.style
    })
  }));
  return [
    { load: !0, font: a },
    { load: !0, font: e },
    { load: !0, font: t },
    ...s
  ];
}), Fe = {
  "red-120": "#feeded",
  "red-130": "#fcd5d0",
  "red-400": "#e84a4a",
  "red-500": "#c51c3a",
  "red-700": "#a21c39",
  "red-800": "#850231",
  "red-900": "#580A2D",
  "teal-80": "#f3fafa",
  "teal-100": "#d6f1f1",
  "teal-200": "#ace3e3",
  "teal-300": "#7acace",
  "teal-400": "#4faab2",
  "teal-500": "#358f97",
  "teal-600": "#287179",
  "teal-700": "#22555c",
  "teal-800": "#21484e",
  "teal-900": "#1f3d42",
  "teal-950": "#0d2126",
  "purple-100": "#d7cfff",
  "purple-700": "#5f2fe9",
  "green-200": "#a4d7aa",
  "green-500": "#38b319",
  "green-800": "#2b3c2f",
  "grey-100": "#f0f0f0",
  "light-50": "rgba(255, 255, 255, .05)",
  "light-100": "rgba(255, 255, 255, .1)",
  "light-200": "rgba(255, 255, 255, .2)",
  "light-400": "rgba(255, 255, 255, .4)",
  "light-500": "rgba(255, 255, 255, .5)",
  "light-640": "rgba(255, 255, 255, .64)",
  "light-800": "rgba(255, 255, 255, .8)",
  "light-1000": "#fff",
  "dark-50": "rgba(0, 0, 0, .05)",
  "dark-80": "rgba(0, 0, 0, .08)",
  "dark-100": "rgba(0, 0, 0, .1)",
  "dark-200": "rgba(0, 0, 0, .2)",
  "dark-250": "rgba(0, 0, 0, .25)",
  "dark-400": "rgba(0, 0, 0, .4)",
  "dark-500": "rgba(0, 0, 0, .5)",
  "dark-640": "rgba(0, 0, 0, .64)",
  "dark-800": "rgba(0, 0, 0, .8)",
  "dark-900": "rgba(0, 0, 0, .9)",
  "dark-1000": "#000"
}, ah = {
  colors: Fe,
  space: {
    xxs: ".25rem",
    xs: ".5rem",
    small: ".75rem",
    medium: "1rem",
    large: "1.5rem",
    xl: "2.5rem"
  },
  sizes: {
    xxs: "1rem",
    xs: "1.5rem",
    small: "2rem",
    medium: "2.5rem",
    large: "3rem"
  },
  fontWeights: {
    regular: 400,
    semibold: 600
  },
  lineHeights: {
    small: 1.1,
    medium: 1.25,
    large: 1.4
  },
  letterSpacings: {
    xxs: "-.04rem",
    xs: "-.03rem",
    small: "-.02rem",
    medium: "-.01rem",
    large: 0
  },
  fontSizes: {
    micro: ".625rem",
    small: ".75rem",
    medium: ".875rem",
    large: "1rem",
    xl: "1.25rem",
    xxl: "1.5rem",
    xxxl: "2rem",
    huge: "2.75rem"
  },
  fontFamilies: {
    sans: 'Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,"Noto Sans", "Noto Color Emoji", sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", "Apple Color Emoji"',
    mono: '"Maison Neue Mono", Menlo, Monaco, Consolas, Liberation Mono, "Courier New", monospace'
  },
  borderWidths: {
    thin: ".0625rem"
  },
  radii: {
    small: ".25rem",
    medium: ".5rem",
    large: ".75rem",
    xl: "1rem"
  },
  shadows: {
    small: `.25rem .25rem .25rem ${Fe["dark-100"]}`,
    medium: `0 .125rem .625rem ${Fe["dark-100"]}`,
    large: `0 .25rem 1rem ${Fe["dark-50"]}`,
    xl: `.25rem .25rem 1rem ${Fe["dark-250"]}`,
    xxl: `0 .25rem 2rem ${Fe["dark-100"]}`,
    xxxl: `.25rem .25rem 3rem ${Fe["dark-250"]}`,
    toolbar: `0 -.625rem .625rem ${Fe["dark-50"]}`,
    text: `0 0 .25rem ${Fe["dark-250"]}`
  },
  timings: {
    fast: ".1s",
    normal: ".2s",
    slow: ".3s"
  },
  easings: {
    linear: "linear"
  },
  focusOutline: {
    width: ".2rem",
    color: Fe["dark-400"]
  },
  iconSizes: {
    small: "0.75rem",
    medium: "1rem",
    large: "1.5rem"
  }
}, er = Tn.flatten(ah, { delimiter: "-" }), oh = Object.keys(er).map((a) => Yt(`:host { --${a}: ${er[a]}; }`)), lh = (a) => {
  class e extends a {
    // Add fonts to parent document as long as they don't exist already
    firstUpdated() {
      nh().forEach(({ load: i, font: r }) => {
        document.fonts.add(r), i && r.load();
      });
    }
  }
  return e.styles = [
    (a == null ? void 0 : a.styles) ?? [],
    oh,
    me`
        :host {
          font-family: var(--fontFamilies-sans);
          font-size: var(--fontSizes-medium);
          line-height: var(--lineHeights-medium);
          font-weight: var(--fontWeights-regular);
        }
      `,
    // Reset
    me`
        *,
        *::before,
        *::after,
        ::slotted(*) {
          box-sizing: border-box;
        }

        body,
        h1,
        h2,
        h3,
        h4,
        p,
        figure,
        blockquote,
        dl,
        dd,
        ::slotted(h1),
        ::slotted(h2),
        ::slotted(h3),
        ::slotted(h4),
        ::slotted(p),
        ::slotted(figure),
        ::slotted(blockquote),
        ::slotted(dl),
        ::slotted(dd) {
          margin: 0;
        }

        ul[role='list'],
        ol[role='list'],
        ::slotted(ul[role='list']),
        ::slotted(ol[role='list']) {
          list-style: none;
        }

        a:not([class]),
        ::slotted(a:not([class])) {
          text-decoration-skip-ink: auto;
        }

        img,
        picture,
        ::slotted(img),
        ::slotted(picture) {
          max-width: 100%;
          display: block;
        }

        input,
        button,
        textarea,
        select,
        ::slotted(input),
        ::slotted(button),
        ::slotted(textarea),
        ::slotted(select) {
          font: inherit;
        }

        @media (prefers-reduced-motion) {
          *,
          *::before,
          *::after,
          ::slotted(*),
          ::slotted(*::before),
          ::slotted(*::after) {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
          }
        }
      `
  ], e;
}, j = lh(pn), hh = (a, e) => (typeof window < "u" && (window.customElements.get(a) ?? window.customElements.define(a, e)), e), ch = (a, e) => {
  const { kind: t, elements: s } = e;
  return {
    kind: t,
    elements: s,
    // This callback is called once the class is otherwise fully defined
    finisher(i) {
      typeof window < "u" && (window.customElements.get(a) ?? window.customElements.define(a, i));
    }
  };
}, ye = (a) => (e) => typeof e == "function" ? hh(a, e) : ch(a, e);
class dh {
  constructor(e) {
    this._memoKey = null, this._lastDeps = null, this._scenes = null, this._video = null, this._handleSeeked = () => {
      this.host._draw();
    }, this._resolveVideo = ct(
      async (t) => {
        const s = await Ds(t);
        return s.node.play = async () => {
        }, s.node.addEventListener("seeked", this._handleSeeked), s;
      },
      {
        cacheKey: ([{ id: t, src: s, playlist: i }]) => JSON.stringify({ id: t, src: s == null ? void 0 : s.split("?")[0], playlist: i == null ? void 0 : i.split("?")[0] })
      }
    ), this._resolveAnswer = ct(
      async (t) => {
        const { id: s, key: i, poster: r } = t, { node: n } = await Ds(t), o = new Image();
        return {
          id: s,
          key: i,
          config: t,
          node: n,
          getSource: () => (r && o.src !== r && (o.onload = () => {
            this.host._draw();
          }, o.src = r), o)
        };
      },
      {
        cacheKey: ([{ id: t, src: s, playlist: i, poster: r }]) => JSON.stringify({
          id: t,
          src: s == null ? void 0 : s.split("?")[0],
          playlist: i == null ? void 0 : i.split("?")[0],
          poster: r == null ? void 0 : r.split("?")[0]
        })
      }
    ), this._resolveVideoMeta = ct(
      async (t, s) => {
        const { id: i, duration: r, startOffset: n, endOffset: o } = t, l = r ?? await hn(s), h = (n ?? 0) * l, c = (1 - (o ?? 0)) * l;
        return {
          id: i,
          start: h,
          duration: c - h
        };
      },
      {
        cacheKey: ([{ id: t, duration: s, startOffset: i, endOffset: r }]) => JSON.stringify({ id: t, duration: s, startOffset: i, endOffset: r })
      }
    ), this.host = e, this.host.addController(this);
  }
  set scenes(e) {
    e !== this._scenes && (this._scenes = e, this.host.requestUpdate());
  }
  get scenes() {
    return this._scenes;
  }
  _setupTask() {
    new ar(
      this.host,
      async ([e, t, s]) => {
        var i, r;
        try {
          if (e) {
            const n = e.includes(".m3u8") ? "playlist" : "video";
            try {
              this.scenes = await lt(
                {
                  data: {
                    questions: {
                      items: [
                        {
                          answer: {
                            id: "source",
                            media: {
                              [n]: e
                            }
                          }
                        }
                      ]
                    }
                  },
                  template: s
                },
                this._resolveVideo,
                this._resolveVideoMeta
              );
            } catch (o) {
              throw new Ne("Video preview source template error", o);
            }
            this._video = ((r = (i = this.scenes.scenes[0]) == null ? void 0 : i.video) == null ? void 0 : r.node) ?? null;
          } else if (t)
            try {
              this.scenes = await lt({ data: t, template: s }, this._resolveAnswer, this._resolveVideoMeta);
            } catch (n) {
              throw new Ne("Video preview data template error", n);
            }
        } catch (n) {
          this.scenes = null, this.host.dispatchEvent(
            new ErrorEvent("error", { composed: !0, bubbles: !0, error: n, message: n.message })
          );
        }
      },
      () => {
        const e = JSON.stringify({
          data: this.host.data,
          template: this.host.template
        });
        if (this._lastDeps && this._memoKey === e)
          return this._lastDeps;
        const t = [this.host.src, this.host.data, this.host.template];
        return this._memoKey = e, this._lastDeps = t, t;
      }
    );
  }
  hostConnected() {
    this._setupTask();
  }
  hostDisconnected() {
    this._video && (this._video.pause(), this._video.removeEventListener("seeked", this._handleSeeked), this._video.src = "", this._video = null);
  }
}
function tr(a, e, t) {
  return Math.min(Math.max(e, a), t);
}
function ks(a, e = {}) {
  const t = Math.max(0, a || 0), s = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), r = Math.floor(t % 3600 % 60), n = Math.floor(t % 1 * 1e3);
  let o = s ? `${s}:${`${i}`.padStart(2, "0")}:${`${r}`.padStart(2, "0")}` : `${i}:${`${r}`.padStart(2, "0")}`;
  return e.includeMs && (o += `:${`${n}`.padStart(3, "0")}`), o;
}
var uh = Object.defineProperty, fh = Object.getOwnPropertyDescriptor, ft = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? fh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && uh(e, t, i), i;
};
let je = class extends j {
  constructor() {
    super(...arguments), this.active = !1, this.size = "small", this.rounded = "medium", this.weight = "light";
  }
  render() {
    return G`<button
      class=${te({
      active: this.active,
      "size-tiny": this.size === "tiny",
      "size-small": this.size === "small",
      "size-large": this.size === "large",
      "radius-medium": this.rounded === "medium",
      "radius-full": this.rounded === "full",
      "weight-light": this.weight === "light",
      "weight-heavy": this.weight === "heavy"
    })}
    >
      <slot></slot>
      ${this.icon && G`<vmp-icon icon=${this.icon}></vmp-icon>`}
    </button>`;
  }
};
je.styles = [
  j.styles ?? [],
  me`
      :host {
        --button-padding: var(--vu-button-padding, var(--space-s));
        --button-color: var(--vu-button-color, var(--colors-dark-640));
        --button-background: var(--vu-button-background, var(--colors-light-1000));
        --button-background-hover: var(--vu-button-background-hover, var(--colors-light-1000));

        display: block;
      }

      button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--space-xxs);
        border: none;
        cursor: pointer;
        font-weight: var(--fontWeights-semibold);
        pointer-events: all;
        transition: background 150ms ease;

        padding: var(--button-padding);
        color: var(--button-color);
        background: var(--button-background);
        padding: var(--button-padding);
      }

      button:focus {
        outline: var(--borderWidths-thin) solid var(--colors-dark-1000);
      }

      .size-tiny {
        --button-padding: var(--vu-button-padding, var(--space-xxs));
        min-width: 20px;
      }

      .size-small {
        --button-padding: var(--vu-button-padding, 6px);
        min-width: 32px;
      }

      .size-large {
        --button-padding: var(--vu-button-padding, var(--space-small));
        min-width: 48px;
      }

      .radius-medium {
        border-radius: var(--radii-small);
      }

      .radius-full {
        border-radius: 100rem;
      }

      .weight-light {
        --button-color: var(--vu-button-color, var(--colors-light-1000));
        --button-background: var(--vu-button-background, transparent);
      }

      .weight-heavy {
        --button-color: var(--vu-button-color, var(--colors-dark-640));
        --button-background: var(--vu-button-background, var(--colors-light-1000));
      }

      .weight-heavy.active,
      .weight-heavy:hover,
      .weight-heavy:focus {
        --button-background: var(--vu-button-background-hover, #cccccc);
      }

      .weight-light.active,
      .weight-light:hover,
      .weight-light:focus {
        --button-background: var(--vu-button-background-hover, #9d9d9d);
      }
    `
];
ft([
  k({ type: Boolean })
], je.prototype, "active", 2);
ft([
  k({ type: String })
], je.prototype, "size", 2);
ft([
  k({ type: String })
], je.prototype, "rounded", 2);
ft([
  k({ type: String })
], je.prototype, "weight", 2);
ft([
  k({ type: String })
], je.prototype, "icon", 2);
je = ft([
  ye("vmp-button")
], je);
const sr = {
  "arrow-left": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M16.6666 9.21875H6.52492L11.1833 4.85156L9.99992 3.75L3.33325 10L9.99992 16.25L11.1749 15.1484L6.52492 10.7812H16.6666V9.21875Z"
        fill="currentColor"
      />
    </svg>`,
  "arrow-right": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M3.75 9.21875H13.2578L8.89062 4.85156L10 3.75L16.25 10L10 16.25L8.89844 15.1484L13.2578 10.7812H3.75V9.21875Z"
        fill="currentColor"
      />
    </svg>`,
  "captions-cross": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M17.0625 19.4167L14.3125 16.6667H3.33333C2.875 16.6667 2.4825 16.5036 2.15583 16.1775C1.82972 15.8509 1.66667 15.4584 1.66667 15V4.16669C1.66667 4.13891 1.66667 4.11446 1.66667 4.09335C1.66667 4.0728 1.66667 4.04863 1.66667 4.02085L0.5625 2.91669L1.75 1.72919L18.25 18.2292L17.0625 19.4167ZM18.3333 15.9375L14.7083 12.3125C14.8056 12.2431 14.8786 12.1495 14.9275 12.0317C14.9758 11.9134 15 11.7917 15 11.6667V10.8334H13.75V11.25H13.6458L12.0833 9.68752V8.75002H13.75V9.16669H15V8.33335C15 8.09724 14.92 7.89919 14.76 7.73919C14.6006 7.57974 14.4028 7.50002 14.1667 7.50002H11.6667C11.4306 7.50002 11.2328 7.57974 11.0733 7.73919C10.9133 7.89919 10.8333 8.09724 10.8333 8.33335V8.43752L5.72917 3.33335H16.6667C17.125 3.33335 17.5175 3.49669 17.8442 3.82335C18.1703 4.14946 18.3333 4.54169 18.3333 5.00002V15.9375ZM5.83333 12.5H8.33333C8.56944 12.5 8.7675 12.42 8.9275 12.26C9.08694 12.1006 9.16667 11.9028 9.16667 11.6667V11.5209L8.47917 10.8334H7.91667V11.25H6.25V8.60419L5.3125 7.66669C5.21528 7.73613 5.13889 7.82974 5.08333 7.94752C5.02778 8.06585 5 8.19446 5 8.33335V11.6667C5 11.9028 5.07972 12.1006 5.23917 12.26C5.39917 12.42 5.59722 12.5 5.83333 12.5Z"
        fill="currentColor"
      />
    </svg>`,
  captions: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M5.83342 12.5H8.33342C8.56953 12.5 8.76758 12.42 8.92758 12.26C9.08703 12.1005 9.16675 11.9028 9.16675 11.6666V10.8333H7.91675V11.25H6.25008V8.74998H7.91675V9.16665H9.16675V8.33331C9.16675 8.0972 9.08703 7.89915 8.92758 7.73915C8.76758 7.5797 8.56953 7.49998 8.33342 7.49998H5.83342C5.5973 7.49998 5.39925 7.5797 5.23925 7.73915C5.0798 7.89915 5.00008 8.0972 5.00008 8.33331V11.6666C5.00008 11.9028 5.0798 12.1005 5.23925 12.26C5.39925 12.42 5.5973 12.5 5.83342 12.5ZM11.6667 12.5H14.1667C14.4029 12.5 14.6006 12.42 14.7601 12.26C14.9201 12.1005 15.0001 11.9028 15.0001 11.6666V10.8333H13.7501V11.25H12.0834V8.74998H13.7501V9.16665H15.0001V8.33331C15.0001 8.0972 14.9201 7.89915 14.7601 7.73915C14.6006 7.5797 14.4029 7.49998 14.1667 7.49998H11.6667C11.4306 7.49998 11.2329 7.5797 11.0734 7.73915C10.9134 7.89915 10.8334 8.0972 10.8334 8.33331V11.6666C10.8334 11.9028 10.9134 12.1005 11.0734 12.26C11.2329 12.42 11.4306 12.5 11.6667 12.5ZM3.33341 16.6666C2.87508 16.6666 2.48258 16.5036 2.15591 16.1775C1.8298 15.8508 1.66675 15.4583 1.66675 15V4.99998C1.66675 4.54165 1.8298 4.14942 2.15591 3.82331C2.48258 3.49665 2.87508 3.33331 3.33341 3.33331H16.6667C17.1251 3.33331 17.5176 3.49665 17.8442 3.82331C18.1704 4.14942 18.3334 4.54165 18.3334 4.99998V15C18.3334 15.4583 18.1704 15.8508 17.8442 16.1775C17.5176 16.5036 17.1251 16.6666 16.6667 16.6666H3.33341Z"
        fill="currentColor"
      />
    </svg>`,
  "chevron-down": () => G`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" part="svg">
      <path
        d="M11.8032 7.13666L10.8632 6.19666L7.80322 9.24999L4.74322 6.19666L3.80322 7.13666L7.80322 11.1367L11.8032 7.13666Z"
        fill="currentColor"
      />
    </svg>`,
  close: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" part="svg">
      <path
        d="M15.8334 5.34163L14.6584 4.16663L10 8.82496L5.34169 4.16663L4.16669 5.34163L8.82502 9.99996L4.16669 14.6583L5.34169 15.8333L10 11.175L14.6584 15.8333L15.8334 14.6583L11.175 9.99996L15.8334 5.34163Z"
        fill="currentColor"
      />
    </svg>`,
  error: () => G`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" part="svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z"
        fill="currentColor"
      />
    </svg>`,
  loading: () => G`<svg class="spinner" width="50" height="50" viewBox="0 0 50 50" part="svg">
    <style>
      /* SVG spinner icon animation */
      .spinner {
        -webkit-animation: rotate 2s linear infinite;
        animation: rotate 2s linear infinite;
      }

      .spinner .path {
        stroke: currentColor;
        stroke-linecap: round;
        -webkit-animation: dash 1.5s ease-in-out infinite;
        animation: dash 1.5s ease-in-out infinite;
      }

      @-webkit-keyframes rotate {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      @keyframes rotate {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      @-webkit-keyframes dash {
        0% {
          stroke-dasharray: 1, 150;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -35;
        }
        100% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -124;
        }
      }

      @keyframes dash {
        0% {
          stroke-dasharray: 1, 150;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -35;
        }
        100% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -124;
        }
      }
    </style>
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
  </svg>`,
  maximize: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66675 3.33331H3.33341H1.66675V4.99998V8.33331H3.33341V4.99998H6.66675V3.33331ZM6.66675 15H3.33341V11.6666H1.66675V15V16.6666H3.33341H6.66675V15ZM13.3334 3.33331H16.6667H18.3334V4.99998V8.33331H16.6667V4.99998H13.3334V3.33331ZM16.6667 15H13.3334V16.6666H16.6667H18.3334V15V11.6666H16.6667V15Z"
        fill="currentColor"
      />
    </svg>`,
  minimize: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.00008 3.33331H6.66675V6.66665V8.33331H5.00008H1.66675V6.66665H5.00008V3.33331ZM5.00008 11.6666H1.66675V13.3333H5.00008V16.6666H6.66675V13.3333V11.6666H5.00008ZM15.0001 6.66665H18.3334V8.33331H15.0001H13.3334V6.66665V3.33331H15.0001V6.66665ZM18.3334 11.6666H15.0001H13.3334V13.3333V16.6666H15.0001V13.3333H18.3334V11.6666Z"
        fill="currentColor"
      />
    </svg>`,
  muted: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M13.75 10C13.75 8.525 12.9 7.25833 11.6667 6.64167V8.48333L13.7083 10.525C13.7333 10.3583 13.75 10.1833 13.75 10ZM15.8333 10C15.8333 10.7833 15.6667 11.5167 15.3833 12.2L16.6417 13.4583C17.1917 12.425 17.5 11.25 17.5 10C17.5 6.43333 15.0083 3.45 11.6667 2.69167V4.40833C14.075 5.125 15.8333 7.35833 15.8333 10ZM3.55833 2.5L2.5 3.55833L6.44167 7.5H2.5V12.5H5.83333L10 16.6667V11.0583L13.5417 14.6C12.9833 15.0333 12.3583 15.375 11.6667 15.5833V17.3C12.8167 17.0417 13.8583 16.5083 14.7417 15.7917L16.4417 17.5L17.5 16.4417L10 8.94167L3.55833 2.5ZM10 3.33333L8.25833 5.075L10 6.81667V3.33333Z"
        fill="currentColor"
      />
    </svg>`,
  pause: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.33333 2.5H5V17.5H8.33333V2.5ZM15 2.5H11.6667V17.5H15V2.5Z"
        fill="currentColor"
      />
    </svg>`,
  "play-large": () => G`<svg width="45" height="53" viewBox="0 0 45 53" fill="none" part="svg">
      <path
        d="M43.5 23.8319C45.5 25.0083 45.5 27.9492 43.5 29.1256L4.5 52.0647C2.5 53.2411 0 51.7706 0 49.4179V3.53961C0 1.18687 2.5 -0.283582 4.5 0.892785L43.5 23.8319Z"
        fill="currentColor"
      />
    </svg>`,
  play: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path d="M17.3803 9.99998L5.83325 16.6666V3.33331L17.3803 9.99998Z" fill="currentColor" />
    </svg>`,
  settings: () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M7.70833 18.3334L7.375 15.6667C7.19445 15.5972 7.02444 15.5139 6.865 15.4167C6.705 15.3195 6.54861 15.2153 6.39583 15.1042L3.91667 16.1459L1.625 12.1875L3.77083 10.5625C3.75694 10.4653 3.75 10.3714 3.75 10.2809C3.75 10.1909 3.75 10.0972 3.75 10C3.75 9.9028 3.75 9.80891 3.75 9.71835C3.75 9.62835 3.75694 9.53474 3.77083 9.43752L1.625 7.81252L3.91667 3.85419L6.39583 4.89585C6.54861 4.78474 6.70833 4.68058 6.875 4.58335C7.04167 4.48613 7.20833 4.4028 7.375 4.33335L7.70833 1.66669H12.2917L12.625 4.33335C12.8056 4.4028 12.9758 4.48613 13.1358 4.58335C13.2953 4.68058 13.4514 4.78474 13.6042 4.89585L16.0833 3.85419L18.375 7.81252L16.2292 9.43752C16.2431 9.53474 16.25 9.62835 16.25 9.71835C16.25 9.80891 16.25 9.9028 16.25 10C16.25 10.0972 16.25 10.1909 16.25 10.2809C16.25 10.3714 16.2361 10.4653 16.2083 10.5625L18.3542 12.1875L16.0625 16.1459L13.6042 15.1042C13.4514 15.2153 13.2917 15.3195 13.125 15.4167C12.9583 15.5139 12.7917 15.5972 12.625 15.6667L12.2917 18.3334H7.70833ZM10.0417 12.9167C10.8472 12.9167 11.5347 12.632 12.1042 12.0625C12.6736 11.4931 12.9583 10.8056 12.9583 10C12.9583 9.19447 12.6736 8.50696 12.1042 7.93752C11.5347 7.36808 10.8472 7.08335 10.0417 7.08335C9.22222 7.08335 8.53111 7.36808 7.96833 7.93752C7.40611 8.50696 7.125 9.19447 7.125 10C7.125 10.8056 7.40611 11.4931 7.96833 12.0625C8.53111 12.632 9.22222 12.9167 10.0417 12.9167ZM10.0417 11.25C9.69445 11.25 9.39945 11.1284 9.15667 10.885C8.91333 10.6422 8.79167 10.3472 8.79167 10C8.79167 9.6528 8.91333 9.3578 9.15667 9.11502C9.39945 8.87169 9.69445 8.75002 10.0417 8.75002C10.3889 8.75002 10.6842 8.87169 10.9275 9.11502C11.1703 9.3578 11.2917 9.6528 11.2917 10C11.2917 10.3472 11.1703 10.6422 10.9275 10.885C10.6842 11.1284 10.3889 11.25 10.0417 11.25ZM9.16667 16.6667H10.8125L11.1042 14.4584C11.5347 14.3472 11.9342 14.1839 12.3025 13.9684C12.6703 13.7534 13.0069 13.4931 13.3125 13.1875L15.375 14.0417L16.1875 12.625L14.3958 11.2709C14.4653 11.0764 14.5139 10.8714 14.5417 10.6559C14.5694 10.4409 14.5833 10.2222 14.5833 10C14.5833 9.7778 14.5694 9.55891 14.5417 9.34335C14.5139 9.12835 14.4653 8.92363 14.3958 8.72919L16.1875 7.37502L15.375 5.95835L13.3125 6.83335C13.0069 6.51391 12.6703 6.24641 12.3025 6.03085C11.9342 5.81585 11.5347 5.6528 11.1042 5.54169L10.8333 3.33335H9.1875L8.89583 5.54169C8.46528 5.6528 8.06611 5.81585 7.69833 6.03085C7.33 6.24641 6.99306 6.50697 6.6875 6.81252L4.625 5.95835L3.8125 7.37502L5.60417 8.70835C5.53472 8.91669 5.48611 9.12502 5.45833 9.33335C5.43056 9.54169 5.41667 9.76391 5.41667 10C5.41667 10.2222 5.43056 10.4375 5.45833 10.6459C5.48611 10.8542 5.53472 11.0625 5.60417 11.2709L3.8125 12.625L4.625 14.0417L6.6875 13.1667C6.99306 13.4861 7.33 13.7534 7.69833 13.9684C8.06611 14.1839 8.46528 14.3472 8.89583 14.4584L9.16667 16.6667Z"
        fill="currentColor"
      />
    </svg>`,
  tick: () => G`<svg width="20" height="21" viewBox="0 0 20 21" fill="none" part="svg">
      <path
        d="M7.50016 14.0001L4.00016 10.5001L2.8335 11.6667L7.50016 16.3334L17.5002 6.33341L16.3335 5.16675L7.50016 14.0001Z"
        fill="currentColor"
      />
    </svg>`,
  "volume-high": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M2.5 7.49998V12.5H5.83333L10 16.6667V3.33332L5.83333 7.49998H2.5ZM13.75 9.99998C13.75 8.52498 12.9 7.25832 11.6667 6.64165V13.35C12.9 12.7417 13.75 11.475 13.75 9.99998ZM11.6667 2.69165V4.40832C14.075 5.12498 15.8333 7.35832 15.8333 9.99998C15.8333 12.6417 14.075 14.875 11.6667 15.5917V17.3083C15.0083 16.55 17.5 13.5667 17.5 9.99998C17.5 6.43332 15.0083 3.44998 11.6667 2.69165Z"
        fill="currentColor"
      />
    </svg>`,
  "volume-low": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path d="M5.83325 7.49998V12.5H9.16658L13.3333 16.6666V3.33331L9.16658 7.49998H5.83325Z" fill="currentColor" />
    </svg>`,
  "volume-medium": () => G`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" part="svg">
      <path
        d="M15.4167 9.99998C15.4167 8.52498 14.5667 7.25831 13.3334 6.64165V13.35C14.5667 12.7416 15.4167 11.475 15.4167 9.99998ZM4.16675 7.49998V12.5H7.50008L11.6667 16.6666V3.33331L7.50008 7.49998H4.16675Z"
        fill="currentColor"
      />
    </svg>`,
  vouch: () => G`<svg
      xmlns="http://www.w3.org/2000/svg"
      height="28"
      width="105"
      viewBox="0 0 105 28"
      fill="currentColor"
      part="svg"
    >
      <path
        d="M9.853 23.246L4.86 7.688H0L7 27.42h5.52l7.265-19.733h-4.65L9.854 23.246zM95.12 7.08a8.905 8.905 0 00-4.648 1.294V0H86.14v27.419h4.332V16.087a4.656 4.656 0 014.649-4.65 4.656 4.656 0 014.649 4.65v11.332h4.332V16.087c.026-4.966-4.015-9.008-8.981-9.008zM57.188 19.02a4.656 4.656 0 01-4.649 4.649 4.656 4.656 0 01-4.649-4.65V7.689h-4.332V19.02c0 4.966 4.041 8.98 8.981 8.98 4.94 0 8.981-4.04 8.981-8.98V7.688h-4.332V19.02zM30.483 7.133c-5.732 0-10.408 4.675-10.408 10.407s4.676 10.408 10.408 10.408c5.732 0 10.408-4.676 10.408-10.408 0-5.732-4.676-10.407-10.408-10.407zm0 16.483a6.076 6.076 0 116.075-6.076c0 3.355-2.747 6.076-6.075 6.076zM74.517 23.616a6.076 6.076 0 010-12.151 6.132 6.132 0 015.045 2.668l3.592-2.43a10.473 10.473 0 00-8.637-4.57c-5.732 0-10.408 4.675-10.408 10.407s4.676 10.408 10.408 10.408a10.35 10.35 0 008.611-4.596l-3.593-2.43a5.975 5.975 0 01-5.018 2.694z"
      />
    </svg>`
};
var gh = Object.defineProperty, mh = Object.getOwnPropertyDescriptor, dn = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? mh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && gh(e, t, i), i;
};
let Kt = class extends j {
  render() {
    return !this.icon || !Object.keys(sr).includes(this.icon) ? null : sr[this.icon]();
  }
};
Kt.styles = [
  j.styles ?? [],
  me`
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
    `
];
dn([
  k({ type: String })
], Kt.prototype, "icon", 2);
Kt = dn([
  ye("vmp-icon")
], Kt);
var ph = Object.defineProperty, vh = Object.getOwnPropertyDescriptor, gt = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? vh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && ph(e, t, i), i;
};
let qe = class extends j {
  constructor() {
    super(...arguments), this.active = !1, this.size = "small", this.rounded = "medium", this.weight = "light";
  }
  render() {
    return G`
      <vmp-button
        ?active=${this.active}
        size=${vt(this.size)}
        rounded=${vt(this.rounded)}
        weight=${vt(this.weight)}
      >
        <vmp-icon
          class=${te({
      tiny: this.size === "tiny",
      small: this.size === "small",
      large: this.size === "large"
    })}
          icon=${vt(this.icon)}
        ></vmp-icon>
      </vmp-button>
    `;
  }
};
qe.styles = [
  j.styles ?? [],
  me`
      .tiny::part(svg) {
        height: 12px;
        width: 12px;
      }

      .small::part(svg) {
        height: 20px;
        width: 20px;
      }

      .large::part(svg) {
        height: 32px;
        width: 32px;
      }
    `
];
gt([
  k({ type: Boolean })
], qe.prototype, "active", 2);
gt([
  k({ type: String })
], qe.prototype, "size", 2);
gt([
  k({ type: String })
], qe.prototype, "rounded", 2);
gt([
  k({ type: String })
], qe.prototype, "weight", 2);
gt([
  k({ type: String })
], qe.prototype, "icon", 2);
qe = gt([
  ye("vmp-icon-button")
], qe);
var yh = Object.defineProperty, Th = Object.getOwnPropertyDescriptor, Ae = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Th(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && yh(e, t, i), i;
};
let Ke = class extends j {
  constructor() {
    super(...arguments), this.disabled = !1, this.aspectRatio = 1, this.compilation = Os, this._currentTime = 0, this._sceneController = new dh(this), this._canvasRef = Se(), this._previewRef = Se(), this._previewTimeRef = Se(), this._handleScrubberMouseEnter = ({ detail: { x: a, y: e, elementLeft: t, elementRight: s } }) => {
      var i, r;
      if ((i = this._previewRef) != null && i.value) {
        const n = this._previewRef.value.getBoundingClientRect(), o = (r = this._previewRef.value.getRootNode().host) == null ? void 0 : r.getBoundingClientRect();
        n && o && (this._previewRef.value.style.opacity = "1", this._previewRef.value.style.transform = `translate3d(${tr(
          t - o.left,
          a - o.left - n.width / 2,
          s - o.left - n.width
        )}px, ${e - o.top - n.height - 28}px, 0)`);
      }
    }, this._handleScrubberMouseMove = ({ detail: { time: a, x: e, elementLeft: t, elementRight: s } }) => {
      var i, r, n, o, l, h, c, d;
      if (this._currentTime = a, (i = this._sceneController.scenes) != null && i.scenes.length) {
        const u = (l = (o = (n = (r = this._sceneController.scenes) == null ? void 0 : r.scenes) == null ? void 0 : n.find(({ start: f, duration: g, video: p }) => p && a >= f && a <= f + g)) == null ? void 0 : o.video) == null ? void 0 : l.node;
        if (u && (u.currentTime = a), this._draw(), (h = this._previewRef) != null && h.value) {
          const f = this._previewRef.value.getBoundingClientRect(), g = (c = this._previewRef.value.getRootNode().host) == null ? void 0 : c.getBoundingClientRect();
          if (f && g) {
            const p = this._previewRef.value.style.transform || "translate3d(0px, 0px, 0px)", [, v] = Array.from(p.matchAll(/([+-]?([0-9]*[.])?[0-9]+)(?=px)\w+/g));
            this._previewRef.value.style.transform = `translate3d(${tr(
              t - g.left,
              e - g.left - f.width / 2,
              s - g.left - f.width
            )}px, ${v[1]}px, 0)`;
          }
        }
        this._previewTimeRef.value && this._previewTimeRef.value.setAttribute(
          "content",
          ks(Math.max(0, Math.min(this._currentTime, (d = this._sceneController.scenes) == null ? void 0 : d.duration)))
        );
      }
    }, this._handleScrubberMouseLeave = () => {
      var a;
      (a = this._previewRef) != null && a.value && (this._previewRef.value.style.opacity = "0");
    }, this._handleScrubberResize = ({ detail: { y: a } }) => {
      var e, t;
      if ((e = this._previewRef) != null && e.value) {
        const s = this._previewRef.value.getBoundingClientRect(), i = (t = this._previewRef.value.getRootNode().host) == null ? void 0 : t.getBoundingClientRect();
        if (s && i) {
          const r = this._previewRef.value.style.transform || "translate3d(0px, 0px, 0px)", [n] = Array.from(r.matchAll(/([+-]?([0-9]*[.])?[0-9]+)(?=px)\w+/g));
          this._previewRef.value.style.transform = `translate3d(${n[1]}px, ${a - i.top - s.height - 28}px, 0)`;
        }
      }
    };
  }
  _draw(a = this._currentTime) {
    var e, t;
    this._sceneController.scenes && this._canvasRef.value && ((t = this.compilation) == null || t.call(this, {
      currentTime: Math.max(0, Math.min(a, (e = this._sceneController.scenes) == null ? void 0 : e.duration)),
      scenes: this._sceneController.scenes,
      canvas: this._canvasRef.value
    }));
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("scrubber:resize", this._handleScrubberResize), document.addEventListener("scrubber:mouseenter", this._handleScrubberMouseEnter), document.addEventListener("scrubber:mousemove", this._handleScrubberMouseMove), document.addEventListener("scrubber:mouseleave", this._handleScrubberMouseLeave);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("scrubber:resize", this._handleScrubberResize), document.removeEventListener("scrubber:mouseenter", this._handleScrubberMouseEnter), document.removeEventListener("scrubber:mousemove", this._handleScrubberMouseMove), document.removeEventListener("scrubber:mouseleave", this._handleScrubberMouseLeave);
  }
  render() {
    var s;
    const { height: a, width: e } = rr({
      resolution: 180,
      aspectRatio: this.aspectRatio
    }), t = ((s = this._sceneController.scenes) == null ? void 0 : s.scenes.length) ?? 0;
    return !this.disabled && (this.src || t > 1) ? G`
          <div
            ${be(this._previewRef)}
            class="preview"
            style=${Fs({
      width: this.aspectRatio > 1 ? "140px" : void 0,
      height: this.aspectRatio <= 1 ? "140px" : void 0,
      aspectRatio: this.aspectRatio
    })}
          >
            <canvas ${be(this._canvasRef)} class="preview-canvas" width=${e} height=${a}></canvas>
            <vmp-text ${be(this._previewTimeRef)} class="preview-text" size="small"></vmp-text>
          </div>
        ` : null;
  }
};
Ke.styles = [
  j.styles ?? [],
  me`
      .preview {
        position: absolute;
        display: flex;
        top: 0;
        left: 0;
        align-items: center;
        flex-direction: column;
        opacity: 0;
        // Always on top
        z-index: 2147483647;
        pointer-events: none;
        border: 3px solid var(--colors-light-1000);
        background: var(--colors-dark-1000);
        border-radius: var(--radii-medium);
        transition: opacity 150ms ease-out;
      }

      .preview-canvas {
        width: 100%;
        height: 100%;
        border-radius: var(--radii-small);
      }

      .preview-text {
        position: absolute;
        bottom: 0;
        transform: translate3d(0, calc(100% + 9px), 0);
        color: var(--colors-light-1000);
        font-variant-numeric: tabular-nums;
      }
    `
];
Ae([
  k({ type: String })
], Ke.prototype, "src", 2);
Ae([
  k({ type: Object })
], Ke.prototype, "data", 2);
Ae([
  k({ type: Object })
], Ke.prototype, "template", 2);
Ae([
  k({ type: Boolean })
], Ke.prototype, "disabled", 2);
Ae([
  k({ type: Number })
], Ke.prototype, "aspectRatio", 2);
Ae([
  k({ attribute: !1 })
], Ke.prototype, "compilation", 2);
Ke = Ae([
  ye("vmp-video-preview-content")
], Ke);
let Xe = class extends j {
  constructor() {
    super(...arguments), this.disabled = !1, this.aspectRatio = 1, this.compilation = Os;
  }
  render() {
    return G`
      <vmp-video-preview-content
        ?disabled=${this.disabled}
        .src=${this.src}
        .data=${this.data}
        .template=${this.template}
        .aspectRatio=${this.aspectRatio}
        .compilation=${this.compilation}
      ></vmp-video-preview-content>
    `;
  }
};
Ae([
  k({ type: String })
], Xe.prototype, "src", 2);
Ae([
  k({ type: Object })
], Xe.prototype, "data", 2);
Ae([
  k({ type: Object })
], Xe.prototype, "template", 2);
Ae([
  k({ type: Boolean })
], Xe.prototype, "disabled", 2);
Ae([
  k({ type: Number })
], Xe.prototype, "aspectRatio", 2);
Ae([
  k({ attribute: !1 })
], Xe.prototype, "compilation", 2);
Xe = Ae([
  ye("vmp-video-preview")
], Xe);
class xh extends yn {
  constructor(e) {
    if (super(e), e.type !== lr.ELEMENT)
      throw new Error("Resize directive must be used in an Element expression");
  }
  update(e, [t]) {
    return t == null || t(e.element), nr;
  }
}
const ir = or(xh);
class Eh {
  constructor(e) {
    this.hiddenControls = [], this._measureRef = Se(), this._prevControlsWidth = 0, this._hideables = {}, this._showables = {}, this._onResize = (t) => {
      var r, n, o;
      const s = this._measureRef.value, i = (o = (n = (r = t == null ? void 0 : t[0]) == null ? void 0 : r.borderBoxSize) == null ? void 0 : n[0]) == null ? void 0 : o.inlineSize;
      if (s && i && i !== this._prevControlsWidth) {
        Object.keys(this._hideables).forEach((h) => {
          this._hideables[h].element.style.display = "";
        }), Object.keys(this._showables).forEach((h) => {
          this._showables[h].element.style.display = "none";
        });
        const l = [];
        for (; s.scrollWidth > s.offsetWidth; ) {
          const h = Object.keys(this._hideables).find(
            (d) => this._hideables[d].hideIndex === l.length
          );
          if (!h)
            break;
          const c = this._hideables[h].element;
          c && (c.style.display = "none"), l.push(h), Object.keys(this._showables).forEach((d) => {
            this._showables[d].showOn.some((u) => l.includes(u)) && (this._showables[d].element.style.display = "flex");
          });
        }
        this.hiddenControls = l, this._prevControlsWidth = i, this.host.requestUpdate();
      }
    }, this.host = e;
  }
  measure() {
    return be(this._measureRef);
  }
  contain() {
    return ei(this._onResize);
  }
  hide(e, t) {
    return ir((s) => {
      this._hideables[e] = { element: s, hideIndex: t };
    });
  }
  show(e, t) {
    return ir((s) => {
      this._showables[e] = { element: s, showOn: t };
    });
  }
}
const ti = `.tippy-box[data-animation=shift-away-subtle][data-state=hidden]{opacity:0}.tippy-box[data-animation=shift-away-subtle][data-state=hidden][data-placement^=top]{transform:translateY(5px)}.tippy-box[data-animation=shift-away-subtle][data-state=hidden][data-placement^=bottom]{transform:translateY(-5px)}.tippy-box[data-animation=shift-away-subtle][data-state=hidden][data-placement^=left]{transform:translate(5px)}.tippy-box[data-animation=shift-away-subtle][data-state=hidden][data-placement^=right]{transform:translate(-5px)}
`;
var Sh = Object.defineProperty, bh = Object.getOwnPropertyDescriptor, At = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? bh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Sh(e, t, i), i;
};
let st = class extends j {
  constructor() {
    super(...arguments), this.semibold = !1, this.truncate = !1, this.size = "medium", this.content = "";
  }
  render() {
    return G`
      <div
        part="content"
        class=${te({
      semibold: this.semibold,
      truncate: this.truncate,
      [this.size]: !0
    })}
        style=${Fs({
      fontFamily: mn({ text: this.content, font: "var(--fontFamilies-sans)" })
    })}
      >
        ${this.content}
      </div>
    `;
  }
};
st.styles = [
  j.styles ?? [],
  me`
      :host {
        --text-size: var(--fontSizes-medium);
        --text-line-height: var(--lineHeights-medium);
        --text-weight: var(--fontWeights-regular);
      }

      div {
        font-size: var(--text-size);
        line-height: var(--text-line-height);
        font-weight: var(--text-weight);
      }

      .small {
        --text-size: var(--fontSizes-small);
        --text-line-height: var(--lineHeights-small);
      }

      .medium {
        --text-size: var(--fontSizes-medium);
        --text-line-height: var(--lineHeights-medium);
      }

      .large {
        --text-size: var(--fontSizes-large);
        --text-line-height: var(--lineHeights-large);
      }

      .semibold {
        --text-weight: var(--fontWeights-semibold);
      }

      .truncate {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    `
];
At([
  k({ type: Boolean })
], st.prototype, "semibold", 2);
At([
  k({ type: Boolean })
], st.prototype, "truncate", 2);
At([
  k({ type: String })
], st.prototype, "size", 2);
At([
  k({ type: String })
], st.prototype, "content", 2);
st = At([
  ye("vmp-text")
], st);
var Lh = Object.defineProperty, Ah = Object.getOwnPropertyDescriptor, Rt = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Ah(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Lh(e, t, i), i;
};
let it = class extends j {
  constructor() {
    super(...arguments), this.activeItems = [], this.visibleItems = null, this.subItemsActive = null, this.tippy = null, this._contentRef = Se();
  }
  _handleBackClick() {
    this.subItemsActive = null, this.visibleItems = this.items ?? null;
  }
  willUpdate() {
    this.visibleItems = this.visibleItems ?? this.items ?? null;
  }
  updated() {
    var e, t;
    const a = (t = (e = this.items) == null ? void 0 : e.items.find(({ id: s }) => this.subItemsActive === s)) == null ? void 0 : t.subItems;
    this.visibleItems = a ?? this.items ?? null, a || (this.subItemsActive = null);
  }
  connectedCallback() {
    super.connectedCallback(), requestAnimationFrame(() => {
      var t;
      const a = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot"), e = a == null ? void 0 : a.assignedElements()[0];
      e && this._contentRef.value && (this.tippy = Ms(e, {
        content: this._contentRef.value,
        allowHTML: !0,
        arrow: !1,
        animation: "shift-away-subtle",
        interactive: !0,
        placement: "top",
        trigger: "click",
        onShow: () => {
          this.dispatchEvent(new CustomEvent("menu:toggle", { detail: !0 }));
        },
        onHide: () => {
          this.dispatchEvent(new CustomEvent("menu:toggle", { detail: !1 }));
        },
        appendTo: () => this.shadowRoot
      }));
    });
  }
  disconnectedCallback() {
    var a;
    super.disconnectedCallback(), (a = this.tippy) == null || a.destroy();
  }
  render() {
    var a, e;
    return G`
      <slot></slot>
      <div ${be(this._contentRef)} class="content">
        <div class="title">
          ${this.subItemsActive ? G`
                <button class="back" @click=${this._handleBackClick}>
                  <vmp-icon icon="chevron-down"></vmp-icon>
                </button>
              ` : null}
          <vmp-text
            ?bold=${!0}
            ?truncate=${!0}
            size="small"
            .content=${((a = this.visibleItems) == null ? void 0 : a.title) ?? "Sub Menu"}
          ></vmp-text>
        </div>
        ${hr(
      ((e = this.visibleItems) == null ? void 0 : e.items) ?? [],
      ({ id: t }) => t,
      (t) => G`
              <button
                class="item"
                @click=${() => {
        t.subItems && (this.subItemsActive = t.id, this.visibleItems = t.subItems), t.event && this.dispatchEvent(new CustomEvent(t.event, { detail: t, bubbles: !0, composed: !0 }));
      }}
              >
                <vmp-text ?semibold=${!0} size="small" content=${t.label}></vmp-text>
                ${t.subItems ? G`<vmp-icon class="forward" icon="chevron-down"></vmp-icon>` : this.activeItems.includes(t.id) ? G`<vmp-icon icon="tick"></vmp-icon>` : null}
              </button>
            `
    )}
      </div>
    `;
  }
};
it.styles = [
  j.styles ?? [],
  Yt(ti),
  me`
      :host {
        display: flex;
      }

      .content {
        display: flex;
        min-width: 140px;
        overflow: hidden;
        flex-direction: column;
        color: var(--colors-dark-1000);
        background: var(--colors-light-1000);
        border-radius: var(--radii-medium);
        transition: height 150ms ease-out;
      }

      .back {
        padding: 0;
        margin: 0;
        border: 0;
        cursor: pointer;
        background: transparent;
        color: var(--colors-dark-400);
        /* TODO: Kinda eyeballing this one */
        margin-left: calc(var(--space-xxs) * -1);
        transform: rotate(90deg);
      }

      .forward {
        transform: rotate(-90deg);
      }

      .title {
        display: flex;
        align-items: center;
        gap: var(--space-xxs);
        color: var(--colors-dark-400);
        text-transform: uppercase;
        height: 36px;
        padding: var(--space-small) var(--space-small) var(--space-xxs) var(--space-small);
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 42px;
        border: none;
        cursor: pointer;
        color: var(--colors-dark-1000);
        background: transparent;
        padding: 0 var(--space-small);
      }

      .item:hover {
        background: var(--colors-dark-100);
      }

      vmp-icon::part(svg) {
        height: 20px;
        width: 20px;
      }
    `
];
Rt([
  k({ type: Object })
], it.prototype, "items", 2);
Rt([
  k({ type: Array })
], it.prototype, "activeItems", 2);
Rt([
  ve()
], it.prototype, "visibleItems", 2);
Rt([
  ve()
], it.prototype, "subItemsActive", 2);
it = Rt([
  ye("vmp-menu")
], it);
var Rh = Object.defineProperty, Ih = Object.getOwnPropertyDescriptor, si = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Ih(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Rh(e, t, i), i;
};
let bt = class extends j {
  constructor() {
    super(...arguments), this.content = "", this.disabled = !1, this.tippy = null, this._contentRef = Se();
  }
  connectedCallback() {
    super.connectedCallback(), requestAnimationFrame(() => {
      var t;
      const a = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot"), e = a == null ? void 0 : a.assignedElements()[0];
      e && this._contentRef.value && (this.tippy = Ms(e, {
        content: this._contentRef.value,
        allowHTML: !0,
        arrow: !1,
        animation: "shift-away-subtle",
        interactive: !1,
        placement: "top",
        // To be above the vmp-menu
        zIndex: 1e4,
        appendTo: () => this.shadowRoot
      }));
    });
  }
  disconnectedCallback() {
    var a;
    super.disconnectedCallback(), (a = this.tippy) == null || a.destroy();
  }
  updated() {
    var a, e;
    this.disabled ? (a = this.tippy) == null || a.disable() : (e = this.tippy) == null || e.enable();
  }
  render() {
    return G`
      <slot></slot>
      <div ${be(this._contentRef)} class="content">
        <vmp-text content=${this.content}></vmp-text>
      </div>
    `;
  }
};
bt.styles = [
  j.styles ?? [],
  Yt(ti),
  me`
      :host {
        display: flex;
      }

      .content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--space-small);
        color: var(--colors-light-1000);
        background: var(--colors-dark-800);
        border-radius: var(--radii-medium);
      }
    `
];
si([
  k({ type: String })
], bt.prototype, "content", 2);
si([
  k({ type: Boolean })
], bt.prototype, "disabled", 2);
bt = si([
  ye("vmp-tooltip")
], bt);
var wh = Object.defineProperty, _h = Object.getOwnPropertyDescriptor, ii = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? _h(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && wh(e, t, i), i;
};
let Lt = class extends j {
  constructor() {
    super(...arguments), this.volume = 1, this.muted = !1, this.tippy = null, this._contentRef = Se(), this._anchorRef = Se(), this._menuOpen = !1;
  }
  connectedCallback() {
    super.connectedCallback(), requestAnimationFrame(() => {
      this._anchorRef.value && this._contentRef.value && (this.tippy = Ms(this._anchorRef.value, {
        content: this._contentRef.value,
        allowHTML: !0,
        arrow: !1,
        animation: "shift-away-subtle",
        interactive: !0,
        placement: "top",
        interactiveBorder: 20,
        onShow: () => {
          this._menuOpen = !0, this.dispatchEvent(new CustomEvent("menu:toggle", { detail: !0 }));
        },
        onHide: () => {
          this._menuOpen = !1, this.dispatchEvent(new CustomEvent("menu:toggle", { detail: !1 }));
        },
        appendTo: () => this.shadowRoot
      }));
    });
  }
  disconnectedCallback() {
    var a;
    super.disconnectedCallback(), (a = this.tippy) == null || a.destroy();
  }
  render() {
    return G`
      <vmp-icon-button
        ${be(this._anchorRef)}
        icon=${this.muted || this.volume === 0 ? "muted" : this.volume < 1 / 3 ? "volume-low" : this.volume < 2 / 3 ? "volume-medium" : "volume-high"}
        weight="heavy"
        rounded="full"
        @pointerdown=${(a) => {
      this._menuOpen && a.preventDefault();
    }}
        @click=${() => {
      this._menuOpen && this.dispatchEvent(new CustomEvent("volume:click", { bubbles: !0, composed: !0, detail: this.muted }));
    }}
      ></vmp-icon-button>
      <div ${be(this._contentRef)} class="content">
        <input
          key="volume"
          type="range"
          min="0"
          max="1"
          step="0.01"
          .value=${this.volume.toString()}
          @blur=${() => {
      var a;
      return (a = this.tippy) == null ? void 0 : a.hide();
    }}
        />
      </div>
    `;
  }
};
Lt.styles = [
  j.styles ?? [],
  Yt(ti),
  me`
      .content {
        --volume-slider-height: 4px;
        --volume-slider-width: 78px;

        display: flex;
        height: var(--volume-slider-width);
        width: var(--volume-slider-height);
      }

      .spacer {
        display: flex;
        height: var(--volume-slider-width);
        width: var(--volume-slider-height);
      }

      input {
        position: absolute;
        appearance: none !important;
        height: var(--volume-slider-height);
        width: var(--volume-slider-width);
        overflow: hidden;
        border-radius: 1000rem;
        cursor: pointer;
        background: var(--colors-light-200);
        rotate: -90deg;
        /* Minus the input margin */
        translate: 0 calc(var(--volume-slider-width) - 4px);
        transform-origin: left;
        transition: height 100ms ease-out, transform 100ms ease-out;
      }

      input:hover {
        height: calc(var(--volume-slider-height) * 2);
      }

      input::-webkit-slider-runnable-track {
        appearance: none !important;
        height: var(--volume-slider-height);
        color: var(--colors-light-1000);
        transition: height 100ms ease-out;
      }

      input::-moz-range-track {
        appearance: none !important;
        height: var(--volume-slider-height);
        color: var(--colors-light-1000);
        transition: height 100ms ease-out;
      }

      input::-ms-track {
        appearance: none !important;
        height: var(--volume-slider-height);
        color: var(--colors-light-1000);
        transition: height 100ms ease-out;
      }

      input:hover::-webkit-slider-runnable-track {
        height: calc(var(--volume-slider-height) * 2);
      }

      input:hover::-moz-range-track {
        height: calc(var(--volume-slider-height) * 2);
      }

      input:hover::-ms-track {
        height: calc(var(--volume-slider-height) * 2);
      }

      input::-webkit-slider-thumb {
        appearance: none !important;
        height: var(--volume-slider-height) !important;
        width: var(--volume-slider-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--volume-slider-width) + var(--volume-slider-height) / 2) * -1) 0 0
            var(--volume-slider-width),
          calc((var(--volume-slider-width) + var(--volume-slider-height) / 2)) 0 0 var(--volume-slider-width)
            var(--colors-dark-640);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      input::-moz-range-thumb {
        appearance: none !important;
        height: var(--volume-slider-height) !important;
        width: var(--volume-slider-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--volume-slider-width) + var(--volume-slider-height) / 2) * -1) 0 0
            var(--volume-slider-width),
          calc((var(--volume-slider-width) + var(--volume-slider-height) / 2)) 0 0 var(--volume-slider-width)
            var(--colors-dark-640);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      input::-ms-thumb {
        appearance: none !important;
        height: var(--volume-slider-height) !important;
        width: var(--volume-slider-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--volume-slider-width) + var(--volume-slider-height) / 2) * -1) 0 0
            var(--volume-slider-width),
          calc((var(--volume-slider-width) + var(--volume-slider-height) / 2)) 0 0 var(--volume-slider-width)
            var(--colors-dark-640);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      input:hover::-webkit-slider-thumb {
        --volume-slider-height: 8px;
        color: var(--colors-light-800);
      }

      input:hover::-moz-range-thumb {
        --volume-slider-height: 8px;
        color: var(--colors-light-800);
      }

      input:hover::-ms-thumb {
        --volume-slider-height: 8px;
        color: var(--colors-light-800);
      }
    `
];
ii([
  k({ type: Number })
], Lt.prototype, "volume", 2);
ii([
  k({ type: Boolean })
], Lt.prototype, "muted", 2);
Lt = ii([
  ye("vmp-volume-button")
], Lt);
var Ch = Object.defineProperty, Dh = Object.getOwnPropertyDescriptor, Xt = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Dh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Ch(e, t, i), i;
};
let ut = class extends j {
  constructor() {
    super(...arguments), this.duration = 0, this.currentTime = 0, this.buffer = [], this._containerRef = Se(), this._handleContainerResize = () => {
      var e;
      const a = (e = this._containerRef.value) == null ? void 0 : e.getBoundingClientRect();
      this.dispatchEvent(
        new CustomEvent("scrubber:resize", {
          detail: a,
          bubbles: !0,
          composed: !0
        })
      );
    }, this._handleMouseEnter = (a) => {
      var t;
      const e = (t = this._containerRef.value) == null ? void 0 : t.getBoundingClientRect();
      this.dispatchEvent(
        new CustomEvent("scrubber:mouseenter", {
          detail: {
            x: a.clientX,
            y: a.clientY,
            elementLeft: (e == null ? void 0 : e.left) ?? 0,
            elementRight: (e == null ? void 0 : e.right) ?? document.body.offsetWidth
          },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._handleMouseMove = (a) => {
      var i;
      const e = (i = this._containerRef.value) == null ? void 0 : i.getBoundingClientRect(), s = (a.clientX - ((e == null ? void 0 : e.left) ?? 0)) / ((e == null ? void 0 : e.width) ?? 1);
      this.dispatchEvent(
        new CustomEvent("scrubber:mousemove", {
          detail: {
            x: a.clientX,
            y: a.clientY,
            time: s * this.duration,
            elementLeft: (e == null ? void 0 : e.left) ?? 0,
            elementRight: (e == null ? void 0 : e.right) ?? document.body.offsetWidth
          },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._handleMouseLeave = (a) => {
      this.dispatchEvent(
        new CustomEvent("scrubber:mouseleave", {
          detail: {
            x: a.clientX,
            y: a.clientY
          },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  render() {
    var e;
    const a = ((e = this.buffer) == null ? void 0 : e.sort((t, s) => t.start < s.start ? -1 : s.start < t.start ? 1 : 0).reduce((t, { start: s, end: i }, r) => {
      const n = t[r - 1], o = Math.floor(s), l = Math.ceil(i);
      return t.push({ id: s, start: Math.max(0, o), end: Math.min(l, 100) }), n && n.end >= s - 1 && (t[r].start = n.end), t;
    }, [])) ?? [];
    return G`
      <div
        class="container"
        ${be(this._containerRef)}
        ${ei(this._handleContainerResize)}
        @mouseenter=${this._handleMouseEnter}
        @mousemove=${this._handleMouseMove}
        @mouseleave=${this._handleMouseLeave}
      >
        <input
          key="scrubber"
          aria-label="Progress scrubber"
          type="range"
          min="0"
          max=${this.duration}
          step="0.01"
          .value=${this.currentTime.toString()}
          data-testid="scrubber"
        />
        ${hr(
      a,
      ({ id: t }) => t,
      (t) => G`
              <div class="buffer" style=${`left: ${t.start}%; width: ${t.end - t.start}%`}></div>
            `
    )}
      </div>
    `;
  }
};
ut.styles = [
  j.styles ?? [],
  me`
      :host {
        --player-scrubber-height: 8px;
        --player-scrubber-shadow-width: 4000px;

        display: flex;
      }

      .container {
        position: relative;
        display: flex;
        width: 100%;
        opacity: 1;
        border-radius: 1000rem;
        overflow: hidden;
        transition: opacity 150ms ease-out;
      }

      input {
        appearance: none !important;
        height: var(--player-scrubber-height);
        width: 100%;
        margin: 0;
        overflow: hidden;
        cursor: pointer;
        background: var(--colors-light-200);
        transition: height 100ms ease-out, transform 100ms ease-out;
      }

      .buffer {
        position: absolute;
        height: var(--player-scrubber-height);
        width: var(--player-buffered-percentage);
        background: var(--colors-light-400);
        pointer-events: none;
        transition: height 100ms ease-out, width 250ms ease-out, left 250ms ease-out;
      }

      .container:hover .buffer {
        height: calc(var(--player-scrubber-height) * 2);
      }

      .container:hover input {
        height: calc(var(--player-scrubber-height) * 2);
      }

      input::-webkit-slider-runnable-track {
        appearance: none !important;
        height: var(--player-scrubber-height);
        color: var(--colors-light-1000);
        z-index: 2;
        transition: height 100ms ease-out;
      }

      input::-moz-range-track {
        appearance: none !important;
        height: var(--player-scrubber-height);
        color: var(--colors-light-1000);
        transition: height 100ms ease-out;
      }

      input::-ms-track {
        appearance: none !important;
        height: var(--player-scrubber-height);
        color: var(--colors-light-1000);
        transition: height 100ms ease-out;
      }

      .container:hover input::-webkit-slider-runnable-track {
        height: calc(var(--player-scrubber-height) * 2);
      }

      .container:hover input::-moz-range-track {
        height: calc(var(--player-scrubber-height) * 2);
      }

      .container:hover input::-ms-track {
        height: calc(var(--player-scrubber-height) * 2);
      }

      input::-webkit-slider-thumb {
        appearance: none !important;
        height: var(--player-scrubber-height) !important;
        width: var(--player-scrubber-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--player-scrubber-shadow-width) + var(--player-scrubber-height) / 2) * -1) 0 0
          var(--player-scrubber-shadow-width);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      input::-moz-range-thumb {
        appearance: none !important;
        height: var(--player-scrubber-height) !important;
        width: var(--player-scrubber-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--player-scrubber-shadow-width) + var(--player-scrubber-height) / 2) * -1) 0 0
          var(--player-scrubber-shadow-width);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      input::-ms-thumb {
        appearance: none !important;
        height: var(--player-scrubber-height) !important;
        width: var(--player-scrubber-height) !important;
        color: var(--colors-light-1000);
        border-radius: 50%;
        border: none;
        background: var(--colors-light-1000);
        box-shadow: calc((var(--player-scrubber-shadow-width) + var(--player-scrubber-height) / 2) * -1) 0 0
          var(--player-scrubber-shadow-width);
        transition: height 100ms ease-out, width 100ms ease-out, box-shadow 100ms ease-out, color 200ms ease-out;
      }

      .container:hover input::-webkit-slider-thumb {
        --player-scrubber-height: 16px;
        color: var(--colors-light-800);
      }

      .container:hover input::-moz-range-thumb {
        --player-scrubber-height: 16px;
        color: var(--colors-light-800);
      }

      .container:hover input::-ms-thumb {
        --player-scrubber-height: 16px;
        color: var(--colors-light-800);
      }
    `
];
Xt([
  k({ type: Number })
], ut.prototype, "duration", 2);
Xt([
  k({ type: Number })
], ut.prototype, "currentTime", 2);
Xt([
  k({ type: Array })
], ut.prototype, "buffer", 2);
ut = Xt([
  ye("vmp-progress-scrubber")
], ut);
var kh = Object.defineProperty, Ph = Object.getOwnPropertyDescriptor, ue = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Ph(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && kh(e, t, i), i;
};
let oe = class extends j {
  constructor() {
    super(...arguments), this.resizeHider = new Eh(this), this.playing = !1, this.volume = 1, this.muted = !1, this.currentTime = 0, this.duration = 0, this.level = -1, this.playbackRate = 1, this.buffer = [], this.levels = [], this.captions = !1, this.fullscreen = !1, this.controls = Js, this.volumeMenuOpen = !1, this.levelsMenuOpen = !1, this.playbackRateMenuOpen = !1, this.settingsMenuOpen = !1;
  }
  _handleNavigateBackClick() {
    this.dispatchEvent(new CustomEvent("navigate:back", { bubbles: !0, composed: !0 }));
  }
  _handleNavigateForwardClick() {
    this.dispatchEvent(new CustomEvent("navigate:forward", { bubbles: !0, composed: !0 }));
  }
  _handlePlayClick() {
    this.dispatchEvent(new CustomEvent("play:click", { bubbles: !0, composed: !0, detail: this.playing }));
  }
  _handleCaptionsClick() {
    this.dispatchEvent(new CustomEvent("captions:click", { bubbles: !0, composed: !0, detail: this.captions }));
  }
  _handleFullscreenClick() {
    this.dispatchEvent(new CustomEvent("fullscreen:click", { bubbles: !0, composed: !0, detail: this.fullscreen }));
  }
  _handleVolumeMenuToggle({ detail: a }) {
    this.volumeMenuOpen = a;
  }
  _handleLevelsMenuOpen({ detail: a }) {
    this.levelsMenuOpen = a;
  }
  _handlePlaybackMenuToggle({ detail: a }) {
    this.playbackRateMenuOpen = a;
  }
  _handleSettingsMenuToggle({ detail: a }) {
    this.settingsMenuOpen = a;
  }
  hideMenus() {
    var a, e;
    (e = Array.from(
      (a = this.shadowRoot) == null ? void 0 : a.querySelectorAll("vmp-menu, vmp-tooltip, vmp-volume-button")
    )) == null || e.forEach((t) => {
      var s;
      (s = t.tippy) == null || s.hide();
    });
  }
  render() {
    var T, x, A, b, C, I, _, D, R, F, P, W, le;
    const a = ((T = this.levels) == null ? void 0 : T.map((V, Y) => {
      const X = Math.min(V.width, V.height);
      return {
        id: `level-${Y.toString()}`,
        event: "level:click",
        label: `${X}p`,
        value: {
          resolution: X,
          level: Y
        }
      };
    })) ?? [], e = {
      title: "Quality",
      items: [
        ...a.reverse(),
        {
          id: "level--1",
          event: "level:click",
          label: "Auto",
          value: {
            level: -1,
            resolution: "auto"
          }
        }
      ]
    }, t = {
      id: "levels",
      label: "Quality",
      subItems: e
    }, s = (x = e.items) == null ? void 0 : x.find(({ value: V }) => V.level === this.level), i = ["levels", "playback-rate", "captions", "fullscreen"].filter(
      (V) => {
        var Y;
        return (Y = this.controls) == null ? void 0 : Y.includes(V);
      }
    ), r = {
      title: "Settings",
      items: [Ql, Jl, t, eh].filter(
        ({ id: V }) => i.includes(V) && this.resizeHider.hiddenControls.includes(V)
      )
    }, n = (A = this.controls) == null ? void 0 : A.includes("progress"), o = (b = this.controls) == null ? void 0 : b.includes("navigation"), l = (C = this.controls) == null ? void 0 : C.includes("play"), h = (I = this.controls) == null ? void 0 : I.includes("volume"), c = (_ = this.controls) == null ? void 0 : _.includes("current-time"), d = (D = this.controls) == null ? void 0 : D.includes("duration"), u = (R = this.controls) == null ? void 0 : R.includes("levels"), f = (F = this.controls) == null ? void 0 : F.includes("speed"), g = (P = this.controls) == null ? void 0 : P.includes("captions"), p = (W = this.controls) == null ? void 0 : W.includes("fullscreen"), v = l || h || c || d || u || f || g || p, y = [
      `level-${(le = this.level) == null ? void 0 : le.toString()}`,
      `playback-rate-${this.playbackRate.toString()}`,
      this.captions && "captions",
      this.fullscreen && "fullscreen"
    ].filter(Boolean);
    return G`
      <div
        ${this.resizeHider.measure()}
        ${this.resizeHider.contain()}
        class=${te({
      container: !0,
      hidden: !n && !v
    })}
      >
        <div
          class=${te({
      "scrubber-container": !0,
      hidden: !n
    })}
        >
          <vmp-progress-scrubber
            class=${te({
      scrubber: !0,
      invisible: this.volumeMenuOpen || this.levelsMenuOpen || this.playbackRateMenuOpen || this.settingsMenuOpen
    })}
            duration=${this.duration}
            currentTime=${this.currentTime}
            .buffer=${this.buffer}
          ></vmp-progress-scrubber>
        </div>
        <div
          ${this.resizeHider.contain()}
          class=${te({
      buttons: !0,
      hidden: !v
    })}
        >
          <div class="section">
            <div
              ${this.resizeHider.hide("navigation", 6)}
              class=${te({
      navigation: !0,
      hidden: !o
    })}
            >
              <vmp-icon-button
                icon="arrow-left"
                weight="heavy"
                rounded="full"
                @click=${this._handleNavigateBackClick}
              ></vmp-icon-button>
              <vmp-icon-button
                icon="arrow-right"
                weight="heavy"
                rounded="full"
                @click=${this._handleNavigateForwardClick}
              ></vmp-icon-button>
            </div>
            <vmp-icon-button
              class=${te({
      hidden: !l
    })}
              icon=${this.playing ? "pause" : "play"}
              weight="heavy"
              rounded="full"
              data-testid="play"
              @click=${this._handlePlayClick}
            ></vmp-icon-button>
            <vmp-volume-button
              class=${te({
      hidden: !h
    })}
              ?muted=${this.muted}
              volume=${this.volume}
              @menu:toggle=${this._handleVolumeMenuToggle}
            ></vmp-volume-button>
            <div class="time">
              <vmp-text
                ${this.resizeHider.hide("current-time", 1)}
                class=${te({
      hidden: !c
    })}
                ?semibold=${!0}
                content="${ks(this.currentTime)}${d ? "/" : null}"
              ></vmp-text>
              <vmp-text
                ${this.resizeHider.hide("duration", 5)}
                class=${te({
      hidden: !d
    })}
                ?semibold=${!0}
                content=${ks(this.duration)}
              ></vmp-text>
            </div>
          </div>
          <div class="section">
            <vmp-menu
              ${this.resizeHider.hide("levels", 0)}
              class=${te({
      hidden: !u || a.length <= 0
    })}
              .items=${e}
              .activeItems=${y}
              @menu:toggle=${this._handleLevelsMenuOpen}
            >
              <vmp-tooltip content="Quality" ?disabled=${this.levelsMenuOpen}>
                <vmp-button ?active=${this.levelsMenuOpen} icon="chevron-down">${s == null ? void 0 : s.label}</vmp-button>
              </vmp-tooltip>
            </vmp-menu>
            <vmp-menu
              ${this.resizeHider.hide("playback-rate", 4)}
              class=${te({
      hidden: !f
    })}
              .items=${cn}
              .activeItems=${y}
              @menu:toggle=${this._handlePlaybackMenuToggle}
            >
              <vmp-tooltip content="Playback speed" ?disabled=${this.playbackRateMenuOpen}>
                <vmp-button ?active=${this.playbackRateMenuOpen} icon="chevron-down"
                  >${this.playbackRate.toFixed(1)}x</vmp-button
                >
              </vmp-tooltip>
            </vmp-menu>
            <vmp-tooltip
              ${this.resizeHider.hide("captions", 3)}
              class=${te({
      hidden: !g
    })}
              content="Captions"
            >
              <vmp-icon-button
                ?active=${this.captions}
                icon=${this.captions ? "captions" : "captions-cross"}
                rounded="full"
                @click=${this._handleCaptionsClick}
              ></vmp-icon-button>
            </vmp-tooltip>
            <vmp-tooltip
              ${this.resizeHider.hide("fullscreen", 2)}
              content="Fullscreen"
              class=${te({
      hidden: !p
    })}
            >
              <vmp-icon-button
                ?active=${this.fullscreen}
                icon=${this.fullscreen ? "minimize" : "maximize"}
                rounded="full"
                data-testid="fullscreen"
                @click=${this._handleFullscreenClick}
              ></vmp-icon-button>
            </vmp-tooltip>
            <vmp-menu
              ${this.resizeHider.show("settings", ["levels", "playback-rate", "captions", "fullscreen"])}
              .items=${r}
              .activeItems=${y}
              @menu:toggle=${this._handleSettingsMenuToggle}
            >
              <vmp-tooltip content="Settings" ?disabled=${this.settingsMenuOpen}>
                <vmp-icon-button ?active=${this.settingsMenuOpen} icon="settings" rounded="full"></vmp-icon-button>
              </vmp-tooltip>
            </vmp-menu>
          </div>
        </div>
      </div>
    `;
  }
};
oe.styles = [
  j.styles ?? [],
  me`
      :host {
        --controls-border-radius: var(--player-border-radius, 0px);

        display: flex;
        width: 100%;
        isolation: isolate;
      }

      .container {
        display: flex;
        flex-direction: column;
        gap: var(--space-small);
        flex: 1;
        min-width: 0;
        overflow: auto;
        padding: var(--space-xl) var(--space-xs) var(--space-xs) var(--space-xs);
        background: linear-gradient(to bottom, transparent 20%, var(--colors-dark-800) 100%);
        border-radius: var(--controls-border-radius);
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }

      .buttons {
        display: flex;
        justify-content: space-between;
        gap: var(--space-xs);
        width: max-content;
        min-width: 100%;
      }

      .section {
        display: flex;
        gap: var(--space-xs);
      }

      .scrubber-container {
        position: relative;
        display: flex;
        height: 8px;
      }

      .scrubber {
        position: absolute;
        width: 100%;
        bottom: 0;
        transition: opacity 150ms ease-out;
      }

      .invisible {
        opacity: 0;
        pointer-events: none;
      }

      .navigation {
        display: flex;
        background: var(--colors-light-1000);
        border-radius: 1000rem;
      }

      .time {
        display: flex;
        align-items: center;
        color: var(--colors-light-1000);
        white-space: nowrap;
        font-variant-numeric: tabular-nums;
      }

      .hidden {
        display: none;
      }
    `
];
ue([
  k({ type: Boolean })
], oe.prototype, "playing", 2);
ue([
  k({ type: Number })
], oe.prototype, "volume", 2);
ue([
  k({ type: Boolean })
], oe.prototype, "muted", 2);
ue([
  k({ type: Number })
], oe.prototype, "currentTime", 2);
ue([
  k({ type: Number })
], oe.prototype, "duration", 2);
ue([
  k({ type: Number })
], oe.prototype, "level", 2);
ue([
  k({ type: Number })
], oe.prototype, "playbackRate", 2);
ue([
  k({ type: Array })
], oe.prototype, "buffer", 2);
ue([
  k({ type: Array, attribute: !1 })
], oe.prototype, "levels", 2);
ue([
  k({ type: Boolean })
], oe.prototype, "captions", 2);
ue([
  k({ type: Boolean })
], oe.prototype, "fullscreen", 2);
ue([
  k({ type: Array })
], oe.prototype, "controls", 2);
ue([
  ve()
], oe.prototype, "volumeMenuOpen", 2);
ue([
  ve()
], oe.prototype, "levelsMenuOpen", 2);
ue([
  ve()
], oe.prototype, "playbackRateMenuOpen", 2);
ue([
  ve()
], oe.prototype, "settingsMenuOpen", 2);
oe = ue([
  ye("vmp-player-controls")
], oe);
var Oh = Object.defineProperty, Fh = Object.getOwnPropertyDescriptor, Mh = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Fh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Oh(e, t, i), i;
};
let Ps = class extends j {
  render() {
    return G`<vmp-icon icon="loading"></vmp-icon>`;
  }
};
Ps.styles = [
  j.styles ?? [],
  me`
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `
];
Ps = Mh([
  ye("vmp-loading-spinner")
], Ps);
var Nh = Object.defineProperty, Uh = Object.getOwnPropertyDescriptor, un = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Uh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Nh(e, t, i), i;
};
let Wt = class extends j {
  constructor() {
    super(...arguments), this.caption = "";
  }
  render() {
    return G`
      <div class="container">
        <vmp-text content=${this.caption} size="large"></vmp-text>
      </div>
    `;
  }
};
Wt.styles = [
  j.styles ?? [],
  me`
      .container {
        display: block;
        margin: 0 var(--space-small);
        text-align: center;
      }

      vmp-text::part(content) {
        display: inline;
        padding: var(--space-xxs) var(--space-xs);
        text-align: center;
        border-radius: var(--radii-small);
        box-decoration-break: clone;
        -webkit-box-decoration-break: clone;
        color: var(--colors-light-1000);
        background: var(--colors-dark-800);
        /* Line height controls the spacing between the cloned boxes so has to override the default */
        line-height: 2.2;
      }
    `
];
un([
  k({ type: String })
], Wt.prototype, "caption", 2);
Wt = un([
  ye("vmp-captions")
], Wt);
var $h = Object.defineProperty, Bh = Object.getOwnPropertyDescriptor, pe = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Bh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && $h(e, t, i), i;
};
const Gh = 3e3;
let ce = class extends j {
  constructor() {
    super(...arguments), this.loading = !1, this.playing = !1, this.volume = 1, this.muted = !1, this.currentTime = 0, this.duration = 0, this.levels = [], this.level = -1, this.playbackRate = 1, this.caption = "", this.buffer = [], this.captions = !1, this.fullscreen = !1, this.controls = Js, this.showControls = !0, this._hasTouched = !1, this._playerControlsRef = Se();
  }
  _startHideControls() {
    clearTimeout(this._controlHideTimeout), this._controlHideTimeout = setTimeout(() => {
      this.showControls = !1, this._hasTouched = !1;
    }, Gh);
  }
  _immediateShowControls() {
    this.showControls = !0, clearTimeout(this._controlHideTimeout);
  }
  _immediateHideControls() {
    this.showControls = !1, this._hasTouched = !1, clearTimeout(this._controlHideTimeout);
  }
  willUpdate(a) {
    var e;
    a.has("playing") && this.playing && this._startHideControls(), a.has("showControls") && this.playing && !this.showControls && ((e = this._playerControlsRef.value) == null || e.hideMenus());
  }
  render() {
    var s;
    const a = (s = this.controls) == null ? void 0 : s.includes("play-large"), e = this.playing && !this.showControls, t = !!(a && !this.playing);
    return G`
      <div
        class=${te({
      container: !0,
      hide: e
    })}
        @mousemove=${() => {
      this._immediateShowControls(), this._startHideControls();
    }}
        @mouseleave=${this._immediateHideControls}
        @touchstart=${(i) => {
      this.playing && !this.showControls && !this._hasTouched && (i.preventDefault(), this._hasTouched = !0, this._immediateShowControls(), this._startHideControls());
    }}
      >
        <div
          class=${te({
      fixtures: !0,
      invisible: !this.loading && !t
    })}
          @click=${() => {
      this.showControls && this.dispatchEvent(
        new CustomEvent("play:click", { bubbles: !0, composed: !0, detail: this.playing })
      );
    }}
        >
          <vmp-icon
            class=${te({
      hidden: !t
    })}
            icon="play-large"
          ></vmp-icon>
          <vmp-loading-spinner
            class=${te({
      hidden: !this.loading || t
    })}
          ></vmp-loading-spinner>
        </div>
        <div
          class=${te({
      controls: !0,
      hide: e
    })}
          @focusin=${this._immediateShowControls}
          @mousemove=${(i) => {
      i.stopPropagation(), this._immediateShowControls();
    }}
          @click=${this._immediateShowControls}
        >
          ${this.captions ? G`<vmp-captions
                class=${te({
      hidden: !this.caption,
      hiddenControls: e
    })}
                caption=${this.caption}
              ></vmp-captions>` : null}
          <vmp-player-controls
            ${be(this._playerControlsRef)}
            ?playing=${this.playing}
            ?muted=${this.muted}
            volume=${this.volume}
            currentTime=${this.currentTime}
            duration=${this.duration}
            .levels=${this.levels}
            .level=${this.level}
            playbackRate=${this.playbackRate}
            .buffer=${this.buffer}
            .controls=${this.controls}
            ?captions=${this.captions}
            ?fullscreen=${this.fullscreen}
          ></vmp-player-controls>
        </div>
      </div>
    `;
  }
};
ce.styles = [
  j.styles ?? [],
  me`
      :host {
        --overlay-border-radius: var(--player-border-radius, 0px);
      }

      .container {
        position: relative;
        display: flex;
        justify-content: space-between;
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-radius: var(--overlay-border-radius);
      }

      .container.hide {
        cursor: none;
      }

      .fixtures {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 1;
        color: var(--colors-light-1000);
        background: var(--colors-dark-200);
        border-radius: var(--overlay-border-radius);
        transition: opacity 150ms ease-out;
      }

      .hidden {
        display: none;
      }

      .invisible {
        opacity: 0;
      }

      .controls {
        position: relative;
        display: flex;
        flex-direction: column;
        align-self: flex-end;
        flex: 1;
        min-width: 0;
        opacity: 1;
        isolation: isolate;
        transform: translateY(0%);
        transition: transform 200ms ease-out;
      }

      .controls.hide {
        pointer-events: none;
        transform: translateY(100%);
      }

      vmp-captions {
        position: absolute;
        bottom: calc(100%);
        width: 100%;
        transform: translateY(var(--space-medium));
        transition: transform 200ms ease-out;
      }

      vmp-captions.hiddenControls {
        transform: translateY(calc(var(--space-small) * -1));
      }
    `
];
pe([
  k({ type: Boolean })
], ce.prototype, "loading", 2);
pe([
  k({ type: Boolean })
], ce.prototype, "playing", 2);
pe([
  k({ type: Number })
], ce.prototype, "volume", 2);
pe([
  k({ type: Boolean })
], ce.prototype, "muted", 2);
pe([
  k({ type: Number })
], ce.prototype, "currentTime", 2);
pe([
  k({ type: Number })
], ce.prototype, "duration", 2);
pe([
  k({ type: Array, attribute: !1 })
], ce.prototype, "levels", 2);
pe([
  k({ type: Number })
], ce.prototype, "level", 2);
pe([
  k({ type: Number })
], ce.prototype, "playbackRate", 2);
pe([
  k({ type: String })
], ce.prototype, "caption", 2);
pe([
  k({ type: Array })
], ce.prototype, "buffer", 2);
pe([
  k({ type: Boolean })
], ce.prototype, "captions", 2);
pe([
  k({ type: Boolean })
], ce.prototype, "fullscreen", 2);
pe([
  k({ type: Array })
], ce.prototype, "controls", 2);
pe([
  ve()
], ce.prototype, "showControls", 2);
ce = pe([
  ye("vmp-player-overlay")
], ce);
var Vh = Object.defineProperty, Hh = Object.getOwnPropertyDescriptor, re = (a, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Hh(e, t) : e, r = a.length - 1, n; r >= 0; r--)
    (n = a[r]) && (i = (s ? n(e, t, i) : n(i)) || i);
  return s && i && Vh(e, t, i), i;
};
const Kh = 1e3 / 60;
let ie = class extends j {
  constructor() {
    super(...arguments), this.burnCaptions = !1, this.debug = !1, this.propAspectRatio = 0, this.preload = "auto", this.autoplay = !1, this.loading = !1, this.compilation = Os, this._sceneController = new ql(this), this._drawController = new En(this), this._observer = null, this._wasPlaying = !1, this._manualMute = this.muted, this._seekerRAF = null, this._seekerTimeout = null, this._lastWaiting = !1, this._lastTimestamp = null, this._playerRef = Se(), this._canvasRef = Se(), this._pageHidden = document.visibilityState === "hidden", this._aspectRatio = this.propAspectRatio, this._processing = !1, this._waiting = !1, this._errors = [], this._seeking = !1, this._captions = !1, this._fullscreen = !1, this._initialised = null, this._paused = !0, this._playbackRate = 1, this._volume = null, this._muted = null, this._videoResolution = -1, this._handleContainerResize = () => {
      var a;
      (a = this.shadowRoot) != null && a.host && !this.propAspectRatio && (this._aspectRatio = this.shadowRoot.host.clientWidth / this.shadowRoot.host.clientHeight);
    }, this._handleCanvasResize = () => {
      this.draw();
    }, this._loop = () => {
      this._endLoop(), this._pageHidden ? this._seekerTimeout = setTimeout(this._seeker, Kh) : this._seekerRAF = requestAnimationFrame(this._seeker);
    }, this._endLoop = () => {
      this._seekerRAF && cancelAnimationFrame(this._seekerRAF), this._seekerTimeout && clearTimeout(this._seekerTimeout), this._seekerRAF = null, this._seekerTimeout = null;
    }, this._seeker = (a = performance.now()) => {
      this.sceneConfig && this.scenes.length > 0 && (this._waiting = this._drawController.activeScenes.some(({ video: e }) => {
        if (e) {
          const { key: t } = e, s = this.videoState[t];
          return !s || !s.initialised || s.waiting || // Video only has a few frames available
          e.node.readyState < 3;
        }
      }), this.waiting ? (this._lastTimestamp = null, this._lastWaiting || this.dispatchEvent(new CustomEvent("waiting"))) : this._lastWaiting && this.dispatchEvent(new CustomEvent("playing")), a - (this._lastTimestamp ?? 0) > 1e3 / this.sceneConfig.frameRate && (this._drawController.currentTime = this._drawController.currentTime + (a - (this._lastTimestamp ?? a)) / 1e3 * this.playbackRate, this._lastTimestamp = a), this._lastWaiting = this._waiting, this._drawController.currentTime >= this.duration && (this.pause(), this.dispatchEvent(new CustomEvent("ended")))), this.paused || this._loop();
    }, this._handleError = (a) => {
      this._errors = [...this.errors, a.error], a.error.fatal && this.pause();
    }, this._handleFullscreenChange = () => {
      document.fullscreenElement ? this._fullscreen = !0 : this._fullscreen = !1;
    }, this._handleVisibilityChange = () => {
      this._pageHidden = document.visibilityState === "hidden", this.paused || this._loop();
    };
  }
  get aspectRatio() {
    return this._aspectRatio;
  }
  get processing() {
    return this._processing;
  }
  get waiting() {
    return !this.paused && this._waiting;
  }
  get errors() {
    return this._errors;
  }
  get seeking() {
    return this._seeking;
  }
  get captions() {
    return this._captions;
  }
  get fullscreen() {
    return this._fullscreen;
  }
  get initialised() {
    return this._initialised = this._initialised ?? new Promise((a) => {
      const e = setInterval(() => {
        !!this.errors.find((s) => s.fatal) && a(!1), !this.loading && !this.processing && this.scenes.length > 0 && a(!0);
      }, 500);
      setTimeout(() => {
        clearInterval(e), a(!1);
      }, 60 * 1e3);
    }), this._initialised;
  }
  get duration() {
    return this._sceneController.duration;
  }
  get scene() {
    return this._drawController.activeScenes[this._drawController.activeScenes.length - 1];
  }
  get scenes() {
    var a;
    return ((a = this._sceneController.scenes) == null ? void 0 : a.scenes) ?? [];
  }
  get sceneConfig() {
    return this._sceneController.scenes;
  }
  get videos() {
    return this._sceneController.videos ?? {};
  }
  get videoState() {
    return this._sceneController.videoState;
  }
  get sceneVideoState() {
    return this.scenes.reduce((a, { video: e, start: t, duration: s }) => {
      const i = (e == null ? void 0 : e.key) ?? `${t}-${s}`;
      return a[i] = this.videoState[i], a;
    }, {});
  }
  set paused(a) {
    a !== this._paused && (this._paused = a, this.requestUpdate(), this.dispatchEvent(new CustomEvent(a ? "pause" : "play")));
  }
  get paused() {
    return this._paused;
  }
  set playbackRate(a) {
    a !== this._playbackRate && (this._playbackRate = a, this.scenes.forEach(({ video: e }) => {
      e && (e.node.playbackRate = a);
    }), this.requestUpdate(), this.dispatchEvent(new CustomEvent("ratechange", { detail: a })));
  }
  get playbackRate() {
    return this._playbackRate;
  }
  set volume(a) {
    const e = Math.min(1, Math.max(0, a));
    e !== this._volume && (this.scenes.forEach(({ video: t }) => {
      t && (t.node.volume = e);
    }), localStorage.setItem("vmp-player-volume", e.toString()), this._volume = e, e > 0 && (this.muted = !1), this.requestUpdate(), this.dispatchEvent(new CustomEvent("volumechange", { detail: a })));
  }
  get volume() {
    return this._volume ?? (this._volume = parseFloat(localStorage.getItem("vmp-player-volume") ?? "1"));
  }
  set muted(a) {
    this.scenes.forEach(({ video: e }) => {
      e && (e.node.muted = a);
    }), a !== this._muted && (this._muted = a, localStorage.setItem("vmp-player-muted", a.toString()), this.requestUpdate(), this.dispatchEvent(new CustomEvent("volumechange", { detail: a ? 0 : this.volume })));
  }
  get muted() {
    return this._muted ?? (this._muted = this.autoplay || localStorage.getItem("vmp-player-muted") === "true");
  }
  set videoResolution(a) {
    a !== this._videoResolution && (this._videoResolution = a, this.scenes.forEach(({ video: e }) => {
      if (e != null && e.hls) {
        const t = e.hls.levels.findIndex((s) => Math.min(s.height, s.width) === a);
        e.hls.currentLevel = t ?? -1;
      }
    }), this.requestUpdate());
  }
  get videoResolution() {
    return this._videoResolution;
  }
  set currentTime(a) {
    a !== this._drawController.currentTime && (this._drawController.currentTime = a, this._sceneController.setVideosCurrentTime(a));
  }
  get currentTime() {
    return this._drawController.currentTime;
  }
  reset(a = 0, e = !1) {
    this._lastTimestamp = null, this._drawController.currentTime = a, this._sceneController.setVideosCurrentTime(a), e ? this.play() : this.pause();
  }
  clear() {
    this._drawController.clear();
  }
  play() {
    this.paused = !1, this._lastTimestamp = null, this.duration > 0 && this._drawController.currentTime >= this.duration && this.reset(0, !0), this._loop();
  }
  pause() {
    this._endLoop(), this.paused = !0, this.scenes.forEach(({ video: a }) => {
      a && a.node.pause();
    });
  }
  draw(a) {
    return this._drawController.draw(a);
  }
  setScene(a) {
    var e, t;
    if ((e = this._sceneController) != null && e.scenes) {
      const s = (t = this.scenes) == null ? void 0 : t[a];
      if (!s) {
        const i = new Ne(`No scene at index: ${a}`);
        return this.dispatchEvent(
          new ErrorEvent("error", { composed: !0, bubbles: !0, error: i, message: i.message })
        );
      }
      this.reset(s.start + this._sceneController.scenes.transitionDuration, !this.paused);
    }
  }
  // This must be called in an event handler that occurs as a result of user action as the browser does not allow programmatic fullscreen
  toggleFullscreen(a) {
    a ?? this.fullscreen ? Zl() : this._playerRef.value && Xl(this._playerRef.value);
  }
  connectedCallback() {
    var a;
    super.connectedCallback(), this.addEventListener("error", this._handleError), document.addEventListener("fullscreenchange", this._handleFullscreenChange), document.addEventListener("visibilitychange", this._handleVisibilityChange), (a = this.shadowRoot) != null && a.host && (this._observer = new ResizeObserver(this._handleContainerResize), this._observer.observe(this.shadowRoot.host));
  }
  willUpdate() {
    this.propAspectRatio && (this._aspectRatio = this.propAspectRatio);
  }
  updated(a) {
    a.has("propAspectRatio") && !this.propAspectRatio && this._handleContainerResize(), // We want to autoplay after the video has processed for the first time
    // but only want it to activate once per session
    this.autoplay && !this.processing && !this._sceneController.hasPlayed && a.has("_processing") && this.play();
  }
  disconnectedCallback() {
    var a;
    super.disconnectedCallback(), (a = this._observer) == null || a.disconnect(), document.removeEventListener("fullscreenchange", this._handleFullscreenChange), document.removeEventListener("visibilitychange", this._handleVisibilityChange);
  }
  _renderStyles() {
    return this.propAspectRatio ? typeof this.propAspectRatio == "number" ? G`
        <style>
          :host {
            aspect-ratio: ${this.propAspectRatio};
          }
        </style>
      ` : null : G`
        <style>
          :host {
            width: 100%;
            height: 100%;
          }
        </style>
      `;
  }
  _renderError() {
    return G`<div class="error">
      <div class="error-icon">
        <vmp-icon icon="error"></vmp-icon>
      </div>
      <div class="error-text">
        <vmp-text semibold content="An error has occurred when attempting to play this video."></vmp-text>
        <vmp-text semibold content="Please try again later."></vmp-text>
      </div>
    </div>`;
  }
  render() {
    var u, f, g, p, v, y;
    const a = this.loading || this.processing || !this.scenes || this.duration <= 0, { height: e, width: t } = rr({
      resolution: ((u = this.sceneConfig) == null ? void 0 : u.resolution) ?? 720,
      aspectRatio: this.aspectRatio
    }), s = Object.keys(this.sceneVideoState).reduce((T, x) => T.concat(this.sceneVideoState[x].buffered ?? []), []), i = (
      // Don't show any controls when disabled because we haven't created the `videos` yet
      // This means that if the user was to play the video then it would have to start muted because we can only unmute videos
      // within user events for autoplay reasons
      a ? [] : (f = this.controls ?? Js) == null ? void 0 : f.filter((T) => !(T === "fullscreen" && zl() || T === "navigation" && (!this.scenes || this.scenes.length <= 1)))
    ), r = !(i != null && i.includes("preview")), n = (((g = this.scenes) == null ? void 0 : g.length) ?? 0) - 1, o = ((p = this.scenes) == null ? void 0 : p.findIndex((T) => T === this._drawController.activeScenes[0])) ?? 0, l = (y = (v = this._drawController.activeScenes[0]) == null ? void 0 : v.video) == null ? void 0 : y.hls, h = this.loading || this.waiting || this.processing, c = !this.src && !this.data, d = !!this.errors.find((T) => T.fatal);
    return G`
      ${this._renderStyles()}
      <div
        ${be(this._playerRef)}
        class=${te({
      player: !0,
      responsive: !this.propAspectRatio
    })}
        style=${Fs({
      aspectRatio: this.aspectRatio
    })}
      >
        ${!h && (c || d) ? this._renderError() : G`<canvas
                ${be(this._canvasRef)}
                ${this._drawController.canvas()}
                ${ei(this._handleCanvasResize)}
                height=${e}
                width=${t}
              ></canvas>
              <vmp-player-overlay
                ${this._drawController.controls()}
                .data=${this.data}
                .template=${this.template}
                ?disabled=${a}
                ?playing=${!this.paused}
                ?loading=${h}
                ?muted=${this.muted}
                volume=${this.volume}
                duration=${this.duration}
                .levels=${(l == null ? void 0 : l.levels) ?? []}
                level=${vt(l != null && l.autoLevelEnabled ? -1 : l == null ? void 0 : l.currentLevel)}
                playbackRate=${this.playbackRate}
                caption=${this._drawController.caption}
                .buffer=${s}
                .controls=${i}
                ?captions=${this.captions}
                ?fullscreen=${this.fullscreen}
                @navigate:back=${(T) => {
      T.defaultPrevented || this.setScene(o <= 0 ? n : o - 1);
    }}
                @navigate:forward=${(T) => {
      T.defaultPrevented || this.setScene(o >= n ? 0 : o + 1);
    }}
                @play:click=${({ detail: T }) => {
      a || (T ? this.pause() : (this.muted = this._manualMute, this.play()));
    }}
                @volume:click=${({ detail: T }) => {
      this.muted = !T, this._manualMute = !T;
    }}
                @level:click=${({ detail: T }) => {
      this.videoResolution = T.value.resolution;
    }}
                @playbackRate:click=${({ detail: T }) => {
      this.playbackRate = T.value ?? 1;
    }}
                @captions:click=${() => {
      this._captions = !this._captions;
    }}
                @fullscreen:click=${() => {
      this.toggleFullscreen();
    }}
                @input=${(T) => {
      const x = T.composedPath()[0], A = x.getAttribute("key");
      if (A === "scrubber") {
        const b = parseFloat(x.value);
        this._drawController.currentTime = b, this._sceneController.setVideosCurrentTime(b), this.dispatchEvent(new CustomEvent("seeking", { detail: b }));
      }
      A === "volume" && (this.volume = parseFloat(x.value));
    }}
                @pointerdown=${(T) => {
      T.composedPath()[0].getAttribute("key") === "scrubber" && (this._seeking = !0, this._wasPlaying = !this.paused, this.paused || this.pause());
    }}
                @pointerup=${(T) => {
      T.composedPath()[0].getAttribute("key") === "scrubber" && (this._seeking = !1, this._wasPlaying && (this.play(), this._wasPlaying = !1), this.dispatchEvent(new CustomEvent("seeked", { detail: this._drawController.currentTime })));
    }}
              ></vmp-player-overlay>
              <vmp-video-preview
                ?disabled=${r}
                .src=${this.src}
                .data=${this.data}
                .template=${this.template}
                .aspectRatio=${this.aspectRatio}
                .compilation=${this.compilation}
              ></vmp-video-preview>`}
      </div>
    `;
  }
};
ie.styles = [
  j.styles ?? [],
  me`
      :host {
        --player-border-radius: var(--vouch-media-player-border-radius, 0px);

        display: flex;
      }

      .player {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--colors-dark-1000);
        border-radius: var(--player-border-radius);
      }

      .responsive {
        width: 100%;
        height: 100%;
      }

      .error {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--space-xxs);
        padding: var(--space-medium);
        width: 100%;
        height: 100%;
        color: white;
      }

      .error-icon {
        color: var(--colors-red-500);
      }

      .error-text {
        display: flex;
        flex-direction: column;
      }

      canvas {
        width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: var(--player-border-radius);
      }

      vmp-player-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      vmp-video-preview {
        position: absolute;
        top: 0;
        left: 0;
      }
    `
];
re([
  k({ type: Object })
], ie.prototype, "data", 2);
re([
  k({ type: Object })
], ie.prototype, "template", 2);
re([
  k({ type: Boolean })
], ie.prototype, "burnCaptions", 2);
re([
  k({ type: Boolean })
], ie.prototype, "debug", 2);
re([
  k({ type: String })
], ie.prototype, "src", 2);
re([
  k({ type: String })
], ie.prototype, "track", 2);
re([
  k({ type: Number, attribute: "aspectratio" })
], ie.prototype, "propAspectRatio", 2);
re([
  k({ type: String })
], ie.prototype, "preload", 2);
re([
  k({ type: Boolean })
], ie.prototype, "autoplay", 2);
re([
  k({ type: Boolean })
], ie.prototype, "loading", 2);
re([
  k({ type: Array })
], ie.prototype, "controls", 2);
re([
  k({ attribute: !1 })
], ie.prototype, "compilation", 2);
re([
  ve()
], ie.prototype, "_pageHidden", 2);
re([
  ve()
], ie.prototype, "_aspectRatio", 2);
re([
  ve()
], ie.prototype, "_processing", 2);
re([
  ve()
], ie.prototype, "_waiting", 2);
re([
  ve()
], ie.prototype, "_errors", 2);
re([
  ve()
], ie.prototype, "_seeking", 2);
re([
  ve()
], ie.prototype, "_captions", 2);
re([
  ve()
], ie.prototype, "_fullscreen", 2);
ie = re([
  ye("vmp-media-player")
], ie);
export {
  ie as MediaPlayer
};
//# sourceMappingURL=media-player.js.map
